export const locale = {
  lang: 'pt',
  data: {
    TESTLANG: 'pt_base',
    LNG_ITEMS: 'Produtos',
    LNG_ITEM: 'Produto',
    LNG_TIENDAS: 'Pontos de Venda',
    LNG_TIENDA: 'Ponto de Venda',
    LNG_PRICES_DECISIONS_FILTER_CATEGORYS: 'Subcategorias',
    GENERAL_INFO: 'Informação',
    GENERAL_DOWNLOAD: 'Descarregar',
    GENERIC_SEARCH: 'Buscar',
    GENERIC_CLEAN: 'Limpar',
    GENERIC_SELECTED_OPTION: 'Opção Selecionada',
    GENERIC_PUBLISH_CONTENT: 'Deseja publicar os seguintes {{val}} registros selecionados?',
    GENERIC_CANCEL_CONTENT: 'Deseja cancelar os seguintes {{val}} registros selecionados?',
    GENERIC_DOWNLOAD_CONTENT: 'Deseja baixar os seguintes {{val}} registros selecionados?',
    GENERIC_UNPUBLISH: 'Erros de Publicação em Massa',
    GENERIC_WITHOUT_PERMISSION: 'Sem permissão para realizar esta ação',
    GENERIC_ACCESS_PERMISSION: 'Sem permissões de acesso a esta tela',
    // PLATFORM-SEC03: usuário sem função
    NO_ROLE_TITLE: 'Você não tem uma função atribuída',
    NO_ROLE_MESSAGE:
      'Você não tem uma função atribuída no Prisma, portanto ainda não tem acesso a nenhum módulo. Entre em contato com o administrador do Prisma da sua organização para que lhe atribua uma função.',
    NO_ROLE_YOUR_DATA: 'Seus dados',
    NO_ROLE_USER: 'Usuário',
    NO_ROLE_NAME: 'Nome',
    NO_ROLE_EMAIL: 'Email',
    USER_WITHOUT_ROLE_WARNING_TITLE: 'Usuário sem função',
    USER_WITHOUT_ROLE_WARNING_MSG:
      'Você está prestes a salvar este usuário sem uma função atribuída. Ele não poderá acessar a ferramenta até que uma seja atribuída. Deseja continuar?',
    USER_WITHOUT_ROLE_SELF_ERROR: 'Você não pode remover a sua própria função.',
    GENERIC_ACTION_ROW_CONTENT_FAILED: 'A ação não pode ser executada corretamente',
    GENERIC_VIEW_ALL: 'Ver tudo',
    GENERIC_CANCEL: 'Cancelar',
    GENERIC_ACCEPT: 'aceitar',
    GENERIC_APPLY: 'Aplicar',
    GENERIC_CLOSE: 'Fechar',
    GENERIC_OK: 'Ok',
    GENERIC_CONTINUE: 'Continuar',
    GENERIC_WARNING: 'Aviso',
    GENERIC_REPORT: 'Relatório Completo',
    GENERIC_ADD: 'Adicionar',
    GENERIC_FILTER: 'Filtrar',
    GENERIC_FULLSCREEN_TTIP: 'Expandir',
    GENERIC_EXITFULLSCREEN_TTIP: 'Recolher',
    GENERIC_EXPORT_TTIP: 'Exportar',
    GENERIC_CLONE: 'Clonar',
    GENERIC_EDIT: 'Editar',
    GENERIC_DELETE: 'Excluir',
    GENERIC_VIEW: 'Ver',
    GENERIC_CONFIRM: 'Confirmar',
    GENERIC_RESET: 'Reiniciar',
    GENERIC_RESET_ALT: 'Resetar',
    GENERIC_VISUALIZE: 'Visualizar',
    GENERIC_SAVE: 'Salvar',
    GENERIC_SAVE_OK: 'Salvo com sucesso.',
    GENERIC_SAVE_AND_GENERATE: 'Salvar e Gerar',
    GENERIC_GENERATE: 'Gerar',
    GENERIC_NONE: 'Nenhum',
    GENERIC_DOWNLOAD_EXCEL: 'download.xlsx',
    GENERIC_ITEMS_NOT_FOUND: 'Nenhum resultado encontrado',
    GENERIC_ITEMS_NOT_ITEMS: 'Não há mais itens',
    GENERIC_NOTICE: 'Aviso',
    GENERIC_SOME: '(Várias)',
    GENERIC_YES: 'Sim',
    GENERIC_NO: 'Não',
    GENERIC_ALL: 'Todos',
    GENERIC_ALL_PAGE: 'A página inteira',
    GENERIC_DESELECT: 'Desmarcar',
    GENERIC_ALL_F: 'Todas',
    GENERIC_DAY1: 'Segunda-feira',
    GENERIC_DAY2: 'Terça-feira',
    GENERIC_DAY3: 'Quarta-feira',
    GENERIC_DAY4: 'Quinta-feira',
    GENERIC_DAY5: 'Sexta-feira',
    GENERIC_DAY6: 'Sábado',
    GENERIC_DAY7: 'Domingo',
    GENERAL_NAME_DUPLICATE: 'Este nome já existe',
    GENERIC_DELETE_LOGIC: 'Desativar registro',
    GENERIC_DELETE_LOGIC_SINGLE_CONTENT: 'Tem certeza de que deseja inativar {{val}}? Só poderá ser excluído se não estiver em uso',
    GENERIC_DELETE_MULTIPLE: 'Inativar registros',
    GENERIC_SUPPORT_CHAT: 'Conversar com o Suporte Técnico',
    GENERIC_DELETE_LOGIC_MULTIPLE_CONTENT:
      'Tem certeza de que deseja inativar {{val}} registros? Só poderão ser excluídos se não estiverem em uso',
    GENERIC_ERRORS: {
      REQUIRED: 'Este campo é obrigatório',
      EMAIL: 'Deve ser um email válido',
      MIN: 'O valor deve ser maior que {{val}}',
      MAX: 'O valor deve ser menor que {{val}}',
      MINLENGTH: 'Mínimo de {{val}} caracteres',
      MAXLENGTH: 'Máximo de {{val}} caracteres',
      PATTERN: 'Formato inválido',
      MATDATEPICKERMIN: 'A data deve ser posterior a {{val}}',
      MATDATEPICKERMAX: 'A data deve ser anterior a {{val}}',
      CODEEXISTS: 'O código já existe',
    },
    LINEAR_SPACE_TYPES: {
      Sales: 'Vendas',
    },
    LNG_PRODUCTS_TYPES: {
      Retail: 'Varejo',
      Ingredient: 'Ingredientes',
      Combo: 'Combo',
      Recipe: 'Receita',
      Supply: 'Abastecimento',
      Item: 'Retail',
    },
    LNG_STORES_TYPES: {
      Store: 'Ponto de Venda',
      DistributionCenter: 'Centro de Distribuição ',
      StoreAndDistributionCenter: 'Ponto de Venda e Centro de Distribuição',
    },
    LNG_STRATEGIES_VARIABLES: {
      Sales: 'Vendas',
      SalesUN: 'Unidades Vendidas',
      Deliveries: 'Entregas',
      DeliveriesUN: 'Entregas em UN',
      Margin: 'Margem',
      MarginWithVendors: 'Margem por acordos',
      MarketSales: 'Vendas no Mercado',
      MarketUN: 'Unidades no Mercado',
    },
    LNG_STRATEGIES_EVENTS: {
      First: 'Primeria compra',
      CreationDate: 'Data de Cadastro',
    },
    STATUS_CONNECTION: {
      NO_CONNECTION: 'Sem Conexão',
      BAD_CONNECTION: 'Conexão pobre',
      ACCEPT: 'OK',
      MODAL_TITLE: 'Problema de Conexão',
      MODAL_MESSAGE: 'Não foi possível conectar ao servidor. Por favor, verifique sua conexão com a internet e tente novamente.',
      MODAL_BUTTON: 'Entendido',
    },
    ABM_STATUS: {
      NEW: 'Novo',
      ENDORSED: 'Endossado',
      INFORMED: 'Informado',
      DELETED: 'Excluído',
      MODIFIED: 'Modificado',
      CURRENT: 'Postado',
      CANCELLED: 'Excluído',
    },
    PUBLISH_STATUS: {
      PROCESSING: 'Postando',
      PROCESSING_TOOLTIP: 'Atualize os resultados da pesquisa quando notificado sobre o sucesso da publicação',
      ROW_DISABLED_BY_PROCESSING: 'A ação não pode ser realizada pois o registro está sendo processado.',
      DELETING: 'Removendo',
      DELETING_TOOLTIP: 'Os resultados da busca serão atualizados ao receber a notificação do sucesso da exclusão',
      ABM_WARNING_DELETING: 'Registro em processo de exclusão.',
    },
    LNG_ADMINISTRATION_MASTER_SUPPLIER_searchStores: 'Encontrar Pontos de Venda',
    LNG_ADMINISTRATION_MASTER_STORES_newStore: 'Novo Ponto de Venda',
    LNG_ADMINISTRATION_MASTER_STORES_tooltipDeleteStore: 'Apagar Pontos de Venda Selecionados',
    LNG_ADMINISTRATION_MASTER_STORES_storeType: 'Tipo de Ponto de Venda',
    LNG_MASTER_STORETYPES_Store: 'Ponto de Venda',
    LNG_MASTER_STORETYPES_DistributionCenter: 'Centro de Distribuição ',
    LNG_MASTER_STORETYPES_StoreAndDistributionCenter: 'Ponto de Venda e Centro de Distribuição',
    LNG_PRICES_SETUP_PRICERULE_storeScope: 'Escopo do Ponto de Venda',
    LNG_PRICES_SETUP_PRICERULE_step3storeScope: 'Passo 3 - Escopo do Ponto de Venda',
    'LNG_PRICE-RULES-TYPES_Margin': 'Margem',
    'LNG_PRICE-RULES-TYPES_Competitive': 'concorrência',
    'LNG_PRICE-RULES-TYPES_ParentItem': 'Parentesco de Produtos',
    'LNG_PRICE-RULES-TYPES_ParentZone': 'Parentesco do Ponto de Venda',
    'LNG_PRICE-RULES-TYPES_ParentCategory': 'Parentesco por Categoria',
    LNG_SET_EFFECTIVE_DATES: 'Definir Datas Válidas',
    LNG_SET_EFFECTIVE_DATE: 'Definir Data Válida',
    LNG_PREVIEW: 'Vista Prévia',
    TIME_UNITS_SHORT: {
      seconds: 'Seg.',
      minutes: 'Mín.',
      hours: 'Horas',
      days: 'Dias',
    },
    GLOBAL: {
      DATES: 'Datas',
      brand: 'Marca',
      brands: 'Bandeira',
      manufacturer: 'Fornecedor',
      internalCode: 'Código Interno',
      externalCode: 'Código Externo',
      Vendor: 'Fornecedor',
      Imprent: 'Imprimir',
      Region: 'Região',
      Market: 'Mercado',
      Format: 'Tipo de Operação Propria',
      Country: 'País',
      State: 'Estado',
      Department: 'Localidade',
      NAME: 'Nome',
      QUANTITY: 'Quantidade',
      City: 'Cidade',
      ZipCode: 'Código Postal',
      Subcategoría: 'Subcategoria',
      OperationType: 'Tipo de Operação Concorrentes',
      UnCheckedSuggestion: 'Sugestão não verificada',
      PriceRaised: 'Preços que Aumentaram',
      NoSuggestions: 'Sem Sugestōes',
      NotCheckedSimulation: 'Simulação não verificada',
      SuggestionAccepted: 'Sugestão aceita',
      ManualPriceEdited: 'Preço editado manualmente',
      SimulationAcepted: 'Simulação aceita',
      Regular: 'Regular',
      Competition: 'concorrência',
      Current: 'Atual',
      New: 'Novo',
      Endorsed: 'Endossado',
      Informed: 'Informado',
      Historic: 'Histórico',
      Future: 'Futuro',
      Checked: 'Comprovada',
      Unchecked: 'Sem revisar',
      PriceZone: 'Zona de Preços',
      Search: 'Procurar',
      Type: 'Tipo',
      WITHOUT_PERMISSIONS: 'Sem Permissão',
      PLACEHOLDER_START_DATE: 'Data de inicio',
      PLACEHOLDER_END_DATE: 'Data final',
      MAX_DIFF_DATE: 'O período de datas não pode exceder a ',
      SECOND_DATE_LOWER_THAN_FIRST: 'A data de início é maior que a data final ',
      DATE: 'Data',
      PDV: 'Pontos de Venda',
      WITHOUT_CHANGES: 'Nenhum Alteração',
      WITHOUT_INVALID_MAIN_DATA: 'Dados Principais Inválidos',
    },
    TYPE_ACTION: {
      approved: 'Aprovar',
      informToERP: 'Publicar Decisões',
      TOOLTIP: {
        approved: 'Aprovar Mudanças',
        informToERP: 'Publicar Decisões',
      },
    },
    NOTIFICATIONS: {
      TITLE: 'Notificações',
      NO_NEW_ITEMS: 'Não tem Novas Notificações',
      NO_OLD_ITEMS: 'Nāo tem Notificações sem ler.',
      MARK_AS_READ: 'Marcar como lida',
      MARK_ALL_AS_READ: 'Marcar Todas como lidas',
      VIEW_LAST: 'Ver últimas lidas',
      CLOSE_LAST: 'Fechar notificações lidas',
      NOT_ENABLED: 'As notificações do seu navegador estão desabilitadas.',
      ENABLE_NOTIFICATIONS: 'Você deve ativar as notificações no seu navegador. Clique para mais info.',
      ENABLE_NOTIFICATIONS_TUTORIAL: 'Tutorial de ativação',
      DOWNLOAD: 'Baixar Arquivo',
      TOGO: 'Ir',
    },
    INSIGHTS: {
      TITLE: 'Insights',
      GO_TO_INSIGHTS: 'Ir para a tela de Insights',
    },
    GLOBAL_CONFIG: {
      TITLE: 'Configuração',
      FONT_SIZE: 'Tamanho da fonte',
      SMALL: 'Pequena',
      NORMAL: 'Normal',
      BIG: 'Grande',
      THEME: 'Tema',
      LIGTH: 'Light',
      DARK: 'Dark',
      DATE_FORMAT: 'Formato de data',
      RESET_WARNING: 'Para aplicar as alterações é necessário reiniciar o aplicativo',
    },
    HELPS: {
      PRICE: {
        SOON: 'Em breve',
        FAQS: {
          ROUTE: 'Preços',
          TITLE: 'Perguntas Frequentes',
          QUESTION1:
            'E se eu tiver uma regra de margem e uma regra de concorrência para o mesmo produto e no mesmo ponto de venda? O que o Prisma vai fazer?',
          ANSWER1:
            'Na Prisma, as regras mais específicas sempre terão prioridade sobre as outras. Ou seja, se houver uma regra de margem para a subcategoria Eletrodomésticos em São Paulo, e por sua vez houver uma regra de concorrência para a subcategoria Eletrodomésticos, para um determinado ponto de venda na área de São Paulo, então a regra de concorrência terá prioridade naquele determinado ponto de venda, enquanto os demais pontos de venda em São Paulo serão regidos pela regra de margem.',
          ANSWER1_1:
            'Se houver uma regra de concorrência e uma regra de margem, elas têm o mesmo escopo de produto e ponto de venda. Então, a regra da concorrência sempre terá prioridade. Ou seja, o Prisma tentará se adequar ao posicionamento competitivo e caso isso não seja possível serão geradas sugestões a partir da regra de margem.',
          QUESTION2: 'Como funciona a regra de margem da zona? Em que casos vou usá-lo?',
          QUESTION3: 'Qual é a diferença entre regras de margem ou markup? Qual devo usar?',
          ANSWER3:
            'A margem de lucro e o markup são duas maneiras de encarar a mesma situação: quanto eu quero ganhar. Eles são exatamente os mesmos. A diferença está na forma como são obtidos: o Mark Up é calculado com base no custo, enquanto a Margem de Lucro é calculada sobre o preço de venda.',
          ANSWER3_1:
            'Por exemplo, um produto ou serviço que tem um custo final de R$ 100,00 e para o qual você deseja ganhar um Mark Up de 20%, terá um preço final de R$ 120,00 e uma Margem de Lucro de 16,66%.',
          ANSWER3_2: 'Mark Up = 20 / Custo = 20/100 = 0.2 x 100 = 20%',
          ANSWER3_3: 'Margem de Lucro = 20 / Preço = 20/120 = 0.16 x 100 = 16.16%',
          QUESTION4: 'Que tipo de custo o Prisma usa para calcular a margem?',
          ANSWER4:
            'Na Prisma recomendamos trabalhar com o Custo de Reposição, ou seja, o preço que temos que pagar ao fornecedor para repor uma mercadoria ou matéria-prima. Este custo pode ser diferente do custo contábil.',
          QUESTION5:
            'Se eu tiver o produto "Little Coffee", que é o pai do produto "Medium Coffee" em uma regra configurada para que o produto filho custe 20% a mais que o produto pai. Posso ter outra regra, ao mesmo tempo, em que "Little Coffee" é o pai de "Big Coffee" e o produto filho ("Big Coffee") custa 40% a mais que o pai ("Little Coffee")?',
          ANSWER5:
            'Você pode, Prisma permite que você crie várias regras de parentesco de produto onde você define o mesmo item como pai. Nesse caso, você criará uma regra de parentesco onde o item Little Coffee é o pai do café médio com uma diferença de 20% e a seguir criará outra regra de relacionamento onde o produto Little Coffee é o pai do Big Coffee com uma diferença de 40%.',
          QUESTION6:
            'Criei uma regra em que o produto "A" é filho do produto "B". "A" muda seu preço cada vez que o preço "B" muda. Quero criar outra regra em que o produto "C" também seja pai de "A"? Então, "A" mudará o preço sempre que o preço de "B" ou "C" mudar.',
          ANSWER6:
            'As regras de parentesco do produto não podem compartilhar Filhos. Dessa forma, se você definir que um produto será filho, ele só poderá ter um único pai.',
          QUESTION7: 'Criei regras de parentesco e não vejo as sugestões de preço, como posso gerá-las?',
          ANSWER7:
            'As regras de parentesco não geram sugestões. As únicas regras que geram sugestões de preços são as Regras de Margem e as Regras de concorrência.',
          QUESTION8: 'Criei uma regra de concorrência / margem para um produto e o Prisma não sugere um preço, o que devo fazer?',
          ANSWER8:
            'Se a prisma não gerou sugestões, significa que seus preços estão de acordo com o posicionamento e as diretrizes definidas. Portanto, você não precisa gerar nenhuma sugestão.',
          ANSWER8_1:
            'No caso das regras de concorrência, lembre-se que a Prisma se alimenta dos preços de seus concorrentes. Você deve verificar se atualizou os preços dos concorrentes.',
          QUESTION9:
            'Quando estou criando uma regra de concorrência, existem pontos de venda que não estão listados para seleção no escopo.',
          ANSWER9:
            'Se eles não aparecem listados, é porque você tem pontos de venda mal rotulados ou não contêm os atributos corretos, você pode verificar isso no menu Configuração> Maestros> Pontos de Venda',
          QUESTION10: 'Quando estou criando uma regra de concorrência, existem produtos que não estão listados para seleção no escopo.',
          ANSWER10:
            'Se nem todos os produtos estiverem listados, você deve verificar se eles estão bem categorizados ou têm os atributos corretos, você pode verificar isso no módulo Catálogo de Produtos.',
          QUESTION11: 'Quando estou criando uma regra de margem, há pontos de venda que não estão listados para seleção no escopo.',
          ANSWER11:
            'Se eles não aparecem listados, é porque você tem pontos de venda mal rotulados ou não contêm os atributos corretos, você pode verificar isso no menu Configuração> Maestros> Pontos de Venda',
          QUESTION12: 'Quando estou criando uma regra de margem, existem produtos que não estão listados para seleção no escopo.',
          ANSWER12:
            'Se nem todos os produtos estiverem listados, você deve verificar se eles estão bem categorizados ou têm os atributos corretos, você pode verificar isso no módulo Catálogo de Produtos.',
          QUESTION13: 'Quando estou criando uma regra de margem, existem produtos que não estão listados para seleção no escopo.',
          ANSWER13:
            'Se eles não aparecem listados, é porque você tem pontos de venda mal rotulados ou não contêm os atributos corretos, você pode verificar isso no menu Configuração> Maestros> Pontos de Venda',
          QUESTION14: 'Quando estou criando uma regra de margem, existem produtos que não estão listados para seleção no escopo.',
          ANSWER14:
            'Se nem todos os produtos estiverem listados, você deve verificar se eles estão bem categorizados ou têm os atributos corretos, você pode verificar isso no módulo Catálogo de Produtos.',
        },
      },
    },
    GENERIC_COMP: {
      SCOPE: {
        CLIPBOARD_STORE_TITLE: 'Pegar pontos de venda do clipboard',
        CLIPBOARD_PRODUCT_TITLE: 'Colar produtos desde a área de transferência',
        STRATEGY_ATTR_TITLE: 'Seleção por atributo',
        STRATEGY_ATTR_MSG: 'Os atributos são selecionados para definir o escopo dos produtos',
        STRATEGY_PROD_TITLE: 'Seleção por produto',
        STRATEGY_PROD_MSG: 'Os produtos devem ser selecionados um por um',
        STRATEGY_ATTR_TITLE_STORE: 'Seleção por atributo',
        STRATEGY_ATTR_MSG_STORE: 'Os atributos são selecionados para definir o escopo dos Pontos de Venda',
        STRATEGY_STORE_TITLE_STORE: 'Seleção por pontos de venda',
        STRATEGY_STORE_MSG_STORE: 'Os pontos de venda devem ser selecionados um a um',
        TAG_SELECTOR: 'Selecção de Etiquetas',
        ADVANCED_TAG_SELECTOR: '(Selecção Avançada de Rótulos)',
        ITEM_LIST_WITH_ACTIONS: {
          TABLE: {
            ADD: 'Agregar Forecast',
            NAME: 'Nome',
            CODE: 'Código',
            FORECAST: 'Forecast',
            MODAL: {
              TITLE: 'Atribuir Forecast',
              INPUT: 'Forecast',
            },
            DELETE_FORECAST_TITLE: 'Confirmar exclusão de Forecast',
            DELETE_FORECAST_CONTENT: 'Tem certeza que deseja excluir o forecast de {{val}} {{val2}}?',
          },
        },
      },
      LOOKUP: {
        Search: 'Procurar',
        clearAll: 'Desmarcar todos os itens',
        clear: 'Desmarque o item',
        selectAll: 'Selecionar todos os ítens',
        selectAllPage: 'Selecionar todos os ítens na página atual',
        selectAllChilds: 'Selecionar todos os ítens filhos',
        onlySelected: 'Mostrar só ítens selecionados',
        allItemsSelected: 'Todos os ítens selecionados',
        noneItemsSelected: 'Nenhum íten selecionado',
        selectedItemsLabel: 'Ítens Selecionados ({{val}}):',
        Included: 'Incluso',
        Excluded: 'Excluído',
        includedAll: 'Incluir todos os itens',
        excludedAll: 'Excluir todos os itens',
        includedclearAll: 'Deselecionar todos os itens selecionados',
        excludedclearAll: 'Deselecionar todos os itens exceto',
        itemsNotFound: 'Nenhum resultado encontrado',
        parent_item_active: 'Esse produto é filho em outras regras, não pode ser usado como pai',
        parent_item_message:
          'Um produto pai não pode ser filho em outra regra. São exibidos em cinza os produtos que são filhos em outras regras.',
        parent_store_active: 'Esse ponto de venda é filho em outras regras, não pode ser usado como pai',
        parent_store_message:
          'Ponto de venda pai não pode ser filho em outra regra. São exibidos em cinza os pontos de venda que são filhos em outras regras',
      },
      CAT_SELECT_V2: {
        LEVEL2: 'Unidade de Negócio',
        LEVEL3: 'Departamento',
        LEVEL4: 'Categoria',
        LEVEL5: 'Subcategoria',
      },
      WEEKDAY_COMPONENT_DAYS: {
        '0': 'Dom',
        '1': 'Seg',
        '2': 'Ter',
        '3': 'Qua',
        '4': 'Qui',
        '5': 'Sex',
        '6': 'Sab',
      },
      NESTED_TREE_TABLE: {},
      IMPORTERV2: {
        DEFAULT_TITLE: 'Importador Geral',
        SELECT_TYPE_PLACEHOLDER: 'Selecione um Distribuidor',
        DEFAULT_DESCRIPTION:
          'Nesta tela você poderá importar informações carregando um arquivo. O formato do mesmo pode ser baixado clicando no botão de download do modelo. Uma vez que o arquivo for carregado, receberá instruções sobre como prosseguir.',
        DOWNLOAD_TEMPLATE: 'Baixar Modelo',
        AssortmentMarketData_alternativeDescription:
          'Após o término da importação, é necessário atribuir os novos produtos do mercado a uma categoria do Prismas na próxima tela: <br><b>Varejo > Configuração > Produtos do Mercado</b>',
        TITLES: {
          FERRYES_AND_COMISIONS: 'Fornecedor Frete e Comissões',
          COST_AND_TAXES: 'Custo Importação e Tributos',
          VENDOR_COST: 'Custos do Fornecedor',
          STORE_TAXES: 'Impostos por Pontos de Venda',
          NEW_PRICES: 'Novos Preços',
          COMPETITOR_PRICES: 'Preços dos Concorrentes',
          ITEMS: 'Itens',
          IMPORT_VENDORS: 'Solução de Conflitos de Fornecedores',
          IMPORT_PRICES_TITLE: 'Precos',
          MARKET_INFORMATION: 'Dados do Mercado',
          MARGIN_WITH_VENDOR: 'Margem por Acordos',
          STORE_ASSORTMENT: 'Sortimento por Ponto de Venda',
          STORE_COSTS: 'Custo por Ponto de Venda',
          STORE_PRICES: 'Preços por Loja de Atendimento',
          STORE_PRICE_OUTPUT: 'Pricing Publication',
          COMPETITORS: 'Concorrentes',
          STORE_PRICE_OUTPUT_PREVIEW: 'Precificação - Visualização',
          CustomItems: 'Produtos Regionais',
          REGULATED_PRICES: 'Preços Regulados',
          VENDOR_COSTS: 'Custos do Fornecedor',
          CustomItemsDelete: 'Borro Regional Products',
          CustomItemsUpdatePrice: 'Atualização de Preços de Produtos Regionais',
          CustomItemsUpdateCosts: 'Atualização dos custos de produtos regionais',
          VendorCosts: 'Custos do Fornecedor',
          DailySales: 'Daily Sales',
          AssortmentMarketData: 'Dados do Mercado',
          Categories: 'Categorias',
          Margin2: 'Margem por Acordos',
          MonthlyInventory: 'Mensal Inventory',
          StoreAssortment: 'Variedade de Lojas',
          Stores: 'Lojas',
          MonthlySales: 'Mensalidades de Vendas',
          ItemMatchings: 'Item Equivalências',
          SpacesAvailability: 'Espaços Disponíveis',
          None: 'Nenhuma Seleção',
          CategoriesV2: 'Categorias V2',
          SalesFuture: 'Vendas Projetadas',
          ItemRanking: 'Ranking de Itens para Exibição',
          Contact: 'Contato',
          MaterialTagValue: 'Material promociónal por etiqueta',
          ChargeDefinitionValue: 'Valores possíveis para Custos e Impostos',
          PromotionDeleteStore: 'Excluir loja promocional',
          DeliveryPlaces: 'Locais de Entrega',
        },
        RESPONSE_OK: 'A importação foi enviada à fila de processamento. Para acompanhar o status clique aqui:',
        RESPONSE_OK_TITLE: 'Importação em andamento',
        TYPES: {
          ALL: 'Todos',
          Items: 'Itens',
          RegulatedPrices: 'Preços Regulados',
          PriceRegulated: 'Preços Regulados',
          ActionExceptionalValue: 'Exceções de Preço Fixo',
          ActionExceptionalMixedValue: 'Exceções de Preço Fixo Múltiplos',
          StoreCosts: 'Custo por Ponto de Venda',
          StorePrices: 'Preços por Loja de Atendimento',
          StorePriceOutput: 'Pricing Publication',
          VendorCostsOutput: 'Output de custos por fornecedor',
          StoreCostsOutput: 'Output de custos por pontos de venda',
          CustomItems: 'Produtos Regionais',
          CustomItemsDelete: 'Borro Regional Products',
          CustomItemsUpdatePrice: 'Preços Regionais dos Produtos',
          CustomItemsUpdateCosts: 'Custos de Produtos Regionais',
          StorePriceOutputPreview: 'Precificação - Visualização',
          ItemCodes: 'Códigos de itens',
          UnitsOfMeasures: 'Unidades de Medida',
          ItemUnitOfMeasures: 'Unidades de Medida por Item',
          Competitors: 'Concorrentes',
          CompetitorPrices: 'Preços dos Concorrentes',
          CompetitorsPrices: 'Preços dos Concorrentes',
          SalesTickets: 'Tickets de Vendas',
          Vendors: 'Fornecedores',
          VendorItems: 'Itens por fornecedor',
          DeliveryPlaces: 'Locais de Entrega',
          DailyInventory: 'Inventário Diário',
          DailySales: 'Daily Sales',
          AssortmentOutputPreview: 'Publicação de sortimento - Prévia',
          AssortmentOutput: 'Publicação do Estoque',
          VendorCosts: 'Custos do Fornecedor',
          VENDOR_COSTS: 'Custos do Fornecedor',
          StoreCostOutput: 'Custo de Saída',
          AssortmentMarketData: 'Dados do Mercado',
          Categories: 'Categorias',
          Margin2: 'Margem por Acordos',
          ItemTags: 'Rótulos de Produtos',
          StoreTags: 'Rótulos de Lojas',
          MonthlyInventory: 'Mensal Inventory',
          StoreAssortment: 'Variedade de Lojas',
          Stores: 'Lojas',
          MonthlySales: 'Mensalidades de Vendas',
          None: 'Nenhuma Seleção',
          DailyMissionReport: 'Daily Missões',
          DailyMissionReport_alt: 'Relatório Diário',
          ItemMatchingReport: 'Relatório de Equivalências',
          StoreCompetitorsReport: 'Lojas e Concorrentes',
          ItemMatchings: 'Item Equivalências',
          SpacesAvailability: 'Espaços Disponíveis',
          PlanogramPopMaterialMarketplaces: 'Material Alugado',
          MarketItemToRegister: 'Produtos de Mercado',
          CategoryTree: 'Árvore de Categorias',
          PromiotonPeriod: 'Períodos promocionais',
          PromiotionPeriod: 'Períodos promocionais',
          Promotion: ' Ofertas',
          PromotionPeriod: 'Períodos promocionais',
          CategoriesV2: 'Categorias V2',
          PromotionReport: 'Relatório de Promoções',
          PrintingList: 'Relatório de Impressão',
          LogisticsList: 'Relatório de Logística',
          TagValues: 'Valores de etiqueta',
          BranchesYpfTiendas: 'Planex Filiais',
          DeliveryStoresYpfTienda: 'Planex Locais de entrega',
          ItemsYpfTiendas: 'Planex Itens',
          PlanogramStructure: 'Estrutura de Planograma',
          TakeAPayBPromotion: 'Promoção leve A pague B',
          DiscountPromotion: 'Promoção de desconto',
          FixedPricePromotion: 'Promoção de preço fixo',
          Planogram: 'Planogramas',
          PopMaterial: 'Materiais POP',
          PlanogramPopMaterial: 'Planogramas materiais',
          PlanogramStore: 'Planogramas lojas',
          PromotionReferencePrice: 'Preços de Referência',
          PromotionSpace: 'Espaços',
          PromotionMaterial: 'Materiais',
          PromotionSpaceStore: 'Espaços lojas',
          PromotionSpaceMaterial: 'Espaços materiais',
          PromotionMaterialStore: 'Materiais lojas',
          AxionFuelsBuildupReport: 'Relatório de Acúmulo',
          DynamicEntities: 'Dinâmicas Entidades',
          MassiveReplacement: 'Substituição em massa',
          PlanogramPreGenerationReport: 'Relatório de pré-geração de planogramas',
          SpacePlanogramItems: 'Relatório múltiplo de planogramas',
          SpacePlanogramItemsFlat: 'Relatório múltiplo de planogramas (aba única)',
          PromotionProductionLists: 'Listas de produção de promoções',
          PromotionLog: 'Log de promoções',
          BranchesAndDeliveryYpfTiendas: 'Planex Filiais e Entrega',
          ClientsOutputYpfTiendas: 'Planex Clientes YPF',
          DeliveryStoresYpfTiendas: 'Planex Entregas YPF',
          ClusterizationImplementationMode: 'Clusterização (Modo de implementação)',
          RangeAssortment: 'Surtido por rango',
          StoreClusterReassignment: 'Reatribuição de lojas entre clusters',
          Roles: 'Funções',
          Users: 'Usuários',
          SystemAudit: 'Auditoria de sistema',
          LoginAudit: 'Auditoria de login',
          AxionFuelsOthosAck: 'Confirmação de Preços',
          PricesAck: 'Confirmação de Preços',
          Status: 'Estado',
          Pending: 'Em processo',
          Success: 'Gerado corretamente',
          Failed: 'Com erros ao gerar',
          ReportNotGenerated: 'Relatório não gerado (Sem dados)',
          PricesOutputYpfTiendas: 'Planex Preços',
          PricesByPriceLevelYpfTiendas: 'Preços por nível de preço',
          VendorItemCostsYpfTiendas: 'Artigos por fornecedor e custos',
          ImagesYpfTiendas: 'Planex Imagens',
          CostTaxAudit: 'Auditoria de Custos e Impostos',
          SalesFuture: 'Vendas Projetadas',
          ItemRanking: 'Ranking de Itens para Exibição',
          Contact: 'Contato',
          DynamicEntitiesReport: 'Relatório de Entidades Dinâmicas',
          BuildupReport: 'Relatório de Acúmulo',
          MaterialTagValue: 'Material promociónal por etiqueta',
          ChargeDefinitionValue: 'Valores possíveis para Custos e Impostos',
          PromotionDeleteStore: 'Excluir loja promocional',
        },
        STATUS: {
          Pending: 'Pendente',
          InProgress: 'Em andamento',
          Succeeded: 'Sucesso',
          SucceededWithWarnings: 'Sucesso com avisos',
          Failed: 'Fracassado',
          Cancelled: 'Cancelado',
          NoDataProcessed: 'Nenhum dado processado',
          PendingReconcile: 'Pendente de reconciliação',
          Reconciling: 'Reconciliando',
          ReconcileSorting: 'Reconciliando: ordenando arquivo',
          ReconcileMerging: 'Reconciliando: comparando com snapshot',
          ReconcileImporting: 'Reconciliando: importando para o core',
          ReconcileFailed: 'Reconciliação falhou',
        },
        STATUS_MSG: {
          information: 'Ok',
          warning: 'Avisos',
          error: 'Erro',
        },
        SOURCE: {
          WebApi: 'API Web',
          Sftp: 'SFTP',
          ExternalPull: 'Dados Externos',
        },
      },
      INTERFACES_LOG: {
        DEFAULT_TITLE: 'Registro de Interface',
        LIST_COL_TYPE: 'Entidade',
        ENTITY: 'Entidade',
        LIST_COL_SOURCE: 'Origem',
        LIST_COL_ID: 'Id',
        LIST_COL_CREATED: 'Criado',
        LIST_COL_STARTED: 'Iniciado',
        LIST_COL_FINISHED: 'Finalizado',
        LIST_COL_DURATION: 'Duração',
        LIST_COL_STATUS: 'Estado',
        LIST_COL_USERNAME: 'Criado',
        LIST_COL_ORIGINAL_FILE_NAME: 'Nome do Arquivo',
        MORE_DETAIL: 'Mais detalhes',
        RETRY: 'Tentar Novamente',
        RETRY_PERMISSION: 'No estão disponíveis os permissões necessárias para tentar novamente o processo de interface com falhas.',
        RETRY_OK: 'A interface com falhas está sendo executada novamente.',
        LIST_COL_RECORDS: 'Registros',
        LIST_COL_BATCHES: 'Lote',
        LIST_COL_BATCHES_PROGRESS: 'Progresso',
        LIST_COL_BATCHES_NUM: 'Lote Nº.',
        LIST_COL_MESSAGES: 'Mensagens',
        LIST_COL_LINE: 'Linha',
        LIST_COL_BATCHES_COMPLETED: 'Lote Completo',
        DATE: 'DATA',
        IMPORTER: 'Importador',
        EXPORT_MSG: 'Exportar Mensagens',
        EXPORT_MSG_SHRT: 'Exportar',
        SIMPLE_VIEW: 'Visualização Simples',
        ADVANCED_VIEW: 'Visão Avançada',
      },
    },
    PRICE_RULES: {
      COMPETENCE: {
        POSITION_AGAINST: {
          Minimum: 'Mínimo',
          Average: 'Média',
          Maximum: 'Máximo',
          Mode: 'Moda',
        },
        POSITION_TREND: {
          HighestMode: 'Moda que mais se repete',
          MinimumPrice: 'Preço Mínimo',
          AveragePrice: 'Preço Médio',
          MaximumPrice: 'Preço Máximo',
        },
        RULE_TYPE: {
          Guideline: 'Diretriz',
          Margin: 'Margem',
          Competitive: 'concorrência',
          ParentItem: 'Parentesco de Produtos',
          ParentZone: 'Parentesco de Pontos de Venda',
          ParentCategory: 'Parentesco por Categoria',
          BasePriceList: 'Preço de Lista Base',
        },
      },
    },
    NAV: {
      HOME: {
        TITLE: 'Inicio',
        DASHBOARD: 'Dashboard',
      },
      DASHBOARD: {
        TITLE: 'Dashboard',
      },
      DATA_ENTRY_ADAPTATIONS: {
        TITLE: 'Entrada de Dados',
        TABLE: {
          TYPE: 'Tipo de Entrada',
          ADAPTATION: 'Gestão de Entrada de Dados',
        },
      },
      PRICES: {
        TITLE: 'Preços',
        SETUP: {
          TITLE: 'Configuração',
          PRICEZONES: 'Zonas de Preço',
          COMPETITORS: 'Concorrentes',
          PRICESRULES: 'Regras de Preço',
          BRANDS: 'Bandeiras',
          GUIDELINESANDSTRATEGIES: 'Diretrizes e Estratégias',
          SENSITIVITIES: 'Sensibilidades',
          ROUNDING: 'Regras de Arredondamento',
          STRATEGYANDRULES: 'Estratégias e Regras',
        },
        DECISIONS: {
          TITLE: 'Decisões',
          DECISIONS: 'Decisões',
          INFORM_ERP: 'Publicar Decisões',
          PRICE_ELASTICITY: 'Elasticidade de Preço',
          PRICE_DECISIONS: 'Decisões de Preço',
          DECISIONSSUMMARY: 'Resumo de Decisões',
        },
        REPORTS: {
          TITLE: 'Relatórios',
          PRICE_CHANGES: 'Auditoría de Preço',
          COMPETITIVENESS_INDEX: 'Índice de Competitividade',
          PRICE_REPORTS: 'Relatório de Preços',
          SUGGESTION_REPORTS: 'Relatório de Sugestões',
          COST_REPORTS: 'Relatório de Custos',
          YPF_REPORTS: 'Relatórios Ypf',
          PRICES_MAP: 'Mapa de Preços',
          PRICE_INCONSISTENCY_REPORT: 'Inconsistencias de Preços',
          DAILY_MARGIN: 'Margens diárias',
          COMPETITOR_PRICES: 'Preços de Concorrentes',
        },
        ADMIN: {
          TITLE: 'Administraçāo',
          TAXES: {
            TITLE: 'Impostos',
            CO2: 'Impostos CO2',
            ICL: 'Impostos ICL',
            IIBB: 'Impostos IIBB',
          },
          IMPORTERS: {
            TITLE: 'Importadores',
            IMPORTPARITY: 'Importar Paridade',
            IMPORTFLETESCOMISIONES: 'Fretes e Comisões',
            IMPORTVENDORCOSTS: 'Custos por Fornecedor',
            IMPORTSTORETAXES: 'Impostos por Ponto de Venda',
            IMPORTSTORECOSTS: 'Custos por Ponto de Venda',
            IMPORTNEWPRICES: 'Novos Preços',
            REGULATEDPRICES: 'Preços Regulados',
            COMPETITORSPRICES: 'Preços de Concorrentes',
            IMPORTCOSTSANDTAXES: 'Custos e Impostos',
          },
        },
      },
      ADMIN: {
        TITLE: 'Administraçāo',
        MASTER: {
          TITLE: 'Catálogos',
          STORES: 'Pontos de Venda',
          STORES_V2: 'Pontos de Venda',
          SUPPLIER: 'Fornecedor',
          SUPPLIER_V2: 'Fornecedor ',
          TAG: 'Etiqueta',
          TAGS: 'Etiquetas',
          INSIGHTS: 'Insights',
          EQUIPMENTS: 'Tipos de Equipamentos',
          DYNAMIC_ENTITIES: 'Entidades Dinâmicas',
          COST_AND_TAXES: 'Custos e Impostos',
          COST_AND_TAXES_TAXES_ONLY: 'Impostos',
          GENERAL_IMPORTER: 'Importador Geral',
          INTERFACES_LOG: 'Log de interface',
        },
        SECURITY: {
          TITLE: 'Segurança',
          USERS: 'Usuários',
          ROLES: 'Funções',
          REPORTS: 'Reportes',
        },
      },
      MYSTERYSHOPPER: {
        TITLE: 'Mystery Shopper',
        MISSIONS: {
          TITLE: 'Misões',
        },
        USER_ASSIGNMENT: {
          TITLE: 'Atribuição de Usuários',
        },
      },
      ITEMMASTER: {
        TITLE: 'Catálogo de Produtos',
      },
      AICHAT: {
        TITLE: 'Ask Prisma',
      },
      AIDASHBOARD: {
        TITLE: 'AI Dashboard',
      },
      ASSORTMENT: {
        TITLE: 'Sortimentos',
        SETUP: {
          TITLE: 'Configuração',
          CLUSTERING: 'Segmentaçāo',
          CATEGORY_SETUP: 'Configurações de categoria',
          TREEOFCATEGORYS: 'Árvore da Categoria',
          ROLES: 'Papéis',
          STRATEGIES: 'Estratégias',
          SEGMENTASSIGNMENTS: 'Designar Segmentos',
          ROLESANDSTRATEGIESASSIGNMENT: 'Categorias Configurações',
          MARKET_INFORMATION: 'Produtos do Mercado',
          RULES: 'Regras',
        },
        DECISIONS: {
          TITLE: 'Decisões',
          ASSORTMENTASIGNATION: 'Decisões de Sortimento',
          INFORM_ERP: 'Publicar Decisões',
          SHOW_COLUMNS_TITLE: 'Selecionar Colunas',
          DINAMIC_COLUMNS_TITLE_ORDER: 'Ordenar',
          DINAMIC_COLUMNS_SUB_TITLE_ORDER: 'Selecionar a ordem dentro de cada grupo de colunas',
          MAX_COLUMNS_SELECTED: 'Máximo de colunas selecionadas ({{val}})',
          MAX_COLUMNS_EXCEED: 'Cantidad máxima superada, os foram selecionados os primeiros {{val}} resultados.',
          WITHOUT_CLUSTERS_FOR_LEVEL: 'Sem grupos atribuídos a esse nível de categoria',
          DINAMIC_COLUMNS_BTN_CANCEL: 'Cancelar',
          DINAMIC_COLUMNS_BTN_APPLY: 'Aplicar',
          DINAMIC_COLUMNS_TITLE: 'Colunas',
          DINAMIC_COLUMNS_SUB_TITLE: 'Selecionar as colunas que você quer ver na tabela',
          TAGS_IN_USE: 'Sólo é possível gerenciar rótulos que estejam aplicados aos produtos deste cluster',
          DINAMIC_COLUMNS_GROUP: {
            defaultHeader: 'Geral',
            productHeader: 'Dados do Produto',
            ticketsHeader: 'Tickets',
            performanceHeader: 'Performance',
            stocksHeader: 'Estoque',
            exhibitionHeader: 'Exhibição',
            marketHeader: 'Mercado',
            paretoHeader: 'Pareto',
            clasificationHeader: 'Classificação',
            TGENERAL: 'Total Geral',
            TGENERAL_RECALC: 'Pareto ReCalculado',
          },
          DINAMIC_COLUMNS: {
            itemCode: 'Código',
            itemName: 'Produto',
            isNew: 'Novo',
            status: 'Estatus',
            segmento: 'Segmento',
            tag: 'Etiqueta',
            itemBrand: 'Marca',
            vendorName: 'Fornecedor',
            itemManufacturer: 'Fornecedor',
            pareto: 'Pareto',
            sales: 'Venda R$',
            salesShare: 'Participação em Venda %',
            salesRanking: 'Vendas R$ Ranking',
            soldUnits: 'Vendas UN',
            soldUnitsShared: '% Vendas UN',
            soldUnitsRanked: 'Vendas UN Rank',
            margin: 'Margem R$',
            marginPercentage: 'Margem %',
            marginWithVendor: 'Margem com Fornecedor',
            presence: 'Apresença',
            discounts: 'Descontos R$',
            price: 'Preço',
            tickets: 'Tickets',
            ticketsTotal: 'Total Tickets',
            ticketsShare: 'Tickets %',
            stockCost: 'Estoque R$',
            stockCostShare: '% Estoque R$',
            stockCostCurrent: 'Estoque Atual R$',
            stockUnits: 'Estoque UN',
            stockUnitsShare: '% Estoque UN',
            stockUnitsCurrent: 'Estoque UN Atual',
            wasteUnits: 'Perda UN',
            availability: 'Disponibilidade',
            outOfStock: 'Ruptura',
            daysInStock: 'Días de Estoque',
            daysInStockCurrent: 'Días de Estoque Atual',
            gmroi: 'GMROI',
            planograms: 'Planogramas',
            popMaterial: 'Material POP',
            facings: 'Frentes',
            linearSpace: 'Espaço Lineal (mt)',
            gmros: 'GMROS',
            marketSales: 'Vendas Mercado R$',
            marketUnits: 'Vendas Mercado UN',
            marketPrice: 'Preço do Mercado',
            marketSalesShare: '% Participação de Mercado R$',
            marketSalesRanking: 'Ranking de Vendas do Mercado',
            marketUnitsShare: '% Vendas Mercado UN',
            marketUnitsRanking: 'Ranking de Unidades do Mercado',
            salesShareGap: 'GAP de Vendas',
            unitsShareGap: 'GAP de Unidades',
            weightedIndex: 'IP %',
            weightedIndexPareto: 'Pareto',
            IP: 'IP %',
            UN: 'UN',
            suggestionRoleName: 'Sugestão de nome',
            suggestionRoleAction: 'Descrição Sugestão',
          },
        },
        REPORTS: {
          TITLE: 'Relatórios',
          CLUSTERANALYSIS: 'Analise de Cluster',
          REPORT_DECISIONS: 'Relatórios de Decisões',
        },
        ADMINISTRATION: {
          TITLE: 'Administraçāo',
          IMPORTERS: {
            TITLE: 'Importadores',
            MARKET_INFORMATION: 'Informação do Mercado',
            MARGIN_WITH_VENDOR: 'Margem por Acordos',
          },
        },
      },
      ASSORTMENTV2: {
        TITLE: 'Sortimentos v2',
        SETUP: {
          TITLE: 'Configuração',
          GUIDELINES: 'Lineamentos',
          EDIT_GUIDELINES: 'Editar Lineamentos',
          CONFIGURE_GUIDELINES: 'Configurar Lineamentos',
          DELETE_CONFIRM_TITLE: 'Confirmar exclusão',
          DELETE_CONFIRM_MESSAGE: 'Deseja excluir a configuração da categoria "{{val}}"?',
          GENERAL_CONFIG_WARNING_FULL_MESSAGE: 'A Configuração Geral deve ser configurada',
          GENERAL_CONFIG_DIALOG_TITLE: 'Configuração Geral',
          GENERAL_CONFIG_TAB_MAIN_DATA: 'Dados principais',
          GENERAL_CONFIG_TAB_ALERTS_VALIDATIONS: 'Alertas e validações',
          GENERAL_CONFIG_TAB_MAIN_DATA_PLACEHOLDER: 'Conteúdo de dados principais - A ser implementado',
          GENERAL_CONFIG_TAB_ALERTS_VALIDATIONS_PLACEHOLDER: 'Conteúdo de alertas e validações - A ser implementado',
          ALERTS_VALIDATIONS: {
            DESCRIPTION: 'Alertas e Validações para garantir que as sugestões atendam às condições do seu negócio.',
          },
          VALIDATION_MODAL: {
            CREATE_TITLE: 'Configurar nova validação',
            EDIT_TITLE: 'Editar validação',
            STEP1_LABEL: 'Critério',
            STEP2_LABEL: 'Ação',
            RANGE_TITLE: 'Intervalo de variação',
            RANGE_SUBTITLE: 'Selecione Variável, Condição e Valor numérico para o critério selecionado',
            FIELD_VARIABLE: 'Variável',
            FIELD_CONDITION: 'Condição',
            FIELD_NUMERIC_VALUE: 'Valor',
            ACTION_VALIDATE: 'Validar',
            ACTION_VALIDATE_DESCRIPTION: 'Força a validação dentro do intervalo configurado',
            BANNER_IF_IN_SUGGESTION: 'Se na sugestão de',
            LEVEL_ALTA: 'Alta',
            LEVEL_BAJA: 'Baixa',
            BANNER_THEN_SYSTEM: 'então o sistema deverá',
            BANNER_SUGGESTED_PRICE: 'a sugestão',
            PLACEHOLDER_LEVEL: 'Alta/Baixa',
            PLACEHOLDER_VARIABLE: 'Variável',
            PLACEHOLDER_COMPARATOR: 'Comparador',
            PLACEHOLDER_VALUE: 'Valor',
            PLACEHOLDER_SYSTEM_ACTION: 'Ação do sistema',
            VARIABLE_OUTOFSTOCK: '% Ruptura de estoque',
            VARIABLE_PRESENCE: '% Presença',
            VARIABLE_COVERAGE: '% Cobertura',
            VARIABLE_GMROI: 'GMROI',
            VARIABLE_GMROS: 'GMROS',
            ERROR_MAX_PERCENTAGE: 'O valor máximo para variáveis percentuais é 100',
          },
          NEW_PRODUCTS: {
            TITLE: 'PRODUTOS NOVOS:',
            DESCRIPTION: 'São aqueles produtos que têm menos de 30 dias desde sua data de registro',
            INTRO: 'Configure por quantos dias um produto é considerado novo e a partir de qual evento a contagem começa.',
            DAYS_LABEL: 'Dias',
            DAYS_DESCRIPTION: 'considerado novo desde sua',
            DAYS_HINT_TEMPLATE: 'Por {{val}} dias desde sua {{val2}}.',
            EVENT_SELECTOR_TITLE: 'A partir de qual evento os dias são contados?',
            EVENT_SELECTOR_HELP: 'Escolha a referência que inicia a contagem.',
            SUMMARY_TITLE: 'Resumo',
            SUMMARY_TEMPLATE: 'Será considerado novo por {{val}} dias desde sua {{val2}}.',
          },
          NEW_PRODUCT_EVENT: {
            FIRST_ITEM_CREATION: 'Data de registro',
            FIRST_ITEM_CREATION_DESC: 'Um produto é considerado novo desde sua data de criação',
            FIRST_STOCK_RECORD: 'Primeiro registro de estoque',
            FIRST_STOCK_RECORD_DESC: 'Um produto é considerado novo desde seu primeiro registro de estoque',
            FIRST_SALES_RECORD: 'Primeiro registro de venda',
            FIRST_SALES_RECORD_DESC: 'Um produto é considerado novo desde seu primeiro registro de venda',
          },
          TYPOLOGIES: {
            TITLE: 'TIPOLOGIAS (cortes de Pareto):',
            DESCRIPTION: '',
            PLACEHOLDER: 'Conteúdo de tipologias - A ser implementado',
          },
          ANALYSIS_PERIOD: {
            TITLE: 'Período de Análise',
            DESCRIPTION:
              'Neste passo você pode definir o período em meses que será considerado para realizar a análise. Para normalizar e poder comparar, você sempre verá valores médios expressos em 30 dias em relatórios e pareto.',
            LATEST_INPUT: 'Últimos',
            LATEST_MONTHS_INPUT: 'Últimos meses',
            MONTHS: 'Meses',
            MONTHS_VALIDATION: 'O número de meses não pode ser maior que os meses selecionados',
            MONTHS_SELECTOR_TITLE: 'Meses a considerar',
            MONTHS_SELECTOR_HELP: 'Escolha quais meses são incluídos na média.',
            SELECTED_COUNT: 'Selecionados: {{val}} de {{val2}}',
            SUMMARY_TITLE: 'Resumo',
            SUMMARY_EMPTY: 'Defina o período para ver o resumo.',
            SUMMARY_TEMPLATE: 'Serão analisados os últimos {{val}} meses. Meses incluídos: {{val2}}.',
            NO_MONTHS_SELECTED: 'Nenhum',
            MONTH_COUNT_SINGULAR: '{{val}} mês',
            MONTH_COUNT_PLURAL: '{{val}} meses',
            LEGEND:
              'Se você excluir um mês da lista, ele não será considerado como parte da média. Se a quantidade de meses selecionados for menor que o período selecionado, a média será calculada com a quantidade de meses disponíveis.',
            JANUARY: 'JAN',
            FEBRUARY: 'FEV',
            MARCH: 'MAR',
            APRIL: 'ABR',
            MAY: 'MAI',
            JUNE: 'JUN',
            JULY: 'JUL',
            AUGUST: 'AGO',
            SEPTEMBER: 'SET',
            OCTOBER: 'OUT',
            NOVEMBER: 'NOV',
            DECEMBER: 'DEZ',
          },
        },
        DECISIONS: {
          TITLE: 'Decisões',
          ASSORTMENT_DECISIONS: 'Resumo de sortimento',
          DECISIONS_SUMMARY: 'Detalhe do sortimento',
          SUGGESTIONS_SUMMARY_NAME: 'Resumo de Sugerencias',
          PUBLISH_DECISIONS: {},
          SUGGESTIONS_SUMMARY: {
            PAGE_TITLE: 'Sugestões de sortimento',
            TABS: {
              PENDING: 'PENDENTES DE APROVAÇÃO',
              HISTORY: 'HISTÓRICO',
            },
            KPI: {
              PENDING_TOTAL: 'Total de sugestões pendentes',
              NEW_SUGGESTIONS: 'Novas sugestões',
              NEXT_TO_EXPIRE: 'Próximas a vencer',
              EXPIRES_TODAY: 'Vencem hoje',
              APPROVERS: 'Aprovadores',
              CATEGORIES_COUNT: 'Quantidade de categorias',
              EXPIRED_YESTERDAY: 'Vencidas ontem',
              BADGE_ALTAS_BAJAS: 'Altas e baixas',
              TODAY: 'hoje',
              THIS_WEEK: 'esta semana',
              CATEGORIES: 'Categorias',
            },
            EMPTY: {
              PENDING_TITLE: 'Não há sugestões para revisar',
              HISTORY_TITLE: 'Nenhuma sugestão foi revisada',
            },
            HISTORY_TABLE: {
              DECISIONS_COUNT: '{{count}} decisões',
              STORES_COUNT: '{{count}} lojas',
              NO_DATA: 'Não foram encontradas decisões para os filtros aplicados',
              COLUMNS: {
                CATEGORY: 'Categoria',
                IMPACTED_STORES: 'Lojas impactadas',
                TYPE: 'Tipo',
                USER: 'Usuário',
                DATE: 'Data',
                STATUS: 'Estado',
              },
              STATUS_FILTER: {
                ALL: 'Todos os estados',
                APPROVED: 'Aprovada',
                REJECTED: 'Rejeitada',
                EXPIRED: 'Vencida',
                PUBLISH_REJECTED: 'Misto por loja',
              },
              DATE_FILTER: {
                FROM: 'Data desde',
                TO: 'Data até',
              },
              STATUS: {
                APPROVED: 'Aprovada',
                REJECTED: 'Rejeitada',
                EXPIRED: 'Vencida',
                PUBLISH_REJECTED: 'Misto por loja',
              },
              TYPE: {
                ALTA: 'Alta',
                BAJA: 'Baixa',
                AMBAS: 'Ambas',
                ALTA_WITH_ALERT: 'Alta com alerta',
                BAJA_WITH_ALERT: 'Baixa com alerta',
                AMBAS_WITH_ALERT: 'Ambas com alerta',
              },
            },
            PENDING_TABLE: {
              SUGGESTIONS_COUNT: '{{count}} sugestões',
              STORES_COUNT: '{{count}} lojas',
              EDIT_STORES: 'Editar lojas',
              NO_DATA_FOR_SEARCH: 'Não foram encontradas sugestões para "{{search}}"',
              BULK: {
                SELECTED_LABEL: 'lojas selecionadas',
                WARNING_TITLE: 'Existem sugestões com alerta',
                WARNING_MESSAGE:
                  'Somente os vínculos item-loja sem alerta serão aprovados. Os que tiverem alerta serão agrupados em uma nova sugestão',
                CONFIRM_WITHOUT_ALERTS: 'APROVAR SEM ALERTAS',
                REJECT_ALL: 'REJEITAR TODAS',
                APPROVE_ALL: 'APROVAR TODAS',
                APPROVE_ALL_NO_ALERT: 'APROVAR TODAS SEM ALERTA',
              },
              COLUMNS: {
                CATEGORY: 'Categoria',
                STORES_TO_IMPACT: 'Lojas a impactar',
                TYPE: 'Tipo',
                USER: 'Usuário',
                VALIDITY: 'Validade',
                ACTION: 'Ação',
              },
              TYPE: {
                ALTA: 'Alta',
                BAJA: 'Baixa',
                AMBAS: 'Ambas',
                ALTA_WITH_ALERT: 'Alta com alerta',
                BAJA_WITH_ALERT: 'Baixa com alerta',
                AMBAS_WITH_ALERT: 'Ambas com alerta',
              },
              STATUS: {
                APPROVED: 'APROVADA',
                REJECTED: 'REJEITADA',
              },
              VALIDITY: {
                MINUTES: '{{val}} min',
                HOURS: '{{val}} h',
                DAYS: '{{val}} dias',
              },
            },
            STORE_EDITOR_MODAL: {
              TITLE: 'Detalhes da sugestão',
              PRODUCT_FALLBACK: 'Nome do produto',
              STORES_TOTAL: '{{count}} Lojas',
              STORES_WITHOUT_ALERT: '{{count}} Sem Alerta',
              STORES_WITH_ALERT: '{{count}} com Alerta',
              SEARCH: 'Buscar...',
              FILTER_ALL: 'Todas as sugestões',
              FILTER_NORMAL: 'Baixa',
              FILTER_ALERT: 'Baixa com alerta',
              FILTER_NORMAL_ADD: 'Alta',
              FILTER_ALERT_ADD: 'Alta com alerta',
              SELECTED_COUNT: '{{selected}} / {{total}} selecionadas',
              COL_STORE_ID: 'Id. loja',
              COL_STORE_NAME: 'Nome da loja',
              COL_SUGGESTION: 'Sugestão',
              COL_NOTES: 'Notas',
              COL_APPLY: 'Aplicar',
              COL_STATUS: 'Estado',
              SUGGESTION_NORMAL: 'Baixa',
              SUGGESTION_ALERT: 'Baixa com Alerta',
              SUGGESTION_ADD: 'Alta',
              SUGGESTION_ADD_ALERT: 'Alta com Alerta',
              SUGGESTION_BOTH: 'Ambas',
              SUGGESTION_BOTH_ALERT: 'Ambas com Alerta',
              NOTE_BREAK_PCT: '% de Ruptura',
              NOTE_NONE: '-',
              EMPTY_FILTER: 'Não há lojas para o filtro informado.',
              REJECT: 'REJEITAR',
              APPROVE: 'APROVAR',
              CLOSE: 'FECHAR',
              VIEW_DETAIL: 'Ver detalhe',
              TAB_SUGGESTIONS: 'Sugestões',
              TAB_PROCESS: 'Processo',
              COL_STORES_COUNT: 'Lojas',
              COL_STEPS: 'Passos',
              EMPTY_PROCESS: 'Sem passos disponíveis',
            },
          },
          PAGE_TITLE: 'Analise o sortimento',
          SUMMARY_PAGE_TITLE: 'Detalhe do sortimento',
          FILTERS: {
            TITLE: 'Filtros',
            GROUP_DECISIONS: 'Decisões',
            GROUP_SETUP: 'Configuração',
            GROUP_PRODUCTS: 'Produtos',
            DEPARTMENT: 'Departamento',
            CATEGORY: 'Categoria',
            SUBCATEGORY: 'Subcategoria',
            STATE: 'Estado',
            ACTION_TYPE: 'Situação',
            RULE_TYPE: 'Tipo de regra',
            ITEM_TYPE: 'Tipo de produto',
            SEARCH: 'Busca',
            SEARCH_PLACEHOLDER: 'Buscar...',
          },
        },
      },
      PROMOTIONS: {
        TITLE: 'Promoções',
        CAMPAIGN: {
          TITLE: 'Campanhas',
        },
        ACTIONS: {
          TITLE: 'Ações',
        },
      },
      PROMOTIONSV2: {
        TITLE: 'Promoções',
        CONFIGURATIONS: {
          TITLE: 'Configuração',
          RULES: {
            TITLE: 'Regras de Promoções',
          },
          REFERENCE_PRICES: {
            TITLE: 'Preços de Referência',
          },
          PROMOTIONAL_PROCESS: {
            TITLE: 'Processos Promocionais',
          },
          MESSAGE_STRUCTURES: {
            TITLE: 'Estruturas de Mensagens',
          },
        },
        CAMPAIGN: {
          TITLE: 'Campanhas ',
        },
        CALENDAR: {
          TITLE: 'Calendario',
        },
        PERIODS: {
          TITLE: 'Períodos Promocionais',
        },
        PROMOTIONAL_PERIOD: {
          TITLE: 'Períodos Promocionais',
        },
        ACTIONS: {
          TITLE: 'Ações',
        },
        PRODUCTIONLIST: {
          TITLE: 'Lista de Produção',
        },
        PRODUCTION_REPORTS: {
          TITLE: 'Relatórios operacionais',
        },
        PROMOTION_OUTPUT: {
          TITLE: 'Output de promoções',
        },
        LOGISTICS_REPORT: {
          TITLE: 'Relatório Logístico',
        },
        AVAILABLE_SPACES: {
          TITLE: 'Material promocional',
        },
        PROMOTION_REPORT: {
          TITLE: 'Relatório de Promoções',
        },
        PROMOTION_PRODUCTION_LISTS: {
          TITLE: 'Listas de Produção de Promoções',
        },
        MARKETPLACE: {
          TITLE: 'Mercado de Produtos',
        },
        REPORTS: {
          TITLE: 'Relatórios',
        },
      },
      SPACES: {
        REPLACE: {
          TITLE: 'Substituições',
          NEW_BTN: 'Substituir',
          LIST_TITLE: 'Últimas substituições realizadas',
        },
        REPORTS_TITLE: 'Relatórios',
        DECISIONS_TITLE: 'Decisões',
        ADMIN_TITLE: 'Administração',
        MATERIAL_PROM_TITLE: 'Material promocional',
        CONFIG_TITLE: 'Configuração',
        INCONSISTENCIES: {
          TITLE: 'Inconsistências',
        },
        FLOORPLANS: {
          TITLE: 'Floor Plans',
        },
        SPACES_TEMPLATES: {
          TITLE: 'Templates',
        },
        TITLE: 'Espaços',
        TITLEV2: 'Espaços',
        PLANOGRAMS: {
          TITLE: 'Planogramas',
        },
        STRUCTURE: {
          TITLE: 'Estruturas',
        },
        GENERIC_SPACE: {
          TITLE: 'Espaço Genérico',
        },
        SUPER_PLANOS: {
          TITLE: 'Multi-Planogramas',
        },
        POPMATERIAL: {
          TITLE: 'Material POP',
        },
      },
      REPORTS: {
        TITLE: 'Relatórios',
        LIST: {
          TITLE: 'Hub de Relatórios',
        },
      },
      SUPPLY: {
        TITLE: 'Abastecimento Inteligente',
        SETUP: {
          TITLE: 'Configuração',
          ORDER_SCHEDULE: 'Programação de pedido',
          GENERAL: 'Geral',
          HOLIDAYS: 'Feriados',
          CAPACITIES: 'Capacidades',
        },
        DECISIONS: {
          TITLE: 'Decisões',
          ORDER_CONTROL: 'Controle de Pedidos',
        },
        ADMINISTRATION: {
          TITLE: 'Administraçāo',
          IMPORTERS: 'Importadores',
        },
      },
    },
    TEST_COMPONENT: {
      TEST_A: 'Frase de teste A',
      TEST_B: 'Frase de teste B',
      ANIDADA: {
        TEST_C: 'Frase de teste C',
      },
      TEST_D: 'Esta frase tem {{val}} valor.',
      TEST_E: 'Esta frase {{val}} valores, não {{val2}} nem {{val3}}',
      TEST_F: 'Esta outra frase tem {{val}} valor.',
      TEST_G: 'Esta frase tem {{val}}, {{val2}} o {{val3}} valores.',
      TEST_H: 'Frase con {{val}} anidadoes',
      TEST_HB: 'VALORES MULTIPLES',
      TEST_I: 'Esta frase tiene {{val}} {{val2}}',
      TEST_I_sinfular: 'valor',
      TEST_I_plural: 'valores',
      TEST_J_ENUM: {
        '1': 'Designado',
        '2': 'Não Designado',
      },
    },
    DATA_ENTRY_ADAPTATIONS: {
      TITLE: 'Administração de Entrada de Dados',
      NEW_ITEM_BTN: 'Nova Entrada de Dados',
      TABLE: {
        TYPE: 'Tipo de Entrada',
        NAME: 'Nome',
      },
      EDIT: {
        TRANSFORMATION_TYPES: {
          Constant: 'Constante',
          Negative: 'Negativo',
          ToPercentage: 'A Porcentagem',
          Trim: 'Recortar',
          TrimStart: 'Recortar Início',
          TrimEnd: 'Recortar Fim',
          ToBoolean: 'A Booleano',
          ConcatHeadersValues: 'Concatenar Valores',
          SubString: 'Subcadeia',
          PadLeft: 'Preenchimento à Esquerda',
          PadRight: 'Preenchimento à Direita',
        },
        UPLOADED_FILE: 'Arquivo Carregado',
        STANDARD_LOAD: 'Carga Padrão',
        ONLY_FIRST_FIVE: 'Apenas os primeiros 5 registros são mostrados',
        CONFIGURE_TRANSFORMATION: 'Configurar Transformação',
        SOURCE_COLUMN: 'Coluna de Origem',
        TARGET_COLUMN: 'Coluna de Destino',
        TRANSFORMATION: 'Transformação',
        ADD_TRANSFORMATION: 'Adicionar Transformação',
        VALUE: 'Valor',
        CHARACTER: 'Caracter',
        TOTAL_WIDTH: 'Largura Total',
        PADDING_CHAR: 'Caracter de Preenchimento',
        INDEX: 'Índice',
        LENGTH: 'Comprimento',
        VALUE_FOR_TRUE: 'Valor para Verdadeiro',
        TYPE_ENTRY: 'Tipo de Entrada',
        NAME_INPUT: 'Nome',
        TAB1: 'Dados Gerais',
        NEW_DATA_ENTRY: 'Nova Entrada de Dados',
        NO_MAPPING_SUGGESTION: 'Não há uma sugestão de coluna de origem para a coluna destino',
      },
      COMP: {
        FILE_UPLOAD: {
          TITLE: 'Arraste o arquivo aqui ou clique para selecionar',
          SIZE_ERROR: 'O arquivo excede o tamanho máximo permitido',
          TYPE_ERROR: 'Tipo de arquivo não permitido',
          ALL_FILES: 'Todos os arquivos',
          ACCEPTED_TYPES: 'Tipos de arquivo aceitos: {{fileTypes}}',
        },
      },
    },
    HOME: {
      ROUTE: 'Inicio',
      TITLE: 'Bem-vindo',
      PRICING_MODULE: 'Preços',
      ASSORTMENT_MODULE: 'Sortimentos',
      SMART_SUPPLY_MODULE: 'Abastecimento Inteligente',
      PROMOTIONS_MODULE: 'Promoções',
      ITEM_MASTER_MODULE: 'Catálogo de Produtos',
      SPACE_MODULE: 'Espaços',
      QUICK_ACCESS: 'Acesso Rápido',
      PRICING_MODULE_RULES: 'Preços - Regras de Preço',
      PRICING_MODULE_DESICIONS: 'Preços - Decisões de Preço',
      ASSORTMENT_MODULE_ROL: 'Sortimento - Papéis',
      ASSORTMENT_MODULE_STRATEGIES: 'Sortimento - Estratégias',
      ASSORTMENT_MODULE_DECISIONS: 'Sortimento - Decisões de Sortimento',
      ITEM_MASTER_MODULE_ABM: 'Catálogo de Produtos. - ABM',
      HELPS: 'Ajuda',
      HELP_1: 'Como criar uma regra de Margem?',
      ARTICLE_BLOG_TITLE: 'Percepções de preço, escolhas do consumidor e o efeito compromisso',
      ARTICLE_BLOG_TITLE2: 'Como extrair o máximo valor de seus dados de varejo',
      READ_MORE_BTN: 'Ler mais',
      PRISMA_PRICES: 'Prisma Preços',
      COMPETITORS_PRICES: 'Preços dos Concorrentes',
      ARTICLE2_BLOG_TITLE: 'Cestas de Alimentos: pronto para comprar com um único clique',
      ARTICLE3_BLOG_TITLE: 'A sua estratégia de preços não está funcionando? Estas podem ser as 4 razões.',
      PRISMA_SPACES: 'Prisma Espaços',
      PRISMA_SPACES_SUB: 'Para varejistas que desejam tornar seus planogramas mais lucrativos',
    },
    PR: {
      STP: {
        COMP: {
          LIST: {
            TITLE: 'Concorrentes',
            DELETE_TTIP: 'Apagar concorrentes selecionados',
            DELETE: 'Apagar',
            FILTER_TTIP: 'Filtrar',
            VIEW_TTIP: 'Vista',
            VIEW_TABLE: 'Apenas tabelas',
            VIEW_MAP: 'Apenas mapas',
            VIEW_TABLE_MAP: 'Mapa e Tabela',
            NAME: 'Nome',
            CODE: 'Código',
            BRAND: 'Bandeira',
            MARKER: 'Marcador',
            EDIT_ROW: 'Editar',
            EDIT_ROW_DISABLED_TOOLTIP: 'Editar Competidores Selecionados',
            DELETE_ROW: 'Apagar',
          },
          ROUTE: 'Preços / Configuração',
          TITLE: 'Concorrentes',
          NEW_COMP_BTN: 'Novo Concorrente',
          IMPORT_BTN: 'Importar',
          IMPORT_OP1_314: 'Preços da 314',
          IMPORT_OP2_COMP: 'Preços dos Concorrentes',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          VIEW_TTIP: 'Vista',
          VIEW_TABLE: 'Apenas tabelas',
          VIEW_MAP: 'Apenas mapas',
          VIEW_TABLE_MAP: 'Mapa e Tabela',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar concorrentes selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          CODE: 'Código',
          BRAND: 'Bandeira',
          MARKER: 'Marcador',
          TYPE: 'Tipo',
          CHANNEL: 'Canal',
          PROVINCE: 'Estado',
          LOCATION: 'Localidade',
          PRICEZONE1: 'Zona de Preço 1',
          PRICEZONE2: 'Zona de Preço 2',
          PRICEZONE3: 'Zona de Preço 3',
          NEW: 'Novo',
          INCOMPLETES: 'Incompletos',
          TITLE_FILTERS: 'Filtros',
          MARKER_FILTER: 'Marcador',
          OP1_ALL: 'Todos',
          OP2_MARKER: 'Marcador',
          OP3_NO_MARKER: 'Sem Marcador',
          BRAND_FILTER: 'Bandeira',
          OPERATION_TYPE_FILTER: 'Tipo de Operação',
          PROVINCES_FILTER: 'Estado',
          LOCATION_FILTER: 'Localidade',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          ADD_FILTER_BTN: 'Adicionar filtro',
          SEARCH_FILTERS: 'Buscar filtros',
          MODAL_314: 'Os 314 dados foram importados corretamente',
          TITLE_FORM: 'Novo Concorrente',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Informação Básica',
          CODE_INPUT: 'Código Interno',
          EXTERNALCODE_INPUT: 'Código Externo',
          VALIDATION_CODE: 'O campo deve ser maior que 0',
          NAME_INPUT: 'Nome',
          BRAND_INPUT: 'Bandeira',
          MARKER_CHECK: 'Marcador',
          MARKER_CHECK_TTP: 'Definir concorrente como marcador',
          ADRESS_INPUT: 'Endereço',
          MAP_DATA: 'Dados Mapa',
          LATITUDE_INPUT: 'Latitude',
          VALIDATION_LATITUDE1: 'Latitude deve ser menor ou igual a 90',
          VALIDATION_LATITUDE2: 'Latitude deve ser maior ou igual a -90',
          LONGITUDE_INPUT: 'Longitude',
          VALIDATION_LONGITUDE1: 'Longitude deve ser menor ou igual a 180',
          VALIDATION_LONGITUDE2: 'Longitude deve ser maior ou igual a -180',
          CLASIFICATION_TAB: 'Classificasão',
          Nuevo: 'Novo',
          Incompleto: 'Incompleto',
        },
        SENSITIVITIES: {
          NEW_SENSITIVITIE: 'Nova sensibilidade',
          SENSITIVITIE: 'Sensibilidade',
          NAME: 'Nome',
          COD: 'Código',
          SURVEYFREQUENCY: 'Frequência da pesquisa',
          EXPIRATIONDAYS: 'Data de Validade',
          VALIDITYINDAYS: 'Días de Validade',
          VALIDATION_1: 'O campo deve ser maior que 0',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Dados Principais',
          DAYSTORELIEVE: 'Dia de Levantamento',
          _weekday: {
            Monday: 'Seg',
            Tuesday: 'Ter',
            Wednesday: 'Qua',
            Thursday: 'Qui',
            Friday: 'Sex',
            Saturday: 'Sab',
            Sunday: 'Dom',
          },
          _frecuency: {
            Daily: 'Diário',
            Weekly: 'Semanal',
            Biweekly: 'Quinzenal',
            Monthly: 'Mensal',
            Biannual: 'Semestral',
            Annual: 'Anual',
            BiMonthly: 'Bimestral',
            ThreeMonth: 'Trimestral',
            Never: 'Nunca',
          },
        },
        ROUND: {
          ROUTE: 'Preços / Configuração',
          TITLE: 'Regras de Arredondamento',
          NEW_ROUNDING_BTN: 'Nova Regra de Arredondamento',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar arredondamentos selecionados',
          DELETE: 'Apagar',
          PRICE_TYPE: 'Tipo de Preço',
          SINCE: 'Desde',
          TO: 'Para',
          DIRECTION: 'Endereço',
          TO_TOP_OP1: 'Para Cima',
          NEAREST_OP2: 'Mais Perto',
          DOWN: 'Para Baixo',
          ROUNDING_TYPE: 'Tipo de Arredondamento',
          WITHOUT_TERMINATIONS: 'Sem Terminações',
          TOLERANCE: 'Tolerância %',
          SKUS: '# Produtos',
          SKUS_TO_EXCLUDE: '# Produtos a Excluir',
          USERS: '# Usuários',
          DEFINE_ROUNDING_STP1: 'Definir Arredondamento',
          PRODUCT_SCOPE_STP2: 'Escopo Produtos',
          STORE_SCOPE_STP3: 'Escopo Ponto de Venda',
          STP1: 'Passo 1 - Definir Arredondamento',
          TITLE_FORM_NEW: 'Novo Arredondamento',
          TITLE_FORM_EDIT: 'Editar Arredondamento',
          PRICE_TYPE_INPUT: 'Tipo de Preço Inicial',
          SINCE_INPUT: 'Desde',
          TO_INPUT: 'Para',
          TOLERANCE_INPUT: 'Tolerância %',
          DIRECTION_INPUT: 'Endereço',
          ROUNDING_TYPE_INPUT: 'Tipo de Arredondamento',
          ROUNDING_UNITS_OP1: 'Unidades de Arredondamento',
          TERMINATIONS_OP2: 'Terminações',
          ROUNDING_UNITS_INPUT: 'Unidades de Arredondamento',
          TERMINATIONS_INPUT: 'Terminações',
          NEXT_BTN: 'Seguinte',
          NEW_TERMINATION: 'Nova Terminaçāo',
          TERMINATION_MODAL_INPUT: 'Terminaçāo',
          NO_TERMINATION: 'Nenhuma Terminaçāo Adicionada',
          ADDED_TERMINATION: 'Terminaçāo Adicionada',
          ADDED_TERMINATIONS: 'Terminações Adicionadas',
          ADD_BTN: 'Adicionar',
          STP2: 'Passo 2 - Escopo Produtos',
          ADD_ATTRIBUTE_BTN: '+',
          PREVIUS_BTN: 'Prévio',
          STP3: 'Passo 3 - Escopo Pontos de Venda',
          SAVE_BTN: 'Salvar',
          NONE: 'Nenhum',
          ALL: 'Todos',
          EXCLUDED: 'Excluido',
          SEARCH: 'Procurar',
          milesimas: 'Milésimos ',
          centesimas: 'Centésimos ',
          decimas: 'Décimos ',
          unidades: 'Unidades ',
          decenas: 'Dezenas ',
          centenas: 'Centenas ',
          miles: 'Milhares ',
          decenas_de_miles: 'Dezenas de Milhares',
          Nearest: 'Ao mais perto',
          Down: 'Para baixo',
          Up: 'Para cima',
        },
        RULES: {
          DELETE_MODAL: {
            TITLE_ONE: 'Deseja excluir {{val}}?',
            CONTENT: 'Pendências de aprovação pendentes serão descartadas. Sugestões aprovadas ou alteradas manualmente serão mantidas.',
            TITLE_MULTIPLE: 'Deseja excluir as regras selecionadas ({{val}})?',
          },
          PARENT_STORE_TITLE: 'Parentesco de {{val}}',
          PARENT_ITEM_TITLE: 'Parentesco de Produtos',
          PARENT_CATEGORY_TITLE: 'Categoria Parentesco',
          COMPETENCE_TITLE: 'concorrência',
          MARGIN_TITLE: 'Margem',
          SELECT_ALL_SUBCATEGORY: 'Selecionar todas as subcategorias',
          SELECT_ALL_CATEGORY: 'Selecionar todas as categorias',
          ROUTE: 'Preços / Configuração',
          TITLE: 'Regras de Preço',
          SUGGESTION_BTN: 'Gerar Sugestões',
          GENERATE_SUGGESTIONS_TOOLTIP: 'Para gerar sugestões, você deve selecionar uma categoria (apenas uma) ou itens da lista.',
          GENERATE_SUGGESTIONS_TOOLTIP_WITH_CATEGORY_REQUIRED: 'Para poder gerar sugestões deve selecionar uma categoria por ves',
          GENERATE_SUGGESTIONS_TOOLTIP_WITH_CATEGORY_REQUIRED_MODAL_DESCRIPTION:
            'Esta pode ser aplicada no filtro avançado ou diretamente desta mesma janela. Uma vez aplicada essa seleção, a lista será filtrada com as regras alcançadas e poderá fazer uso do botão Gerar Sugestão (cor verde) para realizar o pedido da mesma.',
          GENERATE_SUGGESTIONS_SELECTION: 'As sugestões serão geradas com base na seguinte categoria selecionada: ',
          GENERATE_SUGGESTIONS_MODAL_DESCRIPTION:
            'Escolha a categoria para a qual deseja gerar as sugestões. Se você já aplicou uma no filtro, ela vem pré-selecionada.',
          GENERATE_SUGGESTIONS_SCOPE_SELECTED: 'Serão geradas sugestões para estas {{val}} regras, sobre a categoria escolhida:',
          GENERATE_SUGGESTIONS_SCOPE_SELECTED_ONE: 'Serão geradas sugestões para esta regra, sobre a categoria escolhida:',
          GENERATE_SUGGESTIONS_SCOPE_FILTERED:
            'Serão geradas sugestões para as {{val}} regras da lista filtrada, sobre a categoria escolhida.',
          GENERATE_SUGGESTIONS_SCOPE_MORE: 'e mais {{val}}',
          GENERATE_SUGGESTIONS_SCOPE_FILTERS_IGNORED: 'Os filtros da lista não se aplicam quando há regras selecionadas.',
          GENERATE_SUGGESTIONS_SCOPE_WARN_ITEM_STORE:
            'Atenção: os filtros de Produto e Pontos de Venda não limitam a geração, portanto ela pode alcançar mais regras do que você vê na lista.',
          GENERATE_SUGGESTIONS_SCOPE_NOTICE: 'A lista ficará filtrada pela categoria selecionada.',
          GENERATE_SUGGESTIONS_CONFIRM_BTN: 'Gerar',
          SUGGESTION_OP1_MARGIN: 'Margem',
          SUGGESTION_OP2_COMPETITION: 'concorrência',
          NEW_RULE_BTN: 'Nova Regra',
          NEW_RULE_TITLE_MODAL: 'Nova Regra',
          RULE_TYPE_INPUT: 'Tipo de Regra',
          ADDITIONAL_FILTERS: 'Filtros adicionais',
          LEGEND_COMP: 'As regras de concorrência são acionadas quando uma mudança nos preços dos concorrentes é detectada.',
          LEGEND_MARG: 'As regras de margem são acionadas quando uma mudança no fornecedor ou nos custos de fabricação é detectada.',
          LEGEND_P_STORES: 'Regras pai de {{val}} são acionadas toda vez que o preço de um pai {{val2}} é alterado.',
          STORES_VAL: 'Pontos de Venda',
          CATEGORY_VAL: 'Categoria',
          STORE_VAL: 'Ponto de Venda',
          LEGEND_P_ITEMS: 'As regras de parentesco de produtos são avaliados sempre que o preço de um produto pai é alterado.',
          LEGEND_P_CATEGORIES:
            'As regras de relacionamento por categoria são avaliadas cada vez que o preço de uma categoria pai é alterado.',
          CANCEL_BTN: 'Cancelar',
          CREATE_BTN: 'Criar',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar regras selecionadas',
          DELETE: 'Apagar',
          CLEAN_FILTERS: 'Limpar Filtros',
          SHOW_RULES: 'Selecione pelo menos um filtro para mostrar as regras',
          NAME: 'Nome',
          TYPE: 'Tipo',
          STATE: 'Estado',
          COUNTRY: 'País',
          ZONE: 'Zona',
          STORES: '# Pontos de Venda',
          ITEMS: '# Produtos',
          MARGIN: 'Margem',
          MARGIN_MARKUP: 'Markup {{val}} %',
          MARGIN_AMOUNT: '$ {{val}}',
          MARGIN_KEEP_PERCENTAGE: 'Mantém margem %',
          MARGIN_KEEP_AMOUNT: 'Mantém margem $',
          MARGIN_BY_CATEGORY: 'Por categoria',
          IPC: 'IPC %',
          LAST_MODIFICATION: 'Última Mudança',
          USER: 'Usuário',
          TYPE_RULES: 'Regras de Preço',
          SUGGESTIONS_GENERATED_SNACKBAR:
            'O processo de geração de sugestões foi iniciado. Você receberá uma notificação quando este processo for concluído.',
          INCLUDED_ITEMS: 'Produtos Incluídos',
          ACCEPT_BTN: 'Aceitar',
          INCLUDED_STORES: 'Pontos de Venda Incluídos',
          TITLE_FILTERS: 'Filtros',
          CATEGORY_FILTER: 'Categoria',
          SEARCH_CATEGORIES_FILTER: 'Procurar Categorias',
          SUBCATEGORY_FILTER: 'Subcategorias',
          SEARCH_SUBCATEGORIES_FILTER: 'Procurar Categorias',
          RULE_TYPE_FILTER: 'Tipo de Regra',
          USER_FILTER: 'Usuário',
          SEARCH_USER_FILTER: 'Procurar Usuário',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          DEFINE_RULE_STP1: 'Definir Regra',
          PRODUCT_SCOPE_STP2: 'Escopo Produtos',
          STORE_SCOPE_STP3: 'Escopo Pontos de Venda',
          STP3_STORE: 'Passo 3 - Escopo Produtos',
          STP2_STORE: 'Passo 2 - Escopo Pontos de Venda',
          STP4_COMPETENCE: 'Passo 5 - Limites por Concorrente (Opcional)',
          STP5_COMPETENCE: 'Passo 6 - Limites de Margem e Variaçāo (Opcional)',
          STP5_COMPETENCE_ALT: 'Passo 5 - Limites de Margem e Variaçāo',
          STP3_MARGIN: 'Passo 4 - Limites por Concorrente (Opcional)',
          STP4_MARGIN: 'Passo 5 - Limites por Margem (Opcional)',
          STP4_MARGIN_ALT: 'Passo 4 - Limite de Margem (Opcional)',
          STORE_SCOPE_STP5: 'Limites por Concorrente (Opcional)',
          STORE_SCOPE_STP6: 'Limites de Margem e Variaçāo (Opcional)',
          TITLE_FORM_NEW: 'Nova Regra de Margem ou Markup',
          TITLE_FORM_EDIT: 'Regra Margem ou Markup',
          STP1: 'Passo 1 - Definir Regra',
          NAME_INPUT: 'Nome',
          QUERY: 'Descriçāo / Código',
          POSITION_TYPE_INPUT: 'Tipo de Regra',
          NO_COMPETITOR_LIMITS: 'Sem limites por concorrente',
          INDICATE_MARGIN_INPUT: 'Indicar Margem',
          VALIDATION_MARGIN: 'O campo deve ser menor que 100',
          NEXT_BTN: 'Seguinte',
          STP2: 'Passo 2 - Escopo Produtos',
          ADD_ATTRIBUTE_BTN: '+',
          SEARCH: 'Procurar',
          SEE_PROD: 'Ver Produtos',
          CODE: 'Código',
          BRAND: 'Marca',
          MANUFACTURER: 'Fabricante',
          PRICE: 'Preço R$',
          COST: 'Custo R$',
          PRICE_CHIP: 'Preço: R$',
          COST_CHIP: 'Custo: R$',
          REFRESH_PRODUCTS: 'Atualizar Produtos',
          REFRESH_STORES: 'Atualizar Pontos de Venda',
          SEE_STORE: 'Ver Pontos de Venda',
          SELECT_PROD: 'Produtos Selecionados ',
          SELECT_STORE: 'Pontos de Venda Selecionados ',
          FILTER_PROD: 'Produtos Filtrados ',
          FILTER_STORE: 'Pontos de Venda Filtrados ',
          PRICE_TABLE: 'Preço: R$',
          COST_TABLE: 'Custo: R$',
          ADD_PROD: 'Adicionar Produtos ao Listado',
          CHANGE_FORM: 'Mudar Filtros',
          PREVIUS_BTN: 'Anterior',
          STP3: 'Passo 3 - Escopo Pontos de Venda',
          SAVE_BTN: 'Salvar',
          EXIT_BTN: 'Sair',
          SKIP_BTN: 'Omitir',
          SKIP_STEP_LINK: 'Pular esta etapa',
          NONE: 'Nenhum',
          ALL: 'Todos',
          EXCLUDED: 'Excluido',
          COMPETITORS_SCOPE_STP2: 'Escopo Concorrentes',
          PARENT_CATEGORY_SCOPE_STP1: 'Escopo do item',
          PARENT_PRODUCT_SCOPE_STP1: 'Definir Regra',
          PARENT_PRODUCT_SCOPE_STP2: 'Escopo Produtos',
          PARENT_PRODUCT_SCOPE_STP3: 'Escopo Pontos de Venda',
          PARENT_PRODUCT_SCOPE_STP4: 'Configuração de Regra de Parentesco de Itens',
          PARENT_PRODUCT_SCOPE_STP1_TITLE: 'Passo 1 - Definir Regra',
          PARENT_PRODUCT_SCOPE_STP2_TITLE: 'Passo 2 - Escopo Produtos',
          PARENT_PRODUCT_SCOPE_STP3_TITLE: 'Passo 3 - Escopo Pontos de Venda',
          PARENT_PRODUCT_SCOPE_STP4_TITLE: 'Passo 4 - Resumo',
          PARENT_STORE_SCOPE_STP1: 'Definir Regra',
          PARENT_STORE_SCOPE_STP2: 'Escopo Pontos de Venda',
          PARENT_STORE_SCOPE_STP3: 'Escopo Produtos',
          PARENT_STORE_SCOPE_STP1_TITLE: 'Passo 1 - Definir Regra',
          PARENT_STORE_SCOPE_STP2_TITLE: 'Passo 2 - Escopo Pontos de Venda',
          PARENT_STORE_SCOPE_STP3_TITLE: 'Passo 3 - Escopo Produtos',
          PARENT_CATEGORY_STP1_TITLE: 'Paso 1 - Alcance de items',
          PARENT_CATEGORY_STP2_TITLE: 'Paso 2 - Alcance de pontos de venda',
          PARENT_CATEGORY_STP3_TITLE: 'Paso 3 - Configuração de Regra',
          STORE_SCOPE_STP4: 'Escopo Pontos de Venda',
          COMPETITION_TITLE_FORM_NEW: 'Nova Regra de concorrência',
          COMPETITION_TITLE_FORM_EDIT: 'Regra de concorrência',
          POSITIONING_INPUT: 'Posicionamento',
          PERCENT_MARGIN_OBJETIVE: '%',
          MIN_MARGIN_ERROR: 'O valor deve ser maior ou igual a {{val}}%',
          MAX_MARGIN_ERROR: 'O valor deve ser menor ou igual a {{val}}%',
          ONLY_ALERT: 'Apenas Alertar: Gerará um alerta na tela de decisão de preço, mas não gerará nenhuma sugestão de mudança.',
          DO_NOTHING: 'Não fazer nada',
          IN_CASE: 'Em caso de não encontrar os preços de concorrentes:',
          PRICE_SUGGESTION_STEP5: 'O preço sugerido deve estar:',
          SELECTION_COMPETITORS_STEP5: 'Selecção dos concorrentes para calcular o limite:',
          RADIO_MIN_STEP5: 'Como mínimo um',
          RADIO_MAX_STEP5: 'Como máximo um',
          RADIO_AVG_STEP5: 'Introduzir',
          MORE: 'mais',
          AND_THE: 'e a/o',
          COMPETITORS_STEP5: 'quais concorrentes selecionar',
          COMPETITORS_STEP5_SECONDVALUE_CHEAP: 'Mais barato',
          COMPETITORS_STEP5_SECONDVALUE_EXPENSIVE: 'Mais caro',
          COMPETITORS_AVG_STEP5: 'com relação aos concorrentes a serem selecionados nesta etapa',
          SUGESSTION_LOW_STEP5: 'Sugerir abaixo do mínimo',
          SUGESSTION_HIGH_STEP5: 'Sugerir acima do máximo',
          TITLE_COMPETITORS_STEP6:
            'Diretrizes específicas de margem e variação podem ser definidas para esta regra. Se você quiser usar as diretrizes da categoria, salve as alterações diretamente, pulando esta etapa.',
          TITLE_COMPETITORS_STEP6_NOTICE: 'Se este limite for configurado, a configuração dos limites da categoria será substituída.',
          LINEAL_MARGIN_COMPETITORS_STEP6: 'Diretrizes de Margem',
          MIN_MARGIN_INPUT_STEP6: 'Margerm Min %',
          MAX_MARGIN_INPUT_STEP6: 'Margem Max %',
          MIN_MARGIN_INPUT_STEP6_ALT: 'LIMITE DE MARGEM ',
          MAX_MARGIN_INPUT_STEP6_ALT: 'MARGEM MÁXIMA ',
          VARIATION_MARGIN_INPUT_STEP6: 'Variaçāo Significativa Margem R$',
          MIN_SUGGESTION_MARGIN_INPUT_STEP6: 'Sugerir abaixo do mínimo',
          MAX_SUGGESTION_MARGIN_INPUT_STEP6: 'Sugerir acima do máximo',
          VARIATION_PRICE_COMPETITORS_STEP6: 'Variaçāo de Preço',
          MIN_VARIATION_PRICE_INPUT_STEP6: 'Queda Máxima %',
          MAX_VARIATION_PRICE_INPUT_STEP6: 'Aumento Máximo %',
          MIN_VARIATION_PRICE_INPUT_STEP6_ALT: 'Mínima Alta',
          MAX_VARIATION_PRICE_INPUT_STEP6_ALT: 'Máximo Pico',
          MIN_SUGGESTION_VARIATION_PRICE_INPUT_STEP6: 'Sugerir abaixo do mínimo',
          MAX_SUGGESTION_VARIATION_PRICE_INPUT_STEP6: 'Sugerir acima do máximo',
          MARGIN_OBJETIVE: 'Definir Margem Objetivo %',
          MARGIN_OBJETIVE_CATEGORY: 'Objetivo de margem por Subcategorias',
          MARGIN_OBJETIVE_CATEGORY_HELP: 'Tenha em mente que o Margem Objetivo % deve estar completo nos Linhas de Ação e Estratégias.',
          POSITION_AGAINST_INPUT: 'Se Posicionar Contra',
          POSITION_TREND_INPUT: 'Se houver mais de uma tendência a ser usada\n',
          SURVEY_SOURCES_INPUT: 'Fontes de Estudo',
          STP2_COMP: 'Passo 2 - Escopo Concorrentes',
          STP2_COMP_BUTTON_TITLE: 'Selecione como você deseja comparar com seus concorrentes.',
          MAINMARKET_TITLE: 'Principal Concorrente',
          MAINMARKET_MSG: 'Irá pesquisar o preço do Prinicpal Concorrente de cada Ponto de Venda.',
          USE_TRADE_AREA_TITLE: 'Área Comercial',
          USE_TRADE_AREA_MSG: 'Irá pesquisar o preço dos Concorrentes associados à Área Comercial de cada Ponto de Venda',
          SELECT_COMPETITORS_TITLE: 'Seleção de Concorrrentes',
          SELECT_COMPETITORS_MSG: 'Ele irá procurar por concorrentes que atendam aos critérios a serem definidos abaixo',
          TRADE_AREA_CHECK: 'Apenas Área Comercial',
          MARKERS_CHECK: 'Apenas Selecionar Principais Concorrentres',
          STP3_COMP: 'Passo 3 - Escopo Produtos',
          STP4_COMP: 'Passo 4 - Escopo Pontos de Venda',
          STORE_PARENT_TITLE_FORM_NEW: 'Nova Regra Parentesco de Ponto de Venda',
          STORE_PARENT_TITLE_FORM_EDIT: 'Regra Parentesco de Ponto de venda',
          STORE_PARENT_INPUT: 'Ponto de Venda Pai',
          STORE_PARENT_TTIP:
            'Apenas as lojas que não foram designadas como lojas relacionadas em outras regras aparecerão na lista de lojas-pai.',
          SEARCH_PARENT: 'Procurar Pai',
          RELATIONSHIP_TYPE_INPUT: 'Posicionamento de itens filhos',
          RELATIONSHIP_TYPE_INPUT_STORE: 'Posicionamento de lojas filhas',
          DIFFERENCE_IN_INPUT: 'Condição',
          relationshipType_Price: 'Avaliar preço',
          relationshipType_Margin: 'Avaliar margem',
          relationshipType_DeltaPrice: 'Clonar valores do item pai',
          EVALUATE_PARENT_ITEM_PRICE: 'Avaliar preço do item pai',
          EVALUATE_PARENT_ITEM_MARGIN: 'Avaliar margem do item pai',
          EVALUATE_PARENT_STORE_PRICE: 'Combinar preço de saída dos pais',
          EVALUATE_PARENT_STORE_MARGIN: 'Igualar a margem do ponto de venda dos pais',
          DIFFERENCE_IN_OPTION: 'Diferença en',
          DIFFERENCE_INPUT: 'Valor',
          DIFFERENCE_INPUT_NOT_ZERO:
            'O valor deve ser diferente de 0 (Zero). Se desejar replicar o valor do item pai, deve selecionar “Igualar margem/preço do item pai” no campo Condição.',
          DIFFERENCE_INPUT_LENGTH: 'O valor do campo é inválido.',
          TEXT_P_STORES: 'Os {{val}} filhos terão {{val2}} {{val3}} pai',
          CATEGORIES_INPUT: 'Categorias*',
          CATEGORIES_INPUT_EXC: 'Categoprias Excluídas*',
          CATEGORIES_TTIP: 'Você deve selecionar pelo menos uma categoria, para selecionar as subcategorias',
          SEARCH_CATEGORIES: 'Procurar Categorias',
          SUBCATEGORIES_INPUT: 'Subcategorias*',
          SUBCATEGORIES_INPUT_EXC: 'Subcategorias Excluídas*',
          SUBCATEGORIES_TTIP: 'Você deve selecionar pelo menos uma subcategoria por categoria selecionada',
          SEARCH_SUBCATEGORIES: 'Procurar Subcategorias',
          SELECT_ALL: 'Selecionar todos',
          VALIDATION_CATEGORY: 'Você deve selecionar pelo menos uma categoria',
          VALIDATION_SUBCATEGORY: 'Você deve selecionar pelo menos uma opção para cada categoria selecionada',
          GET_OUT_BTN: 'Sair',
          SAME_PRICE: 'O mesmo preço que ',
          SAME_MARGIN: 'o mesmo intervalo de margem ',
          HIGHER: 'Superior',
          LOWER: 'Inferior',
          UNDER: 'em baixo',
          ABOVE: 'acima de',
          MAYOR: 'Maior',
          MINOR: 'Menor',
          TEXT_P_STORES_TS: 'um preço {{val}} em {{val2}} no',
          ITEM_PARENT_TITLE_FORM_NEW: 'Nova Regra Parentesco de Produto',
          ITEM_PARENT_TITLE_FORM_EDIT: 'Regra Parentesco de Produto',
          PARENT_RULE_GENERATE_SUGGESTION_TITLE: 'Geração de Sugestões',
          PARENT_RULE_ONSAVE_GENERATE_SUGGESTION_CONTENT: 'A regra será executada imediatamente',
          ITEM_PARENT_INPUT: 'Produto Pai',
          STORE_INPUT: 'Ponto de venda de referência',
          ITEM_PARENT_TTIP:
            ' Apenas os produtos que não foram atribuídos como produtos filhos em outras regras aparecerão na lista de produtos pai.',
          TEXT_P_COMPETENCE: 'Posicione um {{val}} ',
          TEXT_P_COMPETENCE_TS: '{{val}} {{val2}} o {{val3}} ({{val4}}) de meus concorrentes',
          TEXT_P_COMPETENCE_TRADEAREA: 'dentro de {{val}} de cada Ponto de Venda',
          TEXT_P_COMPETENCE_MARKERS: 'Principais',
          TEXT_P_COMPETENCE_COMPETITORS_SELECTED: 'Selecionados',
          TEXT_P_COMPETENCE_STP3: 'dentro de {{val}} de cada Ponto de Venda',
          TEXT_P_COMPETENCE_STP4: ', para artigos selecionados',
          TEXT_P_COMPETENCE_STP4_ALL: ', para todos os artigos ',
          TEXT_P_ACTUAL_MARGIN: '{{val}} {{val2}}',
          TEXT_P_MARGIN: 'Posição com um {{val}} {{val2}}',
          TEXT_P_MARGIN_TS_1: 'para artigos selecionados',
          TEXT_P_MARGIN_TS_2: 'nas regiões requeridas ',
          TEXT_P_MARGIN_POSITION: '{{val}} de {{val2}}',
          TEXT_P_MARGIN_POSITION_0: 'Margem',
          TEXT_P_MARGIN_POSITION_1: 'Margem',
          TEXT_P_MARGIN_POSITION_2: 'Manter margem atual em %',
          TEXT_P_MARGIN_POSITION_4: 'Manter margem atual em R$',
          TEXT_P_MARGIN_POSITION_5: 'Margem objetivo por zona',
          TEXT_P_MARGIN_POSITION_6: 'Markup',
          TEXT_P_MARGIN_POSITION_7: 'Margem de Categoria',
          MARGIN_POSITION_TYPE_0: 'Margem em %',
          MARGIN_POSITION_TYPE_1: 'Margem em R$',
          MARGIN_POSITION_TYPE_2: 'Manter a Margem Atual em %',
          MARGIN_POSITION_TYPE_4: 'Manter Margem Atual em R$',
          MARGIN_POSITION_TYPE_5: 'Margem objetivo por zona',
          MARGIN_POSITION_TYPE_6: 'Markup em %',
          MARGIN_POSITION_TYPE_7: 'Categoria Margin',
          LEGEND_RULE_TITLE: 'REGRA: ',
          TEXT_P_ITEMS: 'Os produtos filhos terāo {{val}} {{val2}}',
          TEXT_P_ITEMS_VARIANT: 'Os produtos filhos terāo a mesma variaçāo de preço que {{val}} {{val2}}',
          TEXT_P_ITEMS_TS: 'um preço {{val}} em {{val2}} que ',
          TEXT_P_ITEMS_TS_MARGEN: 'uma margem de {{val}} que ',
          TEXT_P_STORE: 'Os Pontos de Venda filhos terāo {{val}} {{val}}',
          TEXT_P_STORE_VARIANT: 'Os Pontos de Venda filhos terāo a mesma variaçāo de preço que {{val}}',
          SEARCH_RESULT_CHILD_STORE: '{val}} Pontos de venda serão afetados por esta regra',
          TEXT_P_STORE_TS: 'um Preço {{val}} em {{val2}} para ',
          TEXT_P_STORE_TS_MARGEN: 'A margem de R$ {{val}} em {{val2}} ',
          MARK_AS_ZONE: 'Marcar como Zona',
          MARK_AS_ZONE_TTIP: 'Mesmo preço para todas as áreas',
          STRATEGY: 'Escolha a estratégia de seleção dos produtos filhos',
          STRATEGY_ATTR_TITLE: 'Seleção por atributo',
          STRATEGY_ATTR_MSG: 'Os atributos são selecionados para definir o escopo dos produtos',
          STRATEGY_STORE_ATTR_MSG: 'Os atributos são selecionados para definir o escopo dos Pontos de Venda',
          STRATEGY_PROD_TITLE: 'Seleção por produto',
          STRATEGY_STORE_TITLE: 'Seleção por Ponto de Venda',
          STRATEGY_PROD_MSG: 'Os produtos devem ser selecionados um por um',
          STRATEGY_STORE_MSG: 'Os Pontos de Venda devem ser selecionados um a um',
          STP3_PARENT_ITEM: 'Passo 3 - Escopo Pontos de Venda',
          GENERIC_MSG_ERRROR_EXECSUGGESTION: 'Não foi possível gerar sugestões.',
          GENERIC_MSG_NOSUGGESTIONS_EXECSUGGESTION: 'Não há novas sugestões.',
          NO_DIFF: 'Sem Diferença',
          LEVEL_SELECT: 'Nível do Arvore de Categoria',
          RULE_NAME: 'Nome da regra',
          RULE_CONDITION: 'Condição',
          RULE_CLONE_PARENT_ITEMS: 'Os itens filhos clonarão qualquer alteração de preço ou margem do item pai.',
          RULE_SAME_PRICE_PARENT_ITEM: 'Os itens filhos manterão o mesmo {{val}} que o item pai.',
          RULE_PRICE_POSITION: 'Os itens filhos se posicionarão com um {{val}} de {{val2}} em relação ao item pai.',
          RULE_PRICE: 'preço',
          RULE_MARGIN: 'margen',
          RULE_ITEM_PARENT_SELECTED: 'Item pai selecionado',
          RULE_ITEM_CHILD_SELECTED: 'Item filhos selecionado',
          RULE_PRICE_UPDATE_ON_CHILD:
            'Qualquer modificação de preço no item pai será replicada nos itens filhos de acordo com a configuração.',
          RULE_POINT_OF_SALE_SELECTED: 'Pontos de venda selecionados',
          RULE_REMEMBER_PARENT_ITEM_INDEPENDENT:
            'Lembre-se de que, por ser uma regra de parentesco de itens, o item pai é independente do ponto de venda. ',
          RULE_REMEMBER_CHECK_ASSORTMENT:
            'Lembre-se de revisar o sortimento dos pontos de venda para verificar se os itens filhos estão incluídos.',
          RULE_CLONE_CHILD_ITEMS: 'Os itens filhos clonarão qualquer modificação de preço ou margem do item pai.',
        },
        BRAND: {
          ROUTE: 'Preços / Configuração',
          TITLE: 'Bandeiras',
          NEW_BRAND_BTN: 'Nova Bandeira',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          DELETE_TTIP: 'Apagar bandeiras selecionadas',
          DELETE: 'Apagar',
          NAME: 'Nome',
          LOGO: 'Logo',
          COLOR: 'Cor',
          TITLE_FORM_NEW: 'Nova Bandeira',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Informação Básica',
          NAME_INPUT: 'Nome',
          PICK_COLOR: 'Escolha uma cor',
          CLEAN_COLOR_TTIP: 'Limpar cor',
          IS_ASIGNED: 'Esta bandeira é atribuída a pontos de venda ou concorrentes, por isso não pode ser eliminada',
          OWN_BRAND: 'Própria marca',
          BRAND_HAS_ASSOCIATED_STORES:
            'A marca tem pontos de venda associados. Migre os pontos de venda antes de desativá-la como marca própria.',
        },
        GUI_AND_STRA: {
          ROUTE: 'Preços / Configuração',
          TITLE: 'Guidelines and Strategies',
          BUSINESS_UNIT: 'Unidade de Negócio',
          SELECT_BUSINESS_UNIT: 'Selecione uma unidade de negócio para ver as categorias',
          GENERAL_CONFIG_BUTTON: 'CONFIGURAÇÃO GERAL',
          GENERAL_CONFIG_EDIT_TOOLTIP: 'Editar Configuração Geral',
          GENERAL_CONFIG_CREATE_TOOLTIP: 'Criar Configuração Geral - Deve configurar as condições de validação antes de continuar',
          GENERAL_CONFIG_WARNING_MESSAGE: 'Não há configuração geral',
          GENERAL_CONFIG_WARNING_FULL_MESSAGE:
            'Configure as Condições de Validação para mudanças de Preços, o Método de cálculo do preço do concorrente de referência e outros parâmetros',
          ASSORTMENTV2: {
            SETUP: {
              GUIDELINES: 'Lineamentos',
              EDIT_GUIDELINES: 'Editar Lineamentos',
              CONFIGURE_GUIDELINES: 'Configurar Lineamentos',
              GENERAL_CONFIG_WARNING_FULL_MESSAGE: 'A Configuração Geral deve ser configurada',
              GENERAL_CONFIG_DIALOG_TITLE: 'Configuração Geral',
              GENERAL_CONFIG_TAB_MAIN_DATA: 'Dados principais',
              GENERAL_CONFIG_TAB_ALERTS_VALIDATIONS: 'Alertas e validações',
              ALERTS_VALIDATIONS: {
                DESCRIPTION: 'Alertas e Validações para garantir que as sugestões atendam às condições do seu negócio.',
              },
              NEW_PRODUCTS: {
                TITLE: 'PRODUTOS NOVOS:',
                DESCRIPTION: 'São produtos que têm menos de 30 dias desde sua data de cadastro',
                INTRO: 'Configure por quantos dias um produto é considerado novo e a partir de qual evento os dias são contados.',
                DAYS_LABEL: 'Dias',
                DAYS_DESCRIPTION: 'considerado novo desde sua',
                DAYS_HINT_TEMPLATE: 'Durante {{val}} dias desde sua {{val2}}.',
                EVENT_SELECTOR_TITLE: 'A partir de qual evento os dias são contados?',
                EVENT_SELECTOR_HELP: 'Escolha a referência que inicia a contagem.',
                SUMMARY_TITLE: 'Resumo',
                SUMMARY_TEMPLATE: 'Será considerado novo durante {{val}} dias desde sua {{val2}}.',
              },
              NEW_PRODUCT_EVENT: {
                FIRST_ITEM_CREATION: 'Data de cadastro',
                FIRST_ITEM_CREATION_DESC: 'Um produto é considerado novo desde sua data de criação',
                FIRST_STOCK_RECORD: 'Primeiro registro de estoque',
                FIRST_STOCK_RECORD_DESC: 'Um produto é considerado novo desde seu primeiro registro de estoque',
                FIRST_SALES_RECORD: 'Primeiro registro de venda',
                FIRST_SALES_RECORD_DESC: 'Um produto é considerado novo desde seu primeiro registro de venda',
              },
              ANALYSIS_PERIOD: {
                TITLE: 'Período de Análise',
                DESCRIPTION:
                  'Neste passo você pode definir o período em meses que será considerado para realizar a análise. Para normalizar e poder comparar, você sempre verá valores médios expressos em 30 dias em relatórios e pareto.',
                LATEST_INPUT: 'Últimos',
                LATEST_MONTHS_INPUT: 'Últimos meses',
                MONTHS: 'Meses',
                MONTHS_VALIDATION: 'O número de meses não pode ser maior que os meses selecionados',
                MONTHS_SELECTOR_TITLE: 'Meses a considerar',
                MONTHS_SELECTOR_HELP: 'Escolha quais meses são incluídos na média.',
                SELECTED_COUNT: 'Selecionados: {{val}} de {{val2}}',
                SUMMARY_TITLE: 'Resumo',
                SUMMARY_EMPTY: 'Defina o período para ver o resumo.',
                SUMMARY_TEMPLATE: 'Serão analisados os últimos {{val}} meses. Meses incluídos: {{val2}}.',
                NO_MONTHS_SELECTED: 'Nenhum',
                MONTH_COUNT_SINGULAR: '{{val}} mês',
                MONTH_COUNT_PLURAL: '{{val}} meses',
                LEGEND:
                  'Se você excluir um mês da lista, ele não será considerado como parte da média. Se a quantidade de meses selecionados for menor que o período selecionado, a média será calculada com a quantidade de meses disponíveis.',
                JANUARY: 'JAN',
                FEBRUARY: 'FEV',
                MARCH: 'MAR',
                APRIL: 'ABR',
                MAY: 'MAI',
                JUNE: 'JUN',
                JULY: 'JUL',
                AUGUST: 'AGO',
                SEPTEMBER: 'SET',
                OCTOBER: 'OUT',
                NOVEMBER: 'NOV',
                DECEMBER: 'DEZ',
              },
              VALIDATION_MODAL: {
                CREATE_TITLE: 'Configurar nova validação',
                EDIT_TITLE: 'Editar validação',
                STEP1_LABEL: 'Critério',
                STEP2_LABEL: 'Ação',
                RANGE_TITLE: 'Intervalo de variação',
                RANGE_SUBTITLE: 'Selecione Variável, Condição e Valor numérico para o critério selecionado',
                FIELD_VARIABLE: 'Variável',
                FIELD_CONDITION: 'Condição',
                FIELD_NUMERIC_VALUE: 'Valor',
                ACTION_VALIDATE: 'Validar',
                ACTION_VALIDATE_DESCRIPTION: 'Força a validação dentro do intervalo configurado',
                BANNER_IF_IN_SUGGESTION: 'Se na sugestão de',
                LEVEL_ALTA: 'Alta',
                LEVEL_BAJA: 'Baixa',
                BANNER_THEN_SYSTEM: 'então o sistema deverá',
                BANNER_SUGGESTED_PRICE: 'o preço sugerido',
                PLACEHOLDER_LEVEL: 'Alta/Baixa',
                PLACEHOLDER_VARIABLE: 'Variável',
                PLACEHOLDER_COMPARATOR: 'Comparador',
                PLACEHOLDER_VALUE: 'Valor',
                PLACEHOLDER_SYSTEM_ACTION: 'Ação do sistema',
                VARIABLE_OUTOFSTOCK: '% Ruptura de estoque',
                VARIABLE_PRESENCE: '% Presença',
                VARIABLE_COVERAGE: '% Cobertura',
                VARIABLE_GMROI: 'GMROI',
                VARIABLE_GMROS: 'GMROS',
                ERROR_MAX_PERCENTAGE: 'O valor não pode ser maior que 100 para variáveis percentuais',
              },
              ROLE: {
                TITLE: 'Função da Categoria',
                DESCRIPTION: 'Selecione a função que define o comportamento estratégico desta categoria.',
                SELECT_LABEL: 'Função',
                DESTINATION: 'Destino',
                ROUTINE: 'Rotina',
                CONVENIENCE: 'Conveniência',
                SEASONAL: 'Sazonal',
              },
              DEPARTMENT_FILTER: 'Departamento',
              DELETE_TITLE_MODAL: 'Apagar',
              DELETE_SUBTITLE_MODAL: 'Tem certeza de que deseja excluir?',
            },
            DECISIONS: {
              NO_DEFAULT_CONFIG: 'Nenhuma configuração padrão foi encontrada, por favor entre em contato com o administrador do sistema.',
              FILTERS: {
                TITLE: 'Filtros',
                PRODUCT_HIERARCHY: 'Hierarquia de produtos',
                HIERARCHY_LEVEL_1: 'Negócio',
                HIERARCHY_LEVEL_2: 'Unidade de Negócio',
                HIERARCHY_LEVEL_3: 'Departamento',
                HIERARCHY_LEVEL_4: 'Categoria',
                HIERARCHY_LEVEL_5: 'Subcategoria',
                DEPARTMENT: 'Departamento',
                CATEGORY: 'Categoria',
                SUBCATEGORY: 'Subcategoria',
                ITEM_TAGS: 'Tags de itens',
                STORE_TAGS: 'Tags de lojas',
                DATES: 'Datas',
                DATE_FROM: 'Desde',
                DATE_TO: 'Hasta',
              },
              STRUCTURE: {
                TITLE: 'Estrutura',
                ADD_PLACEHOLDER: 'Adicionar...',
                ADD_GROUPER: 'ADICIONAR AGRUPADOR',
                NO_RESULTS: 'Sem resultados',
                CLEAR_STRUCTURE: 'Limpar estrutura',
                LOAD_VIEW: 'Carregar vista',
                DEFAULT_VIEW: 'Vista padrão',
                SAVE_VIEW: 'SALVAR VISTA',
                SAVE_VIEW_DIALOG_TITLE: 'Salvar vista',
                SAVE_VIEW_OVERWRITE: 'Sobrescrever',
                SAVE_VIEW_CREATE_NEW: 'Criar nova',
                SAVE_VIEW_NAME_LABEL: 'Nome da vista',
                SAVE_VIEW_NAME_PLACEHOLDER: 'Atribua um nome a esta configuração',
                SAVE_VIEW_NAME_REQUIRED: 'O nome é obrigatório',
                SAVE_VIEW_MAX_CHARS: 'Máximo 60 caracteres',
                SAVE_VIEW_SAVE_BTN: 'Salvar',
                SAVE_VIEW_SUMMARY: 'Resumo de configuração',
                SAVE_VIEW_STRUCTURE: 'Estrutura',
                SAVE_VIEW_LEVELS: 'níveis',
                SAVE_VIEW_SELECTED_VALUES: 'Valores selecionados',
                SAVE_VIEW_VARIABLES: 'variáveis',
              },
              TABLE: {
                HEADER: 'Cabeçalho',
                SUGGESTIONS: 'Sugestões / Decisões',
                SUGGESTIONS_ADD: '+',
                SUGGESTIONS_REMOVE: '-',
                VIEW_DETAIL: 'Ver detalhe',
                VENTAS_AMOUNT: 'Vendas $',
                VENTAS_UNITS: 'Vendas UN',
                MARGEN: 'Margem $',
                MARGEN_ACUERDOS: 'Margem com acordos',
                DESCUENTOS: 'Descontos $',
                PRECIO: 'Preço',
                PRESENCIA: 'Presença',
                TICKETS: 'Tickets',
                TICKETS_TOTAL: 'Tickets Total',
                STOCK_AMOUNT: 'Estoque $',
                STOCK_AMOUNT_ACTUAL: 'Estoque $ Atual',
                STOCK_UNITS: 'Estoque UN',
                STOCK_UNITS_ACTUAL: 'Estoque UN Atual',
                MERMA_UNITS: 'Quebra UN',
                DISPONIBILIDAD: 'Disponibilidade',
                QUIEBRES: 'Rupturas',
                DIAS_STOCK: 'Dias de Estoque',
                DIAS_STOCK_ACTUAL: 'Dias de Estoque Atual',
                GMROI: 'GMROI',
                VENTAS_MERCADO: 'Vendas $ Mercado',
                VENTAS_UN_MERCADO: 'Vendas UN Mercado',
                PRECIO_MERCADO: 'Preço Mercado',
                VENTAS_MERCADO_RANK: 'Vendas $ Mercado Rank',
                VENTAS_UN_MERCADO_RANK: 'Vendas UN Mercado Rank',
                VENTAS_UN_GAP: 'Vendas UN GAP',
                SEARCH: 'Buscar...',
                FILTERS_TOOLTIP: 'Filtros',
                COLUMNS_TOOLTIP: 'Colunas',
                FULLSCREEN_TOOLTIP: 'Expandir',
              },
              SUMMARY_TABLE: {
                NO_FILTER_ALERT: 'Para habilitar edição, selecione uma opção no menu de Filtros à esquerda',
                INCLUDE_NEW_ITEMS: 'Incluir novos',
                INCLUDE_NEW_ITEMS_LABEL: 'Incluir ',
                INCLUDE_NEW_ITEMS_BADGE: 'novos',
                ITEM_NEW: 'Novo',
                ITEM_CODE: 'Código',
                CLUSTER: 'Cluster',
                PARETO: 'Pareto',
                SALES_AMOUNT: 'Vendas $',
                SALES_UNITS: 'Vendas Un.',
                MARGIN: 'Margem %',
                SUGGESTIONS: 'Sugestões',
                NO_SUGGESTIONS: 'Sem sugestões',
                RESULTS: 'resultados',
                ACTIVE_STORES: 'Lojas Ativas',
                ACTIVE_STORES_TOOLTIP: 'Lojas ativas / Total lojas com vendas',
                CLUSTERS: 'Clusters:',
                CLUSTERS_LABEL: 'Clusters',
                CLUSTERS_VISIBLE: 'clusters a visualizar',
                CLUSTERS_TOTAL_GENERAL: 'Total Geral',
                CLUSTERS_ADD_LABEL: 'Adicionar Etiqueta',
                CLUSTERS_APPLY: 'Aplicar',
                CLUSTERS_SEARCH: 'Buscar...',
                CLUSTERS_NO_TAGS: 'Sem etiquetas disponíveis',
                CLUSTERS_NO_VALUES: 'Sem resultados',
                CLUSTERS_SELECT_VALUES: 'Selecionar valores',
                CLUSTERS_REMOVE: 'Remover',
                CLUSTERS_VISIBLE_PANEL_TITLE: 'Clusters a visualizar',
                CLUSTERS_MAX_REACHED: 'Limite de 20 clusters atingido. Desmarque um para adicionar outro.',
                ADD_MULTI_VARIABLE_ANALYSIS: 'Adicionar análise multivariável',
                EDIT_MULTI_VARIABLE_ANALYSIS: 'Editar análise multivariável',
                BULK_REJECT_ALL: 'REJEITAR TODAS',
                BULK_PRE_APPROVE_ALL: 'PRÉ-APROVAR TODAS',
                BULK_PRE_APPROVE_ALL_NO_ALERT: 'PRÉ-APROVAR TODAS SEM ALERTA',
                ROW_MENU_TOOLTIP: 'Ações',
                ROW_MENU_ACCEPT: 'Pre-aprovar',
                ROW_MENU_REJECT: 'Rejeitar',
                ROW_MENU_VIEW_DETAIL: 'Ver detalhe',
                WEIGHTED_INDEX: 'IP%',
                WEIGHTED_INDEX_SCORE: 'Pontuação IP',
                MULTIVARIABLE_TITLE: 'Análise multivariável',
                MULTIVARIABLE_STEP_1: 'Passo 1',
                MULTIVARIABLE_STEP_2: 'Passo 2',
                MULTIVARIABLE_STEP_1_DESCRIPTION: 'Selecione variáveis para o cálculo do índice ponderado.',
                MULTIVARIABLE_STEP_2_DESCRIPTION: 'Selecione o peso para cada variável.',
                MULTIVARIABLE_CLEAR: 'Limpar',
                MULTIVARIABLE_NEXT: 'Seguinte',
                MULTIVARIABLE_BACK: 'Voltar',
                MULTIVARIABLE_APPLY: 'Aplicar',
                MULTIVARIABLE_WEIGHTED_CALC: 'Cálculo do Índice Ponderado',
                MULTIVARIABLE_TOTAL: 'Total',
                MULTIVARIABLE_TOTAL_MUST_BE_100: 'O total deve ser exatamente 100%.',
                MULTIVARIABLE_MIN_TWO_VARS: 'Selecione pelo menos duas variáveis.',
                MULTIVARIABLE_MAX_FIVE_VARS: 'Você pode selecionar no máximo 5 variáveis. Desmarque uma para escolher outra.',
                MULTIVARIABLE_GROUP_CLASSIFICATION: 'Classificação',
                MULTIVARIABLE_GROUP_PERFORMANCE: 'Performance',
                MULTIVARIABLE_GROUP_TICKETS: 'Tickets',
                MULTIVARIABLE_GROUP_STOCK: 'Stock',
                MULTIVARIABLE_GROUP_MARKET: 'Mercado',
                MULTIVARIABLE_VAR_STOCK_AMOUNT: 'Stock $',
                MULTIVARIABLE_VAR_CURRENT_STOCK_AMOUNT: 'Stock $ Atual',
                MULTIVARIABLE_VAR_STOCK_UNITS: 'Stock UN',
                MULTIVARIABLE_VAR_CURRENT_STOCK_UNITS: 'Stock UN Atual',
                MULTIVARIABLE_VAR_SALES_AMOUNT: 'Vendas $',
                MULTIVARIABLE_VAR_SALES_UNITS: 'Vendas UN',
                MULTIVARIABLE_VAR_SALES_UNITS_GAP: 'Vendas UN GAP',
                MULTIVARIABLE_VAR_MARGIN: 'Margem %',
                MULTIVARIABLE_VAR_MARGIN_WITH_VENDORS: 'Margem com acordos',
                MULTIVARIABLE_VAR_DISCOUNTS: 'Descontos $',
                MULTIVARIABLE_VAR_PRICE: 'Preço',
                MULTIVARIABLE_VAR_PRESENCE: 'Presença',
                MULTIVARIABLE_VAR_SUGGESTIONS: 'Sugestões',
                MULTIVARIABLE_VAR_DECISIONS: 'Decisões',
                MULTIVARIABLE_VAR_TICKETS: 'Tickets',
                MULTIVARIABLE_VAR_TICKETS_TOTAL: 'Tickets Total',
                MULTIVARIABLE_VAR_MERMA_UNITS: 'Perda UN',
                MULTIVARIABLE_VAR_AVAILABILITY: 'Disponibilidade',
                MULTIVARIABLE_VAR_STOCKOUTS: 'Rupturas',
                MULTIVARIABLE_VAR_DAYS_IN_STOCK: 'Dias em Stock',
                MULTIVARIABLE_VAR_CURRENT_DAYS_IN_STOCK: 'Dias em Stock Atual',
                MULTIVARIABLE_VAR_GMROI: 'GMROI',
                MULTIVARIABLE_VAR_MARKET_SALES: 'Vendas $ Mercado',
                MULTIVARIABLE_VAR_MARKET_UNITS: 'Vendas UN Mercado',
                MULTIVARIABLE_VAR_MARKET_PRICE: 'Preço Mercado',
                MULTIVARIABLE_VAR_MARKET_SALES_RANK: 'Vendas $ Mercado Rank',
                MULTIVARIABLE_VAR_MARKET_UNITS_RANK: 'Vendas UN Mercado Rank',
                REFERENCE_CLUSTER: 'Cluster de referência',
                SET_AS_REFERENCE: 'Definir como cluster de referência',
                COLUMNS: 'Colunas',
                COLUMN_PICKER_TITLE: 'Seleção e ordem de colunas',
                COLUMN_PICKER_CANCEL: 'CANCELAR',
                COLUMN_PICKER_ACCEPT: 'APLICAR',
                COLUMN_PICKER_EMPTY: 'Selecione pelo menos uma coluna.',
                COLUMN_PICKER_ORDER_TITLE: 'Ordenar colunas',
                COLUMN_PICKER_ORDER_HINT: 'Arraste as linhas para definir a ordem. Só colunas visíveis são listadas.',
                METRIC_GROUP_INDICES: 'Índices e ranking',
                METRIC_GROUP_SALES: 'Performance',
                METRIC_GROUP_STORE_OPERATIONS: 'Estoque e operação',
                METRIC_GROUP_MARKET: 'Mercado',
                METRIC_RANK_IN_CLUSTER: 'Posição no cluster',
                METRIC_WEIGHTED_INDEX_SCORE: 'IP %',
                METRIC_ACTIVE_STORE_COUNT: 'Lojas ativas',
                METRIC_STORES_WITH_SALES: 'Lojas com vendas',
                METRIC_DECISIONS: 'Decisões',
                METRIC_MARGIN: 'Margem $',
                METRIC_MARGIN_WITH_VENDORS: 'Margem com acordos',
                METRIC_DISCOUNTS: 'Descontos $',
                METRIC_PRICE: 'Preço',
                METRIC_PRESENCE: 'Presença',
                METRIC_TICKETS: 'Tickets',
                METRIC_TICKETS_TOTAL: 'Tickets total',
                METRIC_STOCK_AMOUNT: 'Estoque $',
                METRIC_CURRENT_STOCK_AMOUNT: 'Estoque $ atual',
                METRIC_STOCK_UNITS: 'Estoque UN',
                METRIC_CURRENT_STOCK_UNITS: 'Estoque UN atual',
                METRIC_MERMA_UNITS: 'Perda UN',
                METRIC_AVAILABILITY: 'Disponibilidade',
                METRIC_STOCKOUTS: 'Rupturas',
                METRIC_DAYS_IN_STOCK: 'Dias em estoque',
                METRIC_CURRENT_DAYS_IN_STOCK: 'Dias em estoque atual',
                METRIC_GMROI: 'GMROI',
                METRIC_MARKET_SALES: 'Vendas $ mercado',
                METRIC_MARKET_UNITS: 'Vendas UN mercado',
                METRIC_MARKET_PRICE: 'Preço mercado',
                METRIC_MARKET_SALES_RANKING: 'Rank vendas $ mercado',
                METRIC_MARKET_UNITS_RANKING: 'Rank vendas UN mercado',
                METRIC_SALES_UNITS_GAP: 'Vendas UN GAP',
                METRIC_PARKING_CONTRIBUTION: 'Parking apt.',
                PARKING_LABEL: 'Parking',
              },
              SUGGESTION_STEP: {
                STEP_PREFIX: 'Passo {{stepNumber}}: {{stepTitle}}',
                STEP_TITLE_FALLBACK: 'Processo',
                STEP_TITLE: {
                  UserGeneration: 'Geração do usuário',
                  PrismaGeneration: 'Geração do Prisma',
                  PrismaPrioritization: 'Priorização Prisma',
                  PrismaBlocking: 'Bloqueio Prisma',
                  PrismaExclusionCheck: 'Verificação de regras de exclusão',
                  PrismaValidation: 'Validação Prisma',
                  PrismaSuggestion: 'Sugestão Prisma',
                },
                MESSAGE: {
                  UserGenerated:
                    'O usuário gerou uma sugestão de {{action}} com base em {{itemTagLabel}} {{conditionOperator}} {{conditionValue}}{{conditionValueSuffix}}',
                  PrismaGeneratedBoth: 'O Prisma gerou candidatos para Alta e Baixa',
                  PrismaGenerationSkippedSingleDirection: 'O Prisma omitiu a geração independente (tipo: {{action}})',
                  PrismaPrioritizationSkippedBlocked: 'Omitido — o candidato já estava descartado',
                  PrismaPrioritizationCompleted: 'O Prisma priorizou a sugestão de {{action}} sobre uma oposta existente',
                  PrismaPrioritizationSkippedNoConflict: 'Não havia sugestão oposta para este par item-loja',
                  PrismaExclusionCheckPassed: 'Nenhuma regra de exclusão se aplica a este par',
                  PrismaExclusionCheckBlocked: "Sugestão de {{action}} bloqueada pela regra de exclusão de sortimento '{{ruleName}}'",
                  PrismaValidationSkippedExcluded: 'Omitido — o par já estava excluído',
                  PrismaValidationBlocked:
                    'Bloqueada pela condição {{variable}} {{conditionOperator}} {{threshold}} (valor atual: {{actualValue}})',
                  PrismaValidationAlert: 'O Prisma detectou {{alertCount}} alerta(s)',
                  PrismaValidationPassed: 'O Prisma validou o par sem observações',
                  PrismaSuggestionSkippedExcluded: 'Não gerada — bloqueada por regra de exclusão',
                  PrismaSuggestionSkippedBlocked: 'Não gerada — bloqueada por regra de validação',
                  PrismaSuggestionCompleted: 'O Prisma gerou a sugestão final de {{action}}',
                },
                ACTION: {
                  Add: 'alta',
                  Remove: 'baixa',
                },
                CONDITION_OPERATOR: {
                  GreaterThan: 'maior que',
                  LessThan: 'menor que',
                  Equals: 'igual a',
                },
                CONDITION_VALUE_SUFFIX: {
                  Percentage: '%',
                },
              },
            },
          },
          COLUMN_CATEGORY: 'Loja / Categoria / Subcategoria',
          COLUMN_CONFIGURATION: 'Configuração',
          COLUMN_PRICE_INDEX: 'Índice de Preço',
          COLUMN_CURRENT_MARGIN: 'Margem Atual %',
          COLUMN_TARGET_MARGIN: 'Margem Alvo %',
          COLUMN_MIN_MARGIN: 'Margem Mín %',
          COLUMN_MAX_MARGIN: 'Margem Máx %',
          COLUMN_CONFIGURATION_TOOLTIP: 'Indica se a categoria possui configuração personalizada ou herdada',
          COLUMN_PRICE_INDEX_TOOLTIP: 'Índice de preço calculado com base na configuração',
          COLUMN_CURRENT_MARGIN_TOOLTIP: 'Margem atual da categoria. As setas indicam se está acima ou abaixo do alvo.',
          COLUMN_TARGET_MARGIN_TOOLTIP: 'Margem alvo configurada para a categoria ou herdada de seu pai',
          COLUMN_MIN_MARGIN_TOOLTIP: 'Margem mínima permitida de acordo com as condições de validação',
          COLUMN_MAX_MARGIN_TOOLTIP: 'Margem máxima permitida de acordo com as condições de validação',
          CONFIG_TYPE_INHERITED: 'HERDADA',
          CONFIG_TYPE_CUSTOMIZED: 'PERSONALIZADA',
          WARNING_NO_CONFIGURATION: 'Sem configuração',
          WARNING_NO_PRICE_REFERENCE: 'Sem preço de referência',
          WARNING_NO_TARGET_MARGIN: 'Sem margem alvo',
          WARNING_NO_MIN_MARGIN: 'Sem margem mínima',
          WARNING_NO_MAX_MARGIN: 'Sem margem máxima',
          ACTION_EDIT_GUIDELINES: 'Editar diretrizes',
          ACTION_CONFIGURE_GUIDELINES: 'Configurar diretrizes',
          MARGIN_ABOVE_TARGET: 'Margem acima do objetivo',
          MARGIN_BELOW_TARGET: 'Margem abaixo do objetivo',
          MARGIN_EQUALS_TARGET: 'Margem cumpre o objetivo',
          EXPORT_TTIP: 'Exportar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          CATEGORIES: 'Categorias',
          RULES: 'Regras',
          RULES_TTIP: 'Número de regras de preço',
          TARGET_MARGIN: 'Margem Objetivo %',
          TARGET_MARGIN_TTIP: 'Margem Objetivo Percentual',
          MIN_MARGIN: 'Mg Min %',
          MIN_MARGIN_TTIP: 'Margem Miníma Percentual',
          MAX_MARGIN: 'Mg Max %',
          MAX_MARGIN_TTIP: 'Margem Máxima Percentual',
          ALLOW_MIN_VIOLATION: 'Sug. Abaixo Mg Min',
          ALLOW_MIN_VIOLATION_TTIP:
            'Se esta caixa estiver marcada, o Prisma irá sugerir abaixo da margem mínima e exibirá um sinal de alerta próximo à sugestão. Caso contrário, a sugestão o levará ao valor mínimo inserido.',
          ALLOW_MAX_VIOLATION: 'Sug. Acima Mg Max',
          ALLOW_MAX_VIOLATION_TTIP:
            'Se esta caixa estiver marcada, o Prisma irá sugerir acima da margem máxima, e exibirá um sinal de alerta ao lado da sugestão, caso contrário a sugestão irá levá-lo ao valor máximo inserido.',
          SIGNIFICANT_VAR_MARGIN: 'Variação Significativa Mg R$',
          SIGNIFICANT_VAR_MARGIN_TTIP: 'Variação Significativa de Margem em Reais',
          MIN_VARIATION: 'Var Min %',
          MIN_VARIATION_TTIP: 'Redução máxima de preço permitida por alteração de preço',
          MAX_VARIATION: 'Var Max %',
          MAX_VARIATION_TTIP: 'Aumento de preço máximo permitido por alteração de preço',
          ALLOW_MIN_VARIATION: 'Sug. Abaixo Var Min',
          ALLOW_MIN_VARIATION_TTIP:
            'Se esta caixa estiver marcada, o Prisma irá sugerir acima da redução máxima, e exibirá um sinal de alerta ao lado da sugestão, caso contrário a sugestão irá levá-lo ao valor máximo inserido.',
          ALLOW_MAX_VARIATION: 'Sug. Acima Var Max',
          ALLOW_MAX_VARIATION_TTIP:
            'Se esta caixa estiver marcada, o Prisma irá sugerir acima do aumento máximo, e exibirá um sinal de alerta ao lado da sugestão, caso contrário a sugestão irá levá-lo ao valor máximo inserido.',
          SIGNIFICANT_VARIATION: 'Var Significativa R$',
          SIGNIFICANT_VARIATION_TTIP: 'Variação Significativa em Reais',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Informação Básica',
          MARGIN_GUIDELINES: 'Diretrizes de margem',
          TARGET_MARGIN_INPUT: 'Margem Objetivo %',
          MIN_MARGIN_INPUT: 'Margem Min %',
          MAX_MARGIN_INPUT: 'Margem Max %',
          SIGNIFICANT_VAR_MARGIN_INPUT: 'Variação Significativa de Margem R$',
          ALLOW_MIN_VIOLATION_CHECK: 'Sugerir abaixo do mínimo',
          ALLOW_MIN_VIOLATION_CHECK_TTIP:
            'Se esta caixa estiver marcada, o Prisma irá sugerir abaixo da margem mínima, e irá mostrar um sinal de alerta ao lado da sugestão, caso contrário a sugestão irá levá-lo ao valor mínimo inserido.',
          ALLOW_MAX_VIOLATION_CHECK: 'Sugestão acima do máximo',
          ALLOW_MAX_VIOLATION_CHECK_TTIP:
            'Se esta caixa estiver marcada, o Prisma irá sugerir acima da margem máxima, e irá mostrar um sinal de alerta ao lado da sugestão, caso contrário irá levar a sugestão ao valor máximo',
          VARIATION_PRICE: 'Variação de preço',
          MIN_MARGIN_V_INPUT: 'Redução Máxima %',
          MAX_MARGIN_V_INPUT: 'Aumento Máximo %',
          SIGNIFICANT_VAR_MARGIN_V_INPUT: 'Variação Significativa de Margem R$',
          ALLOW_MIN_VIOLATION_V_CHECK: 'Sugerir abaixo do mínimo',
          ALLOW_MIN_VIOLATION_V_CHECK_TTIP:
            ' Se esta caixa estiver marcada, o Prisma irá sugerir acima da redução máxima, e exibirá um sinal de alerta ao lado da sugestão, caso contrário a sugestão irá levá-lo ao valor máximo inserido.',
          ALLOW_MAX_VIOLATION_V_CHECK: 'Sugestão acima do máximo',
          ALLOW_MAX_VIOLATION_V_CHECK_TTIP:
            ' Se esta caixa estiver marcada, o Prisma irá sugerir acima do aumento máximo, e exibirá um sinal de alerta ao lado da sugestão, caso contrário a sugestão irá levá-lo ao valor máximo inserido.',
          TITLE_MODAL: 'Mudanças de impacto nos próximos níveis da árvore de categorias',
          SUBTITLE_MODAL:
            'Deseja estabelecer essas mesmas diretrizes para os níveis seguintes da árvore de categorias, até e incluindo o nível de subcategoria?',
          REFUSE_BTN: 'Cancelar',
          ACCEPT_BTN: 'Aceitar',
          BRAND_LABEL: 'Marca própria',
          BRAND_PLACEHOLDER: 'Selecione uma marca',
          GENERAL_CONFIG_TITLE: 'Configuração Geral de Diretrizes',
          NO_GENERAL_CONFIG_TITLE: 'Configuração Geral Requerida',
          TAB_REFERENCE_PRICE: 'Preço de Referência',
          TAB_VALIDATION_CONDITIONS: 'Condições de Validação',
          TAB_MAIN_DATA: 'Dados Principais',
          CATEGORY_CONFIG_TITLE: 'Configurar Categoria',
          TARGET_MARGIN_HINT: 'Indique a porcentagem de margem objetivo para esta categoria',
          ERROR_TAB_INCOMPLETE: 'Complete os campos obrigatórios na aba "{{val}}"',
          AUTO_GENERATE_MARGIN_RULE: 'Gerar sugestões de preços',
          AUTO_GENERATE_MARGIN_RULE_TOOLTIP:
            'Ao ativar esta opção, será criada uma regra de margem com a margem objetivo da categoria/subcategoria.',
          AUTO_GENERATE_ACTIVE_DESC:
            'Diante da mudança de custos e/ou impostos, Prisma gerará sugestões que busquem cumprir com a margem objetivo.',
          TARGET_MARGIN_PLACEHOLDER: 'Indique a porcentagem de margem objetivo',
          TARGET_MARGIN_MIN_ERROR: 'O valor deve ser maior ou igual a {{val}}%',
          TARGET_MARGIN_MAX_ERROR: 'O valor deve ser menor ou igual a {{val}}%',
          CROSS_MIN_GREATER_THAN_TARGET: 'A margem mínima não pode ser maior que a margem objetivo',
          CROSS_MAX_LESS_THAN_TARGET: 'A margem máxima não pode ser menor que a margem objetivo',
          CROSS_MIN_GREATER_THAN_MAX: 'A margem mínima não pode ser maior que a margem máxima',
          REFERENCE_PRICE: {
            TAB_TITLE: 'Configure Preço de Referência para configuração geral',
            COMPETITOR_TITLE: 'Concorrente',
            COMPETITOR_DESC: 'Selecione a maneira que deseja comparar com seus concorrentes',
            COMPETITOR_PRINCIPAL: 'Concorrente Principal',
            COMPETITOR_PRINCIPAL_DESC: 'Buscará o preço do Concorrente Principal de cada Ponto de Venda.',
            COMPETITOR_TRADE_AREA: 'Trade Area',
            COMPETITOR_TRADE_AREA_DESC: 'Buscará o preço dos Concorrentes associados ao Trade Area de cada Ponto de Venda.',
            COMPETITOR_SELECTION: 'Seleção de Concorrentes',
            COMPETITOR_SELECTION_DESC: 'Buscará os concorrentes que cumpram com os critérios a definir a seguir.',
            POSITION_TITLE: 'Posição',
            POSITION_DESC: 'Selecione a posição na qual deseja comparar contra seu concorrente',
            POSITION_MIN: 'Mínimo',
            POSITION_MIN_DESC: 'O valor mais baixo',
            POSITION_MAX: 'Máximo',
            POSITION_MAX_DESC: 'O valor mais alto',
            POSITION_AVERAGE: 'Promedio',
            POSITION_AVERAGE_DESC: 'A média dos valores',
            POSITION_MODE: 'Moda',
            POSITION_MODE_DESC: 'O valor que mais se repete',
            SOURCE_TITLE: 'Fontes de Relevância',
            SOURCE_DESC: 'Selecione a origem de onde se obtém a informação ou os dados para esta configuração',
            SOURCE_MYSTERY: 'Mystery Shopper App',
            SOURCE_APP: 'Prisma App',
            SOURCE_MANUAL: 'Relevância Manual',
            ONLY_RELEVANT_COMPETITORS: 'Selecionar apenas concorrentes relevantes (Markers)',
            INCLUDE_FILTERS: 'Incluir',
            EXCLUDE_FILTERS: 'Excluir',
          },
          VALIDATION_CONDITIONS: {
            TITLE: 'Condições de Validação',
            DESCRIPTION: 'Alertas, Limites e Bloqueios para garantir que as sugestões cumpram com as condições do seu negócio.',
            AUTO_APPROVE_TITLE: 'Aprovar automaticamente',
            AUTO_APPROVE_DESC:
              'Se estiver ativado, as sugestões e mudanças de preços serão aprovadas de forma automática, sempre que cumpram com todas as condições de validação.',
            ADD_VALIDATION: 'ADICIONAR VALIDAÇÃO',
            NO_VALIDATIONS: 'Não há validações configuradas. Adicione uma nova validação para começar.',
            TABLE_PRIORITY: 'Prioridade',
            TABLE_CRITERION: 'Critério',
            TABLE_ACTION: 'Ação',
            TABLE_DESCRIPTION: 'Descrição',
            TABLE_MIN: 'Mínimo',
            TABLE_MAX: 'Máximo',
            TABLE_ACTIONS: 'Ações',
            ACTION_ALERT: 'Alertar',
            ACTION_LIMIT: 'Limitar',
            ACTION_BLOCK: 'Bloquear',
            CRITERION_MARGIN_PERCENTAGE: 'Margem %',
            CRITERION_MARGIN_AMOUNT: 'Margem $',
            CRITERION_PRICE_VARIATION_PERCENTAGE: 'Variação de preços %',
            CRITERION_PRICE_VARIATION_AMOUNT: 'Variação de preços $',
            CRITERION_COMPETENCE_LIMIT: 'Limite de concorrência',
            CRITERION_MY_PRICE_VS_COMPETITOR_RANGE: 'Meu preço atual vs faixa do concorrente',
            QUICK_ADD_TITLE: 'Garanta que as sugestões de preços cumpram com suas condições de negócio',
            QUICK_ADD_SUBTITLE: 'Adicione validações para customizar as sugestões de preços',
            MODAL_CREATE_TITLE: 'Configurar nova validação',
            MODAL_EDIT_TITLE: 'Editar validação',
            STEP1_LABEL: 'Critério e Faixa',
            STEP2_LABEL: 'Ação do sistema',
            STEP_COMPETITOR_LABEL: 'Tipo de Preço e Concorrente',
            STEP_DATA_SOURCES_LABEL: 'Levantamento e Dados',
            CRITERION_TITLE: 'Critério',
            CRITERION_DESCRIPTION: 'Selecione um critério para a validação de preços',
            RANGE_TITLE: 'Faixa de variação',
            RANGE_DESCRIPTION: 'Selecione mínimo e máximo para o critério selecionado',
            MINIMUM: 'Mínimo',
            MAXIMUM: 'Máximo',
            MIN_PLACEHOLDER: 'Indique mínimo em números',
            MAX_PLACEHOLDER: 'Indique máximo em números',
            ACTION_TITLE: 'Ação do sistema',
            ACTION_DESCRIPTION: 'Selecione a posição na qual deseja estar contra seu concorrente',
            ACTION_ALERT_DESCRIPTION: 'Permite sugestão fora da faixa, mas notifica',
            ACTION_ALERT_DESCRIPTION_ASSORTMENT: 'Permite gerar a sugestão, mas emite uma notificação de advertência por incumplimento',
            ACTION_LIMIT_DESCRIPTION: 'Força a sugestão dentro da faixa',
            ACTION_LIMIT_DESCRIPTION_ASSORTMENT: 'Bloqueia a geração da sugestão se o valor estiver fora do intervalo configurado',
            ACTION_BLOCK_DESCRIPTION: 'Bloqueia qualquer sugestão fora da faixa',
            BANNER_TITLE: 'Se no preço sugerido...',
            BLOCK_LIMITS: 'Limites',
            DESC_RANGE_OUTSIDE: 'se estiver fora da faixa {{min}}-{{max}}{{unit}}',
            DESC_RANGE_LESS: 'se for menor que {{min}}{{unit}}',
            DESC_RANGE_MORE: 'se for maior que {{max}}{{unit}}',
            DESC_COMPETITOR_COMPARISON: ' vs {{competitor}}{{markers}}',
            DESC_MARKERS_RELEVANT: ' (relevantes)',
            DESC_PRICE_TYPE: ' - {{priceType}}',
            DESC_DATA_SOURCES: ' ({{sources}})',
            COMPETITOR_TYPE_PRINCIPAL: 'Concorrente Principal',
            COMPETITOR_TYPE_TRADE_AREA: 'Trade Area',
            COMPETITOR_TYPE_SELECTION: 'Seleção de Concorrentes',
            BANNER_LESS_THAN: ' é menor que ',
            BANNER_OR: ' ou ',
            BANNER_GREATER_THAN: ' maior que ',
            BANNER_RESPECT_TO_RELEVANT: ' em relação ao ',
            BANNER_RESPECT_TO: ' em relação a ',
            BANNER_RELEVANT_COMPETITORS_OF: 'os concorrentes relevantes de',
            BANNER_OF_THE: ' do ',
            BANNER_ACCORDING_TO: ', de acordo com os dados levantados de ',
            BANNER_THROUGH: ' através de',
            BANNER_AND: ' e ',
            BANNER_THEN: ', então ',
            BANNER_SUGGESTED_PRICE: ' o preço sugerido',
            BANNER_PLACEHOLDER_CRITERION: '[Critério]',
            BANNER_PLACEHOLDER_COMPETITORS: '[Concorrentes]',
            BANNER_PLACEHOLDER_COMPETITOR_TYPE: '[Tipo de concorrente]',
            BANNER_PLACEHOLDER_PRICE_TYPE: '[Tipo de preço]',
            BANNER_PLACEHOLDER_SOURCE: '[Fonte de Levantamento]',
            BANNER_PLACEHOLDER_ACTION: '[Ação do sistema]',
            BLOCK_LIMITS_ASSORTMENT: 'Validações',
            BLOCK_BLOCKS: 'Bloqueios',
            BLOCK_ALERTS: 'Alertas',
            EMPTY_BLOCK: 'Não há validações nesta categoria',
            BUTTON_BACK: 'Voltar',
            BUTTON_NEXT: 'Próximo passo',
            BUTTON_SAVE: 'Salvar nova validação',
            BUTTON_UPDATE: 'Atualizar validação',
            PRICE_TYPE_TITLE: 'Tipo de preço relevado',
            PRICE_TYPE_DESCRIPTION: 'Selecione qual tipo de preço será levado em conta para esta validação',
            PRICE_TYPE_REGULAR: 'Regular',
            PRICE_TYPE_PROMOTIONAL: 'Promocional',
            PRICE_TYPE_WHOLESALE: 'Atacado',
            PRICE_TYPE_OTHER: 'Outro',
            DATA_SOURCES_TITLE: 'Fontes de Levantamento',
            DATA_SOURCES_DESCRIPTION:
              'Selecione a origem de onde se obtém a informação ou os dados de preço relevado para esta configuração',
            DATA_SOURCE_MYSTERY_SHOPPER: 'Mystery Shopper App',
            DATA_SOURCE_PRISMA_APP: 'Prisma App',
            DATA_SOURCE_MANUAL: 'Levantamento Manual',
            DATA_SOURCE_OTHER: 'Outra',
          },
          GENERAL_CONFIG_LOADING_TOOLTIP: 'Carregando...',
        },
      },
      REPORTS: {
        ROUTE: 'Preços / Relatórios',
        SUGGESTIONREPORTS: {
          ROUTE: 'Preços / Relatórios',
          GENERATE: 'Geração de relatório',
          TITLE: 'Relatório de Sugestões',
          GENERATE_TITLE: 'Geração do Relatório de Sugestões',
          INPROCESS: 'Geração de relatório',
          DAY: 'Dia',
          INTRODUCTION: 'Gere relatório com os detalhes de todas as sugestões do dia indicado.',
        },
        COSTREPORTS: {
          ROUTE: 'Preços / Relatórios',
          GENERATE: 'Geração de relatório',
          TITLE: 'RELATÓRIO DE CUSTOS',
          GENERATE_TITLE: 'Geração do Relatório de Custos',
          INPROCESS: 'Geração de relatório',
          DAY: 'Dia',
          INTRODUCTION:
            'Gere relatório com os detalhes de todos os custos filtrados. A partir daqui, será possível selecionar um intervalo de datas não superior a 30 dias para o download dos custos.',
        },
        YPF: {
          ROUTE: 'Preços / Relatórios',
          TITLE: 'Relatórios YPF',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          COMPETITIVE_POSITION: 'Posicionamento Competitivo',
          EXPORT_TTIP: 'Exportar',
          APP_TTIP: 'Compartilhe com o aplicativo',
          DASHBOARD_TTIP: 'Ir para o dashboard',
          COMPETITOR: 'Concorrente',
          N2: 'N2',
          N3: 'N3',
          G2: 'G2',
          G3: 'G3',
          CHEAPER: 'Mais barato',
          EQUEAL_PRICE: 'Igual Preço',
          MORE_EXPENSIVE: 'Mais caro',
          PROVINCE_FILTER: 'Província',
          FILTER: 'Filtro',
          LOCATION_FILTER: 'Localidade',
          BRANDS_FILTER: 'Bandeiras',
          APPLY_BTN: 'APLICAR FILTROS',
          COMPETITION_PRICES: 'Preços dos Concorrentes',
          NS: 'NS',
          INF: 'INF',
          UD: 'UD',
          D500: 'D500',
          INF_D: 'INF D',
          INF_NS: 'INF vs NS',
          INFD_D500: 'INF vs D500',
          RETAIL_MARGIN: 'Margens Varejista',
          PRODUCTS_FILTER: 'Produtos',
          WARNING_CONTINUE_PLANEX: 'A ação a realizar enviará informações a PLANEXWARE. Deseja continuar?',
        },
        DAILYMARGIN: {
          LIST: {
            TITLE: 'Relatórios diários de margens',
            ROUTE: '/prices/reports/daily-margin',
            DELETE: 'Eliminar',
            DELETE_TTIP: 'Eliminar',
            FILTER_TTIP: 'Filtro',
            EXPORT: 'Download',
            EXPORT_TTIP: 'Exportar relatório em formato excel',
            STORECODE: 'Código do ponto de venda',
            STORENAME: 'Ponto de venda',
            ITEMCODE: 'Código do produto',
            ITEMNAME: 'Produtos',
            PRICE: 'Preço',
            PRICEWOTAXES: 'Preço sem impostos',
            COST: 'custo',
            MARGIN: 'Margem',
            MAXMARGINAMOUNT: 'Margem máxima',
            COMPETITOR: 'Concorrente',
            COMPETITORSPRICE: 'Preço do concorrente',
            MARKETAVERAGEPRICE: 'Preço médio',
            CURRENTDATE: 'Data atual',
            MARGINVSMAXMARGIN: 'Margem vs Margem Máxima',
            COMPETITIVEINDEX: 'Competitividade',
            MARKETCOMPETITIVEINDEX: 'Competitividade de mercado',
          },
        },
        PRICE_INCONSISTENCY: {
          ROUTE: 'Preços / Relatórios',
          TITLE: 'Inconsistências de preço',
          CODE: 'Código',
          NAME: 'Nome',
          CURRENT_PRICE: 'Preço Atual',
          MAXIMUM_PRICE: 'Preço Máximo',
          STORE: 'Ponto de Venda',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          TITLE_FILTERS: 'Filtros',
          CATEGORY_FILTER: 'Categoria',
          SEARCH_CATEGORY_FILTER: 'Procurarr Categorias',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
        },
        PRICES_MAP: {
          ROUTE: 'Preços / Relatórios',
          TITLE: 'Mapa de Preços',
          CHOOSE_PRODUCT: 'Escolha um produto para mostrar o mapa',
          CHOOSE_PRODUCT_AND_ZONE: 'Escolha um produto e zona para mostrar o mapa',
          FILTER_TTIP: 'Filtrar',
          PRODUCT_FILTER: 'Produtos',
          MARKER_FILTER: 'Marker',
          OP1_ALL: 'Todos',
          OP2_MARKER: 'Marker',
          OP3_NO_MARKER: 'Sem Marcador',
          NAME: 'Nome',
          CODE: 'Código',
          PRICE: 'Preço',
          BRAND: 'Bandeira',
          MARKER: 'Marker',
          Nuevo: 'Novo',
          SOURCE: 'Fonte',
          SOURCE_TTIP: 'Font de Relevância',
          VALIDFROM: 'Data da Releitura.',
          Incompleto: 'Incompleto',
          OWN_BRAND: 'Própria marca',
          CHART_TITLE: 'Preços históricos',
          CHART_TITLE_PRICE: 'Preço',
          CHART_TITLE_VENTAS: 'Vendas',
          REFERENCE_STORE: 'PDV de Referência',
        },
        COMPETITOR_PRICES: {
          ROUTE: 'Preços / Relatórios',
          TITLE: 'Preços dos Concorrentes',
          DOWLOAD_REPORT: 'Baixar Relatório',
          SINCE_INPUT: 'Desde',
          TO_INPUT: 'Até',
        },
        CONTEXT_REPORT: {
          HEADER: {},
          FILTERS: {},
          METHODOLOGY: {},
          TABLE: {},
          EVIDENCE: {},
          VALIDATION: {},
        },
        PRICES_AUDIT: {
          PRICE_CHANGES: 'Auditoria de Preços',
          PROD_FILTERS: 'Filtros de Produto',
          FUELS: 'Combustíveis',
          BUSINESS_UNIT: 'Unidades de Negócio',
          DEP: 'Departamento',
          CAT: 'Categoria',
          SUBCAT: 'Subcategoria',
          PROD: 'Produto',
          POS_FILTERS: 'Filtros PDV',
          REGION: 'Região',
          OPERATION_TYPE_FILTER: 'Tipo de Operação',
          STORE_TYPE_INPUT: 'Ponto de Venda',
          DATE_FILTER: 'Filtros Data',
          INITIAL_DATE: 'Data Inicial',
          END_DATE: 'Data Final',
          USER: 'Usuário',
          REPORT: 'Gerar Reporte',
          REPORT_UPDATE: 'Atualizar Reporte',
          CODE: 'Código',
          STORES: 'Pontos de Venda',
          NAME: 'Nome',
          PREVIUS_PRICE_INPUT: 'R$ Preço Anterior',
          MARGIN_PRICE_INPUT: '% Margem Anterior',
          NEW_PRICE_INPUT: 'R$ Preço Novo',
          AUDIT_PRICE_CHANGE: 'Mudança de Preço',
          MARGIN_NEW: '% Margem Novo',
          INFORM: 'data informada',
          INFORM_BY: 'Informado por',
          SUBTITLE: 'Preços / Relatórios',
        },
        PRICE_REPORT: {
          TITLE: 'Preços / Relatórios',
          WeightedIndex: 'Índice P',
          SalesUnits: 'Vendas U',
          Sales: 'Vendas R$',
          Margin: 'Margem R$',
          PercentageMargin: 'Margem %',
          Gmroi: 'GMROI',
          COMPETITIVENESS_INDEX: 'Indice de competitividade',
          PREVIOUS_MONTH_DIF: 'Dif % Vs Mês anterior',
          SUGGESTIONS_ACCEPTED: '% Sugestões Aceitas',
          MarginDif: 'Dif. Margem vs Mês Anterior',
          PercentageMarginDif: 'Pontos Percentuais vs Mês Anterior',
          DEC_TYPE: 'Tipos de Decisões',
          INDEX_COMP: 'Indice de competitividade (IC%)',
          CATEGORY: 'Categoria',
          CHEAPER: 'Mais barato',
          SAME: 'Iguais',
          MORE_EXPENSIVE: 'Mais Caros',
          PRICES_TYPES: 'Tipos de Preços',
          PERIOD: 'Período',
          CATEGORYS: 'Categorias',
          EVOL_GRAPH: 'Gráfico Evolutivo',
          VARIABLE: 'Variável',
          VARIABLES: 'Variáveis',
          MAP: 'Mapa',
          PRODUCT_PERFORMANCE: 'Desempenho de Produtos',
          PRODUCT: 'Produto',
          VOLUME: 'Volume',
        },
      },
      DECISIONS: {
        SUMMARY: {
          ROUTE: 'Preços / Desições',
          TITLE: 'Resume de Decisōes',
          REVISE_BTN: 'Revisar tudo',
          UPDATE_STATISTICS: 'Atualizar Estatísticas',
          LASTUPDATEDON: 'Última atualização:',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          REVIEW_PENDING: 'Sem Revisar',
          CATEGORY: 'Categoria',
          REVIEW_PENDING_TTIP: 'Sugestões Pendentes de Revisão',
          DECISIONS: 'Revisadas',
          DECISIONS_TTIP: 'Decisões Tomadas',
          ADVANCED: 'Progresso %',
          ADVANCED_TTIP: 'Leva em consideração apenas sugestões',
          SEND: 'Enviar',
          SUGGESTED_IMPACT: 'Imp. Sug. R$',
          SUGGESTED_IMPACT_TTIP: 'Impacto Sugerido',
          DECISIONS_IMPACT: 'Decis. Imp. R$',
          DECISIONS_IMPACT_TTIP: 'Impacto Desições',
          REVIEW_IMPACT: 'Avaliação do impacto R$',
          REVIEW_IMPACT_TTIP: 'Avaliação do impacto',
          PENDING_APPROVAL: 'Sem Aprovar',
          PENDING_APPROVAL_TTIP: 'Número de decisões pendentes para aprovação',
          APPROVED: '# Aprovados',
          APPROVED_TTIP: 'Decisões Aprovadas',
          TITLE_FILTERS: 'Filtros',
          PROVINCES_FILTER: 'Estado',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          REJECTED_TTIP: 'Rejeitados',
          REJECTED: 'Rejeitadas',
          APPROVE: 'Aprovar',
          APPROVE_ALL: 'Aprovar Tudo',
          REVIEW: 'Avaliar',
          CONFIRM_SEND: 'Confirma o Envío?',
          CONFIRM_SEND_ALL: 'Confirma o envío de todos os ítens?',
          CONFIRM_APPROVE: 'Confirma a aprovaçāo?',
          CONFIRM_APPROVE_ALL: 'Confirma a aprovação de todos os itens?',
          CONFIRM_REVIEW: 'Confirma a revisão de todos os itens?',
        },
        ERP: {
          ROUTE: 'Preços / Desições',
          TITLE: 'Publicar Decisões',
          DOWLOAD_BTN: 'Baixar Info',
          PREVIEW_BTN: 'Vista Prévia',
          INFORM_BTN: 'Publicar',
          LAST_PRICES: 'Últimos preços Publicados',
          GENERATION_DATE: 'Data de geração',
          GENERATION_TIME: 'Tempo de Geração',
          USER: 'Usuário',
          FILE: 'Arquivo',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          PREVIEW_PROCCESING: 'O processamento foi iniciado. Você receberá uma notificação quando terminar.',
          PREVIEW_WITHOUT_PROCCESING: 'Não há novos dados para processar.',
        },
        PRICE_DECISIONS: {
          NO_GROUPID: 'Elecione uma categoria para exibir a lista',
          APPLY_FILTERS: 'Filtros Aplicáveis',
          STRATEGY_DIALOG: {
            UNIT: 'Unidade',
            Price: 'R$',
            Margin: '%',
            UsdxM3: 'R$ * M3',
            MIN_MARGIN_ERROR: 'O valor deve ser maior ou igual a {{val}}%',
          },
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          SUGGESTED_IMPACT_TITLE: 'Impacto Sugerido R$',
          CHANGES_TITLE: '# Mudanças',
          VS_SUGGESTED_IMPACT_TITLE: 'Vs Impacto Sugerido R$',
          CHANGES_PRICE_TITLE: 'Preço Variação%',
          NEW_IMPACT_TITLE: 'Impacto Novo R$',
          SUGGESTIONS_ACCEPTED_DESCRIPTION: 'Sugestões Aceitas',
          WEIGHTED_SALE_DESCRIPTION: 'Ponderado por Vendas',
          PERCENT_CHANGE: 'Variação %',
          FILTER_CHIP: 'Filtrar preço de',
          CODE_ITEM: 'Código do produto',
          CODE_STORE: 'Código do ponto de venda',
          PARENT_RULE: 'Regra de parentesco',
          FILTER_CHIP_PARENT: 'Filtrar preços pela regra de relacionamento',
          FILTER_CHIP_PARENT_ITEM: 'Produto pai:',
          FILTER_CHIP_PARENT_STORE: 'Ponto de Venda, Pai:',
          TABLE_TITLE: 'Análise da Sugestão',
          INIT_PRICE_IMPORT_TITLE: 'Precificação inicializada pela importação',
          OBSERVATIONS: 'Observações',
          REASON: 'Motivo',
          STEP_BY_STEP: 'Passo a passo',
          SEE_MORE_TABLE: 'Ver mais...',
          PRICE_TABLE: 'Preço',
          MARGIN_TABLE: 'Margem',
          CI_TABLE: 'Custos mais Impostos',
          ORIGINAL_TABLE: 'Original R$',
          ACTUAL_TABLE: 'Atual R$',
          SUGGESTED_TABLE: 'Sugerido R$',
          DECISION_TABLE: 'Decisão R$',
          ROUTE: 'Preços / Desições',
          TITLE: 'Decisões de Preços',
          FILTER_TTIP: 'Filtrar',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          KEEP_PRICES: 'Ignorar Sugestões',
          KEEP_PRICES_TTIP: 'Ignorar sugestões selecionadas',
          ACCEPT_SUGGESTIONS: 'Aceitar sugestões',
          ACCEPT_SUGGESTIONS_TTIP: 'Aceitar sugestões selecionadas',
          ENDORSE: 'Aprovar Mudanças',
          ENDORSE_TTIP: 'Aprovar mudanças selecionadas',
          REJECT_ENDORSE: 'Rejeitar alterações',
          REJECT_ENDORSE_TTIP: 'Rejeitar alterações selecionadas',
          REVERT_PRICE: 'Reverter Preços',
          REVERT_PRICE_TTIP: 'Reverter preços selecionados',
          MARK_REVIEWED: 'Solicitar Aprovação',
          MARK_REVIEWED_TTIP: 'Solicitar Aprovação das decisões selecionadas',
          EDIT_PRICES: 'Modificar Preços',
          EDIT_PRICES_TTIP: 'Modificar Preços Manualmente',
          EFFECTIVE_DATE: 'Datas válidas',
          EFFECTIVE_DATE_TTIP: 'Definir datas válidas para produtos selecionados',
          CLEAN_FILTERS: 'Limpar Filtros',
          PRODUCT: 'Produto',
          PRICE_TYPE: 'Tipo de Preço',
          CURRENT_PRICE_TTIP: 'Preço Atual',
          VALID_PRICE_TTIP: 'Preço Válido',
          NOT_VALID_PRICE_TTIP: 'Preço Inválido',
          SUGGESTION_PRICE_TTIP: 'Preço sugerido R$',
          CHECK_TTIP: 'Revisada',
          PRICE: 'Preço Atual R$',
          COMPETITION_PRICE: 'Precificação da Concorrência $',
          SUGGESTION: 'Preço sugerido R$',
          DECISIONS: 'Decisão R$',
          IMPACT: 'Impacto R$',
          NEWVALIDATEDATE: 'Data de vigência',
          ACCEPT_SUGGESTION: 'Aceitar sugestões',
          KEEP_PRICE: 'Manter o preço atual',
          EDIT_MANUALLY: 'Mudar Manualmente',
          TEXT_SNACKBAR: 'Foram modificados {{val}} registros',
          TEXT_SNACKBAR_MAX_BULK_LIMIT: 'Não é possível realizar ações em massa para mais de {{val}} itens.',
          EFFECTIVE_DATE_MODAL: 'Data válida',
          EFFECTIVE_DATE_INPUT: 'Data válida',
          TO_DATE_INPUT: 'Data de Vencimento da Validade',
          CANCEL_BTN: 'Cancelar',
          ACCEPT_BTN: 'Aceitar',
          TEXT_SNACKBAR2: 'Foram modificados {{val}} registros',
          TITLE_FILTERS: 'Filtros',
          PROVINCE_FILTERS: 'Província',
          CITY_FILTERS: 'Cidade',
          PRICE_ZONE1_FILTERS: 'Zona de preço 1',
          PRICE_ZONE2_FILTERS: 'Zona de preço 2',
          PRICE_ZONE3_FILTERS: 'Zona de preço 3',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          EDIT_PRICE_MODAL: 'Modificar Preços',
          STRATEGY_INPUT: 'Estratégia',
          ROUNDING_CHECK: 'Use regras de arredondamento',
          VALUE_INPUT: 'Valor',
          TAB1: 'Decisão',
          TAB2: 'Concorrentes',
          TAB3: 'Custos e Margens',
          TAB4: 'Auditoria',
          TAB5: 'Pontos de Venda Filhos',
          TAB6: 'Receita',
          TAB7: 'Produtos em Combo',
          TAB8: 'Combo',
          TAB_ZONES: 'Zonas',
          TAB_ZONES_TITLE: 'Zonas de preço (escopo de Pontos de Venda)',
          CODE_INPUT: 'Código',
          UM_BASE_INPUT: 'Base UM',
          BRAND_INPUT: 'Bandeira',
          NAME_INPUT: 'Nome',
          WITHOUT_SUGGESTION: 'Sem Sugestão',
          REVIEW_RULE_BTN: 'Revisar Regra',
          DISABLED_BY_CHILD: 'Nenhuma ação pode ser realizada. Este produto depende das decisões tomadas no pai da regra pai',
          SAME_PRICE_WARNING: 'The selected item already has a price of: $',
          SUGGESTION_ACCEPTED_BTN: 'Sugestão Aceita',
          SUGGESTION_ACCEPTED_OP1: 'Manter o preço atual',
          SUGGESTION_ACCEPTED_OP2: 'Mudar Manualmente',
          SUGGESTION_WITHOUT_REVIEW: 'Sugestão sem Revisão',
          SUGGESTION_ACCEPTED: 'Sugestão Aceita',
          SUGGESTION_IGNORED: 'Sugestão Ignorada',
          SUGGESTION_ACCEPT: 'Aceitar sugestões',
          SUGGESTION_IGNORE: 'Ignorar Sugestāo',
          SUGGESTION_REVIEWED: 'Revisado',
          SUGGESTION_ENDOECE: 'Aprovar Mudanças',
          SUGGESTION_ENDOECE_REJECTED: 'Rejeitar Alterações',
          SUGGESTION_REJECTED: 'Mudanças rejeitadas',
          SUGGESTION_ALREADY_ENDOECE: 'Aprovar',
          SUGGESTION_CHANGE_MANUALY: 'Mudar Manualmente',
          SUGGESTION_CHANGED_MANUALY: 'Mudar Manualmente',
          SUGGESTION_MARK_AS_REVIEW: 'Solicitar Aprovação',
          REVERT_NEW_PRICE: 'Reverter Preço',
          NO_DECISIONS_BTN: 'Sem decisões',
          NO_DECISIONS_OP1: 'Confirmar o Preço Atual',
          NO_DECISIONS_OP2: 'Mudar Manualmente',
          EDIT_MANUALLY_BTN: 'Editado Manualmente',
          EDIT_MANUALLY_OP1: 'Mudar Manualmente',
          EDIT_MANUALLY_OP2: 'Manter o preço atual',
          ORIGINAL_PRICE_INPUT: 'Preço Original',
          PREVIUS_PRICE_INPUT: 'Preço Anterior',
          COST_INPUT: 'Custo',
          MARGIN_INPUT: 'Margem R$',
          PERCENTAGE_MARGIN_INPUT: 'Mergem %',
          LEGEND_COMP_MAP:
            'Filtre o mapa e os KPIs usando os preços na Área Comercial do Ponto de Venda ou usando os preços da regra competitiva',
          COMPETITOR_INPUT: 'Concorrente',
          SOURCE_INPUT: 'Fonte',
          MARKERS_CHECK: 'Apenas Marcadores',
          MARKERS_TTIP: 'Apenas Concorrentes Relevantes',
          BRAND: 'Bandeira',
          CODE_NAME: 'Cód | Nome',
          TYPE: 'Tipo',
          SURVEY_DATE: 'Data',
          SURVEY: 'Fonte',
          COMPETENCE_TAB_KPIS_TITLE_1: 'Preço do Conc. Atual',
          COMPETENCE_TAB_KPIS_TITLE_2: 'IC% Atual',
          COMPETENCE_TAB_KPIS_TITLE_3: 'IC% Sugerido',
          COMPETENCE_TAB_KPIS_TITLE_4: 'Preço Sugerido',
          COMPETENCE_TAB_KPIS_DESC_3: 'Vs. IC atual',
          COMPETENCE_TAB_KPIS_DESC_4: 'Vs. Preço atual',
          COMPETENCE_KPIS_TITLE_TRADE: 'Área Comercial',
          COMPETENCE_KPIS_TITLE_COMPETITOR: 'Prinicipais Concorrentes',
          COMPETENCE_KPIS_TITLE_RULE: 'Regra',
          TITLE_MAP_SECTION: 'Mapa dos Concorrentes',
          TITLE_TABLE: 'Área Comercial',
          TITLE_KPIS: 'Analise da concorrência',
          NEW: 'Status',
          NEW_CHIP: 'NOVO',
          INVALID_CHIP: 'Inválido',
          OLD_CHIP: 'Velho',
          SUGGESTION_COLUMN: 'Sugerido',
          MARK: 'Marcador',
          OWNER: 'Prinicipal Concorrente',
          PVC: 'PVP',
          MARGIN: 'Margem',
          MARGIN_USD: 'Margem R$xM3',
          PERCENTAGE_MARGIN: 'Margem %',
          COST_TAXES: 'Custos e Impostos',
          CURRENT: 'Atual',
          PREVIUS: 'Anterior',
          VAR: 'Variação %',
          LAST_VAR: 'Últ. Var.',
          EVENT: 'Evento',
          DATE: 'Data',
          PREVIUS_PRICE: 'Preço Anterior R$',
          DECISIONS_PRICE: 'R$',
          COST: 'Custo',
          USER: 'Usuário',
          CHILDREN_STORE: 'Ponto de Venda Filho',
          CODE: 'Código',
          RECIPE: 'Receita',
          NAME: 'Nome',
          CURRENT_PRICE: 'Atual R$',
          SUGGESTION_RECIPE: 'Sugestão R$',
          DECISION: 'Decisão R$',
          SEE_RECIPE_BTN: 'Ver Receitas',
          INGREDIENTS: 'Ingredientes',
          ORIGIN_COST: 'Custo Original R$',
          QUANTITY: 'Quantidade',
          CURRENT_COST: 'Custo Atual R$',
          COMBO_PRODUCT: 'Produtos em Combo',
          COMBOS: 'Combos',
          PARTICIPATION: 'Participação %',
          SEE_COMBO_BTN: 'Ver Combo',
          PARTICIPATION_TTIP: 'Participação nas vendas deste combo.',
          LEGEND_COMBO: 'Os seguintes Combos podem ser direta ou indiretamente afetados pela decisão de preço tomada.',
          COMBO: 'Combo',
          SUGGESTION_COMBO: 'Sugestão R$',
          COMBOS_COMPONENTS: 'Componentes do Combo',
          BLOCK: 'Grupo',
          TOOLTIP_PARENT: 'Produto Pai',
          TOOLTIP_PARENT_OPEN: 'abrir produtos filhos',
          TOOLTIP_PARENT_OPENED: 'Fechar produtos filhos',
          TOOLTIP_CHILD: 'Produto Filho',
          TOOLTIP_PRICE_VARIATION: 'Os produtos filhos terão a mesma variação de preço que o produto pai',
          TOOLTIP_SUPERIOR_PRICE: 'Os produtos filhos terão um preço mais alto em {{val}} do que o produto pai',
          TOOLTIP_INFERIOR_PRICE: 'Os produtos filhos terão um preço inferior em {{val}} do que o produto pai',
          TOOLTIP_SAME_PRICE: 'Os produtos filhos terão o mesmo preço do produto pai',
          TOOLTIP_SUPERIOR_MARGIN: 'Produtos-filho terão uma margem mais alta em {{val}} do que o produto-pai',
          TOOLTIP_INFERIOR_MARGIN: 'Produtos-filho terão uma margem inferior em {{val}} do que o produto-pai',
          TOOLTIP_SAME_MARGIN: 'Os produtos filhos terão a mesma margem do produto pai',
          TOOLTIP_COMBO: 'Combo',
          TOOLTIP_RECIPE: 'Receita',
          TOOLTIP_STORE: 'Parentesco de Ponto de Venda',
          TOOLTIP_COMBO_ITEM: 'Componentes do Combo',
          TOOLTIP_MAX_PRICE: 'O preço encontra-se acima do preço regular.',
          TOOLTIP_IS_PARENT: 'Item pai na regra de parentesco. A variação de seu preço afeta seus itens filhos.',
          RULE_TYPE_TITLE: 'Tipo de Regra',
          COMBO_ANALYST: 'Analista',
          COMBO_DECISIONTYPE: 'Tipo de Decisão',
          COMBO_APPROVER: 'Aprovador',
          COMBO_RULETYPE: 'Tipo de Regra',
          AUDIT_PRICE_CHANGE: 'Mudança de Preço',
          SHOW_KPIS: 'Mostrar KPIs',
          HIDE_KPIS: 'Ocultar KPIs',
          RULE_TYPE: {
            Guideline: 'Diretriz',
            Margin: 'Margem',
            Competitive: 'Competitivo',
            ParentItem: 'Produtos Relacionados',
            ParentZone: 'Pontos de Venda Relacionados',
            ParentCategory: 'Parentesco por Categoria',
            BasePriceList: 'Preço de Lista Base',
          },
          ADVANCED_FILTER: {
            NONE: 'Todos',
            SEE_CHILDS_MSG:
              'Ao habilitar esta opção você poderá pesquisar e visualizar os produtos filhos de outros produtos no que diz respeito à gestão de preços realizada nas regras de preços de lojas e produtos',
            SEE_CHILDS: 'Ver produtos filhos',
            SEE_FIXED_PRICES_MSG:
              'Ao ativar essa opção, você poderá procurar e visualizar apenas os produtos com preços fixos. Não é possível fazer sugestões baseadas neles.',
            SEE_FIXED_PRICES: 'Ver preços fixos',
            TITLE_FILTERS: 'Filtros',
            STATE_FILTERS: 'Estado',
            ACTION_TYPE_FILTERS: 'Situação',
            PRICE_TYPE_FILTERS: 'Tipo de Preço',
            TYPE_FILTERS: 'Tipo de Produto',
            CATEGORY_INPUT: 'Categoria',
            SEARCH_CATEGORY: 'Procurar Categorias…',
            SUBCATEGORIES_INPUT: 'Subcategorías',
            SEARCH_SUBCATEGORIES: 'Procurar Subcategorias',
            TitleStoreTags: 'Filtros para Pontos de Venda',
            TitleItemTags: 'Filtros de Produto',
            UnCheckedSuggestion: 'Sugestão sem revisar',
            PriceRaised: 'Preço aumentado',
            NoSuggestions: 'Sem sugestões',
            NotCheckedSimulation: 'Sugestões sem revisar',
            SuggestionAccepted: 'Sugestões Aceitas',
            ChangeRuleParent: 'Mudança de Regra de Parentesco',
            PricePublished: 'Preço Publicado',
            BlockedSuggestion: 'Sugestão Bloqueada',
            NewSuggestion: 'Sugestão Nova',
            SuggestionExpired: 'Sugestão Expirada',
            KeepPrice: 'Manter o preço atual',
            MarkAsReviewed: 'Aprovação solicitada',
            MarkAsReviewedIgnoringSuggestions: 'Aprovação solicitada ignorando sugestões',
            SetEffectiveDate: 'Definir Data de Vigência',
            ChangePrice: 'Preço modificado',
            RevertNewPrice: 'Preço revertido',
            RejectEndorse: 'Mudanças rejeitadas',
            Endorse: 'Aprovados',
            ManualPriceEdited: 'Preços alterados manualmente',
            SimulationAcepted: 'Simulação Aceita',
            AboutToExpire: 'Prestes a expirar',
            OldPrices: 'Preços Antigos',
            Regular: 'Regular',
            Competition: 'Concorrente',
            Current: 'Vigente',
            Todos: 'Todos',
            Checked: 'Revisados',
            Unchecked: 'Sem Revisar',
            ApprovalPending: 'Pendente por Aprovaçāo',
            'ApprovalPending-Aproval': 'Pendente por Aprovaçāo',
            Rejected: 'Rejeitados',
            Approved: 'Aprovado',
            Error: 'Erro no cálculo da sugestão',
            SuggestionIgnored: 'Sugestões Ignoradas',
            PriceDrop: 'Queda de Preço',
            SharpPriceDrop: 'Queda acentuada de preços',
            SharpPriceRaised: 'Subida acentuada de preços',
            DepressedMargins: 'Margens',
            HighMargins: 'Margens Altas',
            Margin: 'Regra de Margem',
            Competitive: 'Margens Deprimidas',
            AUDIT_PRICE_CHANGE: 'Mudança de Preço',
          },
          TAB: {
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_APPLIED_FORCED:
              'O preço de {{val}} foi alterado para {{val3}} porque os limites de Preços Máximos Regulados foram aplicados.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED_FORCED:
              'O preço de {{val}} está dentro dos limites de preços máximos regulados {{val3}}.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED_HIGHER_NOTFORCED:
              'O preço de {{val}} excede os limites de Preços Máximos Regulados {{val3}}, mas nenhuma correção foi feita.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED_MINOR_NOTFORCED:
              'O preço de {{val}} está dentro dos limites de Preços Máximos Regulados {{val3}}, e nenhuma correção foi feita.',
            STEP_LINK_COMPETITIVE_RULE: 'Regra de concorrência ',
            STEP_TEXT_COMPETENCE_RULE_below: 'abaixo da média ',
            STEP_TEXT_COMPETENCE_RULE_above: 'Acima da Média ',
            STEP_TEXT_COMPETENCE_RULE_equal: 'igual à média ',
            STEP_TEXT_COMPETENCE_RULE_PRE: 'Foi aplicada uma ',
            STEP_TEXT_COMPETENCE_RULE_POST: 'para definir o preço de um {{val2}} {{val}} {{val4}}, permanecendo em {{val3}}',
            STEP_TEXT_COMPETENCE_RULE: 'foi aplicada uma {{val}}: "{{val2}}" e gerou um preço sugerido de {{val3}}',
            STEP_TEXT_MARGIN_RULE: 'foi aplicado um {{val}}: "{{val2}}" e gerou um preço sugerido de {{val3}}',
            STEP_TEXT_COMPETENCE_RULE_NOTAPPLIED: 'Nenhuma regra de preço aplicada',
            STEP_TEXT_MARGIN_RULE_NOTAPPLIED: 'Nenhuma regra de preço aplicada',
            STEP_TEXT_MARGIN_SUGGESTION_TRIGGER:
              'PRISMA detectou que seu preço atual de {{val}} não está de acordo com a margem alvo de {{val2}}',
            STEP_TEXT_COMPETITIVE_SUGGESTION_TRIGGER:
              'PRISMA detectou que seu preço atual de {{val}} não está de acordo com seu posicionamento competitivo definido na regra {{val2}} considerando o preço de referência de mercado de {{val3}}',
            STEP_TEXT_SUGGESTION_ERROR:
              'O PRISMA não conseguiu calcular o preço sugerido para esse item e loja (preço sugerido {{val}}), por favor verifique os custos e impostos dele ou entre em contato com suporte',
            STEP_TEXT_COMPETITIVE_SUGGESTION_TRIGGER_SHORT:
              'PRISMA detectou que seu preço atual de {{val}} não está de acordo com seu posicionamento competitivo.',
            STEP_TEXT_RELATED_PRODUCTS_RULE_SHORT:
              'A regra de relacionamento do produto foi aplicada: "{{val}}" e gerou um preço de {{val2}}',
            STEP_TEXT_RELATED_STORES_RULE_SHORT:
              'A regra de relacionamento com a loja foi aplicada: "{{val}}" e gerou um preço de {{val2}}',
            STEP_TEXT_COMPETENCE_LIMITS_APPLIED:
              'A sugestão de {{val}} foi alterada para {{val2}} porque os limites de competência foram aplicados',
            STEP_TEXT_COMPETENCE_LIMITS_NOTAPPLIED: 'Não há limites de competição carregados.',
            STEP_TEXT_COMPETENCE_RULE_MARGIN_FALLBACK:
              'Prisma não conseguiu encontrar o preço de referência do mercado. A sugestão foi criada usando fallback de margem de regra. {{val}}',
            STEP_TEXT_COMPETENCE_CATEGORY_MARGIN_FALLBACK:
              'Prisma não conseguiu encontrar preço de referência de mercado. A sugestão foi criada usando o fallback de margem de categoria. {{val}}',
            STEP_TEXT_VARIATION_GUIDELINES_APPLIED:
              'A sugestão de {{val}} (variação: {{val2}}) foi alterada para {{val3}}, pois o {{val5}} compatível com esta categoria é {{val4}}.',
            STEP_TEXT_VARIATION_GUIDELINES_NOTAPPLIED: 'As diretrizes de variação de preços foram verificadas. Nenhuma correção foi feita.',
            STEP_TEXT_MARGIN_GUIDELINES_APPLIED:
              'A sugestão de {{val}} (margem: {{val2}}) foi alterada para {{val3}} pois {{val5}} era a margem de {{val4}} para a categoria.',
            STEP_TEXT_VARIATION_GUIDELINES_APPLIED_RULE:
              'A sugestão de {{val}} (variação: {{val2}}) foi alterada para {{val3}}, pois o {{val5}} compatível com esta regra é {{val4}}.',
            STEP_TEXT_MARGIN_GUIDELINES_APPLIED_RULE:
              'A sugestão de R${{val}} (margem: {{val2}}%) foi alterada para R${{val4}} pois o valor {{val3}} é a margem {{val5}} da regra.',
            STEP_TEXT_MARGIN_GUIDELINES_NOTAPPLIED: 'As diretrizes de margem foram verificadas. Nenhuma correção foi feita.',
            STEP_TEXT_ROUNDING_APPLIED: 'A sugestão foi arredondada para {{val}}',
            STEP_TEXT_ROUNDING_NOTAPPLIED: 'Nenhum arredondamento foi aplicado',
            STEP_TEXT_SUMMARY_ACCEPTED: 'Você tomou uma decisão e aceitou a sugestão de {{val}}',
            STEP_TEXT_SUMMARY_CHANGED: 'Você tomou uma decisão e alterou o preço para {{val}}',
            STEP_TEXT_SUMMARY_IGNORED: 'Você tomou uma decisão e ignore o preço {{val}}',
            STEP_TEXT_SUMMARY_WITHOUT_SUGGESTION: 'Você tomou uma decisão e alterou o preço de {{val}} para {{val2}}',
            STEP_LINK_APPLIED_RULE: 'revisar regra…',
            STEP_LINK_COMPETITIVE_SUGGESTION_TRIGGER: 'ver dados…',
            STEP_LINK_VARIATION_GUIDELINES_APPLIED: 'revisar diretrizes ...',
            STEP_LINK_MARGIN_GUIDELINES_APPLIED: 'revisar diretrizes ...',
            STEP_LINK_VARIATION_GUIDELINES_APPLIED_RULE: 'Revisar Regra...',
            STEP_LINK_MARGIN_GUIDELINES_APPLIED_RULE: 'Revisar Regra...',
            STEP_LINK_ROUNDING_APPLIED: 'revisar regra…',
            STEP_LINK_REGULATEDPRICE_GUIDELINES_APPLIED: 'Acessar Configurações',
            STEP_LINK_REGULATEDPRICE_GUIDELINES_NOTAPPLIED: 'Acessar Configurações',
            STEP_LINK_RELATED_PRODUCTS_RULE: 'ver regra de parentesco...',
            STEP_LINK_RELATED_STORES_RULE: 'ver regra de parentesco...',
            STEP_COMPETENCE_RULE: 'Regra de concorrência',
            STEP_MARGIN_RULE: 'Regra de Margem',
            SUGGESTION_TITLE: 'Decisão de Preço',
            NOT_STEPS: 'Nenhum passo encontrado',
            AUX_MAX_MARGIN: 'máximo',
            AUX_MIN_MARGIN: 'mínimo',
            AUX_MAX_VARIATION: 'aumento máximo',
            AUX_MIN_VARIATION: 'mínimo baixo',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_APPLIED:
              'O preço do {{val}} foi alterado para {{val3}}, pois foram aplicadas as limitações dos Preços Máximos Regulados.',
            STEP_TEXT_REGULATEDPRICE_GUIDELINES_NOTAPPLIED:
              'O preço de R${{val}} excede os limites dos Preços Máximos Regulamentados R${{val3}}, mas não foram feitas correções.',
            STEP_TEXT_APPLY_PRODUCTS_RULE:
              'Este item foi identificado como principal em certas regras de hierarquia de itens. Em relação a este item, as seguintes regras foram aplicadas e geraram uma decisão sobre os itens secundários: {{val}}',
            STEP_TEXT_APPLY_STORES_RULE:
              'Esta loja foi identificada como principal em certas regras de hierarquia de lojas. Em relação a este item, as seguintes regras foram aplicadas e geraram uma decisão sobre as lojas secundárias: {{val}}',
          },
          TAB_ZONES_COL_ZONE: 'Zona de Preço',
          TAB_ZONES_COL_RULE: 'Regra',
          TAB_ZONES_COL_ACTUAL: 'Atual',
          TAB_ZONES_COL_SUGGEST: 'Sugerir',
          TAB_ZONES_COL_DIFF: 'dif%',
          TAB_ZONES_COL_DECISION: 'Decisão',
          TAB_ZONES_COL_IMPACT: 'Impacto',
          WARNING_CHILD_WHITH_WARNING: 'Preços relacionados com avisos',
          WARNINGS_PRICES_LIST: {
            TEST: 'teste de aviso / valor: {{val}}, digite: {{val2}}',
            MIN_MARGIN: 'A margem {{val}} está abaixo da margem mínima de {{val2}}.',
            MAX_MARGIN: 'A margem {{val} está acima da margem máxima de {{val2}}.',
            EQUAL_MARGIN: 'O MARGEM DE {{val}} É IGUAL AO MARGEM MÁXIMO DE {{val2}}',
            VAR_BAJA: 'O preço diminuiu {{val}}. A diminuição máxima é {{val2}} de acordo com as diretrizes.',
            VAR_SUBA: 'O preço aumentou em {{val}}. O aumento máximo é {{val2}} de acordo com as diretrizes.',
            SUGGESTION_ERROR: 'Precificação sugerida inválida.',
          },
          STRATEGY_OP3: 'Carregue um preço fixo',
          STRATEGY_OP2: 'Levar a uma margem alvo',
          STRATEGY_OP1: 'Aplicar variaçāo de preço',
          SUGGESTED_IMPACT_TTIP: 'Não inclui produtos filhos',
          NEW_IMPACT_TTIP: 'Inclui produtos filhos',
          DATETIME: 'Data e hora',
          OLD_PRICE: 'Preço anterior',
          NEW_PRICE: 'Preço novo',
          USERNAME: 'Usuario',
          VAR_TABLE: ' ',
          COMBO_SITUATION: 'Situação',
        },
        ANALYSIS: {
          TITLE: 'Análise',
          COLUMNS: {
            GROUP: 'Grupo',
            CHANGE_PERCENT: 'Variação %',
            IMPACT: 'Impacto R$',
            MARGIN: 'Margem %',
          },
          ACTIONS: {},
          FILTERS: {
            STATUS: {},
            ALERTS: {},
          },
        },
        FILTERS: {
          STATUS_LABEL: 'Status',
          STATUS: {
            ALL: 'Todos',
            NEW: 'Novo',
            REVIEWED: 'Revisado',
          },
        },
        ALERTS_LABEL: 'Alertas',
        ALERTS: {
          ALL: 'Todos',
          NO_ALERTS: 'Sem alertas',
          WITH_ALERTS: 'Com alertas',
        },
      },
      TAXES: {
        IIBB: {
          ROUTE: 'Resultados de traducción',
          TITLE: 'Renda Bruta',
          JURISDICTION: 'Jurisdição',
          PERCENTAGE_RATE: 'Taxa Percentual',
          SAVE_BTN: 'Salvar',
          PERCENTAGE_RATE_INPUT: 'Taxa Percentual',
          VALIDATION_1: 'O campo não pode ser maior que 100',
          VALIDATION_2: 'O campo deve ser maior que 0',
          VALIDATION_3: 'O campo é obrigatório',
        },
        CO2: {
          ROUTE: 'Preços / Administração / Impostos',
          TITLE: 'Impostos CO2',
          YES: 'Sim',
          NOT: 'Não',
          EXCEMPT_ZONE: 'Zona Isenta',
          NS: 'NS',
          IN: 'IN',
          UD: 'UD',
          D500: 'D500',
          EURO: 'EURO',
          SAVE_BTN: 'Salvar',
          NS_INPUT: 'NS',
          VALIDATION1: 'O campo não deve exceder 100',
          VALIDATION2: 'O campo deve ser maior que 0',
          IN_INPUT: 'IN',
          UD_INPUT: 'UD',
          D500_INPUT: 'D500',
          EURO_INPUT: 'EURO',
          TITLE_FORM: 'Impostos CO2 - Zona {{val}} isento',
        },
        ICL: {
          ROUTE: 'Preços / Administração / Impostos',
          TITLE: 'Impostos ICL',
          YES: 'Sim',
          NOT: 'Não',
          EXCEMPT_ZONE: 'Zona Isenta',
          NS: 'NS',
          IN: 'IN',
          UD: 'UD',
          D500: 'D500',
          EURO: 'EURO',
          SAVE_BTN: 'Salvar',
          NS_INPUT: 'NS',
          VALIDATION1: 'O campo não deve exceder 100',
          VALIDATION2: 'O campo deve ser maior que 0',
          IN_INPUT: 'IN',
          UD_INPUT: 'UD',
          D500_INPUT: 'D500',
          EURO_INPUT: 'REAIS',
          TITLE_FORM: 'Impostos ICL - Zona {{val}} isenta',
        },
      },
      IMPORTERS: {
        PARITY: {
          ROUTE: 'Preços / Administração / Importadores',
          TITLE: 'Import Parity',
          IP_BTN: 'Carregar IP Diário',
          DAY: 'Dia',
          TRANSFER_PRICING: 'Preços de transferência',
          IMPORT_TTIP: 'Importar dados',
          IP_DAILY: 'Ponderação IP diaria',
          IP_NS: 'IP NS',
          IP_IN: 'IP IN',
          IP_GO2: 'IP GO2',
          IP_GO3: 'IP GO3',
          TC: 'TC',
          TERMINAL: 'Terminal',
          DESCRIPTION: 'Descrição',
          NS: 'NS',
          IN: 'IN',
          GO2: 'GO2',
          GO3: 'GO3',
          TITLE_FORM: 'Importar Paridade - Coeficientes',
          SAVE_BTN: 'Salvar',
          DATE_COEFFICIENTS_INPUT: 'Mudar data de coeficientes IP',
          VALIDATION1: 'O campo deve ser maior que 0',
          TC_INPUT: 'TC',
          NS_INPUT: 'NS',
          IN_INPUT: 'IN',
          GO2_INPUT: 'GO grau 2',
          GO3_INPUT: 'GO grau 3',
        },
        FERRYES_AND_COMISIONS: {
          TITLE: 'Importador Frete e comissões',
        },
        COST_AND_TAXES: {
          TITLE: 'Importador Custos e Taxas',
        },
        VENDOR_COST: {
          TITLE: 'Importador de custos por Fornecedor',
        },
        STORE_TAXES: {
          TITLE: 'Importador de impostos por Ponto de Venda',
        },
        NEW_PRICES: {
          TITLE: 'Novo importador de preço',
        },
        COMPETITOR_PRICES: {
          TITLE: 'Importador de preço dos Concorrentes',
        },
      },
    },
    ASSORT: {
      STP: {
        CLUSTERING: {
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Clusterização',
          SUBTITLE:
            'A Clusterização permite classificar estrategicamente os pontos de venda de acordo com um conjunto de variáveis. Pode ser um único cluster para todas as categorias ou várias classificações, dependendo da categoria. Desta forma, a tomada de decisões de negócios é simplificada e as ofertas de produtos são padronizadas. Nessa tela, você pode criar e modificar clusterizações.',
          NEW_CLUSTERIZATION_BTN: 'Nova Clusterização',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar clusters selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          OBSERVATION: 'Observação',
          EDIT_TITLE_FORM: 'Editar Clusterização',
          NEW_TITLE_FORM: 'Nova Clusterização',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Informação Básica',
          NAME_INPUT: 'Nome',
          OBSERVATION_INPUT: 'Observação',
          CLUSTER_NAME_TTIP: 'Clique aqui para ver os Pontos de Venda e clusters associados',
        },
        CLUSTER_ASSIGN: {
          REDO_CHANGE_CLUSTERS: 'Retornar mudanças de clusters selecionados',
          REDO_CHANGE_CLUSTERS_DESC: 'Você quer filtrar pelo cluster selecionado? isso irá apagar as alterações não salvas',
          ROUTE: 'Clusterização / Atribuição de Clusters',
          SUBTITLE:
            'Nesta tela você pode criar e atribuir um cluster a cada ponto de venda. Ou trabalhe os pontos de venda como agentes livres sem atribuir um cluster. Neste caso, funciona de forma independente como um cluster com um único ponto de venda.',
          SAVE_BTN: 'Salvar',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          STORES: 'Pontos de Vendas',
          CODE: 'Código',
          TYPE: 'Tipo',
          PROVINCE: 'Província',
          STATE: 'Estado',
          CLUSTER: 'Cluster',
          NEW_CLUSTER: 'Novo Cluster',
          NO_CLUSTER_ASSIGNED: 'Nenhum cluster atribuído',
          NEW_CLUSTER_BTN: 'NOVO CLUSTER',
          NEW_CLUSTER_TITLE: 'Novo Cluster',
          NEW_CLUSTER_SUBTITLE:
            'O cluster é um grupo de pontos de venda, com características específicas ou comportamento de compra semelhante, aos quais são atribuídos um papel e uma estratégia juntamente com a categoria. Por sua vez, simplifica a alocação e o gerenciamento do sortimento.',
          NAME_INPUT: 'Nome',
          OBSERVATION_INPUT: 'Observação',
          CANCEL_BTN: 'Cancelar',
          ADD_BTN: 'Adicionar',
          TITLE_FILTERS: 'Filtros',
          STATE_FILTERS: 'Estado',
          TYPE_FILTERS: 'Tipo',
          SEARCH_TYPE: 'Procurar Tipo...',
          PROVINCE_FILTERS: 'Província',
          CLUSTER_FILTERS: 'Cluster',
          SEARCH_CLUSTER: 'Procurar Cluster…',
          CLEAN_BTN: 'Limpar',
          APPLY_BTN: 'Aplicar',
          Todos: 'Todos',
          Checked: 'Ativo',
          Unchecked: 'Inativo',
          FREE_AGENTS: 'Agente Livre',
        },
        CATEGORY_SETUP: {
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Configurações de categoria',
          SUBTITLE:
            'Nesta tela você pode atribuir um agrupamento e a segmentação principal de produtos para cada nível de categoria, previamente definida na árvore de categorias; você também pode atribuir uma função e uma estratégia diferenciada para cada agrupamento, e ver as informações relativas à distribuição e atribuição dos segmentos.',
          LIST: {
            CATEGORIES: 'Categorias',
            CLUSTERIZATION: 'Clustering',
            ROL: 'Papel',
            STRATEGY: 'Estratégia',
            SEGMENTATION: 'Segmentação',
            SEGMENT_QUANTITY: '# Segmentos',
            SEGMENT_QUANTITY_TTIP: 'Quantidade de Segmentos',
            CLASSIFIELDS: 'Clssificados %',
            CLASSIFIELDS_TTIP: 'Porcentagem de produtos dentro da categoria classificados com um segmento.',
            SWITCH_ACTIVE: 'Mostrar Categorias sem Atribuição',
            SWITCH_INACTIVE: 'Mostrar Categorias com Atribuição',
            CLUSTERIZATION_OR_SEGMENT_DISABLE: 'Categoria não editável porque tem itens associados.',
            FILTER_TTIP: 'Filtrar',
            NOTFOUNDCATEGORYTREE:
              'Não foram encontradas categorias não atribuídas com os filtros selecionados, entre em contato com o suporte para habilitá-los.',
            WITHOUTCLUSTERIZATION: 'Sem Agrupamento',
            WITHOUTSEGMENT: 'Sem Segmentos',
            WITHOUTSTRATEGY: 'Sem Estratégias',
            WITHOUTROL: 'Sem Aglomerados',
            WITHOUTCLUSTER: 'Sem Aglomerados',
            CLUSTERING: 'Clusterização',
          },
        },
        ROLES_STRATEGIES_ASSIGN: {
          SUBTITLE:
            'Nesta tela você pode atribuir um cluster para cada nível de categoria, previamente definido na árvore de categorias. Por sua vez, para cada cluster ou ponto de venda do cluster selecionado, pode-se atribuir uma função e uma estratégia diferenciada.',
          EXPORT_TTIP: 'Exportar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          CATEGORIES: 'Categorias',
          CLUSTERING: 'Clusterização',
          ROL: 'Papel',
          STRATEGY: 'Estratégia',
          UNALLOCATED_TTIP: 'Não Atribuído',
          SEARCH_CLUSTER: 'Procurar Cluster…',
          SEARCH_ROL: 'Procurar Papel…',
          WITHOUT_CLUSTERS: 'Função habilitada se os clusters são atribuídos',
          SEARCH_STRATEGY: 'Procurar Estratégia…',
          CHANGE_CLUSTERING_TITLE: 'Tem certeza de que deseja alterar este clust',
          CHANGE_CLUSTERING_SUBTITLE: 'Isso limpará os papéis e estratégias atribuídas a todos os clusters nesta categoria.',
          CANCEL_BTN: 'Cancelar',
          CHANGE_BTN: 'Mudar',
          ACCEPT_BTN: 'Aceitar',
          CHANGE_RS_TITLE: 'Modificar Papel / Estratégia',
          CHANGE_RS_SUBTITLE: 'Você deseja atribuir: {{val}} a todos os clusters nesta categoria?',
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Configurações de categoria',
        },
        ROLES: {
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Papéisl',
          SUBTITLE: 'Nesta tela você pode criar e modificar as diferentes funções que serão atribuídas às categorias.',
          NEW_ROLE_BTN: 'Novo Papel',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar papéis selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          OBSERVATION: 'Observação',
          DELISTING_RULE: 'Desativar regra',
          LISTING_RULE: 'Ativar Regra',
          OTHERS_RULES: 'Outras Regras',
          FRECUENCY: 'Frequência',
          DEFINE_ROL_STP1: 'Definir Papel',
          DELISTING_RULES_STEP2: 'Regras para Desativar\n',
          LISTING_RULES_STEP3: 'Regras para Ativar',
          OTHERS_RULES_STEP4: 'Regras Adicionais',
          FRECUENCY_STEP5: 'Frequência de Análise',
          TITLE_FORM_NEW: 'Novo Papel',
          TITLE2_FORM_NEW: 'Novo Papel /',
          STP1: 'Etapa 1 - Definir Papel',
          LEGEND_ROL:
            'O papel da categoria define os critérios para ativar ou desativar um produto para um determinado cluster. O papel e a estratégia definem os critérios e métricas a serem avaliados para gerar sugestões.',
          NAME_INPUT: 'Nome',
          OBSERVATION_INPUT: 'Observação',
          NEXT_BTN: 'Próximo',
          STP2: 'Etapa 2 - Regras para Desativar',
          LEGEND_DELISTING_RULE: 'Nesta etapa você pode definir os critérios para desativar produtos.',
          RULE_DELISTING_RULE: 'Sugerir desativar produtos cujo ',
          RULE_LISTING_RULE: 'Sugerir ativar produtos cujo ',
          RULE_DELISTING_RULE_ALT: 'Sugerir produtos que desativam ',
          RULE_LISTING_RULE_ALT: 'Sugerir produtos ativadores ',
          RULE_HIGH_AI: 'Sugerir ativar produtos usando IA',
          MINIMUM_AVAILABILITY: 'Disponibilidade mínima de ',
          PRESENCE_IN_STORES: 'Presença mínima na loja de ',
          SUPPLIERS_W_SKU: 'Fornecedores com uma participação mínima de produtos de ',
          NEW_DATES: 'Quando novos dados são inseridos',
          OPPORTUNITIES_IA: 'Quando a IA encontra oportunidades',
          AND: 'E',
          THE: 'o',
          THEFREQ: 'o',
          AUXS: {
            _variableSource: {
              _DEMOMercado: 'Mercado',
              ParetoCluster: 'Pareto do Cluster',
              ParetoGeneral: 'Pareto Total',
              ParetoMarket: 'Pareto do Mercado',
              TotalMarket: 'MERCADO TOTAL',
              ParetoReference: 'Referência Pareto',
            },
            _variableSource_phrase: {
              ParetoCluster: 'do Pareto do Cluster',
              ParetoGeneral: 'do Pareto Total',
              ParetoMarket: 'do Pareto do Mercado',
              TotalMarket: 'do Mercado Total',
              ParetoReference: 'da Marca de Referência de Pareto',
            },
            _variable: {
              WeightedIndex: 'Índice P',
              SalesUnits: 'Vendas U',
              Sales: 'Vendas R$',
              Margin: 'Margem R$',
              MarginWithVendor: 'Margem por acordo',
              PercentageMargin: 'Margem %',
              Gmroi: 'GMROI',
              Presence: 'Presença',
              MarketSales: 'Mercado $',
              MarketUnits: 'Mercado Un.',
            },
            _variable_phrase: {
              WeightedIndex: 'de Vendas em Índice Ponderado',
              SalesUnits: 'de Vendas em Unidades',
              Sales: 'de Vendas em R$',
              Margin: 'Margem em R$',
              MarginWithVendor: 'de Margem por acordo',
              PercentageMargin: 'Margem em %',
              Gmroi: 'de GMROI',
              Presence: 'Presença',
              MarketSales: 'Vendas de Mercado em $',
              MarketUnits: 'Vendas de Mercado em Unidades',
            },
            _method: {
              AbsoluteValue: 'Valor Absoluto',
              TotalShare: 'Participação %',
              CumulativeShare: 'Participaçāo Acum. %',
            },
            _methodTop: {
              AbsoluteValue: 'Valor Absoluto',
              TotalShare: 'Share %',
              CumulativeShare: 'Top %',
            },
            _method_phrase: {
              AbsoluteValue: 'Valor Absoluto',
              TotalShare: 'Participação %',
              CumulativeShare: 'Participaçāo Acum. %',
            },
            _condition: {
              GreaterThan: 'é maior',
              LowerThan: 'é menor',
              Equals: 'é igual',
            },
            _condition_phrase: {
              GreaterThan: 'ser maior que',
              LowerThan: 'ser menor que',
              Equals: 'ser igual a',
            },
            _condition_banner: {
              GreaterThan: 'é maior que',
              LowerThan: 'é menor que',
              Equals: 'é igual a',
            },
            _conditionTopBottom: {
              LowerThan: 'Topo',
              GreaterThan: 'Inferior',
            },
            _conditionTopBottom_phrase: {
              LowerThan: 'é menor ou igual a',
              GreaterThan: 'é maior que ou igual a',
            },
            _combinationMethod: {
              And: 'e',
              Or: 'ou',
            },
            _combinationMethod_phrase: {
              And: 'e a',
              Or: 'ou o',
            },
            _weekday: {
              Monday: 'Segunda',
              Tuesday: 'Terça',
              Wednesday: 'Quarta',
              Thursday: 'Quinta',
              Friday: 'Sexta',
              Saturday: 'Sábado',
              Sunday: 'Domingo',
            },
            _frecuency: {
              Biweekly: 'Quinzenal',
              Monthly: 'Mensal',
              BiMonthly: 'Bimestral',
              ThreeMonth: 'Trimestral',
              FourMonth: 'A cada 4 meses',
              SixMonth: 'Semestral',
              Annually: 'Anual',
            },
            _frecuency_phrase: {
              Biweekly: 'Quinzenal',
              Monthly: 'Mensal',
              BiMonthly: 'Bimensal',
              ThreeMonth: 'Trimestral',
              FourMonth: 'A cada 4 meses',
              SixMonth: 'Semestral',
              Annually: 'Anual',
            },
          },
          COMBINATION: 'REGRA',
          DELETE_COMBINATION_TTIP: 'Apagar Regra',
          CANCEL_BTN: 'Cancelar',
          CONFIRM_BTN: 'Confirmar eliminação',
          VARIABLE_SOURCE_INPUT: 'Fonte',
          VARIABLE_INPUT: 'Variável',
          METHOD_INPUT: 'Método',
          CONDITION_INPUT: 'Condição',
          VALUE_INPUT: 'Valor',
          LOGIC_INPUT: 'Lógica',
          REFERENCE_CLUSTER: 'Cluster de referência',
          ADD_COMBINATION_BTN: 'Adicionar Regra',
          PREVIUS_BTN: 'Anterior',
          STP3: 'Etapa 3 - Regras para Ativar',
          LEGEND_LISTING_RULE: 'Nesta etapa você pode definir os critérios para ativar novos produtos.',
          STP4: 'Etapa 4 - Outras Regras',
          LEGEND_OTHERS_RULES: 'Nesta etapa, você pode configurar outras regras e restrições que deseja adicionar a esta função.',
          CHECK_AVAILABILITY: 'Verifique a disponibilidade antes de desativar',
          CHECK_AVAILABILITY_TEXT:
            'Sugere desativar um produto somente se a disponibilidade for igual ou superior ao valor aqui especificado. Você tem que ter dados de estoque.',
          MINIMUM_AVAILABILITY_INPUT: 'Disp. Mín.',
          MINIMUM_AVAILABILITY_TTIP: 'Disponibilidade Mínima',
          CHECK_PRESENCE: 'Verifique a presença antes de desativar',
          CHECK_PRESENCE_TEXT:
            'Sugere desativar apenas quando um produto tiver vendas no mínimo {{val}}% das lojas no cluster e dentro do período de análise selecionado.',
          MINIMUM_PRESENCE_INPUT: 'Pres. Mínima',
          MINIMUM_PRESENCE_TTIP: 'Presença Mínima',
          CHECK_SUPPLIER: 'Verifique fornecedores com poucos produtos',
          CHECK_SUPPLIER_TEXT:
            'Se esta opção estiver ativada, o Prisma irá sugerir a desativação de todos os produtos pertencentes a fornecedores com uma participação nas vendas inferior ao aqui especificado, otimizando assim a sua cadeia de abastecimento.',
          MINIMUM_PART_INPUT: 'Participação Mínima',
          MINIMUM_PART_TTIP: 'Participação Mínima',
          SUGGEST_HIGH: 'Sugere ativar com inteligência artificial',
          SUGGEST_HIGH_TEXT:
            'A inteligência artificial do prisma irá sugerir a ativação de produtos dependendo de seus atributos e desempenho no {{val}} / cluster.',
          COMING_SOON: 'Em breve',
          STP5: 'Etapa 5 - Frequência de análise',
          LEGEND_CATEGORY_ANALYSIS:
            'Nesta etapa, você definirá com que frequência executará uma análise de revisão de intervalo para as categorias com este papel.',
          FRECUENCY_INPUT: 'Frequência',
          WEEKDAY_INPUT: 'Dia da semana',
          GENERATE_SUGGESTIONS_IA: 'Gerar sugestões ativas quando a IA encontra oportunidades',
          GENERATE_SUGGESTIONS_IA_TEXT:
            'Cada vez que a inteligência artificial encontra uma oportunidade de melhoria, sugestões serão geradas para ativar produtos além da frequência e regras definidas.',
          GENERATE_SUGGESTIONS: 'Gerar sugestões de ativação sempre que novas informações de mercado estiverem disponíveis',
          GENERATE_SUGGESTIONS_TEXT:
            'Gerar sugestões ativas para novos lançamentos de produtos com base nas informações de mercado disponíveis.',
          SAVE_BTN: 'Salvar',
          NEW_COMBINATION: 'Nova Regra',
          ADD_BTN: 'Adicionar',
          REPEATED_VARIABLE_AND_SOURCE: 'Variável e Fonte não podem ser duplicadas para mais de uma regra.',
          SUGGESTION_ROLE_NAME: 'Sugestão de Perfil',
          SUGGESTION_ROLE_DESCRIPTION: 'SUGESTÃO DE DESCRIÇÃO',
        },
        STRATEGIES: {
          DELETE_TITLE: 'Excluir estratégia',
          DELETE_TITLE_MULTIPLE: 'Excluir estratégias',
          DELETE_CONTENT: '{{val}} estratégia será excluída.',
          DELETE_CONTENT_MULTIPLE: '{{val}} registros de estratégia serão excluídos.',
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Estratégias',
          SUBTITLE: 'Nesta tela você pode criar e modificar as diferentes estratégias que serão atribuídas às categorias.',
          NEW_STRATEGY_BTN: 'Nova Estratégia',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar estrategias selecionadas',
          DELETE: 'Apagar',
          STRATEGY: 'Estratégia',
          OBSERVATION: 'Observação',
          VARIABLE: 'Variável',
          NEWS: 'Novo',
          TYPOLOGIES: 'Classificação',
          PERIOD: 'Periodo',
          DEFINE_STRATEGY_STP1: 'Definir Estratégia',
          VARIABLES_SELECTION_STP2: 'Seleção de Variáveis',
          OTHER_CONFIGURATIONS_STP3: 'Outras Configurações',
          ANALYSIS_PERIOD_STP4: 'Periodo de Análise',
          TITLE_FORM_NEW: 'Nova Estratégia',
          TITLE_FORM_EDIT: 'Editar Estratégia',
          STP1: 'Etapa 1 - Definir Estratégia',
          LEGEND_STRATEGY: 'A estratégia o ajudará a definir a métrica pela qual a análise de Pareto será realizada.',
          NAME_INPUT: 'Nome',
          OBSERVATION_INPUT: 'Observação',
          NEXT_BTN: 'Próximo',
          STP2: 'Etapa 2 - Seleção de Métricas',
          LEGEND_SELECTION_VARIABLES: 'Nesta etapa você pode definir os critérios para que o sortimento seja analisado e otimizado.',
          VARIABLE_INPUT: 'Variável',
          COMBINATION_PERCENTAGE_INPUT: 'Combinação',
          VALIADATION: 'O valor inserido deve ser maior que 0 ou igual a 100%',
          DELETE_VARIABLE_TTIP: 'Apagar',
          VALIADATION2: 'A soma de todas as métricas deve ser 100%',
          ADD_COMBINATION_BTN: 'Adicionar Combinaçāo',
          PREVIUS_BTN: 'Anterior',
          STP3: 'Etapa 3 - Outras Configurações',
          LEGEND_OTHER_CONFIGURATIONS: 'Nesta etapa, você pode inserir configurações adicionais que melhorarão a precisão da análise.',
          OTHER_CONFIGURATIONS_TEXT: 'Um produto é considerado novo por',
          DAYS_INPUT: 'Dias',
          DAY_INPUT: 'Dia',
          SINCE_TEXT: 'considerado novo a partir da',
          SINCE: 'desde sua',
          EVENT_INPUT: 'Evento',
          TYPOLOGIES_TEXT: 'CLASSIFICAÇÃO (seções de Pareto):',
          DEFINE_PARETO_TEXT:
            ' Defina os intervalos das seções de Pareto para classificar os produtos automaticamente com base na métrica selecionada.',
          HIGH_ROTATION: 'ALTO GIRO',
          HIGH_ROTATION_TEXT: ': Produtos cujo índice acumulado (Pareto) vai de 0 a',
          VALIDATION_HIGH_ROTATION: 'Deve ser inferior a 100% e inferior a produtos de baixo giro',
          LOW_ROTATION: 'BAIXO GIRO',
          LOW_ROTATION_TEXT: ': Produtos cujo índice acumulado (Pareto) vai de {{val}}% a',
          VALIDATION_LOW_ROTATION: 'Deve ser menor que 100% e maior que Alto Giro',
          LONG_TAIL: 'CAUDA LONGA',
          LONG_TAIL_TEXT: ': Produtos cujo índice acumulado (Pareto) vai de {{val}}% a 100%. Eles são os últimos {{val2}}% do Pareto.',
          WITHOUT_ROTATION: 'SEM-GIRO',
          WITHOUT_ROTATION_TEXT: ': Produtos sem vendas durante o período de análise selecionado.',
          NEWS1: 'NOVOS PRODUTOS',
          NEWS_TEXT: 'Produtos que têm menos de {{val}} dias desde seu {{val2}}',
          STP4: 'Etapa 4 - Período de Análise',
          DEFINE_PERIOD_TEXT:
            'Nesta etapa você pode definir o período em meses que levará para realizar a análise. Para normalizar e poder comparar você sempre verá valores médios expressos em 30 dias em relatórios e pareto.',
          LATEST_INPUT: 'Últimos',
          MONTHS: 'Meses',
          JANUARY: 'JAN',
          FEBRUARY: 'FEV',
          MARCH: 'MAR',
          APRIL: 'APRL',
          MAY: 'MAI',
          JUNE: 'JUN',
          JULY: 'JUL',
          AUGUST: 'AGO',
          SEPTEMBER: 'SET',
          OCTOBER: 'OUT',
          NOVEMBER: 'NOV',
          DECEMBER: 'DEZ',
          LEGEND_MOTHS:
            'Se você excluir um mês da lista, ele não será considerado como parte da média. Se o número de meses selecionados for menor que o período selecionado, a média será calculada usando o número de meses disponíveis.',
          SAVE_BTN: 'Salvar',
          FROM_DATE_OF: 'a partir da data de',
          LAST_MONTH_: 'Último mês',
          LASTS_: 'Último',
          MONTHS_: 'Meses',
          EXCEPT_FOR: 'Exceto por',
          MONTHS_VALIDATION: 'Os meses de análise não podem ser maiores que os meses habilitados',
        },
        RULES: {
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Regras de atribuição e exclusão',
          SUBTITLE: 'Nesta tela você pode criar e modificar as diferentes regras de configuração.',
          DOWNLOAD_CATALOG: 'BAIXAR CATÁLOGO',
          DOWNLOAD_CATALOG_ERROR: 'Erro ao baixar o catálogo. Por favor, tente novamente.',
          DOWNLOAD_UNASSIGNED: 'BAIXAR SEM ATRIBUIÇÃO',
          DOWNLOAD_UNASSIGNED_TOOLTIP: 'Selecione uma categoria para baixar',
          DOWNLOAD_UNASSIGNED_ERROR: 'Erro ao baixar sem atribuição. Por favor, tente novamente.',
          VIEW_RULES: 'VER REGRAS',
          SELECT_CATEGORY_TITLE: 'Selecione <a Categoria> com a qual deseja trabalhar',
          SELECT_CATEGORY_DESCRIPTION: 'Uma vez selecionada, você pode agrupar lojas e atribuir o sortimento da categoria',
          SELECTED_CATEGORY: 'Categoria selecionada',
          STORES_TAB: 'LOJAS DA CATEGORIA SELECIONADA',
          PRODUCTS_TAB: 'PRODUTOS DA CATEGORIA SELECIONADA',
          SELECT_CATEGORY_MESSAGE: 'Por favor, selecione uma categoria para ver as lojas',
          SEARCH_STORES: 'Buscar lojas por nome ou código',
          STORES_WITHOUT_ASSORTMENT: 'Há pelo menos uma loja(s) sem sortimento atribuído',
          VIEW: 'VER',
          BACK: 'VOLTAR',
          STORE_COLUMN: 'Loja',
          TAGS_COLUMN: 'Tags',
          CATEGORIES_COLUMN: 'Categorias Atribuídas',
          NO_ASSORTMENT: 'Sem sortimento',
          NO_STORES_FOUND: 'Nenhuma loja encontrada com os filtros aplicados.',
          SEARCH_PRODUCTS: 'Buscar produtos',
          PRODUCTS_WITHOUT_ASSORTMENT: 'Há pelo menos um produto que não está atribuído a nenhuma loja',
          PRODUCT_COLUMN: 'Produto',
          STORES_COLUMN: 'Lojas',
          IN_ALL_STORES: 'Em todas as lojas',
          IN_STORES: 'Em {{val}} Lojas',
          IN_ZERO_STORES: 'Em 0 lojas',
          NO_PRODUCTS_FOUND: 'Nenhum produto encontrado',
          NO_PRODUCTS_IN_CATEGORY: 'Não há produtos nesta categoria',
          NO_ASSIGNMENT_MESSAGE: 'Você ainda não atribuiu este sortimento a nenhuma loja',
          CREATE_FIRST_RULE: 'Crie a primeira regra de atribuição da categoria',
          DOWNLOAD_ITEMS_STORES_WITHOUT_ASSIGNMENT: 'BAIXAR ITENS/LOJAS SEM ATRIBUIÇÃO',
          CREATE_RULE: 'CRIAR REGRA',
          SEARCH_RULES: 'Buscar regras',
          RULE_TYPE_FILTER_LABEL: 'Tipo de regra',
          RULE_TYPE_FILTER_ALL: 'Todas',
          RULE_TYPE_FILTER_INCLUSION: 'Inclusão',
          RULE_TYPE_FILTER_EXCLUSION: 'Exclusão',
          KPI_INCLUSION_ONLY_WARNING: 'Os KPIs exibidos correspondem sempre às regras de inclusão, não às de exclusão.',
          DELETE_MODAL: {
            TITLE_ONE: 'Deseja excluir a regra {{val}}?',
            CONTENT: 'Esta ação não pode ser desfeita. A regra será excluída permanentemente.',
          },
          CREATE_RULE_MODAL: {
            TITLE: 'Configurar nova regra',
            STEP1_LABEL: 'Segmentar suas Lojas',
            STEP2_LABEL: 'Segmentar seu sortimento',
            STEP3_LABEL: 'Nomear a regra',
            STEP1_TITLE: 'Segmentar suas lojas',
            STEP2_TITLE: 'Segmentar seu sortimento',
            STEP3_TITLE: 'Nomear a regra',
            BUTTON_NEXT: 'PRÓXIMO PASSO',
            STEP3_HEADING: 'Atribua um nome a esta regra',
            STEP3_NAME_PLACEHOLDER: 'Atribua um nome a esta regra',
            REQUIRED_FIELD: 'Campo obrigatório',
            SUMMARY_TITLE: 'Resumo da regra',
            SUMMARY_STORES_TITLE: 'Nas seguintes ({{val}}) lojas:',
            SUMMARY_ITEMS_TITLE: 'Atribuir os seguintes ({{val}}) itens:',
            SUMMARY_EXCLUDING: 'Exceto por',
            SUMMARY_STORES_INCLUDED: 'Lojas incluídas ({{val}})',
            SUMMARY_PRODUCTS_INCLUDED: 'Produtos incluídos ({{val}})',
            SUMMARY_NO_STORES: 'Não há lojas para exibir.',
            SUMMARY_NO_ITEMS: 'Não há produtos para exibir.',
          },
          KPI_STORES_TITLE: 'Total de Lojas vs Lojas Atribuídas',
          KPI_STORES_SUBTITLE: 'As lojas atribuídas são as que têm sortimento atribuído',
          KPI_STORES_TOTAL: 'Total de Lojas',
          KPI_STORES_ASSIGNED: 'Lojas Atribuídas',
          KPI_STORES_UNASSIGNED: 'Lojas Sem Atribuir',
          KPI_ITEMS_TITLE: 'Total Itens vs Itens Atribuídos',
          KPI_ITEMS_SUBTITLE: 'Lorem ipsum dolor',
          KPI_ITEMS_TOTAL: 'Total itens de sortimento',
          KPI_ITEMS_ASSIGNED: 'Total itens atribuídos',
          KPI_ITEMS_UNASSIGNED: 'Total itens sem atribuir',
          KPI_PROGRESS: 'Progresso',
          TABLE_RULE_NAME: 'Nome da Regra',
          TABLE_STORE_SEGMENTS: 'Seg. Lojas',
          TABLE_STORE_COUNT: 'Qtd. de Lojas',
          TABLE_ITEM_SEGMENTS: 'Seg. Itens',
          TABLE_ITEM_COUNT: 'Qtd. de Itens',
          TABLE_EXCLUDES: 'Exclui',
          NO_RULES_MESSAGE: 'Não há regras disponíveis',
        },
        SEG_ASSIGNMENT: {
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Designar Segmentos',
          SUBTITLE:
            'Nesta tela pode-se atribuir a cada nível de categoria, previamente definido na árvore de categorias, a segmentação do produto principal que se utilizará para realizar a análise e a otimização do sortimento.',
          EXPORT_TTIP: 'Exportar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          CATEGORY: 'Categoria',
          SEGMENTATION: 'Segmentação',
          NOT_ASSIGNED_TTIP: 'Não Atribuído',
          SEARCH_SEGMENTATION: 'Procurar Segmentação…',
          SEGMENT_QUANTITY: '# Quant. de Segmentos',
          SEGMENT_QUANTITY_TTIP: 'Quantidade de Segmentos',
          CLASSIFIELDS: 'Clssificados %',
          CLASSIFIELDS_TTIP: 'Porcentagem de produtos dentro da categoria classificados com um segmento.',
        },
        CATEGORIES: {
          ROUTE: 'Sortimento / Configuração',
          TITLE: 'Árvore de Categorias',
          SUBTITLE: 'Aqui você pode visualizar a hierarquia de categorias carregadas no Prisma.',
          SAVE_BTN: 'Salvar',
          PRINT_TTIP: 'Imprimir',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          SECTOR: 'Setor',
          CATEGORY: 'Categoria',
          SUBCATEGORY: 'Subcategoria',
          ELEMENTS: 'Elementos',
          SELECTED_CATEGORIES_TTIP: 'Categorias Selecionadas: ',
          MODAL_TTILE: 'Você deseja salvar as alterações?',
          MODAL_SUBTTILE: 'Ao salvar, as alterações anteriores serão acionadas',
          CLOSE_BTN: 'Fechar',
          UNDO_BTN: 'Desfazer alterações',
          ACCEPT_BTN: 'Aceitar',
        },
        HELP: {
          VARIABLE_SOURCE_INPUT:
            'Indica se a sugestão será gerada com base no pareto do cluster em análise, no pareto de todos os clusters ou com informações de mercado.',
          VARIABLE_INPUT: 'Indique com qual variável o pareto deve ser construído para avaliar a regra.',
          CONDITION_INPUT: 'Indica a condição numérica para gerar a regra. Pode ser maior, menor ou igual.',
          METHOD_INPUT:
            'Permite definir que tipo de corte será utilizado para a regra. Pode ser um valor absoluto, uma porcentagem de participação ou uma porcentagem cumulativa de participação.',
          VALUE_INPUT: 'Valor numérico necessário para completar a condição da regra.',
          FRECUENCY_INPUT: 'Indica a repetição da análise da categoria ao longo do tempo.',
          WEEKDAY_INPUT: 'Dias da semana em que a análise da categoria deve ser realizada.',
          VARIABLE_S_INPUT: 'Indica com qual variável o sortimento deve ser analisado.',
          COMBINATION_PERCENTAGE_INPUT:
            'Indica o percentual da variável que será levado em consideração para a análise. Se for uma única variável, o valor deve ser 100%. Se houver mais variáveis de análise, a soma das porcentagens de análise das mesmas deve ser 100%.',
        },
        MARKET_INFO: {
          TITLE: 'Produtos do Mercado',
          CATEGORY_ASSIGN: 'Atribuir Categoria',
          CATEGORY_ASSIGN_TOOLTIP: 'Atribuir Categoria',
          CATEGORY_ASSIGN_DISABLED_TOOLTIP: 'Você não tem permissões',
          CATEGORY_ASSIGN_MSG: 'Precisamente, por gentileza, escolha uma Categoria para atribuir aos produtos selecionados.',
          marketItemName: 'Nome',
          marketItemCode: 'Código de Barra',
          marketCategory: 'Categoria do Mercado',
          prismaCategory: 'Categoria',
          marketItemBrand: 'Brand',
          marketItemManufacturer: 'Fornecedor',
          matching: 'Alineamento',
          CREATION_DATE: 'Criado em',
          ITEMS_NOT_MATCH: 'Visualizar produtos sem correspondência',
          MARKET_CATEGORIES: 'Categorias do Mercado',
          MARKET_CATEGORY: 'Categoria do Mercado',
          PRODUCT: 'Produto',
          PRODUCTS: 'Produtos',
          itemMarketDataType: {
            ownItems: 'Produtos Próprios',
            marketItems: 'Produtos do Mercado',
            all: 'Todos',
          },
        },
      },
      DECISIONS: {
        ASSORT_ASSIGNATION: {
          ROUTE: 'Sortimento / Decisões',
          TITLE: 'Decisões de Sortimento',
          SUBTITLE:
            'Nesta tela você verá como é composto o mix de sortimento por categoria em cada cluster. Por sua vez, você terá um resumo das sugestões e impactos delas. Usando as alavancas, você pode ativar ou desativar categorias, segmentos ou mix de sortimento.',
          SELECT_CATEGORY: 'Selecione a categoria que deseja trabalhar.',
          LAST_SALE: 'Último mês de vendas:',
          NO_DATA: 'Sem dados',
          LAST_STOCK: 'Último mês de estoque:',
          LAST_MARGIN2: 'Último mês de Margem por Acordos:',
          LAST_MARKET_INFO: 'Último mês de Informação de Mercado:',
          SHOW_CLUSTER_ASSORTMENT: 'Escolha uma categoria para mostrar o sortimento de cada cluster',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          PRINT_TTIP: 'Imprimir',
          CLUSTER: 'Cluster',
          CATEGORY: 'Categoria',
          SEGMENT: 'Segmento',
          NO_SEGMENT: 'Você deve ter um segmento para poder ativá-lo',
          IE: 'IE%',
          LISTINGS: '# Ativos',
          SKUS: '# Produtos',
          TOTAL: '# Total',
          INACTIVE: '# Para Desativar',
          ACTIVE: '# Para Ativar',
          IMPACT: 'Impacto R$',
          VIEW_PARETOC_TTIP: 'Clique aqui para ver o pareto de "categoria" em "cluster"',
          VIEW_PARETOT_TTIP: 'Clique aqui para ver o pareto da "categoria" total da empresa',
          IMPACT_TTIP: 'Impacto nas vendas de R$ se as sugestões forem ativadas ou desativadas',
          DELIST_TTIP: 'Número de sugestões para desativar',
          LIST_TTIP: 'Número de sugestões para ativar',
          TOTAL_TTIP: 'Total de produtos dentro do segmento',
          LISTINGS_TTIP: 'Total de produtos ativos no cluster',
          PERCENTAGE_TTIP: 'Porcentagem de produtos ativos',
          ERROR: 'Alocação falhou',
          CORRECT: 'Alocação salva com sucesso',
          ACCEPT_BTN: 'Alocação salva com sucesso',
          ENABLE_ASSIGNMENT_TITLE: 'Confirma ativar esses produtos neste cluster?',
          DISABLE_ASSIGNMENT_TITLE: 'Confirma desativar esses produtos neste cluster?',
          ACTION_ASSIGNMENT_SUBTITLE: 'Esta ação modificará o sortimento de todos os produtos do Cluster.',
          CANCEL_BTN: 'Cancelar',
          EDIT_BTN: 'Modificado',
          CHECK: 'Não perguntar de novo.',
          TITLE_FILTERS: 'Filtros',
          CATEGORY_FILTERS: 'Categoria',
          CATEGORY_FILTERS_TTIP: 'Você deve selecionar pelo menos uma categoria para poder filtrar por cluster',
          SEARCH_CATEGORY: 'Procurar Categorias…',
          COUNT_FILTRED: 'Quantidade filtrada',
          TOTAL_COUNT: 'Quantidade total',
          CLUSTER_FILTERS: 'Cluster',
          WITHOUT_NEWS: 'Sem novos produtos',
          TOTALITEMS: 'Total de produtos',
          TOTALSALES: 'Total de vendas',
          MSG_WITHOUT_NEWS: 'Os produtos que não estiverem em novas condições serão exibidos, mantendo sua posição na tabela.',
          WITHOUT_INACTIVES: 'Sem produtos inativos',
          MSG_WITHOUT_INACTIVES: 'Produtos inativos não serão exibidos para os clusters selecionados.',
          RECALC_PARETO: 'Recálculo de Pareto',
          SHOW_ONLY_SUGGESTIONS: 'Mostrar Somente Sugestões',
          MSG_RECALC_PARETO: 'O pareto será atualizado com base nos produtos filtrados.',
          ANALYST_FILTERS: 'Analista',
          APPROVER_FILTERS: 'Aprovador',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          UNASSIGNEDSEGMENTS: 'Mostrar segmentos não atribuídos',
          UNASSIGNEDCLUSTERS: 'Mostrar Clusteres sem Atribuição',
          EXPORT_TTIP: 'EXPORTAR',
        },
        ASSORT_ASSIGNATION_ITEM: {
          OBSERVATION: 'Observações',
          ACTIVE_IN: 'Ativo em',
          ITEM_TAGS: 'Filtros de produtos',
          STORE_TAGS: 'Filtros de Lojas',
          BEHAVIOR_FOR_CATEGORY: 'Este item só pode ser operado a partir do cluster geral Pareto.',
          SUGGESTION_MODAL_MSG:
            'A solicitação para gerar sugestões para este cluster será atendida, você será notificado assim que o processo for concluído, pode demorar alguns minutos',
          NOT_ASSORTMENT_BASED: 'Este item não é baseado em sortimento. Você deve modificá-lo a partir do mestre do item primeiro.',
          BLOCKED_FOR_SALES: 'Este item está bloqueado para venda. Você deve modificá-lo a partir do mestre do item primeiro.',
          BLOCKED_FOR_MARKET: 'Este item está bloqueado. Produto de Mercado, deve ser gerido a partir das sugestões por cluster.',
          ROUTE: 'Alocação de sortimento /',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          ORDER_TTIP: 'Ordenar',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          PRINT_TTIP: 'Imprimir',
          ACTIVATE: 'Ativar',
          ACTIVATE_TTIP: 'Ativar os produtos selecionados',
          INACTIVATE: 'Desativar',
          INACTIVATE_TTIP: 'Desativar os produtos selecionados',
          PRODUCT: 'Produto',
          BRAND: 'Marca',
          STATE: 'Estado',
          ACTIVE: 'Ativo',
          INACTIVE: 'Inativo',
          INACTIVE_MARKET_PROD: 'Produto de Mercado, devem ser geradas sugestões para ação',
          SEGMENT: 'Segmento',
          CIA: '# UN Companhia',
          MARKET: '# UN Mercado.',
          PRICE: 'Preço R$',
          MARGIN: 'Margem %',
          CORRECT: 'Alocação salva com sucesso',
          REPORT_OK:
            'Geração do relatório de Configurações Especiais de Estoque. Você será notificado quando o relatório do item estiver pronto',
          ACCEPT_BTN: 'Aceitar',
          TITLE_FILTERS: 'Filtros',
          STATE_FILTERS: 'Estado',
          ALL_OP1: 'Todos',
          ACTIVE_OP2: 'Ativo',
          INACTIVE_OP3: 'Inativo',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          LISTING: 'Ativar',
          DELISTING: 'Desativar',
          ACCEPT_SUGGESTION: 'Aceitar sugestões',
          REJECT_SUGGESTION: 'Rejeitar Sugestão',
          ACCEPT_SUGGESTIONS: 'Aceitar Sugestões',
          REJECT_SUGGESTIONS: 'Ignorar Sugestões',
          REVERT_SUGGESTION: 'Reverter alterações',
          REVERT_SUGGESTION_TO_INACTIVE: 'Reverter alterações (desativar)',
          REVERT_SUGGESTION_TO_ACTIVE: 'Reverter alterações (ativar)',
          COLUMN_DISPLAY_TTIP: 'Visualização de Colunas',
          REPORTS: 'Reportes',
          SUGGESTION: 'Gerar sugestão',
          PRODUCTS: 'Produtos',
          SALES: 'Vendas',
          IMPACT: 'Impacto nas Vendas',
          DAYS: 'Dias',
          COST: 'Custo R$',
          ORDERS: '# Ordens',
          DAYS_STOCK: 'Dias de Estoque',
          IN_STOCK: 'Em-Estoque',
          CLUSTER_SUGGESTION_ADD_TTIP: 'INATIVO <br> Sugere-se Ativar esse produto nesse cluster conforme a regra gerada:',
          CLUSTER_SUGGESTION_REMOVE_TTIP: 'ATIVO <br> Sugere-se desativar esse produto nesse cluster conforme a regra gerada:',
          REFERENCE_MISSING_TTIP: 'Não foi possível avaliar este produto: não há dados no Cluster de Referência da regra.',
          CLUSTER_SUGGESTION_ADD_DEMO_TTIP: 'Sugestão para ativar produtos com participação de vendas no topo 80% do mercado',
          CLUSTER_SUGGESTION_REMOVE_DEMO_TTIP: 'Sugestão para desativar produtos nos 5% inferiores em vendas e com estoque acima de 80%',
          ACTIVE_NEW: 'Para ativar',
          INACTIVE_NEW: 'Para desativar',
          ASSORTMENT_FOR_CATEGORY__BY_CLUSTER: 'Manipular por cluster',
          ASSORTMENT_FOR_CATEGORY__BY_CATEGORY: 'Manipular por Total Geral',
          LISTING_ALL_CLUSTERS: 'Ativar em todos os clusters',
          DELISTING_ALL_CLUSTERS: 'Desativar em todos os clusters',
          STATUS_PDV: 'Apenas sortimento de ponto de venda',
          STATUS_COMBO: 'Parte da Receita ou do Combo',
          CHANGE_GENERAL_CONFIRM_DIALOG_TITLE: 'Confirmação da atribuição do sortimento',
          CHANGE_GENERAL_CONFIRM_DIALOG_BODY: 'Você quer lidar com este item de uma maneira geral?',
          CHANGE_GENERAL_CONFIRM_DIALOG_BODY_ALT:
            'A atribuição do sortimento será alterada para "Geral". Perder-se-ão as tarefas individuais de agrupamento.',
          WHITH_FILTERS: 'Com filtros',
          WHITH_NO_FILTERS: 'Não filtrado',
          setOrderBydefault: 'Pareto Order',
          setOrderBysalesShare: 'Ordemar por Participação de Vendas',
          setOrderBysalesShareGap: 'Ordemar por Gap de Compartilhamento',
          EXIST_EXCEPTION_STORE_ASSORTMENT_TOOLTIP:
            'Há existem Conformidades Especiais de Estoque para esse item. Clique aqui para baixar o relatório',
          STORE_CLUSTER_COUNT_TOOLTIP_ACTIVE: 'O produto está Ativo para venda em {{val}} de {{val2}} PDV.',
          STORE_CLUSTER_COUNT_TOOLTIP_INACTIVE: 'O produto está Inativo para venda em {{val}} de {{val2}} PDV.',
        },
        ASSORT_CLUSTER_REPORTS: {
          GENERAL_REPORT: 'Relatório Geral',
          REPORT_DECISIONS: 'Relatórios de Decisão',
          CLUSTER_REPORT: 'Relatório por Cluster',
          PREFIX_REPORT: 'Reportado por',
        },
        ERP: {
          ROUTE: 'Sortimento / Desições',
          TITLE: 'Publicar Decisões',
          DOWLOAD_BTN: 'Baixar Info',
          PREVIEW_BTN: 'Vista Prévia',
          INFORM_BTN: 'Publicar',
          LAST_PRICES: 'Últimos preços publicados',
          GENERATION_DATE: 'Data de geração',
          GENERATION_TIME: 'Tempo de Geração',
          USER: 'Usuário',
          FILE: 'Arquivo',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          PREVIEW_PROCCESING: 'O processo começou. Você receberá uma notificação quando terminar.',
          PREVIEW_WITHOUT_PROCCESING: 'Não há novos dados para processar.',
          REPORT_ASSORTMENT_DECISIONS: 'Decisões de Sortimento',
          REPORT_MARKET_ITEM: 'Produtos de Mercado',
        },
      },
      REPORTS: {
        TITLE_DECISIONS: 'Relatórios de Decisões',
        CLUSTER_ANALYSIS: {
          ROUTE: 'Sortimento / Reportes',
          TITLE: 'Analise do Cluster',
          SUBTITLE:
            'Prisma utiliza algoritmos de inteligência artificial para detectar padrões de compra do consumidor e, assim, validar o clusterização realizada. Nesta tela, você pode analisar a consistência da clusterização definida anteriormente e alterar um ponto de venda de um cluster, se necessário. Ao aceitar uma sugestão de mudança, Prisma produzirá automaticamente a reatribuição do sortimento e o relatório que deve ser publicado ou pontos de venda para que a mudança seja corretamente implementada.',
          DISPERSION_TITLE: 'Dispersão de {{val}} por Cluster',
          EXPORT_TTIP: 'Exportar',
          APP_TTIP: 'Compartilhe com o aplicativo',
          DASHBOARD_TTIP: 'Ir para o dashboard',
          NUMBER_OF_STORES: 'Número de lojas',
          PREVIOUS_MONTH_DIF: 'Dif % Vs Mês Anterior',
          CLUSTER_QUANTITY: 'Quantidade de Cluster',
        },
      },
      ADMIN: {
        IMPORTERS: {
          MARKET_INFO: {
            TITLE: 'Informação de Mercado',
          },
        },
      },
      ABM_MODAL: {
        ROLE_SELECTION: 'Seleção do papel',
        NEW_ROL_NAME: 'Dados de papel',
        RULES_TO_DELIST: 'Regras de desabilitação',
        RULES_TO_LIST: 'Regras para Ativar',
        MARKET_LIST: 'Aumento de Preço',
        VIEW: 'Ver',
        RULES_SELECT_LEGEND1:
          'A ordem será tomada para gerar as sugestões para esta categoria, você será notificado assim que o processo for concluído, podendo levar alguns minutos.',
        RULES_SELECT_LEGEND2:
          'O papel é atribuído à categoria e combinado com a estratégia define os critérios e variáveis a serem avaliados nas sugestões.',
        RULES_SELECT_LEGEND3: ' As sugestões só serão geradas para grupos visíveis.',
        ASSIGN_ROLE: 'Atribuir Papel',
        ROLES_TYPES_TITLES: {
          NORMAL: 'Papel predefinido da categoria:',
          OTHER: 'Atribuir Papel Previamente criado',
          NEW: 'Criar e atribuir um novo papel',
          TEST: 'Atribuir regras de teste',
          MARKET: 'Cadastro de Produtos do Mercado',
        },
        ROLES_TYPES_DESCRIPTION: {
          NORMAL:
            'As sugestões para registro e cancelamento de registro serão geradas de acordo com o Papel já selecionado para esta categoria.',
          OTHER:
            'As sugestões para registro e cancelamento do registro serão geradas de acordo com a seleção de uma Função previamente registrada.',
          NEW: 'Permite criar e atribuir um novo papel para esta categoria.',
          TEST: ' As regras de descarga e descarga serão atribuídas e geradas de acordo com as configurações pré-definidas, de forma personalizada para esta categoria.',
          MARKET: 'Permite criar produtos que não temos em ItemMaster',
        },
        GENERATE_SUGGESTIONS_OK: 'Sugestão atribuída com sucesso',
      },
    },
    IMV2: {
      LIST: {
        TITLE: 'Item Master',
        NEW_ITEM: 'Novo item',
        ROUTE: 'Item-mestre / lista',
        DELETE: 'Desativar',
        DELETE_TTIP: 'Desativar registro',
        UNDELETE: 'Ativar',
        UNDELETE_TTIP: 'Ativar the registry',
        DELETE_ROWS: 'Desativar registros',
        DELETE_ROW_CONTENT: 'Seguro que desea Desativar {{val}}? solo podra ser desativados si não se encuentra en uso',
        DELETE_ROWS_CONTENT: 'Seguro que desea Desativar {{val}} produtos? solo podran ser Desativados si no se encuentran en uso',
        UNDELETE_ROW: 'Ativar Registro',
        UNDELETE_ROWS: 'Ativar Registros',
        UNDELETE_ROW_CONTENT: 'Você tem certeza que quer ativar {{val}? quando ativado, ele será iniciado com o novo estado',
        UNDELETE_ROWS_CONTENT:
          'Você tem certeza de que quer ativar os produtos {{val}}? Quando ativados, eles começarão com o novo status.',
        ACTION_ROW_CONTENT_SUCCESS: 'Ação concluída com sucesso',
        ENTITIES: {
          REPORT: 'Relatório completo aqui',
          APPLY: 'Devido à estar em uso nas seguintes entidades:',
          ITEM_NOT_FOUND: 'Produto(s) não encontrado(s)',
          USEDINCOMBOS: 'CÓDIGOS: {{val}}',
          USEDINMISSIONS: 'Misões: {{val}}',
          USEDINPARENTRULES: 'Regras de Preços: {{val}}',
          USEDINPLANOGRAMS: 'Plano de Exposição: {{val}}',
          USEDINPROMOTIONS: 'OFERTAS: {{val}}',
          USEDINRECIPES: 'Receitas: {{val}}',
          IMPEDIMENT: {
            USEDINPARENTRULES:
              'O produto pai não pode ficar vazio. Excluir a regra e criar uma nova com outro produto pai, caso necessário.',
            USEDINMISSIONS: 'O produto de presente não pode ficar vazio. Atribua outro produto de presente primeiro.',
            USEDINPLANOGRAMS:
              'Não é possível excluir um produto que está em um plano de exposição. Retire-o do plano de exposição primeiro.',
            USEDINRECIPES: 'Não é possível excluir um produto que faz parte de uma receita. Retire-o da receita primeiro.',
            USEDINCOMBOS: 'Não é possível excluir o último produto de um bloco. Adicionar outro produto ao bloco ou excluir o bloco.',
          },
        },
        ACTION_FAIL: {
          DESCRIPTION_ERROR: 'A problema foi gerado por ',
          TYPE: 'Tipo: {{val}}',
          KEYWORD: 'Chave de Palavra: {{val}}',
          VALUES: 'VALORES: {{val}}',
          WARNING: 'Aviso',
          ERROR: 'Erro',
          ENTITYNOTFOUND: 'Entidade não encontrada',
        },
        FILTER_TTIP: 'Filtro',
        FULLSCREEN_TTIP: 'Maximizar',
        EXPORT_TTIP: 'Exportar',
        REPORT_REQUIRES_FILTER: 'Aplique pelo menos um filtro para gerar o relatório',
        NAME: 'Nome',
        CODE: 'Código',
        INTERNAL_CODE: 'Código',
        CODE_EXIST: 'O código {{val}} já existe',
        TYPE: 'Gentil',
        CATEGORY: 'Categoria',
        SUBCATEGORY: 'Subcategoria',
        BRAND: 'Marca',
        EDIT_ROW: 'Editar registro',
        VIEW_ROW: 'Visualizar Registro',
        EDIT_ROW_DISABLED_TOOLTIP: 'Não é possível editar um registro no processo de publicação',
        COPY_ROW: 'Copiar registro',
        DISABLED_CLONE_TOOLTIP: 'Somente registros no estado publicado podem ser clonados',
        DISABLED_CLONE_TOOLTIP_OR_NEW: 'Sólo é possível clonar registros em estado publicado ou novo.',
        DELETE_ROW: 'Desativar registro',
        TYPE_FILTERS: 'Tipos de itens',
        SEE_DELETED_FILTERS: 'Ver Inativados',
        SEE_ITEMS_CREATED_WHIT_MARKET_RULE: 'Visualizar Itens criados com base em Informações do Mercado',
        SEE_WITHOUT_EXHIBITION: 'Ver itens sem unidade de exibição',
        SHORT_NAME: 'Pequena descrição',
        STATUS: 'Status',
        STATUS_NEW: 'Novo',
        STATUS_MODIFIED: 'Modified',
        STATUS_CURRENT: 'Postado',
        EAN: 'Código Interno',
        ITEM_CREATION_ON: 'Data de criação',
        DEPARTMENT: 'Departamento',
        CREATOR: 'Criador',
        ITEM_MODIFY_ON: 'Data de modificação',
        ASSORTMENTBEHAVIORS: 'Surtido',
        STORES_FILTER: 'Pontos de Venda',
        CLONE_ITEM_TITLE: 'Clone Item',
        CLONE_ITEM_CONTENT:
          'Definir nome e código interno para o novo item. Todos os pontos existentes serão clonados de {{val}} ({{val2}}), havendo a possibilidade de edição.',
        ITEM_TAGS: 'Filtros de Produto',
        ITEM_FILTER: 'Produto',
        ACTION_ROW_CONTENT_FAILED: 'Ação não pode ser realizada corretamente.',
      },
      EDIT: {
        AUTOSAVE: {
          SYNCING: 'Salvando automaticamente…',
          SAVED: 'Salvo automaticamente',
          ERROR: 'Não foi possível salvar automaticamente',
        },
        ITEM: {
          SAVE: 'Salvar',
          PUBLISH: 'Publicar',
          WARNING_SAVE: 'As alterações atuais devem ser salvas.',
          WARNING_PUBLISH: 'Você precisa republicar para que as alterações salvas tenham efeito.',
          NOVALID_PUBLISH_ADVICE: 'A seguinte tab não é válido:',
          BASIC_INFORMATION_TAB: 'Dados Principais',
          CLASSIFICATION_TAB: 'Classificasão',
          UNITS_OF_MEASURE_TAB: 'Unidades de medida',
          ASSORTMENT_TAB: 'Sortimentos',
          WARNING_SEGMENT: 'Precisa preencher o campo Setor na aba Estoque, para que possa publicar as alterações.',
          VENDORS_TAB: 'Fornecedores, Custos e Impostos',
          PRICES_TAB: 'Preços',
          INGREDIENTS_TAB: 'Ingredientes',
          COMPONENTS_TAB: 'Componentes',
          CODES_TAB: 'Códigos',
          CODES_MATCHING: 'Equivalência',
          VARIANTS_TAB: 'Variantes',
          DELIVERY_TAB: 'Canais de venda',
          LOADING: 'Carregando...',
          NEW_ITEM_BTN: 'Novo item',
          PUBLISH_CONFIRM:
            'O processo de publicação inclui a criação do sortimento, preços, custos e outros registros relacionados ao produto. <br> <br> <b> Tem certeza que deseja publicar? </b>',
          PUBLISH_CONFIRM_TITLE: 'Confirmação de Publicação',
          PUBLISHING_WARNING: 'Item em processo de publicação, tente novamente em alguns minutos.',
          PUBLISH_LONG_TIME:
            'A publicação deste Produto pode demorar alguns minutos, quando for encerrada você será notificado com uma notificação.',
          PUBLISH_InvalidCombo: 'A combinação é inválida, verifique na aba correspondente ao produto.',
          PUBLISH_InvalidRecipe: 'A receita é inválida, verifique na aba correspondente ao produto.',
          PUBLISH_Vendors: 'Há um erro nos fornecedores associados, verifique a aba correspondente aos fornecedores.',
          REPORT: 'Reporte',
          REPORT_WARNING: 'A publicação é necessária para baixar o relatório.',
        },
        MAIN_DATA: {
          NAME: 'Nome',
          SHORT_NAME: 'Pequena descrição',
          TICKET_DESCRIPTION: 'Descrição do Ticket',
          NOMBRE_ARTICULO_TAG_FIELD: 'Nome do Artigo',
          NAME_AUTO_HINT: 'Gerado automaticamente a partir das etiquetas de classificação.',
          COMPOSE_TAGS_MISSING:
            'Não foi encontrada alguma das etiquetas necessárias para o nome automático: {{val}}. Entre em contato com a equipe de suporte.',
          TICKET_DESCRIPTION_HINT: 'Nome truncado ao limite de impressão do ticket.',
          CREATION_DATE: 'Data de criação',
          INTERNAL_CODE: 'Código Interno',
          CODE_AUTO_HINT: 'Será criado automaticamente ao gravar.',
          VALIDATION_CODE2: 'O código {{val}} já existe.',
          BAR_CODE: 'Código de barras',
          REGIONAL_ITEM: 'Produto Regional',
          REGIONAL_ITEM_CHANGE: 'Mudar para Produto padrão',
          REGIONAL_ITEM_DISABLED: 'Não tem permissões para alterar para Produto padrão',
          REGIONAL_ITEM_MODAL_TITLE: 'Cambiar status do produto regional',
          REGIONAL_ITEM_MODAL_CONTENT:
            'Tem certeza de desejar alterar o produto para deixá-lo sem a categoria Produto Regional? Essa operação é irreversível. Somente por meio de interfaces podem ser criados produtos da categoria Regional e não podem ser modificados para esse estado outros tipos de produtos.',
          DISPLAY_NAME: 'Nome para Totem',
          DISPLAY_NAME_TIP:
            'Nome que o cliente final verá nos totens de autoatendimento ao personalizar o produto. Opcional: se ficar vazio, o nome do item é usado.',
          KDS_PREP_MINUTES: 'Minutos de preparo (KDS)',
          KDS_PREP_SECONDS: 'Segundos de preparo (KDS)',
          KDS_PREP_TIME_TIP:
            'Tempo de preparo exibido no KDS (tela da cozinha). Opcional: se ambos ficarem vazios, nada é enviado; se apenas um for preenchido, o outro conta como 0.',
        },
        UNITS_OF_MEASURE: {
          NAME: 'Nome',
          DUP_CODE_AND_CONVERSION: 'Não pode haver 2 unidades de medida com um nome exato e fator de conversão.',
          ONLY_SINGLE_SELLING_UNIT_UOM: 'Não podem existir 2 unidades de medida de venda.',
          UNIT_NAME: 'Nome da Unidade',
          CONVERSION: 'Fator de Conversão',
          UNIT_BASE: 'Unidade Base',
          SALES_UNITS: 'Unidade de Venda',
          SOME_SELLING_UNIT: 'Deve haver pelo menos uma unidade de vendas.',
          INITIAL_PRICE: 'Preço Inicial',
          INITIAL_PRICE_TIP: 'Este precio se va a aplicar a todas las tiendas donde el producto este activo',
          FRONT_PHOTO: 'Imagem do item frontal',
          SIDE_PHOTO: 'Imagem do item lateral',
          PHOTO_ABOVE: 'Imagem do item acima',
          EXHIBITION_UNITS: 'Unidade de Exhibição',
          CAN_EXHIBIT_ON_HOOK_MODULE: 'Exibível em ganchera?',
          FACINGS_LIMIT: 'Limite de Faces',
          MIN_FACES: 'Mínimo de Faces',
          MAX_FACES: 'Máximo de Faces',
          MAG_HEIGHT_WITH_MAG: 'Altura (cm.)',
          MAG_WIDTH_WITH_MAG: 'Largura (cm)',
          MAG_DEPTH_WITH_MAG: 'Profundidade (cm.)',
          EXHIBITION_DIMENSIONS_REQUIRED: 'Preencha altura, largura e profundidade maiores que 0 para salvar com exibição.',
          MAX_COMPRESSION_PERCENT: '% máx. compressão',
          MAX_COMPRESSION_PERCENT_HINT: 'Opcional. Valor entre 0 e 100. Vazio = produto não comprimível.',
          MAX_COMPRESSION_PERCENT_ERROR: 'A porcentagem deve ser maior que 0 e menor que 100.',
          STACKABLE_SWITCH: 'Empilhável',
          OVERTHROW_SWITCH: 'Pode Tombar',
          ROTATE_SWITCH: 'Pode Girar',
          MAX_STACKS: 'Máximo de pilhas',
          NEW_UNIT_BTN: 'Nova Unidade',
          REGULATED_PRICE_MAX: 'Precificação Máxima',
          REGULATED_COST_MAX: 'Custo Máximo',
          REGULATED_PRICE_TIP: 'Defina o valor máximo para o preço (Preço Regulado)',
          REGULATED_COST_TIP: 'Defina o valor máximo para o custo (Custo Regulado)',
          FORCE_REGULATED_PRICE_MAX: 'Forçar Preço Máximo',
          FORCE_REGULATED_COST_MAX: 'Forçar Custo Máximo',
          REGULATED_PRICE_MARGIN: 'Margem',
          REGULATED_PRICE_MARGIN_TIP: 'Defina o Lucro por Preço (Lucro para Preço Regulado)',
          EXHIBITION_UNIT: 'Unidade de Exibição',
          FRONT_LOAD: 'Unidades Frontais',
          DEPTH_LOAD: 'Unidades de Profundidade',
          HEIGHT_LOAD: 'Empilhamento em altura',
          HEIGHT_LOAD_TIP: 'Quantidade de níveis verticais do SRP. Se vazio, será considerado 1.',
          HEIGHT_LOAD_ERROR: 'O empilhamento em altura deve ser um inteiro maior ou igual a 1.',
          SRP: 'SRP',
          SHELF_READY_PACKAGE: 'Pacote Pronto para Estante',
          EXHIBITION_TYPE: 'Tipo de Exibição',
          INDIVIDUAL: 'Igual à unidade de venda',
          SRP_REPLACE_BASE_UNIT_WARNING:
            'Ao adicionar esta unidade de exibição, a mesma substituirá a unidade individual na geração de planogramas',
          TOOLTIP_SINGLE_SELLING_UNIT_UOM: 'Sólo é permitida uma unidade de venda.',
          DELETION_BLOCKERS: {
            TITLE: 'Não é possível excluir a unidade de medida {{val}}:',
            NotFound: 'A unidade de medida não foi encontrada',
            AlreadyDeleted: 'Já foi excluída',
            IsBase: 'É a unidade base',
            IsSellingUnit: 'É a unidade de venda',
            UsedByVendors: 'É a unidade de pedido de um fornecedor',
            UsedByVendorCosts: 'Possui custos de fornecedor',
            UsedByItemCodes: 'Possui códigos associados',
            UsedByRecipes: 'É usada em uma receita',
            UsedByCombos: 'É usada em um combo',
            UsedByStorePrices: 'Possui preços ativos (republique o produto antes de excluí-la)',
          },
        },
        RECIPE: {
          COMPONENT: 'componente',
          TYPE: 'Tipo',
          NO_UOM: 'Item sem unidade de medida',
          UOM: 'Unidade de medida',
          QUANTITY: 'Quantidade',
          WASTE_INPUT: 'Desperdício %',
          COST: 'Custo',
          TAX: 'Imposto',
          TOTAL_COST: 'Custo Total Aproximado:',
          ADD_COMPONENT: 'Adicionar Componente',
          OPTIONAL: 'Personalizável',
          OPTIONAL_TIP: 'O cliente final pode remover este componente do produto no ponto de venda.',
        },
        COMBO: {
          NAME: 'Nome',
          QUANTITY: 'Quantidade',
          NO_UOM: 'Item sem unidade de medida',
          UOM: 'Unidade de medida',
          MAX_COST_TIP: 'O componente com o maior custo é levado em consideração',
          TOTAL_COST: 'Custo Total Aproximado:',
          ADD_BLOCK: 'Adicionar Grupo',
          ADD_COMPONENT: 'Adicionar Componente',
          COST: 'Custo',
          TAX: 'Imposto',
        },
        CODES: {
          HELP_BOX: 'Nesta seção, você pode adicionar códigos de barras adicionais ou outros códigos externos.',
          CODE_TYPE: 'Tipo de código',
          CODE: 'Código',
          VALIDATION_CODE2: 'O código {{val}} já existe.',
          VALIDATION_CODE_DUPLICATE: 'Existem códigos duplicados',
          INVALID_CODE: 'Formato de código inválido.',
          UNITS_OF_MEASURE_BUY: 'Unidade de Medida',
          ADD_CODE: 'Adicionar Código',
          NEW_CODE: 'Novo Código',
          PRIMARY_CODE_DELETE_WARNING: 'Não é possível excluir um Código Principal.',
          PRIMARY_VENDOR_DELETE_WARNING: 'Não é possível excluir um Código Principal.',
        },
        VARIANTS: {
          ADD_VARIANT: 'Adicionar Variante',
          PRINCIPAL_LABEL: 'Produto Principal:',
          DESCRIPTION:
            'Nesta seção você pode configurar o produto principal deste item quando faz parte de um grupo de variantes de exibição.',
          ALREADY_PRINCIPAL: 'Este item já é produto principal de outras variantes. Não pode ser atribuído como variante de outro produto.',
        },
        MATCHINGS: {
          ADD_MATCHING: 'Adicionar equivalência',
          ITEM_CODE_TYPE: 'Tipo de código do item',
          ITEM_CODE: 'Código do item',
          ITEM_NAME: 'Nome do item',
          DUPLICATED_FLAGS: 'Combinação Código do Item-Bandeira Duplicada',
          DUPLICATED_FLAG_AND_CODE: 'Combinação Código do Item-Bandeira Duplicada',
          INVALID_CODE: 'CÓDIGO INVÁLIDO',
          NAME_REQUIRED: 'NOME OBRIGATÓRIO',
          FLAG_REQUIRED: 'Bandeira obrigatória',
          MATCHING_OF: 'Equivalência de',
          CONVERTION_RATE: 'Fator de Conversão',
          CONVERTION_RATE_REQUIRED: 'Fator de Conversão Requerido',
          CONVERSION_FACTOR_CALCULATOR: 'Calculadora de Fator de Conversão',
          FORMULA: 'Fórmula',
          QUANTITY: 'Quantidade',
          VOLUME_YOUR: 'Volume produto próprio',
          VOLUME_COMPETITOR: 'Volume produto equivalente',
          YOUR_PRODUCT: 'Produto próprio',
          COMPETITOR_PRODUCT: 'Produto equivalente',
          VOLUME: 'Volume / Peso / Comprimento',
          TOTAL: 'Total',
          CALCULATED_FACTOR: 'Fator calculado',
          CLEAR: 'Limpar',
          UNIT_WARNING: 'Ambos os produtos devem usar a mesma unidade de medida para que o cálculo seja correto.',
        },
        ASSORTMENT: {
          NOT_PARAMETERIZED: 'Para ativar esse botão é necessário concluir a configuração da categoria no Estoque.',
          NOT_ACCESS_PERMISSION: 'Não tenho permissão para completar esta seção',
          NOTIFY_USER: 'NOTIFICAR USUÁRIO',
          NOTIFIED_USER: 'Usuário notificado',
          IMPORT_FILE_NAME_LINK: 'determinar-PDV.xlsx',
          IMPORT_FILE_NAME_BTN: 'Carregamento de sortimento excepcional',
          IMPORT_ASSORTMENT_STORE_CONTEXT:
            'Pode importar exceções de sortimento pelo botão do importador ou ver o estado do sortimento para este item',
          BTN1_TITLE: 'Baseado no Sortimento',
          BTN1_MSG:
            'Leva em consideração a segmentação principal definida para a categoria, podendo fazer exceções por meio de um importador.',
          BTN2_TITLE: 'Ativo em todos os Pontos de Venda',
          BTN2_MSG: 'O produto estará ativo em todos os pontos de venda',
          BTN3_TITLE: 'Só se faz parte da Receita ou Combo',
          BTN3_MSG: 'O produto pode participar de uma receita ou de um combo',
          BTN4_TITLE: 'Só sortimento de Pontos de Venda',
          BTN4_MSG: 'O produto estará ativo em determinados Pontos de Venda',
          BTN3_TOOLTIP_COMBO: 'Combos não podem fazer parte de receitas ou combos',
          NO_PERMISSION_TOOLTIP: 'Você não tem permissão para editar o comportamento do sortimento',
          NO_IMPORT_PERMISSION_TOOLTIP: 'Você não tem permissão para importar exceções de sortimento',
          LOCKED_BY_DELIVERY_PLACES: 'Definido pela configuração de Locais de Entrega',
          BTN3_TITLE_RECIPE: 'Só se faz parte de um Combo',
          BTN3_MSG_RECIPE: 'O produto pode participar de um combo.',
          BTN1_TOOLTIP_RECIPE: 'Receitas não podem usar a opção Baseado em Sortimento quando o módulo está licenciado',
          ASSORTMENT_SEGMENT_SETUP_TITLE: 'Definir segmento',
          ASSORTMENT_SEGMENT_SETUP_CONTENT_1: 'Definir segmento para a categoria {{val}}',
          ASSORTMENT_SEGMENT_SETUP_CONTENT_2: 'Esta mudança terá impacto na tela de atribuição de segmentos no módulo de sortimentos.',
          SEGMENT: 'Segmento',
          DEFINE: 'Definir',
          CANCEL: 'Cancelar',
          IMPORT_TITLE: 'Importar Pontos de Venda',
          ASSORTMENTBEHAVIORS_BASEDONASSORTMENT: 'Com base na variedade',
          ASSORTMENTBEHAVIORS_ACTIVEINALLSTORES: 'Ativo em todos os pontos de venda',
          ASSORTMENTBEHAVIORS_ONLYIFPARTOFRECIPEORCOMBO: 'Apenas se fizer parte da Receita ou Combinação',
          ASSORTMENTBEHAVIORS_ONLYSTOREASSORTMENT: 'Apenas variedade de pontos de venda',
          INIT_ASSORMENT: 'Inicialização de sortimentos',
          CHOOSE_OPT_ASSORMENT: 'Escolha uma opção de inicialização de sortimento',
          BLOCKED_FOR_PURCHASE: 'Bloqueio de compra',
          BLOCKED_FOR_SALES: 'Bloqueio de venda',
          CLONE_EXCEPTION_STORE_ASSORTMENT: 'Clonar Exceções de Estoque',
          CLONE_EXCEPTION_STORE_ASSORTMENT_MSG:
            'Quando essa opção for ativada, as exceções de estoque deste registro serão clonadas. Deve haver pelo menos uma exceção de estoque não bloqueada para venda.',
          DOWLOAD_EXCEL: 'Descarregar excel',
          VIEW_ASSORTMENT_STATUS: 'Relatório de sortimento',
          VIEW_ASSORTMENT_STATUS_ACTUAL: 'Relatório de sortimento Actual',
          REQUIRE_SAVE_ASSORTMENT_STATUS: 'É necessário salvar as alterações feitas',
          REQUIRE_SAVE_ASSORTMENT_STATUS_MSG:
            'Foram detectadas alterações que afetam o status do Sortimento, para poder acessar você deve salvar as alterações feitas',
          IMPORT_ITEMS: 'Stock por ponte de venda',
          IMPORT_EXCEL_ITEMS_FIXED_PRICE: 'Importar Preços Fixos',
          IMPORT_EXCEL_ITEMS_DISCOUNT: 'Importar Descontos',
          IMPORT_EXCEL_ITEMS: 'Importar exceções',
          DELETE_EXCEL_ITEMS: 'Excluir Exceções',
          DELETE_EXCEL_ITEMS_MESSAGE: 'Todas as exceções carregadas serão excluídas.',
          IMPORT_EXCEL_ITEMS_WARNING: 'Para importar é necessário ter pelo menos os dados principais salvos. ',
          CATEGORY_CONFIG_WARNING:
            'Para utilizar o comportamento baseado em estoque, é necessário que a categoria desse item tenha atribuídas Segmentação e Clusterização.',
          CONFIG_CATEGORY: 'Atribuir Segmentação e Agrupamento à Categoria',
          CONFIG_TAG: 'Atribuir valores à etiqueta',
          CONFIG_TAG_CONTENT: 'O segmento pertencente à categoria selecionada não tem valores.',
          DEFINE_SEGMENT: 'DEFINIR SEGMENTO',
          CATEGORY_WARNING:
            'A categoria {{val}} não tem uma segmentação principal definida, escolha uma opção para avançar com a inicialização do sortimento.',
          CATEGORY_SELECT_WARNING:
            'Você precisa selecionar uma categoria para este produto para prosseguir com a inicialização do sortimento.',
          NAME: 'Nome',
          CODE: 'Código',
          ACTIVE: 'Ativo',
          BLOCQUED_SELL: 'Bloqueado para a venda',
          BLOCQUED_BUY: 'Bloqueado para a compra',
          OBSERVATIONS: 'Observações',
        },
        PRICES: {
          SUGGESTED_PRICE_INPUT: 'Preço Fixo a Nível Nacional',
          DINAMIC_PRICE_INPUT: 'Desconto % sobre componentes',
          PRICE_TYPE_INPUT: 'Tipo de preço',
          DISCOUNT_INPUT: 'Desconto',
          BTN3_TITLE: 'Em base ao preço de seus componentes',
          BTN3_MSG: 'Cada vez que você altera o preço de um componente, o preço do kit pode mudar.',
          PERMANENT_PRICE_INPUT: 'Preço fixo',
          BTN1_TITLE: 'Preço Nacional',
          BTN1_MSG: 'Leva em consideração o preço único inicial definido para cada uma das unidades de medida de venda',
          BTN2_TITLE: 'Preço do clone',
          BTN2_MSG: 'Clone o preço de um produto existente',
          INIT_PRICE: 'Inicialização de Preços',
          CHOOSE_INIT_PRICE: 'Escolha uma opção de inicialização de preço',
          REVIEW_CHANGES: 'Para consultar as alterações de preço, vá para ',
          PRICE_DECISIONS: 'Decisões de Precos',
          NO_PRICE_TIP:
            'No caso de não se encontrar um preço em nenhum ponto de venda para o produto clonado, será utilizado o preço inicial da unidade de medida de venda.',
          INITIAL_PRICE: 'Preço Inicial',
          SELL_UOM: 'Unidade de medida de venda',
          IVA: 'IVA',
          VIEW_ASOCIATED_RULES: 'VER REGRAS ASSOCIADAS',
          CONFIRM_CLONE_VALIDATION_MSG:
            'O produto cujos preços você deseja clonar não possui as mesmas unidades de medida. Recomenda-se escolher um produto com as mesmas unidades de medida de venda.',
          CONFIRM_CLONE_VALIDATION_TITLE: 'Confirmar seleção',
          CONFIRM_CLONE_VALIDATION_OK: 'Continuar com a seleção atual',
          CONFIRM_CLONE_VALIDATION_CANCEL: 'Escolha um novo produto',
          VIEW_ASOCIATED_RULES_TITLE: 'Sem regras associadas',
          VIEW_ASOCIATED_RULES_TITLE_MGS: 'Não é possível consultar um item que não foi publicado',
        },
        VENDORS: {
          TITLE: 'Fornecedores, Custos e Impostos',
          SUBTITLE:
            'Defina um (s) fornecedor (es) para este produto. Se optar por uma segmentação, todos os pontos de venda devem ter um valor atribuído e desta forma podem carregar custos e impostos específicos para cada valor do segmento.',
          VENDOR: 'Fornecedor',
          PRIMARY_VENDOR_WARNING: 'Deve existir pelo menos um Fornecedor Principal.',
          MISSING_DELIVERY_PLACES_INLINE: 'Sem Locais de Entrega',
          MISSING_DELIVERY_PLACES_TOOLTIP:
            'Este fornecedor não tem Locais de Entrega configurados. Configure pelo menos uma entrada antes de publicar o item.',
          PRIMARY_VENDOR_WARNING_ONLY_ONE: 'Não pode haver mais de um Provedor Principa',
          PRIMARY_VENDOR_WARNING_UOM: 'Não  pode existir o mesmo fornecedor com a mesma unidade de medida de compra.',
          PRIMARY_VENDOR_WARNING_DUP: 'Não é possível registrar um provedor mais de uma vez.',
          REGIONAL_PRODUCT_WITH_ONE_VENDOR: 'Não é possível ter mais de um fornecedor',
          PRIMARY_VENDOR_DELETE_WARNING: 'Não é possível excluir um provedor principal.',
          CONFIRM_DELETE_TITLE: 'Excluir Fornecedor',
          CHECKING_DELETE_IMPACT: 'Consultando locais de entrega associados…',
          CONFIRM_DELETE_WITH_DELIVERY_PLACES: 'Excluir o fornecedor {{val}} removerá {{val2}} locais de entrega associados. Confirmar?',
          INTERNAL_CODE: 'Código Interno do Provedor',
          SEGMENT: 'Segmento',
          SEGMENTATION: 'Segmentação',
          UOM_BUY: 'Unidade de medida de compra',
          MIN_ORDER: 'Ordem Mínima',
          MAX_ORDER: 'Ordem Máxima',
          NEW_VENDOR: 'Novo Fornecedor',
          UNIQUE_COST: 'Custo Único',
          UNIQUE_COST_NATIONAL: 'Custo nacional',
          SEGMENT_COSTS: 'Segmentar Custos',
          PRIMARY_VENDOR: 'Fornecedor primário',
          SECONDARYY_VENDOR: 'Fornecodor secundário',
          INDICATE_TEXT: 'indique os valores de custo e impostos correspondentes a:',
          VENDOR_ITEM_NUMBER_EXISTS: 'O código interno do fornecedor já existe (Código de produto: {{val}})',
          TAX_PERCENT_OUT_OF_RANGE: 'O valor deve estar entre 0 e 100.',
          UNIT_COST_LABEL: 'Custo unitário',
        },
      },
    },
    ITEM_MASTER: {
      TITLE: 'Maestro de Itens',
      DELIVERY_PLACES: {
        NO_MATCHES: 'Não há resultados para a sua busca.',
        NO_ROWS: 'Sem dados para exibir.',
        DISCARD_TITLE: 'Descartar alterações',
        DISCARD_MESSAGE:
          'Você tem {{count}} alteração(ões) não salva(s). Se fechar o pop-up, elas serão perdidas. Deseja fechar mesmo assim?',
        SAVE_OK_WITH_WARNINGS: 'As alterações foram salvas, mas há {{count}} linha(s) com avisos. Revise as marcadas em vermelho.',
        SAVE_IMPACT_TITLE_CREATE: 'Confirmar cadastro de locais de entrega',
        SAVE_IMPACT_MESSAGE_CREATE:
          'Você está cadastrando os locais de entrega deste fornecedor. Depois de salvar, o produto vai começar a chegar nas lojas selecionadas. Confirmar?',
        SAVE_IMPACT_TITLE_MODIFY: 'Confirmar alteração de locais de entrega',
        SAVE_IMPACT_MESSAGE_MODIFY:
          'Você está alterando os locais de entrega deste fornecedor: algumas lojas vão deixar de receber o produto por aqui e outras vão começar a receber. Confirmar?',
        CHIP_MANAGE: 'Gerenciar',
        TAB_LABEL: 'Locais de entrega',
        NO_PERMISSION_TOOLTIP: 'Você não tem permissão para configurar Locais de Entrega. Contate o administrador.',
        SAVE_VENDOR_FIRST: 'Salve o fornecedor antes de configurar os locais de entrega',
        VENDOR_LABEL: 'Fornecedor',
        PILLS_LABEL: 'Modos de entrega',
        PILL_DIRECTA: 'Direta',
        PILL_CEDIS: 'CEDIS',
        COL_REGIONS: 'Regiões',
        COL_ZONAS: 'Zonas',
        COL_TIENDAS: 'Lojas',
        COL_CEDIS: 'CEDIS',
        SEARCH_REGION: 'Pesquisar região...',
        SEARCH_ZONA: 'Pesquisar zona...',
        SEARCH_TIENDA: 'Pesquisar loja...',
        SEARCH_CEDIS: 'Pesquisar CEDIS...',
        TIENDAS_LABEL: 'lojas',
        SELECT_ALL_TOOLTIP: 'Selecionar / desmarcar todos',
        COVERAGE_TITLE: 'Configurar cobertura do CEDIS',
        COVERAGE_HINT_APPLY_THEN_SAVE: 'Estas alterações se aplicam localmente. Pressione "Salvar" no popup principal para persistir.',
        COVERAGE_EMPTY: 'Nenhuma loja corresponde à pesquisa.',
        COVERAGE_CONFIGURE_TOOLTIP: 'Configurar lojas incluídas na cobertura do CEDIS',
        COVERAGE_APPLIED_REMEMBER_SAVE: 'Cobertura aplicada. Pressione "Salvar" para confirmar as alterações.',
        APPLY_BTN: 'Aplicar',
        SAVE_BTN: 'Salvar',
        CANCEL_BTN: 'Cancelar',
        SAVING_BTN: 'Salvando...',
        SAVE_OK: 'Locais de Entrega salvos',
        SAVE_ERROR: 'Erro ao salvar. Tente novamente.',
        NO_CHANGES: 'Nenhuma alteração para salvar',
        LOAD_ERROR: 'Não foi possível carregar os dados',
        COHERENCE_ERROR:
          'Conflito de coerência em {{count}} linha(s). Revise as marcadas em vermelho: o Tipo de Entrega deve coincidir com os demais fornecedores para a mesma loja.',
        NO_VENDOR: 'Selecione um fornecedor para começar.',
        NO_PILLS_ACTIVE: 'Ative pelo menos um modo de entrega (DIRETA ou CEDIS).',
      },
      NEW_ITEM_BTN: 'Iten Novo',
      DUPLICATED_ITEM: 'Iten duplicado',
      FILTER_TTIP: 'Filtrar',
      FULLSCREEN_TTIP: 'Expandir',
      EXITFULLSCREEN_TTIP: 'Reduzir',
      EXPORT_TTIP: 'Exportar',
      IMPORT_TTIP: 'Importar',
      PRINT_TTIP: 'Imprimir',
      DELETE_TTIP: 'Apagar itens selecionados',
      DELETE: 'Apagar',
      RECOVER: 'Recuperar',
      RECOVER_TTIP: 'Recuperar itens selecionados',
      NAME: 'Nome',
      CODE: 'Código',
      TYPE: 'Tipo',
      CATEGORY: 'Categoria',
      SUBCATEGORY: 'Subcategoria',
      BRAND: 'Marca',
      CREATION_DATE: 'Data de Criação',
      RECOVER_ITEMS_TITLE: 'Você quer recuperar os itens selecionados?',
      RECOVER_ITEMS_SUBTITLE: 'Esses itens desaparecerão da lista de itens excluídos.',
      CANCEL_BTN: 'Cancelar',
      CONFIRM_BTN: 'Confirmar',
      NEW_ITEM_MODAL: 'Iten Novo',
      ITEM_TYPE_INPUT: 'Tipo de Iten',
      LEGEND_RETAIL:
        'Os itens de Varejo são itens regulares que podem ser vendidos em qualquer canal de vendas sem sofrer transformações ou combinações com outros itens.',
      LEGEND_INGREDIENT: 'Esses itens não podem ser vendidos individualmente, mas fazem parte de uma receita.',
      LEGEND_RECIPES: 'É um produto constituído por um ou mais ingredientes.',
      LEGEND_SUPPLY: 'Esses itens não podem ser vendidos individualmente, mas fazem parte de uma receita.',
      CREATE_BTN: 'Criar',
      TITLE_FILTERS: 'Filtros',
      SEE_DELETED_FILTERS: 'Ver Eliminados',
      TYPE_FILTERS: 'Tipo',
      CLEAN_FILTER_BTN: 'Limpar',
      APPLY_FILTER_BTN: 'Aplicar',
      DEFINE_ITEM_STP1: 'Definir Iten',
      CLASSIFICATION_STP2: 'Classificação',
      LOGISTICS_DATA_STP3: 'Informação de Logística',
      INTEGRATION_STP3: 'Integração',
      PURCHASE_DATA_STP4: 'Dados de Compra',
      SALES_DATA_STP5: 'Dados de Venda',
      EDIT_TITLE_FORM: 'Editar',
      NEW_TITLE_FORM: 'Novo',
      INGREDIENT_TITLE: 'Ingrediente',
      SUPPLY_TITLE: 'Abastecimento',
      RETAIL_TITLE: 'Varejo',
      RECIPE_TITLE: 'Iten - Receita',
      COMBO_TITLE: 'Iten - Kit',
      ITEM: 'Iten',
      STP1: 'Etapa 1 - Definir Iten',
      INTERNAL_CODE_INPUT: 'Código Interno',
      ERROR: 'Incorreto',
      EAN_INPUT: 'Código EAN',
      TYPE_INPUT: 'Tipo',
      NAME_INPUT: 'Nome',
      SHORT_DESCRIPTION_INPUT: 'Descrição Curta',
      SHORT_DESCRIPTION_VALIDATION: 'Caracteres inseridos:',
      CREATION_DATE_INPUT: 'Data de Criação',
      NEXT_BTN: 'Próximo',
      STP2: 'Etapa 2 - Classificação do Iten',
      CATEGORY_INPUT: 'Categoria',
      SEARCH_CATEGORY: 'Procurar Categoria…',
      SUBCATEGORY_INPUT: 'Subcategoria',
      SEARCH_SUBCATEGORY: 'Procurar Subcategoria…',
      BRAND_INPUT: 'Marca',
      SEARCH_BRAND: 'Procurar Marca…',
      ADD_BRAND_BTN: 'Adicionar Marca',
      PREVIUS_BTN: 'Anterior',
      STP3: 'Etapa 3 - Dados Logísticos',
      UNIT_NAME: 'Nome da Unidade',
      UNIT_NAME_INPUT: 'Nome da Unidade',
      DELETE_UM: 'Apagar Unidade de Medida',
      CODE_INPUT: 'Código',
      REQUIRED: 'Campo obrigatório',
      CODE_VALIDATION: 'O Código deve ser único',
      UNIT_REPEATED: 'Unidade Repetida',
      CODE_REPEATED: 'Código repetifdo',
      CREATE_UNIT: 'Criar nova Unidade',
      CONVERSION_FACTOR_INPUT: 'Fator de Conversão',
      UNIT_BASE_CHECK: 'É Unidade Base',
      NEW_UNIT_BTN: 'Nova Unidade',
      UNIT_ALREADY_EXIST: 'Unidade já existente',
      STP4: 'Etapa 4 - Dados de Compra',
      STP5: 'Etapa 5 - Dados de Compra',
      PURCHASE_UNIT_INPUT: 'Unidade de Compra',
      QUANTITY_UMB_INPUT: 'Quantidade x UMN',
      SUPPLIER_INPUT: 'Fornecedores',
      SEARCH_SUPPLIER: 'Procurar Fornecedores…',
      COST_INPUT: 'Custo',
      PURCHASE_IVA_INPUT: 'Imposto de Compra',
      SALE_IVA_INPUT: 'Taxa Venda',
      SAVE_BTN: 'Salvar',
      STP_4_2: 'Etapa 4 - Integração',
      UNITS_OF_MEASURE_INPUT: 'Unidade de medida',
      WASTE_INPUT: 'Desperdício %',
      STP5_R: 'Etapa 5 - Dados de Venda',
      SALES_UNITS: 'UNIDADE DE VENDA',
      SALES_UNITS_DELETE_TTIP: 'Apagar Unidade de Venda',
      SALES_UNITS_INPUT: 'Unidade de Venda',
      SALES_UNITS_VALIDATION: 'Unidade já selecionada',
      HIGH_INPUT: 'Alto',
      WIDTH_INPUT: 'Largura',
      DEPTH_INPUT: 'Profundidade',
      MAX_STACKABLE: 'Máxima quantidade a empilhar',
      OVERTHROW_SWITCH: 'Pode Tombar',
      ROTATE_SWITCH: 'Pode Girar',
      ROTATEY_SWITCH: 'Gira em Y',
      EXHIBITION_UNITS_INPUT: 'Unidade de Exhibição',
      STACKABLE_SWITCH: 'Empilhável',
      FRONT_PHOTO: 'Carregar imagem do item frontal',
      SIDE_PHOTO: 'Faça upload da imagem do item lateral',
      PHOTO_ABOVE: 'Carregar imagem do item acima',
      COMPOSITION_STP3: 'Ingredientes',
      STP3_RECIPES: 'Etapa 3 - Copmposição da receita',
      INGREDIENT: 'Ingrediente',
      ITEM_TITLE: 'Iten',
      INGREDIENT_DELETED_TTIP: 'Apagar o {{val}} ingrediente',
      ITEM_DELETED_TTIP: 'Apagar o {{val}} iten',
      INGREDIENT_INPUT: 'Ingrediente',
      ITEM_INPUT: 'Iten',
      SEARCH_INGREDIENT: 'Procurar Ingredientes…',
      QUANTITY_INPUT: 'Quantidade',
      NEW_INGREDIENT_BTN: 'Novo Ingrediente',
      DEFINE_COMBO_STP1: 'Definir Combo',
      COMBO_ARMING_STP3: 'Grupos de itens do Combo',
      PRICE_STP4: 'Preço',
      STP1_COMBO: 'Etapa 1 - Definir Combo',
      STP3_COMBO: 'Etapa 3 - Grupos de itens do Combo',
      BLOCK_NAME_INPUT: 'Nome do Grupo',
      BLOCK_DELETED_TTIP: 'Apagar Bloco',
      ITEMS_INPUT: 'Itens',
      SEARCH_ITEMS: 'Procurar Itens…',
      ADD_BLOCK_BTN: 'Adicionar Grupo',
      STP4_COMBO: 'Etapa 4 - Definição do tipo de preço',
      PRICE_TYPE_INPUT: 'Tipo de Preço',
      DISCOUNT_INPUT: 'Desconto',
      FIXED_PRICE_MESSAGE: 'O preço fixo em todo o país definirá o mesmo preço para todas as lojas e canais',
      DISCOUNT_MESSAGE:
        'Leva em consideração o preço do componente mais barato de cada grupo e apenas os itens que estão ativos no sortimento de cada loja.',
      SUGGESTED_PRICE_INPUT: 'Preço fixo a nível nacional',
      PERMANENT_PRICE_INPUT: 'Preço Fixo',
      EXCLUDED_RULES_CHECK: 'Este combo será excluído das regras de margem e competição',
      EXCLUDED_RULES_CHECK_ALT: 'Este combo será incluido nas regras de margem e competição',
      DINAMIC_PRICE_INPUT: 'Desconto % sobre componentes',
      PRICE_STRATEGY: 'Como você vai definir o preço deste kit?',
      INIT_PRICE: 'Como você vai definir o preço inicial deste kit?',
      INIT_PRICE_EDIT: 'Quer alterar o preço atual?',
      PRICE_STRATEGY_COMPONENT_TITLE: 'Com base no preço de seus componentes',
      PRICE_STRATEGY_COMPONENT_MSG: 'Cada vez que você altera o preço de um componente, o preço do kit pode mudar.',
      PRICE_STRATEGY_RULE_TITLE: 'Más información sobre este texto de origen',
      PRICE_STRATEGY_RULE_MSG:
        'Quando o preço de um concorrente muda ou quando o preço de um item relacionado muda, o Prisma irá sugerir uma mudança de preço.',
      SUGGESTED_PRICE_TEXT:
        ': Preço mínimo dos produtos em todos os blocos - Mesmo preço em todos os pontos de venda, partindo ou não do sugerido.',
      DINAMIC_PRICE_TEXT:
        ': Preço atual de cada ponto de venda (de acordo com seus produtos) + desconto. Não será afetado pelas regras de parentesco.',
      DINAMIC_PRICE_TTIP: 'Preço Dinâmico: Preço atual de cada loja (de acordo com seus itens) + desconto',
      NEW_UNIT: 'Nova Unidade',
      NAME_INNPUT: 'Nome',
      ADD_BTN: 'Adicionar',
      NEW_INGREDIENT: 'Novo Ingrediente',
      FREE_STORES: 'Pontos de Vendasem custo nem preço',
      FREE_STORES_SUBTITLE: 'Custos e preços foram gerados para todas as lojas',
      ACCEPT_BTN: 'Aceitar',
      ERROR1: 'Nenhum custo ou preço foi gerado para essas lojas, pois alguns dos itens dos combos não possuem preço.',
      ERROR2: 'Nenhum custo ou preço foi gerado para essas lojas, pois alguns dos ingredientes não têm custo.',
      NEW_BRAND: 'Nova Marca',
      NEW_SUPPLIER: 'Novo Fornecedor',
      INFO_PERMISSION: 'O usuário atual tem permissão apenas para editar atributos, nenhuma outra alteração será permitida.',
      Retail: 'Varejo',
      Ingrediente: 'Ingrediente',
      Receta: 'Receita',
      Combo: 'Combo',
      Supply: 'Abastecimento',
      Insumo: 'Abastecimento',
    },
    SUPPLY: {
      SETUP: {
        ORDER_SCHEDULE: {
          TITLE: 'Cronograma de Pedidos',
          ROUTE: 'Abastecimwento / Configuração',
          DEFINITION: 'Definição do Centro / Fornecedor',
          SCOPE_PDV: 'Escopo de Pontos de Venda',
          FREQUENCY: 'Frequência',
          NEW_ORDER_BTN: 'NOVA CRONOGRAMA',
          STORES_FILTER: 'Pontos de Venda',
          SUPPLY_FILTER: 'Fornecedor',
          TYPE_ALL: 'Todos',
          TYPE_SUPPLIER: 'Fornecedor',
          TYPE_DISTRIBUTION_CENTER: 'Centro de Distribuição',
          TITLE_SCHEDULE_TO_LEAD: 'Cronograma a carregar',
          TITLE_FRECUENCY: 'Frequência',
          TITLE_INCLUDES: 'Inclui',
          TITLE_LEAD_TIME: 'Lead Time (dias)',
          TITLE_OVERLAPP: 'Cronogramas Sobrepostos',
          TTIP_OVERLAPP: 'Ver cronogramas sobrepostos',
          BTN_OVERLAPP_MODAL_CLOSE: 'Fechar',
          PH_CATEGORYS: 'Categorias',
          PH_CATEGORYS_EXC: 'Categorias Excluídas',
          FORM: {
            EDIT: 'Editar Cronograma',
            NEW: 'Novo Cronograma',
            STEP: 'Passo',
            NEXT_BTN: 'Próximo',
            PREVIUS_BTN: 'Anterior',
            SAVE_BTN: 'Salvar',
            SCOPE_PDV: {
              CODE_SEARCH: 'Procurar por código',
              TITLE: 'Seleção Avançada',
              DESC: 'Aplique filtros à sua pesquisa para chegar ao resultado desejado. Esta opção irá anluar a seleção por filtros.',
              CLIPBOARD_TITLE: 'Colar pontos de venda desde a área de transferência',
            },
            FRECUENCY: {
              HOLIDAY_RECEPTION: 'Caso o dia de "Recepção do pedido" / "Entrega da mercadoria" seja feriado / dia não útil',
              NEXT_BUSINESS_DAY: 'O pedido é recebido no próximo dia útil',
              NEXT_DAY_STIPULATED: 'O pedido é recebido no dia seguinte estipulado no cronograma.',
            },
          },
          TYPEOFDELIVER: {
            DELIVERY: 'Entrega de produtos',
            RECEIPT: 'Recebimento de pedidos',
          },
          FREQUENCYTIME: {
            DAILY: 'Diária',
            WEEKLY: 'Semanal',
            MONTHLY: 'Mensal',
          },
          HOLIDAYSHANDLING: {
            WEEKLY_DAYS_NO_HOLIDAYS: 'Apenas dias da semana, exceto feriados',
            ALL_DAYS_NO_HOLIDAYS_NO_SUNDAYS: 'Todos os dias, exceto feriados e domingo',
            ALL_DAYS_NO_HOLIDAYS: 'Todos os dias, exceto feriados',
            ALL_DAYS: 'Todos os dias',
          },
        },
        ORDER_SCHEDULE_LIST: {
          TYPE_FILTER: 'Tipos',
          STORES_FILTER: 'Pontos de Venda',
          NAME: 'Fornecedor / CD',
          NAME_TTIP: 'Fornecedor ou Centro de Distribuição',
          CATEGORY: 'Categorias',
          STORES: 'Pontos de Venda',
          STORES_TTIP: 'Pontos de Venda',
          FREQUENCY: 'Frequência',
          MONDAY_CHAR: 'S',
          TUESDAY_CHAR: 'T',
          WEDNESDAY_CHAR: 'Q',
          THURSDAY_CHAR: 'Q',
          FRIDAY_CHAR: 'S',
          SATURDAY_CHAR: 'S',
          SUNDAY_CHAR: 'D',
        },
      },
      DECISIONS: {
        ORDER_CONTROL: {
          TITLE: 'Controle de Pedidos',
          ROUTE: 'Abastecimento / Decisões',
          INFORM_BTN: 'Informar',
          NEW_ORDER_BTN: 'Novo Pedido',
          FILTER_TTIP: 'Filtrar',
          FULLSCREEN_TTIP: 'Expandir',
          EXPORT_TTIP: 'Exportar',
          STATUS_FILTER: 'Status',
          TYPE_FILTER: 'Tipo de movimento',
          TYPE_ALL: 'Todos',
          TYPE_AUTOMATIC: 'Automático',
          TYPE_MANUAL: 'Manual',
          ORIGIN_FILTER: 'Origem',
          DESTINATION_FILTER: 'Destino',
          CREATION_DATE_FILTER: 'Data do Pedido',
          PLANNING_DATE_FILTER: 'Data de Entrega Objetivo',
          DELIVERY_DATE_FILTER: 'Data de Entrega',
          NRO: 'Nro.',
          TYPE: 'Tipo',
          TYPE_TOOLTIP: 'Tipo de movimento',
          ORIGIN: 'Origem',
          DESTINATION: 'Destino',
          CREATION_DATE: 'Data do Pedido',
          CREATION_DATE_TTIP: 'Data do Pedido',
          PLANNING_DATE: 'Data de Entrega Objetivo',
          PLANNING_DATE_TTIP: 'Data de Entrega Objetivo',
          DELIVERY_DATE: 'Data de Entrega',
          DELIVERY_DATE_TTIP: 'Data de Entrega',
          STATUS: 'Status',
          VALUE: 'R$ Custo',
          DECISIONS: 'Decisões',
          SAVE_BTN: 'Salvar',
          HEADER: 'Cabeçalho',
          PRINT_TTIP: 'Imprimir',
          ADD_TTIP: 'Adicionar Produtos ao Pedido',
          COPY_TTIP: 'Adicionar produtos de uma lista copiada para sua área de transferência',
          CODE: 'Código',
          DESCRIPTION: 'Descrição',
          CATEGORY: 'Categoria',
          BRAND: 'Marca',
          APPROVE: 'Aprovar',
          REJECT: 'Rejeitar',
          INFORM: 'Informar',
          TYPE_INPUT: 'Tipo de movimento',
          CODE_INPUT: 'Código',
          ORIGIN_INPUT: 'Origem',
          DESTINATION_INPUT: 'Destino',
          STATE_INPUT: 'Status',
          PRIORITY_INPUT: 'Prioridade',
          OBSERVATION_INPUT: 'Observação',
          CREATION_DATE_INPUT: 'Data do Pedido',
          PLANNING_DATE_INPUT: 'Data de Entrega Objetivo',
          DELIVERY_DATE_INPUT: 'Data de Entrega',
          CANCEL_BTN: 'Cancelar',
          ORDER_VALUE: 'Custo do Pedido:',
          ADD_BTN: 'Adicionar',
          ADD_PROD_TITLE_MODAL: 'Adicionar produtos ao pedido',
          PRODUCT_INPUT: 'Produto',
          UDM_INPUT: 'Unidade de medida',
          QUANTITY_INPUT: 'Quantidade',
          DELETE: 'Apagar',
          DELETE_TTIP: 'Remover produto do predido',
          SUGGESTED: '# Sugerida(o)',
          SUGGESTED_TTIP: 'Quantidade Sugerida',
          TO_ASK: '# A pedir',
          TO_ASK_TTIP: 'Quantidade a pedir',
          TO_ASK_TTIP_ANEXO: '(Pallets)',
          UDM: 'UDM',
          EAN: 'EAN: {{val}}',
          SUPPLIER: 'Fornecedor: {{val}}',
          STEP_BY_STEP: 'Passo a Passo',
          UNITS_INPUT: 'Unidades',
          NAME: 'Nome',
          FORECASTED_SALE: 'Previsão de Vendas',
          CURRENT_STOCK: 'Estoque atual no Super San Martin',
          CURRENT_STOCK2: 'Estoque atual no Centro de Distribuição Campana',
          TRANSIT_STOCK: 'Estoque em trânsito para Super San Martin',
          MINIMUM_STOCK: 'Estoque Mínimo',
          MAXIMUM_STOCK: 'Estoque Máximo',
          AVAILABITY_DAYS_NOW: 'Dias de Disponibilidade Agora',
          AVAILABITY_DAYS_AFTER: 'Dias de Disponibilidade Depois',
          NEED: 'Necessidade',
          SUBCATEGORY: 'Subcategoria',
          EDIT_TTIP: 'Editar quantidade do produto a pedir',
          INVENTORY: 'Inventário',
        },
      },
    },
    ADMIN: {
      MASTER: {
        STORES: {
          LIST: {
            TYPE_FILTERS: 'Tipo',
            STATUS: 'Estado',
            STORE_TAGS: 'Etiqueta Pontos de Venda',
            NAME: 'Nome',
            CODE: 'Código',
            BRAND: 'Bandeira',
            STATE: 'Status',
            TYPE: 'Tipo',
            AVAIBLE: 'Habilitado',
            ROUTE: 'Administração / Mestres',
            TITLE: 'Pontos de Venda',
            NEW_STORE_BTN: 'Novo Ponto de Venda',
            FILTER_TTIP: 'Filtrar',
            FULLSCREEN_TTIP: 'Expandir',
            EXITFULLSCREEN_TTIP: 'Reduzir',
            VIEW_TTIP: 'Vista',
            VIEW_TABLE: 'Só Tabela',
            VIEW_MAP: 'Só Mapa',
            VIEW_TABLE_MAP: 'Mapa e Tabela',
            EDIT_ROW: 'Editar',
            COPY_ROW: 'Clonar',
            DELETE_ROW: 'Apagar',
            INACTIVE: 'Inativo',
            ACTIVE: 'Ativa',
            CLONE_STORE_TITLE: 'Clonar Ponto de Venda',
            CLONE_ITEM_CONTENT: 'Um novo ponto de venda será criado a partir dos dados da linha selecionada',
            CANCEL_BTN: 'Cancelar',
            CREATE_BTN: 'Criar',
          },
          SAVE_TOOLTIP: {
            ASSORTMENT_INVALID: 'Você deve atribuir a todos os clusters um cluster para salvar.',
          },
          PRICES: {
            BTN2_TITLE: 'Clonar preços de um Ponto de Venda',
            BTN2_MSG: 'Escolha um ponto de venda de referência, de onde serão copiados todos os preços.',
          },
          STORES_FILTER: 'Ponto de Venda',
          ROUTE: 'Administração / Mestre',
          TITLE: 'Pontos de Venda',
          NEW_STORE_BTN: 'Novo Ponto de Venda',
          FILTER_TTIP: 'Filtros',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          VIEW_TTIP: 'Visualizar',
          VIEW_TABLE: 'Apenas Tabela',
          VIEW_MAP: 'Apenas Mapa',
          VIEW_TABLE_MAP: 'Mapa e Tabela',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar pontos de venda selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          CODE: 'Código',
          BRAND: 'Bandeira',
          TYPE: 'Tipo',
          STORE: 'Ponto de Venda',
          STORES_V2: 'Ponto de Venda',
          STATE: 'Estado',
          INACTIVE: 'Inativo',
          ACTIVE: 'Ativo',
          TITLE_FILTERS: 'Filtros',
          STATE_FILTER: 'Estado',
          TYPE_FILTER: 'Tipo',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          TITLE_FORM: 'Novo Ponto de Venda',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Informação Básica',
          LATITUDE_INPUT: 'Latitude',
          VALIDATION_LATITUDE1: 'A latitude deve ser menor ou igual a 90',
          VALIDATION_LATITUDE2: 'A latitude deve ser maior ou igual a -90',
          LONGITUDE_INPUT: 'Longitude',
          VALIDATION_LONGITUDE1: 'O comprimento deve ser menor ou igual a 180',
          VALIDATION_LONGITUDE2: 'O comprimento deve ser maior ou igual a -180',
          CODE_INPUT: 'Código',
          EXTERNALCODE_INPUT: 'Código Externo',
          VALIDATION_CODE: 'O campo deve ser maior que 0',
          VALIDATION_CODE2: 'O código {{val}} já existe.',
          NAME_INPUT: 'Nome',
          BRAND_INPUT: 'Bandeira',
          EMAIL_INPUT: 'Email',
          PHONE_INPUT: 'Telefone',
          OPENING_DATE_INPUT: 'Data de abertura',
          ADRESS_INPUT: 'Endereço',
          ACTIVE_CHECK: 'Ativo',
          ACTIVE_TTIP: 'Marcar como Ativar o {{val}}',
          EXCEMPT_CHECK: 'Isento',
          EXCEMPT_TTIP: 'Marcar como isento',
          CLASSIFICATION_TAB: 'Classificação',
          WITHOUT_SELECTION: 'Sem Seleção ...',
          ADD_ATRIBUTE_BTN: 'Adicionar Atributos',
          QUERY_FILTER: 'Nome',
          FEATURES_TAB: 'Características',
          STORE_TYPE_INPUT: 'Tipo de Ponto de Venda',
          TERMINAL_INPUT: 'Centro de Distribuição',
          NO_DISTRIBUTION_CENTERS_HINT: 'Não há centros de distribuição cadastrados',
          TRADE_AREA_TAB: 'Área Comercial',
          LEGEND_FILTERS: 'Filtre os concorrentes definindo a Área Comercial',
          TRADE_AREA_TITLE: 'Distância da área comercial dos concorrentes: ',
          SELECTED_COMPETITORS: 'Concorrentes Selecionados',
          NO_SELECTED_COMPETITORS: 'Nenhum concorrente selecionado.',
          NO_SELECTED_COMPETITORS_TTIP: 'Atualizar lista',
          DELETE_BTN: 'Remover',
          DELETE_COMPETITOR_TTIP: 'Apagar Concorrente',
          CODE_NAME: 'Cod | Nome',
          MARKER: 'Marcador',
          PROVINCE: 'Província',
          LOCATION: 'Localidade',
          ADD_COMPETITORS_BTN: 'Adicionar Concorrentes',
          EMPTY_STATE: 'Nenhum concorrente encontrado com os critérios de pesquisa selecionados.',
          ADD_BTN: 'Adicionar',
          ADD_COMPETITOR_TTIP: 'Adicionar Concorrente',
          CHANGE_TRADE_AREA_TITLE_MODAL: 'Modifique a área comercial para: {{val}} Km.',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL:
            'Os competidores selecionados serão perdidos e serão modificados com os da nova Área Comercial.',
          EDIT_BTN: 'Modificar',
          SEARCH: 'Procurar ',
          SET_PRINCIPAL_COMPETITOR_TTIP: 'Marque como principal concorrente desta Loja',
          SET_PRINCIPAL_COMPETITOR__REMOVE_TTIP: 'Remover como principal concorrente desta loja',
          ASSORTMENT_TAB: 'Sortimento',
          ASSORTMENT_TAB_ENABLED: 'Guia habilitada apenas na criação',
          ASSORTMENT_TAB_NO_EDIT_TOOLTIP: 'esta informação pode ser completada ao criar o ponto de venda',
          ASSORTMENT_TITLE: 'Inicialização de Sortimento',
          ASSORTMENT_SUBTITLE: 'Selecionar o cluster ao qual a nova loja pertencerá em cada uma das Clusterizações definidas no Prisma.',
          CLUSTERING: 'Clusterização',
          CLUSTER: 'Cluster',
          CLUSTER_ASSIGNMENT: 'Atribuição de Cluster',
          CLONE_TTIP: 'Clone de um Ponto de Venda existente.',
          CLONE_MODAL_TITLE: 'Clonar Sortimento',
          CLONE_MODAL_SUBTITLE: 'Os clusters serão clonados para cada agrupamento de acordo com o ponto de venda selecionado.',
          STORES: 'Ponto de Venda',
          CANCEL_BTN: 'Cancelar',
          CLONE_BTN: 'Clonar',
          PRICING_TAB: 'Preços',
          PRICING_TITLE: 'Inicialização de preços',
          PRICING_SUBTITLE: 'Escolha uma opção de inicialização de preço',
          BTN1_TITLE: 'Completar preços no Excel',
          BTN1_MSG: 'A coluna de preço deve ser preenchida para todo o sortimento ativo.',
          BTN2_TITLE: 'Clonar preço de um Ponto de Venda',
          BTN2_MSG: 'Escolha um ponto de venda de referência, de onde serão copiados todos os preços.',
          BTN3_TITLE: 'Regras de Parentesco',
          BTN3_MSG: 'As regras de parentesco serão levadas em consideração para o preenchimento automático dos preços',
          DOWLOAD_EXCEL: 'Baixar Excel',
          IMPORT_EXCEL_BTN: 'Importar preços do Excel',
          CLONE_PRICE_MODAL_TITLE: 'Clonar Preços',
          CLONE_PRICE_MODAL_SUBTITLE: 'Os preços serão clonados de acordo com a loja selecionada.',
          EXCEL1: 'Completar-Preços.xlsx',
          EXCEL2: 'Clonar-Preços.xlsx',
          EXCEL3: 'Regras-de-Parentesco.xlsx',
          IMPORT_PRICES_TITLE: 'Importar preços',
          VENDORS: 'Fornecedores',
          TABS: {
            VENDORS: {
              TITLE: 'Inicialização dos fornecedores',
              INTRO: 'Atribui quais fornecedores fornecem cada produto ao ponto de venda.',
              DISABLED_VENDORS_INPUT: 'Fornecedores já inicializados',
              BTN_IMPORT_SWITCH: 'Resolver Conflitos',
              COMP: {
                TITLE: 'Seleção Avançada',
                INTRO: 'Selecione os fornecedores que abastecerão o ponto de venda.',
              },
            },
          },
          STORE_V2: 'Ponto de Venda',
        },
        STORESV2: {
          LIST: {
            TYPE_FILTERS: 'Tipo',
            STATUS: 'Estado',
            STORE_TAGS: 'Etiqueta Pontos de Venda',
            NAME: 'Nome',
            CODE: 'Código',
            BRAND: 'Bandeira',
            STATE: 'Status',
            TYPE: 'Tipo',
            AVAIBLE: 'Habilitado',
            ROUTE: 'Administração / Mestres',
            TITLE: 'Pontos de Venda',
            NEW_STORE_BTN: 'Novo Ponto de Venda',
            FILTER_TTIP: 'Filtrar',
            FULLSCREEN_TTIP: 'Expandir',
            EXITFULLSCREEN_TTIP: 'Reduzir',
            VIEW_TTIP: 'Vista',
            VIEW_TABLE: 'Só Tabela',
            VIEW_MAP: 'Só Mapa',
            VIEW_TABLE_MAP: 'Mapa e Tabela',
            EDIT_ROW: 'Editar',
            EDIT_ROW_DISABLED_TOOLTIP: 'Não é possível editar um registro no processo de publicação',
            COPY_ROW: 'Clonar',
            DISABLED_CLONE_TOOLTIP: 'Apenas registros em estado publicado podem ser clonados',
            DISABLED_DELETE_EQUIPMENT: 'Há equipamentos atribuídos, exclua ou realoque todos os equipamentos para que possa excluir a loja',
            DELETE_ROW: 'Inativo',
            UNDELETE_ROW: 'Ativa',
            INACTIVE: 'Inativo',
            ACTIVE: 'Ativa',
            CLONE_STORE_TITLE: 'Clonar Ponto de Venda',
            CLONE_ITEM_CONTENT: 'Um novo ponto de venda será criado a partir dos dados da linha selecionada',
            CANCEL_BTN: 'Cancelar',
            CREATE_BTN: 'Criar',
            SEE_DELETED_FILTERS: 'Ver Eliminados',
            PUBLISH_TTIP: 'Publicar pontos de venda selecionados',
            PUBLISH_ROW_CONTENT: 'Deseja publicar o ponto de venda {{val}}?',
            PUBLISH_ROWS_CONTENT: 'Deseja publicar {{val}} pontos de venda selecionados?',
            PUBLISH_SUCCESS: 'Os pontos de venda estão sendo publicados. Você receberá uma notificação quando o processo for concluído.',
          },
          SAVE_TOOLTIP: {
            ASSORTMENT_INVALID: 'Você deve atribuir a todos os clusters um cluster para salvar.',
          },
          CLONE_DELIVERY_PLACES: {
            TITLE: 'Clonar Locais de Entrega de…',
            HINT: 'Copie os Locais de Entrega de outro ponto de venda ou CEDIS já publicado. Substitui os mapeamentos anteriores do destino.',
            REQUIRES_CEDIS: 'Atribua primeiro um Centro de Distribuição na aba Dados.',
            SOURCE_NOT_ELIGIBLE: 'A origem selecionada não é mais elegível (o CEDIS ou o status mudou).',
            STORE_MISSING_FOR_PUBLISH: 'O ponto de venda não possui Locais de Entrega configurados. Configure-os antes de publicar.',
            NO_SOURCES: 'Não há pontos de venda publicados para clonar com este CEDIS atribuído.',
          },
          PRICES: {
            BTN2_TITLE: 'Clonar preços de um Ponto de Venda',
            BTN2_MSG: 'Escolha um ponto de venda de referência, de onde serão copiados todos os preços.',
            REVIEW_CHANGES: 'Para consultar as alterações de preço, vá para ',
            PRICE_DECISIONS: 'Decisões de Preços',
            VIEW_ASOCIATED_RULES: 'VER REGRAS ASSOCIADAS',
            MAIN_SAVE_WARNING: 'Para usar esta seção, é necessário pelo menos ter os dados principais salvos',
          },
          EQUIPMENT: {
            ownerShip: 'Dono',
            acquisitionDate: 'Data de aquisição',
            acquisitionValue: 'Custo de aquisição',
            adquisitionDate: 'Data de aquisição',
            adquisitionValue: 'Custo de aquisição',
            usefulLife: 'Life Expectancy (years)',
            EQUIPMENT_TYPE: 'Equipamento tipo',
            ADD_EQUIPMENT: 'Adicionar Equipamento',
            REMAINING_LIVE: 'Vida restante',
            NAME: 'Nome',
            ASSIGMENT_DATE: 'Data de Atribuição',
            EDIT_EQUIPMENT: 'Editar Equipamento',
            ADD_EQUIPMENT_TITLE: 'Adicionar Equipamento',
            AWARD_DATE: 'Atribuição Data',
            DELETE_TITLE: 'Inativar Equipamento',
            DELETE_CONTENT: 'Ação não pode ser desfeita. Deseja continuar?',
            NAME_ALREADY_EXIST: 'O nome já está em uso.',
            DISABLE_REUBICATION: 'A atribuição deve ser salva para ser realocada',
            REUBICATION_CONFIRM: 'Tem certeza de que deseja redistribuir esse equipamento para a loja de vendas {{val}}?',
            REUBICATION: 'Reatribuir para outro ponto de venda',
            OWNER_OPTION: {
              Owner: 'Proprio',
              Third: 'Terceiro',
            },
          },
          COMPETITORS_SCOPE: 'Abrangência dos Concorrentes',
          COMPETITORS_SCOPE_SUBTITLE: 'Selecionar o escopo dos concorrentes deste ponto de venda',
          SELECTED_COMPETITOR_TTIP: 'Concorrente Selecionado',
          COMPETITOR_SELECTED: 'Concorrentes selecionadas',
          COMPETITOR_SELECTED_COUNT: 'Quantidade de Concorrentes selecionadas',
          COMPETITOR_SELECTED_TITLE: 'Selecionar Concorrentes',
          COMPETITOR_SELECTED_CONTENT: 'Pesquise e adicione concorrentes por área de negócios e rótulos',
          VIEW_ASOCIATED_RULES_TITLE: 'Sem regras associadas',
          VIEW_ASOCIATED_RULES_TITLE_MGS: 'Não é possível consultar uma loja que não foi publicada',
          INFO_ASSORTMENT_STATUS:
            'O status do sortimento exibido representa o status depois de publicado, da mesma forma que todos os dados afetados por esta modificação terão efeito quando estiverem nesse estado.',
          IMPORT_ITEMS: 'Sortimento por item',
          CODE_EXIST: 'El código {{val}} ya existe',
          ITEMS_ALLOWED: '# Itens permitidos',
          TIP_ITEMS_ALLOWED: 'Número máximo de produtos próprios que esta loja pode criar.',
          NOT_ACCESS_PERMISSION: 'Você não tem permissão para completar esta seção',
          NOTIFY_USER: 'NOTIFICAR USUÁRIO',
          NOTIFIED_USER: 'Usuário notificado',
          IMPORT_FILE_NAME_LINK: 'determinar-PDV.xlsx',
          IMPORT_FILE_NAME_LINK_ITEMS: 'determinar-surtido.xlsx',
          IMPORT_FILE_NAME_BTN: 'carga de exceção de sortimento',
          IMPORT_ASSORTMENT_STORE_CONTEXT:
            'Pode importar exceções de sortimento pelo botão do importador ou ver o estado do sortimento para este ponto de venda',
          STORES_FILTER: 'Ponto de Venda',
          ROUTE: 'Administração / Mestre',
          TITLE: 'Pontos de Venda',
          NEW_STORE_BTN: 'Novo Ponto de Venda',
          FILTER_TTIP: 'Filtros',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          VIEW_TTIP: 'Visualizar',
          VIEW_TABLE: 'Apenas Tabela',
          VIEW_MAP: 'Apenas Mapa',
          VIEW_TABLE_MAP: 'Mapa e Tabela',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar pontos de venda selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          CODE: 'Código',
          BRAND: 'Bandeira',
          TYPE: 'Tipo',
          STORE: 'Ponto de Venda',
          STORES_V2: 'Ponto de Venda',
          STATE: 'Estado',
          INACTIVE: 'Inativo',
          ACTIVE: 'Ativo',
          TITLE_FILTERS: 'Filtros',
          STATE_FILTER: 'Estado',
          TYPE_FILTER: 'Tipo',
          CLEAN_FILTER_BTN: 'Limpar',
          APPLY_FILTER_BTN: 'Aplicar',
          TITLE_FORM: 'Novo Ponto de Venda',
          SAVE_BTN: 'Salvar',
          BASIC_INFORMATION_TAB: 'Informação Básica',
          LATITUDE_INPUT: 'Latitude',
          VALIDATION_LATITUDE1: 'A latitude deve ser menor ou igual a 90',
          VALIDATION_LATITUDE2: 'A latitude deve ser maior ou igual a -90',
          LONGITUDE_INPUT: 'Longitude',
          VALIDATION_LONGITUDE1: 'O comprimento deve ser menor ou igual a 180',
          VALIDATION_LONGITUDE2: 'O comprimento deve ser maior ou igual a -180',
          CODE_INPUT: 'Código',
          EXTERNALCODE_INPUT: 'Código Externo',
          VALIDATION_CODE: 'O campo deve ser maior que 0',
          VALIDATION_CODE2: 'O código {{val}} já existe.',
          NAME_INPUT: 'Nome',
          BRAND_INPUT: 'Bandeira',
          EMAIL_INPUT: 'Email',
          PHONE_INPUT: 'Telefone',
          OPENING_DATE_INPUT: 'Data de abertura',
          ADRESS_INPUT: 'Endereço',
          ACTIVE_CHECK: 'Ativo',
          ACTIVE_TTIP: 'Marcar como Ativar o {{val}}',
          EXCEMPT_CHECK: 'Isento',
          EXCEMPT_TTIP: 'Marcar como isento',
          CLASSIFICATION_TAB: 'Classificação',
          WITHOUT_SELECTION: 'Sem Seleção ...',
          ADD_ATRIBUTE_BTN: 'Adicionar Atributos',
          FEATURES_TAB: 'Características',
          STORE_TYPE_INPUT: 'Tipo de Ponto de Venda',
          TERMINAL_INPUT: 'Centro de Distribuição',
          TRADE_AREA_ALL_DISTANCE: 'Serão procurados todos os concorrentes sem considerar sua distância',
          GEOLOCATION_STORE: 'Córdenas do ponto de venda para Área de Comércio',
          TRADE_AREA_TAB: 'Área Comercial',
          LEGEND_FILTERS: 'Filtre os concorrentes definindo a Área Comercial',
          TRADE_AREA_TITLE: 'Distância da área comercial dos concorrentes: ',
          SELECTED_COMPETITORS: 'Concorrentes Selecionados',
          NO_SELECTED_COMPETITORS: 'Nenhum concorrente selecionado.',
          NO_SELECTED_COMPETITORS_TTIP: 'Atualizar lista',
          DELETE_BTN: 'Remover',
          DELETE_COMPETITOR_TTIP: 'Apagar Concorrente',
          CODE_NAME: 'Cod | Nome',
          MARKER: 'Marcador',
          PROVINCE: 'Província',
          LOCATION: 'Localidade',
          ADD_COMPETITORS_BTN: 'Adicionar Concorrentes',
          EMPTY_STATE: 'Nenhum concorrente encontrado com os critérios de pesquisa selecionados.',
          ADD_BTN: 'Adicionar',
          ADD_COMPETITOR_TTIP: 'Adicionar Concorrente',
          CHANGE_TRADE_AREA_TITLE_MODAL: 'Modifique a área comercial para: {{val}} Km.',
          CHANGE_TRADE_AREA_TITLE_MODAL_ALT: 'Mudar Localização',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL:
            'Os competidores selecionados serão perdidos e serão modificados com os da nova Área Comercial.',
          CHANGE_TRADE_AREA_SUBTITLE_MODAL_ALT:
            'Os competidores selecionados serão perdidos e serão modificados com os da nova Área Comercial.',
          EDIT_BTN: 'Modificar',
          SEARCH: 'Procurar ',
          SET_PRINCIPAL_COMPETITOR_TTIP: 'Marque como principal concorrente desta Loja',
          SET_PRINCIPAL_COMPETITOR__REMOVE_TTIP: 'Remover como principal concorrente desta loja',
          ASSORTMENT_TAB: 'Sortimento',
          ASSORTMENT_TAB_ENABLED: 'Guia habilitada apenas na criação',
          ASSORTMENT_TAB_NO_EDIT_TOOLTIP: 'esta informação pode ser completada ao criar o ponto de venda',
          ASSORTMENT_TITLE: 'Inicialização de Sortimento',
          ASSORTMENT_SUBTITLE: 'Selecionar o cluster ao qual a nova loja pertencerá em cada uma das Clusterizações definidas no Prisma.',
          CLUSTERING: 'Clusterização',
          CLUSTER: 'Cluster',
          CLUSTER_ASSIGNMENT: 'Atribuição de Cluster',
          CLONE_TTIP: 'Clone de um Ponto de Venda existente.',
          CLONE_MODAL_TITLE: 'Clonar Sortimento',
          CLONE_MODAL_SUBTITLE: 'Os clusters serão clonados para cada agrupamento de acordo com o ponto de venda selecionado.',
          STORES: 'Ponto de Venda',
          CANCEL_BTN: 'Cancelar',
          CLONE_BTN: 'Clonar',
          PRICING_TAB: 'Preços',
          PRICING_TITLE: 'Inicialização de preços',
          PRICING_SUBTITLE: 'Escolha uma opção de inicialização de preço',
          BTN1_TITLE: 'Completar preços no Excel',
          BTN1_MSG: 'A coluna de preço deve ser preenchida para todo o sortimento ativo.',
          BTN2_TITLE: 'Clonar preço de um Ponto de Venda',
          BTN2_MSG: 'Escolha um ponto de venda de referência, de onde serão copiados todos os preços.',
          BTN3_TITLE: 'Regras de Parentesco',
          BTN3_MSG: 'As regras de parentesco serão levadas em consideração para o preenchimento automático dos preços',
          DOWLOAD_EXCEL: 'Baixar Excel',
          VIEW_ASSORTMENT_STATUS: 'Relatório de sortimento',
          VIEW_ASSORTMENT_STATUS_ACTUAL: 'Relatório de sortimento Actual',
          REQUIRE_SAVE_ASSORTMENT_STATUS: 'Requer salvar as alterações feitas',
          REQUIRE_SAVE_ASSORTMENT_STATUS_MSG:
            'Foram detectadas alterações que afetam o status do Sortimento, para poder acessar você deve salvar as alterações feitas',
          IMPORT_EXCEL_BTN: 'Importar preços do Excel',
          CLONE_PRICE_MODAL_TITLE: 'Clonar Preços',
          CLONE_PRICE_MODAL_SUBTITLE: 'Os preços serão clonados de acordo com a loja selecionada.',
          EXCEL1: 'Completar-Preços.xlsx',
          EXCEL2: 'Clonar-Preços.xlsx',
          EXCEL3: 'Regras-de-Parentesco.xlsx',
          IMPORT_PRICES_TITLE: 'Importar preços',
          VENDORS: 'Fornecedores',
          IMPORT_EXCEL_ITEMS: 'IMPORTAR PDV DESDE EXCEL',
          IMPORT_EXCEL_ITEMS_EXCEPT: 'AVALIAÇÃO DE IMPORTAÇÃO DO EXCEL',
          NO_IMPORT_PERMISSION_TOOLTIP: 'Você não tem permissões para importar variedade do Excel',
          IMPORT_TITLE_ITEMS: 'Variedade importante',
          MAIN_SAVE_WARNING: 'Para usar esta seção, é necessário pelo menos ter os dados principais salvos',
          IMPORT_PDV_OK: 'PONTOS DE VENDA IMPORTADOS',
          NOVALID_PUBLISH_ADVICE: 'A seguinte tab não é válido:',
          TABS: {
            VENDORS: {
              TITLE: 'Inicialização dos fornecedores',
              INTRO: 'Atribui quais fornecedores fornecem cada produto ao ponto de venda.',
              DISABLED_VENDORS_INPUT: 'Fornecedores já inicializados',
              BTN_IMPORT_SWITCH: 'Resolver Conflitos',
              COMP: {
                TITLE: 'Seleção Avançada',
                INTRO: 'Selecione os fornecedores que abastecerão o ponto de venda.',
              },
            },
          },
          ITEM: {
            SAVE: 'Salvar',
            PUBLISH: 'Publicar',
            REPORT: 'Reporte',
            REPORT_TOOLTIP: 'Será gerado um relatório que poderá ser baixado através das notificações.',
            REPORT_WARNING: 'Es necesario Publicar para descargar el reporte.',
            WARNING_SAVE: 'As alterações atuais devem ser salvas.',
            WARNING_PUBLISH: 'Você precisa republicar para que as alterações salvas tenham efeito.',
            BASIC_INFORMATION_TAB: 'Dados Principais',
            CLASSIFICATION_TAB: 'Classificasão',
            PRICES_TAB: 'Preços',
            LOADING: 'Carregando...',
            NEW_ITEM_BTN: 'Novo item',
            TRADE_AREA_TAB: 'Trade Area',
            COMPETITORS_SCOPE: 'Abrangência dos Competidores',
            PUBLISH_CONFIRM:
              'O processo de publicação inclui a criação de Sortimento, Preços, Custos e outros registros relacionados à Loja. <br> <br> <b> Tem certeza que deseja Publicar? </b>',
            PUBLISH_CONFIRM_TITLE: 'Confirmação de Publicação',
            PUBLISHING_WARNING: 'Item em processo de publicação, tente novamente em alguns minutos.',
            PUBLISH_LONG_TIME:
              'A publicação deste item pode demorar alguns minutos, quando for encerrada você será notificado com uma notificação.',
          },
        },
        SUPPLIER: {
          ROUTE: 'Administração / Mestre',
          TITLE: 'Fornecedor',
          NEW_SUPPLIER_BTN: 'Novo Fornecedor',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar fornecedores selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          CODE: 'Código',
          PHONE: 'Telefone',
          DEFINE_SUPPLIER_STP1: 'Definir Fornecedor',
          ITEMS_ALLOCATION_STP2: 'Produtos Fornecidos',
          EDIT_TITLE_FORM: 'Editar Fornecedor',
          NEW_TITLE_FORM: 'Novo Fornecedor',
          STP1: 'Etapa 1 - Definir Fornecedor',
          NAME_INPUT: 'Nome',
          CODE_INPUT: 'Código',
          PHONE_INPUT: 'Telefone',
          NEXT_BTN: 'Próximo',
          STP2: 'Etapa 2 - Atribuição de Produtos',
          ITEM: 'Produto',
          MAIN_STORES: '# Pontos de Venda',
          SECONDARY_STORES: '# Pontos de Venda Sucundários',
          DELETE_ITEM_TTIP: 'Apagar Produto',
          ADD_ITEM_BTN: 'Adicionar Produto',
          PREVIUS_BTN: 'Anterior',
          SAVE_BTN: 'Salvar',
          DELETE_TITLE_MODAL: 'Apagar',
          DELETE_SUBTITLE_MODAL: 'Tem certeza de que deseja excluir?',
          DELETE_SUBTITLE2_MODAL: 'Você vai excluir: {{val}}}. Tem certeza?',
          DELETE_BTN: 'Apagar',
          ALLOCATION_STORES: 'Atribuição de Pontos de Venda',
          ITEM_INPUT: 'Produto',
          SEARCH_ITEM: 'Procurar Produto…',
          STORES_INPUT: 'Pontos de Venda',
          ADD_STORES: 'Adicionar mais Pontos de Venda',
          SEARCH_STORES: 'Procurar Pontos de Venda…',
          ALL_CHECK: 'Todos',
          SECONDARY_STORES_INPUT: 'Pontos de Venda Secundários',
          ADD_SECONDARY_STORE: 'Adicionar mais Pontos de Venda secundários',
          SEARCH_SECONDARY_STORE: 'Procurar Pontos de Venda Secundários',
          CANCEL_BTN: 'Cancelar',
          ACCEPT_BTN: 'Aceitar',
        },
        SUPPLIERV2: {
          ROUTE: 'Administração / Mestre',
          TITLE: 'Fornecedor',
          NEW_SUPPLIER_BTN: 'Novo Fornecedor',
          FULLSCREEN_TTIP: 'Expandir',
          EXITFULLSCREEN_TTIP: 'Reduzir',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          DELETE_TTIP: 'Apagar fornecedores selecionados',
          DELETE: 'Apagar',
          NAME: 'Nome',
          CODE: 'Código',
          PHONE: 'Telefone',
          STATUS: 'Status',
          DEFINE_SUPPLIER_STP1: 'Definir Fornecedor',
          CLASIFICATION: 'Classificação',
          ITEMS_ALLOCATION_STP2: 'Produtos Fornecidos',
          EDIT_TITLE_FORM: 'Editar Fornecedor',
          NEW_TITLE_FORM: 'Novo Fornecedor',
          STP1: 'Etapa 1 - Definir Fornecedor',
          NAME_INPUT: 'Nome',
          CODE_INPUT: 'Código',
          PHONE_INPUT: 'Telefone',
          NEXT_BTN: 'Próximo',
          STP2: 'Etapa 2 - Atribuição de Produtos',
          ITEM: 'Produto',
          MAIN_STORES: '# Pontos de Venda',
          SECONDARY_STORES: '# Pontos de Venda Sucundários',
          DELETE_ITEM_TTIP: 'Apagar Produto',
          ADD_ITEM_BTN: 'Adicionar Produto',
          PREVIUS_BTN: 'Anterior',
          SAVE_BTN: 'Salvar',
          DELETE_TITLE_MODAL: 'Apagar',
          DELETE_SUBTITLE_MODAL: 'Tem certeza de que deseja excluir?',
          DELETE_SUBTITLE2_MODAL: 'Você vai excluir: {{val}}}. Tem certeza?',
          DELETE_BTN: 'Apagar',
          ALLOCATION_STORES: 'Atribuição de Pontos de Venda',
          ITEM_INPUT: 'Produto',
          SEARCH_ITEM: 'Procurar Produto…',
          STORES_INPUT: 'Pontos de Venda',
          ADD_STORES: 'Adicionar mais Pontos de Venda',
          SEARCH_STORES: 'Procurar Pontos de Venda…',
          ALL_CHECK: 'Todos',
          SECONDARY_STORES_INPUT: 'Pontos de Venda Secundários',
          ADD_SECONDARY_STORE: 'Adicionar mais Pontos de Venda secundários',
          SEARCH_SECONDARY_STORE: 'Procurar Pontos de Venda Secundários',
          CANCEL_BTN: 'Cancelar',
          ACCEPT_BTN: 'Aceitar',
          SEGMENTATION: 'Segmentação',
          INTERNAL_CODE_INPUT: 'Código Interno',
          UNIQUE_CODE_INPUT: 'Código Único',
          ITEM_FORM: {
            SAVE: 'Salvar',
            PUBLISH: 'Publicar',
            WARNING_SAVE: 'As alterações atuais devem ser salvas.',
            WARNING_PUBLISH: 'Você precisa republicar para que as alterações salvas tenham efeito.',
            LOADING: 'Carregando...',
            NEW_ITEM_BTN: 'Novo item',
            PUBLISH_CONFIRM:
              'O processo de publicação inclui a criação de custos nas lojas relacionadas ao fornecedor. <br> <br> <b> Tem certeza que deseja Publicar? </b>',
            PUBLISH_CONFIRM_TITLE: 'Confirmação de Publicação',
            NO_SEGMENT: 'Não segmentado',
            PUBLISHING_WARNING: 'Item em processo de publicação, tente novamente em alguns minutos.',
            PUBLISH_LONG_TIME:
              'A publicação deste item pode demorar alguns minutos, quando for encerrada você será notificado com uma notificação.',
            TIP_ATTRIBUTES_NO_SELECT: 'Os custos do fornecedor serão aplicados a toda a rede.',
            TIP_ATTRIBUTES_SELECT: 'Os custos do fornecedor se aplicam apenas a pontos de venda marcados como:',
            TIP_USESOWNITEMNUMBERS:
              'Se o código interno for necessário, tanto a atualização de custo quanto os pedidos do módulo de abastecimento devem ser concluídos com os códigos internos do fornecedor.',
          },
        },
        INSIGHTS: {
          ROUTE: 'Administração / Mestre',
          TITLE: 'Insights',
          FILTER_TTIP: 'Filtrar',
          NAME: 'Nome',
          DESCRIPTION: 'Descrição',
          MARGIN: 'Margem R$',
          CREATE_DATE: 'Data',
          ACTIONS: 'Ações',
          CONSULT_REPORTS: 'Consultar Reportes',
          REVIEW_PRICES: 'Rever Preços',
          TOGGLE_FILTER: 'Só os meus Insights',
          ANTIQUITY_FILTER: 'Antiguedade',
          INSIGHTS_TYPE_FILTER: 'Tipo de Insight',
          STORES_FILTER: 'Pontos de Venda',
        },
        CONTACTS: {
          ERROR: {},
        },
        EQUIPMENTS: {
          ROUTE: 'Gestão / Mestres',
          TITLE: 'Equipamentos',
          TITLE_FULL: 'Tipos de Equipamento',
          FILTER_TTIP: 'Filtro',
          NAME: 'Nome',
          DESCRIPTION: 'Descrição',
          EDIT: 'Editar Tipo de Equipamento" se traduce a Portugués (Brasil) como:',
          NEW: 'Novo Tipo de Equipamento',
          DELETE: 'Excluir Tipo de Equipamento',
          DELETE_WARN: 'Esse tipo de equipamento está atribuído, não é possível excluí-lo.',
          ITEMS: 'Itens',
          ATTR: 'Atributos',
          ATTR_ALT: 'Atributos',
          REQUIRED: 'Obrigatório',
          SAVE: 'Salvar',
          PUBLISH: 'Publishar',
          WARNING_SAVE: 'Precisa salvar as alterações atuais.',
          WARNING_PUBLISH: 'Precisa de re-publicação para que as alterações salvas tenham efeito.',
          LOADING: 'Cargando...',
          ADD_ATTR: 'Agregar Atributo',
          EDIT_ATTR: 'Editar Atibuto',
          TYPE_ATTR: 'Tipo de Atributo',
          NEW_ITEM: 'Novo Tipo de Equipamento',
          VALUE_LIST: 'Lista de Preços:',
          ADD_VALUE: 'Adicionar Valor',
          VALUE: 'Valor',
          VALIDATION_NAME_DUPLICATE: 'Esse nome já existe',
          VALIDATION_ATTR_DUPLICATE: 'Há atributos duplicados',
          ASSIGNED: 'Atribuído',
          ATTR_REQUIRED: 'Atributo obrigatório',
          ATTR_UNIQUE: 'Atributo único',
          UNIQUE: 'Único',
          GENERAL: 'Geral',
          ASSIGN_REQUIRED_DISCLAIMER:
            'Esse tipo de equipamento já tem unidades atribuídas às lojas, esse ajuste não será retroativo para as unidades que já foram atribuídas.',
          REPORT: 'Baixar Relatório',
          TYPES: {
            NUMBER: 'Número',
            STRING: 'Texto',
            BOOLEAN: 'Booleano',
            LIST: 'Lista de Valores',
            PRICE: 'Precificação',
            DATETIME: 'Data',
          },
        },
        DYNAMIC_ENTITIES: {
          ROUTE: 'Gestão / Mestres',
          TITLE: 'Equipamentos',
          TITLE_FULL: 'Dinâmicas Entidades',
          FILTER_TTIP: 'Filtro',
          NAME: 'Nome',
          INSTANCES: 'Instances',
          DESCRIPTION: 'Descrição',
          EDIT: 'Editar Tipo de Entidade',
          NEW: 'Nova Categoria de Entidade',
          DELETE: 'Excluir Tipo de Entidade',
          DELETE_INSTANCE: 'Excluir instância',
          DELETE_WARN: 'Esse tipo de entidade está atribuído, não é possível excluí-lo.',
          DELETE_INSTANCE_WARN: 'Este tipo de entidade está atribuído, não é possível excluí-lo',
          ITEMS: 'Itens',
          ATTR: 'Atributos',
          ATTR_ALT: 'Atributos',
          REQUIRED: 'Obrigatório',
          SAVE: 'Salvar',
          PUBLISH: 'Publish',
          WARNING_SAVE: 'Precisa salvar as alterações atuais.',
          WARNING_PUBLISH: 'Precisa de re-publicação para que as alterações salvas tenham efeito.',
          LOADING: 'Cargando...',
          ADD_ATTR: 'Agregar Atributo',
          EDIT_ATTR: 'Editar Atibuto',
          TYPE_ATTR: 'Tipo de Atributo',
          NEW_ITEM: 'Nova Categoria de Entidade',
          VALUE_LIST: 'Lista de Preços:',
          ADD_VALUE: 'Adicionar Valor',
          VALUE: 'Valor',
          VALIDATION_NAME_DUPLICATE: 'Esse nome já existe',
          VALIDATION_ATTR_DUPLICATE: 'Há atributos duplicados',
          VALIDATION_ATTR_CHANGE_NOT_ALLOWED:
            'Não é possível alterar a validação do atributo porque existem inconsistências nas instâncias carregadas.',
          ASSIGNED: 'Atribuído',
          ATTR_REQUIRED: 'Atributo obrigatório',
          ATTR_UNIQUE: 'Atributo único',
          UNIQUE: 'único',
          ATTR_OPTIONAL: 'Opcional',
          ATTR_OPTIONAL_DESC: 'O campo pode estar vazio',
          ATTR_REQUIRED_DESC: 'O campo deve ser preenchido',
          ATTR_REQUIRED_UNIQUE: 'Obrigatório e único',
          ATTR_REQUIRED_UNIQUE_DESC: 'Não pode repetir nem estar vazio',
          ATTR_TYPE_SELECTION: 'Tipo de atributo',
          GENERAL: 'Geral',
          ASSIGN_REQUIRED_DISCLAIMER:
            'Esse tipo de entidade já tem equipamentos atribuídos às lojas, esse ajuste não será retroativo para os equipamentos que já foram atribuídos.',
          REPORT: 'Baixar Relatório',
          TYPES: {
            NUMBER: 'Número',
            STRING: 'Texto',
            BOOLEAN: 'Booleano',
            LIST: 'Lista de Valores',
            PRICE: 'Precificação',
            DATETIME: 'Data',
          },
          NAME_ALREADY_EXISTS: 'O nome já existe',
          UNIQUE_ATTRIBUTE_EXISTS: 'O valor "{{value}}" já existe para o campo "{{field}}"',
          SET_NAME_AS_UNIQUE_TITLE: 'Definir Nome como Único',
          SET_NAME_AS_UNIQUE_BODY: 'Deseja marcar o campo Nome como único? Isso impedirá valores duplicados.',
          UNSET_NAME_AS_UNIQUE_TITLE: 'Remover Unicidade do Nome',
          UNSET_NAME_AS_UNIQUE_BODY: 'Deseja remover a restrição de unicidade do campo Nome? Isso permitirá valores duplicados.',
          CODE_ALREADY_EXISTS: 'O código já existe',
          ADD_ENTITY_TITLE: 'Nova Entidade',
          ADD_INSTANCE_TITLE: 'Nova Instância',
          EDIT_ENTITY: 'Modificar Entidade',
          CODE: 'Código',
          TAGNAME: 'Nome da Etiqueta',
          ADD_INSTANCE: 'Inserir instância',
          EDIT_INSTANCE: 'Modificar Instância',
          CANCEL_BTN: 'Cancelar',
          RELATION_WITH_ITEMS: 'Associação com Itens',
          RELATION_WITH_STORES: 'Relação com Pontos de Venda',
          RELATION: 'Associação',
          DELETE_TITLE: 'Excluir Entidade',
          DELETE_CONTENT: 'Ação não pode ser desfeita. Deseja continuar?',
          STORES: 'Pontos de Venda',
          MASSIVE_IMPORT: 'Importação em Massa',
          NEW_DYNAMIC_ENTITY: 'Nova entidade dinâmica, não é possível exibir instâncias.',
          IMPORT_SUCCESS: 'Importação realizada com sucesso',
          RELATIONSHIP_TYPE: 'Tipo de Relacionamento',
          ITEM_RELATIONSHIP: 'Relacionamento com Itens',
          STORE_RELATIONSHIP: 'Relacionamento com Pontos de Venda',
          VENDOR_RELATIONSHIP: 'Relacionamento com Fornecedores',
          NO_RELATIONSHIP: 'Sem Relacionamento',
          ITEM: 'Itens',
          STORE: 'Pontos de Venda',
          VENDOR: 'Fornecedores',
        },
        COST_AND_TAXES: {
          TITLE: 'Custos e Impostos',
          TITLE_TAXES_ONLY: 'Impostos',
          NEW: 'Criar custo ou imposto',
          NEW_TAXES_ONLY: 'Criar imposto',
          TABLE: {
            NAME: 'Nome',
            VALUE: 'Valor',
            CODE: 'Código',
            TYPE: 'Tipo',
            FROM: 'A partir de',
            STORE_QUANTITY: '# de Lojas',
            ITEM_QUANTITY: '# de Prod.',
            VALIDATION: 'Validação',
            STATUS: 'Estado',
            APPLICATION: 'Aplicação',
            VALIDITY: 'Vigência',
            TYPE_CURRENT: 'Atual',
            TYPE_FUTURE: 'Futuro',
            TYPE_NA: 'N/A',
            TYPE_NEW: 'Novo',
            VALIDATION_NOT_REVIEWED: 'Não Revisado',
            VALIDATION_APPROVED: 'Aprovado',
            VALIDATION_REJECTED: 'Rejeitado',
            ADD_FUTURE_VALUE: 'Adicionar Valor Futuro',
            EDIT_SEE_DETAIL: 'Editar / Ver Detalhes',
            CHANGE_VALIDATION_STATUS: 'Alterar estado',
            VIEW_HISTORY_CHANGES: 'Ver histórico de mudanças',
          },
          ADD_NEW_FUTURE_VALUE: 'Adicionar novo valor futuro',
          TYPE: 'Tipo',
          COST_TYPE: 'Tipo de Custo',
          TAX_TYPE: 'Tipo de Imposto',
          TAX_SUBTYPE_TAX_RATE_DISPLAY: 'IVA',
          APPLICATION_STATUS: 'Estado de Aplicação',
          VALIDATION_STATUS: 'Estado de Validação',
          COST: 'Custo',
          TAX: 'Imposto',
          COSTS: 'Custos',
          TAXES: 'Impostos',
          ALL: 'Todos',
          FORM: {
            NEW: 'Novo',
            MAIN_DATA: 'Dados principais',
            STORE_SCOPE: 'Alcance de Pontos de Venda',
            ITEM_SCOPE: 'Alcance de Itens',
            HISTORY: 'Histórico',
            NAME: 'Nome',
            CODE: 'Código',
            VALUE: 'Valor',
            VALUE_TYPE: 'Tipo de Valor',
            ADD_FUTURE_VALUE: 'Adicionar Valor Futuro',
            CODE_EXISTS: 'O código já existe',
          },
          APPLIED_FROM: 'Aplicado desde',
          NEW_VALUE: 'Novo Valor',
          APPLY_FROM: 'Aplicar a partir de',
          NEW_VALUE_REQUIRED: 'O novo valor é requerido',
          NEW_VALUE_MIN: 'O novo valor deve ser maior que 0',
          APPLY_FROM_REQUIRED: 'A data de aplicação é requerida',
          VALUE_CREATED_SUCCESS: 'O novo valor foi criado com sucesso',
          VALUE_APPROVED_SUCCESS: 'O novo valor foi aprovado com sucesso',
          VALUE_REJECTED_SUCCESS: 'O novo valor foi rejeitado com sucesso',
          NOT_REVIEWED_PENDING: 'Estado sem revisar pendente',
          APPROVE: 'Aprovar',
          REJECT: 'Rejeitar',
          CHANGES_HISTORY: 'Histórico de Mudanças',
          USER: 'Usuário',
          NO_DATA_HISTORY: 'No hay datos de historial disponibles',
          VALUE_REJECT_SUCCESS: 'O novo valor foi rejeitado com sucesso',
        },
        TAGS: {
          ACCEPT: 'Aceitar',
          NAME_ALREADY_EXIST: 'O nome já está em uso.',
          TYPES: {
            Item: 'Produto',
            Store: 'Ponto de Venda',
            Competitor: 'Concorrente',
            Brands: 'Bandeiras',
            Vendor: 'Fornecedor',
          },
          DATA_TYPES: {
            Text: 'Texto',
            Number: 'Número',
            Boolean: 'Boleano',
            DynamicEntity: 'Entidade dinâmica',
            FreeNumber: 'Número livre',
          },
          ENTITIES: {
            COMPETITORS: 'Concorrentes: {{val}}',
            ITEMS: 'Produtos: {{val}}',
            ROUNDINGRULES: 'Regras de arredondamento: {{val}}',
            COMPETITIVELIMITRULES: 'Limite de concorrentes: {{val}}',
            PRICINGRULESITEMS: 'Regras de parentesco de produtos: {{val}}',
            PRICINGRULESSTORES: 'Regras de parentesco de pontos de venda: {{val}}',
            STORES: 'Pontos de venda: {{val}}',
            VENDORS: 'Fornecedores: {{val}}',
            VENDORCOSTS: 'Custos: {{val}}',
            ASSORTMENTASSIGNMENTS: 'Atribuição de sortimento: {{val}}',
            ASSORTMENTITEMEXCEPTIONS: 'Exceção de sortimento por produtos: {{val}}',
            ASSORTMENTSTOREEXCEPTIONS: 'Exceção de sortimento por ponto de venda: {{val}}',
            ASSORTMENTCATEGORIES: 'Categorias de sortimento: {{val}}',
          },
          DEFAULTVALUE: 'Iniciar com esse valor padrão',
          ISDEFAULTVALUE: 'Peso Padrão',
          TAG_IN_USE: 'Erro ao excluir a tag está em uso',
          ENTITIES_IN_USE: 'Você deve reatribuir o seguinte número de registros para cada entidade que usa a tag para excluir',
          CANCEL_BTN: 'Cancelar',
          NEW_TAG_VALUE_ADD_BTN: 'Criar novo valor de etiqueta',
          FREE_NUMBER_VALUES_INFO:
            'Esta etiqueta é do tipo Número livre. Seus valores não são administrados nesta tela: são carregados no Item Master e criados automaticamente ao salvar o produto.',
          ALLOW_DIRECT_VALUE_LOAD: 'Carga direta de valores',
          ALLOW_DIRECT_VALUE_LOAD_POPOVER_TOOLTIP:
            'Permite criar valores novos a partir da aba de Classificação (Item Master, Lojas ou Fornecedor) sem ir ao mestre de etiquetas.',
          ADD_TAG_VALUE_INLINE: '+ Adicionar valor',
          ADD_TAG_VALUE_INLINE_TITLE: 'Adicionar valor de etiqueta',
          ADD_TAG_VALUE_INLINE_VALUE_LABEL: 'Valor',
          ADD_TAG_VALUE_INLINE_CONFIRM: 'Adicionar',
          ADD_TAG_VALUE_INLINE_SUCCESS: 'Valor adicionado',
          ADD_TAG_VALUE_INLINE_DEDUPE: 'Esse valor já existia; o existente foi selecionado.',
          ADD_TAG_VALUE_INLINE_ERROR: 'Não foi possível adicionar o valor. Tente novamente.',
          ROUTE: 'Administração / Mestre',
          ISDELETED: 'Eliminados',
          ISDELETED_POPOVER_TOOLTIP: 'Ao ativar apenas as etiquetas excluídas serão mostradas',
          USEFORREPORTS: 'Usados para relatórios',
          USEFORREPORT: 'Usado para relatórios',
          USEFORREPORTS_POPOVER_TOOLTIP: 'Ao habilitar, apenas as etiquetas atribuídas aos relatórios serão mostradas',
          YES: 'Sim',
          NO: 'Não',
          REQUIRED_CHECKBOX_POPOVER_TOOLTIP:
            'Torne este campo obrigatório para todos os "produtos" ...\nO sistema não permitirá elementos que este campo não esteja completo.',
          REQUIRED_FOR_COMPETITOR_POPOVER_TOOLTIP:
            "Habilita a exigir que esse campo seja preenchido obrigatoriamente para todos os 'concorrentes'. Permite atribuir um valor padrão caso essa opção esteja ativada.",
          REQUIRED_FOR_STORE_POPOVER_TOOLTIP:
            "Hoje torna obrigatório o preenchimento deste campo em todos os 'locais de venda'. Permite atribuir um valor padrão caso essa opção esteja ativada.",
          TERMINATION_SLIDE_POPOVER_TOOLTIP:
            'Você pode adicionar uma terminação padrão aos valores da etiqueta. Ex: para conteúdo líquido, "cc" ou "cm3". Tag: 250 cc',
          DEPENDENCIES_POPOVER_TOOLTIP:
            'Usá-lo em caso esta etiqueta dependa de outra. Relacionamento pai / filho. Ex: "Cidade" depende de "Estado"',
          SELECT_PARENT_TAG_POPOVER_TOOLTIP:
            'Em caso de mudança para outra etiqueta pai, os valores desta etiqueta serão eliminados. Em caso de desalocação, os valores desta etiqueta perderão relação com os valores pais',
          SELECT_PARENT_TAG_WARNING:
            'Certifique-se de selecionar a etiqueta pai correta antes de carregar os valores pai, se alterado você perderá os valores adicionados anteriormente',
          TITLE: 'Etiquetas',
          CANCEL: 'Cancelar',
          OK: 'Ok',
          NEW_STORE_BTN: 'Nova Etiqueta',
          DELETE: 'Apagar',
          DELETE_TTIP: 'Apagar Etiquetas Selecionadas',
          FILTER_TTIP: 'Filtrar',
          EXPORT_TTIP: 'Exportar',
          IMPORT_TTIP: 'Importar',
          PRINT_TTIP: 'Imprimir',
          NAME: 'Nome',
          TYPE: 'Tipo',
          FIELD_TYPE: 'Tipo de Campo',
          REQUIRED: 'Obrigatório',
          QUANTITY_TAGS: '# Etiquetas',
          QUANTITY_TAGS_TTIP: 'Quantidade de etiquetas que pertencem a um grupo',
          DEFINE_TAG_STP1: 'Definir Etiqueta',
          ADMIN_TAG_STP2: 'Gerenciar Etiqueta',
          EDIT_TAG: 'Editar Etiqueta',
          DELETE_ROW: 'Apagar Tag',
          NEW_TAG: 'Nova Etiqueta',
          STP1: 'Definir Etiqueta',
          NAME_INPUT: 'Nome',
          TYPE_INPUT: 'Tipo de Etiqueta',
          DATATYPE_INPUT: 'Tipo de Dados',
          REQUIRED_CHECKBOX: 'Obrigatório para todos os produtos',
          REQUIRED_FOR_COMPETITOR: 'Obrigatório para todos os concorrentes',
          REQUIRED_FOR_STORE: 'Obrigatório para todos os Pontos de Venda das marcas próprias',
          ADDITIONAL_SLIDE: 'Características adicionais',
          COLOR_SLIDE: 'Cor',
          ICON_SLIDE: 'Ícone e Imagen',
          REQUIRED_SLIDE: 'Requer Permissão Especial',
          TERMINATION_SLIDE: 'Terminação',
          TERMINATION_INPUT: 'Ingressar Terminação',
          DEPENDENCIES: 'Dependências',
          DEPENDENCIES_INPUT: 'Selecionar Etiqueta Pai',
          REQUIRED_WARNING_OFF_CONTENT: 'Se o valor desta etiqueta for definido como padrão, ele estará desativado.',
          REQUIRED_WARNING_OFF_TITLE: 'Deseja que essa etiqueta não seja obrigatória?',
          NEXT_BTN: 'Próximo',
          STP2: 'Gerenciar Valores da Etiqueta',
          NEW_TAG_INPUT: 'Adicionar nova etiqueta',
          DEPENCENCY_TAG_INPUT: 'Selecionar o Valor da Etiqueta Pai',
          PARENT: 'Pai',
          TYPE_CENTER: 'Tipo de Centro',
          COLOR: 'Cor',
          ICON: 'Ícone',
          TERMINATION: 'Terminação',
          PARENT_VALUE: 'Valor do Pai',
          ELEMENTS: '# Elemenos',
          ELEMENTS_TTIP: 'Quantidade de Elementos',
          PREVIOUS_BTN: 'Anterior',
          SAVE_BTN: 'Salvar',
          ADD_BTN: 'Adicionar',
          EDIT_BTN: 'Editar',
          TAG_VALUE_EXIST: 'O valor da etiqueta já existe',
          DEFAULT_TTP: 'Não é possível atribuir valor padrão se a etiqueta não for marcada como obrigatória',
          INVALID_TAG_VALUES_FORM: 'Todos os valores carregados devem conter os campos obrigatórios',
          OWN_STORES: 'próprias lojas',
          PRODUCTS: 'produtos',
          COMPETITORS: 'concorrentes',
          REQUIRED_DEFAULT_TAG: 'Você deve configurar um valor de etiqueta padrão para poder Salvar',
          TAG_UPDATE_ALL_PRODUCTS: 'Esta etiqueta atualizará todos os Produtos. Deseja continuar?',
          TAG_UPDATE_ALL_OWN_STORES: 'Esta etiqueta atualizará todos os Pontos de Venda Própria. Deseja continuar?',
          TAG_UPDATE_ALL_COMPETITORS: 'Esta etiqueta atualizará todos os Competidores. Deseja continuar?',
        },
      },
      SECURITY: {
        REPORTS: {
          TITLE: 'Relatórios de Segurança',
          USERS: 'Usuários',
          ROLES: 'Funções',
          LOGIN_AUDIT: 'Auditoria de Login',
          SYSTEM_AUDIT: 'Auditoria de Sistema',
        },
        USERS: {
          LIST: {
            TITLE: 'Usuários',
            EDIT_ROW: 'Editar',
            USERNAME_INPUT: 'Nome de usuário',
            EMAIL_INPUT: 'Email',
            ROLE_INPUT: 'Função',
            BLOCK_ROW: 'Bloquear usuário',
            UNBLOCK_ROW: 'Desbloquear usuário',
            BLOCK_TITLE: 'Bloquear usuário',
            BLOCK_CONFIRM:
              'Ao bloquear {{val}}, ele não poderá acessar o Prisma, nem pelo acesso corporativo nem com usuário e senha, mesmo que a conta continue habilitada no diretório da sua organização. Deseja continuar?',
            BLOCK_OK: 'Usuário bloqueado',
            UNBLOCK_OK: 'Usuário desbloqueado',
          },
          ITEM: {
            TAB1: 'Dados Gerais',
            USERNAME_INPUT: 'Nome de usuário',
            FIRSTNAME_INPUT: 'Nome',
            LASTNAME_INPUT: 'Sobrenome',
            EMAIL_INPUT: 'Email',
            PASSWORD_INPUT: 'Contra-senha',
            PREV_PASSWORD_INPUT: 'Contra-senha anterior',
            RESET_PASS: 'Blanquear Contra-senha',
            REPEAT_PASSWORD_INPUT: 'Redifinir Contra-senha',
            PASSWORD_BTN: 'Esconder contra-senha',
            ROLES_INPUT: 'Função',
            CATEGORIES: 'Categorias',
            STORES: 'Pontos de Venda',
            EDIT_STORES: 'Editar Pontos de Venda',
            CATEGORIES_ADVICE: 'Caso deixe esta seleção vazia, nenhuma restrição por categoria será aplicada ao usuário.',
            STORES_ADVICE: 'Caso deixe esta seleção vazia, nenhuma restrição por ponto de venda será aplicada ao usuário.',
          },
          NEW_USER_BTN: 'Novo Usuário',
        },
        ROLES: {
          LIST: {
            TITLE: 'Funções',
            EDIT_ROW: 'Editar',
            NAME_INPUT: 'Nome',
            DELETE_ROW: 'Excluir',
            SELECTED: 'Seleccionado',
            SELECTED_PLURAL: 'Seleccionados',
          },
          NEW_ROLE_BTN: 'Novo Função',
          DELETE: {
            TITLE: 'Excluir Função',
            MESSAGE: 'Tem certeza de que deseja excluir a função {{name}}? Esta ação não pode ser desfeita.',
            SUCCESS_TITLE: 'Função Excluída',
            SUCCESS_MESSAGE: 'A função foi excluída com sucesso.',
            ERROR_TITLE: 'Não é possível excluir a função',
            ERROR_MESSAGE: 'A função não pode ser excluída porque possui usuários atribuídos: {{users}}',
            GENERAL_ERROR: 'Ocorreu um erro ao tentar excluir a função. Por favor, tente novamente.',
          },
          ITEM: {
            TAB1: 'Dados Gerais',
            NAME_INPUT: 'Nome',
            NAME_ROLE: 'Nome',
            DESCRIPTION_ROLE: 'Descrição',
            SELECTED: 'Selecionado',
            SELECTED_PLURAL: 'Selecionados',
            ROLE: {
              admin_view: 'Visualizar menu de Administração',
              itemmaster_view: 'Visualizar menu de Item Master',
              prices_competitors_view: 'Visualizar menu de bandeiras e concorrentes',
              prices_costsandtaxes: 'Importador de custos por loja e custos por fornecedor',
              prices_decisions: 'Alterar preços, Aceitar e ignorar sugestões. Solicitar aprovação e importar novos preços',
              prices_endorse: 'Aprovar preços e rejeitar alterações.',
              prices_guidelineStrategy_view: 'Visualizar menu de diretrizes e estratégias',
              prices_competitors_delete: 'Excluir um concorrente',
              prices_roundings_delete: 'Excluir uma regra de arredondamento',
              prices_rules_delete: 'Excluir uma regra',
              prices_sensitivities_delete: 'Excluir uma sensibilidade',
              prices_decisions_prices_endorse: 'Aceitar uma sugestão (enviar para publicação)',
              assortment_clustering_save: 'Salvar uma nova clusterização',
              assortment_clustering_delete: 'Excluir uma clusterização',
              assortment_roles_save: 'Salvar alterações em um papel (ou criar um novo)',
              assortment_roles_delete: 'Excluir um papel',
              assortment_strategies_save: 'Salvar alterações em uma estratégia (ou criar uma nova)',
              assortment_strategies_delete: 'Excluir uma estratégia',
              assortment_decisions_save: 'TBD',
              assortment_output: 'TBD',
              spaces_planograms_save: 'Salvar alterações em um planograma (ou criar um novo)',
              spaces_planograms_upload_audit_photo: 'Carregar fotos de auditoria do planograma',
              spaces_planograms_approve: 'Ação no fluxo de aprovação do planograma (TBD)',
              spaces_planograms_request_approval: 'Ação no fluxo de aprovação do planograma (TBD)',
              spaces_planograms_inform: 'Ação no fluxo de aprovação do planograma (TBD)',
              spaces_planograms_messaging: 'TBD',
              spaces_planograms_pop_material_save: 'Salvar material POP padrão (TBD Promos)',
              spaces_layout_save: 'Salvar alterações em um layout (ou criar um novo)',
              spaces_layout_delete: 'Excluir um layout',
              spaces_layout_messaging: 'Adicionar comentários em um layout',
              spaces_templates_save: 'Salvar uma nova configuração do Gerador de Planograma',
              spaces_templates_delete: 'Excluir uma configuração do Gerador de Planograma',
              equipments_save: 'Salvar alterações em um equipamento (ou criar um novo)',
              equipments_delete: 'Excluir equipamento',
              storemaster_save: 'Salvar alterações em um Ponto de Venda (ou criar um novo)',
              storemaster_delete: 'Acessar menu de Tags',
              tags_delete: 'Excluir uma tag',
              vendor_save: 'Salvar alterações em um Fornecedor (ou criar um novo)',
              vendor_publish: 'Publicar um fornecedor (TBD)',
              vendor_delete: 'Excluir um fornecedor',
              general_importer_view: 'Acessar importador geral',
              itemmaster_save: 'Salvar alterações em um item (ou criar um novo)',
              itemmaster_publish: 'Publicar um item',
              itemmaster_delete: 'Excluir um item',
              update_custom_item_to_standard_item: 'Converter um item próprio em um item padrão',
              mysteryShopper_missions_save: 'Salvar alterações em uma missão (ou criar uma nova)',
              mysteryShopper_missions_delete: 'Excluir uma missão',
              prices_output: 'Publicar decisões de preços',
              prices_output_readonly: 'Visualizar menu de Publicar decisões e gerar visualização prévia',
              prices_roundings_view: 'Visualizar menu de regras de arredondamento',
              prices_rules_view: 'Visualizar menu de regras de preços',
              prices_sensitivities_view: 'Visualizar menu de sensibilidades',
              prices_view: 'Visualizar menu de decisões de preços',
              pricing_manual_suggestions: 'Permitir gerar sugestões de preços manualmente',
              pricing_survey: 'Permitir importar preços da concorrência',
              storemaster_view: 'Visualizar menu de Pontos de venda',
              tags_view: 'Visualizar menu de tags',
              prices_competitors_save: 'Criar e atualizar bandeiras e concorrentes',
              prices_guidelineStrategy_save: 'Atualizações sobre diretrizes e estratégias',
              prices_roundings_save: 'Criar e atualizar regras de arredondamento',
              prices_rules_save: 'Criar e atualizar regras de preços',
              prices_sensitivities_save: 'Criar e atualizar sensibilidade',
              tags_save: 'Criar e atualizar tags',
              assortment_categoryTree_view: 'Visualizar menu de Árvore de categorias e Configuração de categorias.',
              categories_tree_view: 'Visualizar menu de Árvore de categorias e Configuração de categorias.',
              assortment_clustering_view: 'Visualizar menu de agrupamento',
              assortment_decisions_view: 'Visualizar menu de decisões de sortimento',
              assortment_output_readonly: 'Visualizar menu de publicar decisões de sortimento e permitir gerar visualização prévia',
              assortment_roles_view: 'Visualizar menu de papéis',
              assortment_strategies_view: 'Visualizar menu de estratégias',
              assortment_view: 'Habilitar menu geral de sortimento',
              equipments_view: 'Visualizar menu de equipamentos',
              category_tree_button_view: 'Visualizar botão de relatório de árvore de categorias.',
              mysteryShopper_missions_view: 'Visualizar menu de missões',
              mysteryShopper_userAssigment_view: 'Visualizar menu de atribuição de usuários',
              mysteryShopper_view: 'Habilitar menu geral de missões',
              promotion_action_view: 'Visualizar menu de Ações',
              promotion_campaign_view: 'Visualizar menu de Campanhas',
              promotion_view: 'Habilitar menu geral de promoções',
              promotion_calendar_view: 'Visualizar o menu de calendário',
              promotion_configuration_view: 'Visualizar o menu de configurações',
              promotion_reportes_view: 'Visualizar o menu de relatórios',
              promotion_periods_view: 'Visualizar o menu de períodos promocionais',
              promotion_audit_report_view: 'Ver o relatório do registro promocional',
              promotion_reportes_production_view: 'Visualizar listas de produção',
              promotion_reportes_logistic_view: 'Visualizar listas de logística',
              promotion_reportes_pos_view: 'Visualizar dados para POS',
              promotion_action_save: 'Criar e atualizar ações promocionais',
              promotion_action_cancel: 'Eliminar ações promocionais',
              promotion_action_publish: 'Publicar ações promocionais',
              promotion_campaign_save: 'Criar e atualizar campanhas',
              promotion_reports_view: 'Visualizar relatórios de promoções',
              promotion_can_edit_all_promotional_actions: 'Criar ou editar promoções de períodos que já começaram/terminaram',
              promotion_promotional_process_view: 'Visualizar o menu de processos promocionais',
              promotion_promotional_process_edit: 'Criar e atualizar processos promocionais',
              spaces_layout_view: 'Visualizar menu de Layout',
              spaces_planograms_pop_material_view: 'Visualizar menu de Material Pop',
              spaces_planograms_view: 'Permitir visualizar menu de planogramas',
              spaces_view: 'Habilitar menu geral de espaços',
              vendor_view: 'Visualizar menu de fornecedores',
              masters_delivery_places_view: 'Visualizar Locais de Entrega do item por fornecedor',
              masters_delivery_places_save: 'Salvar e atualizar Locais de Entrega do item por fornecedor',
              admin_security: 'Permissões na gestão de Funções e Usuários',
              spaces_planograms_delete: 'Habilita o usuário a inativar todos os planogramas criados.',
              output_system_audit: 'Relatório de auditoria de sistema',
              output_users: 'Relatório de usuários',
              output_login_audit: 'Relatório de auditoria de login',
              output_roles: 'Relatório de funções',
              output_promotion_production_lists: 'Relatório de Listas de Produção',
              output_spaces_availability: 'Relatório de Espaços Disponíveis',
              output_promotion_period: 'Relatório de Períodos de Promoções',
              output_promotion_log: 'Relatório de Histórico de Promoções',
              output_promotion_oxxo: 'Relatório para PDV',
              output_promotion_report_oxxo: 'Relatório de Promoções',
              output_dynamic_entities_report: 'Relatório de Entidades Dinâmicas',
              output_context_report: 'Relatório de Contexto',
              output_item_matching_report: 'Relatório de Equivalências de Itens',
              output_prices_by_price_level_ypf_tiendas: 'Relatório de Preços por nível de preço',
              output_vendor_item_costs_ypf_tiendas: 'Relatório de Artigos por fornecedor e custos',
              range_rules_edit: 'Editar regras de faixa',
              range_rules_delete: 'Excluir regras de faixa',
              range_rules_pending_coverage_download: 'Baixar cobertura pendente de regras de faixa',
              range_assignment_rules_list_view: 'Visualizar lista de regras de atribuição de faixa',
              range_category_rules_list: 'Visualizar lista de regras de categoria de faixa',
              range_category_setup_save: 'Salvar configuração de categoria de faixa',
              range_category_setup_edit: 'Editar configuração de categoria de faixa',
              range_category_setup_delete: 'Excluir configuração de categoria de faixa',
              dynamic_entities_view: 'Visualizar entidades dinâmicas',
              dynamic_entities_save: 'Criar e atualizar entidades dinâmicas',
              dynamic_entities_delete: 'Excluir entidades dinâmicas',
              workflows_execute_action: 'Executar ação de fluxos de trabalho',
              workflows_execute_start: 'Iniciar execução de fluxo de trabalho',
              range_rules_save: 'Criar e atualizar regras de faixa',
              'update-custom-item-to-standard-item': 'Atualizar item personalizado para item padrão',
              itemmaster_assortment_edit: 'Editar sortimento de itens mestres',
              itemmaster_assortment_import: 'Importar sortimento de itens mestres',
              outputintegration_view: 'Visualizar integrações de saída',
              outputintegration_execute: 'Executar integrações de saída',
              outputintegration_retry: 'Tentar novamente integrações de saída',
              interfaces_retry_failed_batches: 'Tentar novamente lotes de interfaces com falha',
              storemaster_publish: 'Publicar lojas mestras',
              prices_decisions_read: 'Ler decisões de preços',
              prices_charge_view: 'Visualizar encargos de preços',
              prices_charge_save: 'Criar e atualizar encargos de preços',
              prices_charge_delete: 'Excluir encargos de preços',
              'prices_decisions,prices_endorse': 'Aprovar decisões de preços',
              mysteryShopper_userAssigment_save: 'Salvar atribuição de usuário Mystery Shopper',
              promotion_can_rebuild_action_scope: 'Reconstruir escopo de ação promocional',
              spaces_templates_view: 'Visualizar modelos de espaços',
              assortment_decisions_endorse: 'Aprovar decisões de sortimento',
              output_prices_output: 'Relatório de saída de preços',
              output_prices_suggestions: 'Relatório de sugestões de preços',
              output_promotion_item_tasks: 'Relatório de tarefas de itens promocionais',
              output_promotion_item_stores: 'Relatório de lojas de itens promocionais',
              output_promotion_report: 'Relatório de promoções',
              output_printing_list: 'Relatório de lista de impressão',
              output_logistics_list: 'Relatório de lista de logística',
              output_promotion_biactives: 'Relatório BI de promoções ativas',
              output_promotion_biplanned: 'Relatório BI de promoções planejadas',
              output_promotion_overlapping: 'Relatório de promoções sobrepostas',
              output_space_planogram_items: 'Relatório de itens de planograma de espaços',
              output_competitors_prices: 'Relatório de preços de concorrentes',
              output_promotion_bi: 'Relatório BI de promoções',
              output_assortment_report: 'Relatório de sortimento',
              output_assortment_prisma_output_report: 'Relatório de saída Prisma de sortimento',
              output_markdown_activation: 'Relatório de ativação de markdown',
              output_markdown_items: 'Relatório de itens markdown',
              output_admin_items_to_ignore: 'Relatório de itens a ignorar',
              output_fuels_all_information_report: 'Relatório de todas as informações de combustíveis',
              output_assortment_output: 'Relatório de saída de sortimento',
              output_pos_items_data_with_assortment: 'Relatório de dados de itens PDV com sortimento',
              output_daily_margin_report: 'Relatório diário de margem',
              output_equipment_assigment: 'Relatório de atribuição de equipamentos',
              output_daily_mission_report: 'Relatório diário de missões',
              output_list_missions: 'Relatório de lista de missões',
              output_other_reports: 'Outros relatórios',
              output_items: 'Relatório de itens',
              output_stores: 'Relatório de lojas',
              range_store_report_view: 'Visualizar relatório de lojas',
              output_market_item_to_register: 'Relatório de itens de mercado a registrar',
              output_promotion: 'Relatório de promoção',
              output_planogram_pre_generation_report: 'Relatório pré-geração de planograma',
              output_planogram_post_generation_report: 'Relatório pós-geração de planograma',
              output_massive_replacement: 'Relatório de substituição massiva',
              output_prices_costs: 'Relatório de custos de preços',
              output_contacts: 'Relatório de contatos',
              output_assortment_status_current_report: 'Relatório de status atual de sortimento',
              output_cost_tax_audit: 'Relatório de auditoria de custos e impostos',
              output_range_unassigned_report: 'Relatório de faixas não atribuídas',
              output_range_active_current_assortment_report: 'Relatório de faixa ativa de sortimento atual',
              output_vendor_cost_output: 'Relatório de custos de fornecedores',
              output_tag_values: 'Relatório de valores de etiquetas',
              output_assortment_decisions_report: 'Relatório de decisões de sortimento',
              output_category_tree: 'Relatório de árvore de categorias',
            },
          },
        },
      },
      PROFILE: {
        CHANGE_PASS: 'Redifinir Contra-senha',
        PROFILE_TITLE: 'Meu Perfil',
        PERMISSIONS: 'Permissões',
      },
    },
    PROMO: {
      CAMPAIGNS: {
        ROUTE: 'Promoções',
        TITLE: 'Campanha',
        NEW_CAMPAING_BTN: 'Nova Campanha',
        NAME: 'Nome',
        CODE: 'Código',
        ACTIONS: '# Ações',
        SINCE: 'Desde',
        TO: 'Até',
        STATE: 'Estado',
        USER: 'Usuário',
        LAST_MOD: 'Última Modif.',
        FULLSCREEN_TTIP: 'Expandir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        EXPORT_TTIP: 'Exportar',
        IMPORT_TTIP: 'Importar',
        PRINT_TTIP: 'Imprimir',
        TITLE_FORM: 'Nova Campanha',
        SAVE_BTN: 'Salvar',
        BASIC_INFORMATION_TAB: 'Dados Principais',
        CODE_INPUT: 'Código',
        NAME_INPUT: 'Nome',
        SINCE_INPUT: 'Desde',
        TO_INPUT: 'Até',
        DESCRIPTION_INPUT: 'Descrição',
        STATUS_STORES: 'Todos',
        STATUS_HISTORY: 'Histórica',
        STATUS_VIGENT: 'Vigente',
        STATUS_FUTURE: 'Futura',
        STATUS_NOTVALID: 'Inválido',
        STATUS_EMPTY: 'Inválido',
        INVALID_TO_DATE: 'Deve ser maior que a data de início e dentro do intervalo de datas da campanha',
        INVALID_FROM_DATE: 'Deve ser menor que a data de término e dentro do intervalo de datas da campanha',
        INVALID_TO_DATE_CAMPAING: 'Deve ser maior que a data de início',
        INVALID_FROM_DATE_CAMPAING: 'Deve ser menor que a data de término',
        NAME_TTIP: 'Clique aqui para ver as ações relacionadas',
        ACTIONS_TTIP: 'Número de Ações',
        LAST_MOD_TTIP: 'Última Modificação',
      },
      ACTIONS: {
        ROUTE: 'Promoções',
        TITLE: 'Ações',
        FILTER_TTIP: 'Filtrar',
        FULLSCREEN_TTIP: 'Expandir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        NAME: 'Nome',
        CODE: 'Código',
        TYPE: 'Tipo',
        STORES: '# Pontos de Venda',
        LIFT: 'Lift %',
        BRAND: 'Marca',
        NONE: 'Nenhum',
        SINCE: 'Desde',
        TO: 'Até',
        SUPPLIES_LAST: 'Sujeito à disponibilidade de estoque',
        USER: 'Usuário',
        LAST_MOD: 'Última Modif.',
        STATE: 'Estado',
        TYPE_OP1: 'Leve A pague B',
        TYPE_OP2: 'Desconto Direto',
        TYPE_OP3: 'Desconto por Quantidade',
        STATUS_STORES: 'Todos',
        STATUS_HISTORY: 'Histórica',
        STATUS_VIGENT: 'Vigente',
        STATUS_FUTURE: 'Futura',
        STATUS_NOTVALID: 'Inválido',
        STATUS_EMPTY: 'Inválido',
        STATUS_CANCELLED: 'Cancelada',
        INVALID_TO_TIME: 'Deve ser maior que a hora inicial',
        INVALID_FROM_TIME: 'Deve ser menor que a hora de término',
        INVALID_TO_DATE: 'Deve ser maior que a data de início e dentro do intervalo de datas das campanhas',
        INVALID_FROM_DATE: 'Deve ser menor que a data de término e dentro do intervalo de datas das campanhas',
        INVALID_TO_DATE_CAMPAING: 'Deve ser maior que a data de início',
        INVALID_FROM_DATE_CAMPAING: 'Deve ser menor que a data de término',
        DEFINE_ACTION_STP1: 'Definir Ação',
        RESTRICTIONS_STP2: 'Restrições',
        PRODUCTS_SCOPE_STP3: 'Escopo dos Produtos',
        STORES_SCOPE_STP4: 'Escopo Pontos de Venda',
        OTHERS_TERMS_STP5: 'Outras condições',
        TITLE_FORM_NEW: 'Nova Ação - ',
        TITLE_FORM_EDIT: 'Editar Ação - ',
        STP1: 'Etapa 1 - Definir Ação',
        CODE_INPUT: 'Código',
        PROMOTION_CODE_INPUT: 'Código Promo Externo',
        NAME_INPUT: 'Nome',
        TYPE_INPUT: 'Tipo',
        QUANTITY_BUY_INPUT: 'Quantidade a comprar',
        QUANTITY_PAY_INPUT: 'Quantidade a pagar',
        DISCOUNT_RATE_INPUT: 'Taxa de Desconto',
        UNIT_DISCOUNT_INPUT: 'Desconto por unidade',
        DISCOUNT_VALUE_INPUT: 'Valor do Desconto',
        QUANTITY_UNITS_INPUT: 'Quantidade de unidades a serem levadas',
        UNIT_DISCOUNT_PER_INPUT: 'Desconto por unidade {{val}}',
        SINCE_INPUT: 'Desde',
        TO_INPUT: 'Até',
        SUPPLIES_LAST_CHECK: 'Enquanto durarem os estoques',
        UNITS_AVAILABLE_INPUT: 'Unidades Disponíveis',
        FRECUENCY_INPUT: 'Frequência',
        DAYS_INPUT: 'Dias',
        TIME_FROM_INPUT: 'Horario Desde',
        TIME_TO_INPUT: 'Horario Até',
        TICKET_MESSAGE_INPUT: 'Mensagem do Ticket',
        OBSERVATION_INPUT: 'Observação',
        NEXT_BTN: 'Próximo',
        MONDAY: 'Segunda',
        TUESDAY: 'Terça',
        WEDNESDAY: 'Quarta',
        THURSDAY: 'Quinta',
        FRIDAY: 'Sexta',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo',
        DAILY: 'Diariamente',
        WEEKLY: 'Semanal',
        BIWEEKLY: 'Quincenal',
        MONTHLY: 'Mensal',
        BIMONTHLY: 'Bimestral',
        CUARTERLY: 'Trimestral',
        SEARCH_CONDITIONS: 'Procurar Outras Condições…',
        STP2: 'Etapa 2 - Restrições',
        UNIT_RESTRICTION: 'Restrição de Unidade',
        MINIMUM_AMOUNT_INPUT: 'Quantidade mínima',
        MAXIMUM_AMOUNT_INPUT: 'Quantidade máxima',
        AMOUNT_RESTRICTION: 'Restrição de quantidade',
        OTHERS_INPUT: 'Outras condições',
        PREVIOUS_BTN: 'Anterior',
        EQUAL_BRAND: 'Mesma Marca',
        EQUAL_PRICE: 'Mesmo Preço',
        EQUAL_CATEGORY: 'Mesma Categoria',
        EQUAL_DISCOUNT: 'Mesmo Desconto',
        EQUAL_PRODUCT: 'Mesmo Produto',
        STP3: 'Etapa 3 - Escopo dos Produtos',
        MANUAL_SELECTION_RADIO: 'Seleção Manual',
        CATEGORY_INPUT: 'Categoria',
        SEARCH_CATEGORY: 'Procurar Categoria…',
        EXCLUDE_CATEGORY_INPUT: 'Categoria a excluir',
        SEARCH_EXCLUDE_CATEGORY: 'Procurar Categoria a excluir',
        SUBCATEGORY_INPUT: 'Subcategoria',
        SEARCH_SUBCATEGORY: 'Procurar Subcategoria',
        EXCLUDE_SUBCATEGORY_INPUT: 'Subcategoria a excluir',
        SEARCH_EXCLUDE_SUBCATEGORY: 'Procurar Subcategoria a excluir',
        SUPPLIER_INPUT: 'Fornecedor',
        SEARCH_SUPPLIER: 'Procurar Fornecedor',
        EXCLUDE_SUPPLIER_INPUT: 'Fornecedor a excluir',
        SEARCH_EXCLUDE_SUPPLIER: 'Procurar Fornecedor a exluir',
        BRAND_INPUT: 'Marca',
        SEARCH_BRAND: 'Procurar Marca',
        EXCLUDE_BRAND_INPUT: 'Marca a excluir',
        SEARCH_EXCLUDE_BRAND: 'Procurar Marca a excluir',
        TAGS_INPUT: 'Atributos',
        SEARCH_TAGS: 'Procurar Atributos',
        EXCLUDE_TAGS_INPUT: 'Atributos a excluir',
        SEARCH_EXCLUDE_TAGS: 'Procurar Atributos a excluir',
        ITEMS_INPUT: 'Produtos',
        SEARCH_ITEMS: 'Procurar Produtos',
        EXCLUDE_ITEMS_INPUT: 'Produtos a serem excluídos',
        SEARCH_EXCLUDE_ITEMS: 'Procurar Produtos a excluir',
        MANUAL_LOAD_RADIO: 'Carregamento manual',
        DRAG_FILE: 'Arraste e solte o arquivo aqui ou clique para pesquisar em seu PC',
        STP4: 'Etapa 4 - Escopo dos Pontos de Venda',
        CLUSTER_INPUT: 'Cluster',
        SEARCH_CLUSTER: 'Procurar Cluster…',
        EXCLUDE_CLUSTER_INPUT: 'Cluster a excluir',
        SEARCH_EXCLUDE_CLUSTER: 'Procurar Cluster a excluir',
        FORMAT_INPUT: 'Formato',
        SEARCH_FORMAT: 'Procurar Clientes / Comunidades',
        EXCLUDE_FORMAT_INPUT: 'Formato para excliuir',
        SEARCH_EXCLUDE_FORMAT: 'Procurar Formato a excluir',
        STORE_INPUT: 'Ponto de Venda',
        SEARCH_STORE: 'Procurar Ponto de Venda',
        EXCLUDE_STORE_INPUT: 'Ponto de Venda a excluir',
        SEARCH_EXCLUDE_STORE: 'Procurar Ponto de Venda a excluir…',
        STP5: 'Etapa 5 - Outras Condições',
        CLIENTS_COMMUNITIES: 'Clientes / Comunidades',
        SEARCH_CLIENTS_COMMUNITIES: 'Procurar Clientes / Comunidades',
        PAYMENT_METHODS: 'Médios de Pagamento',
        SEARCH_PAYMENT_METHODS: 'Procurar Métodos de Pagamento',
        BANK_PROMOTIONS: 'Promoções Bancárias',
        SEARCH_BANK_PROMOTIONS: 'Procurar Promoções bancárias',
        CUMULATIVE: 'Cumulativo com outras promoções',
        SAVE_BTN: 'Salvar',
        NEW_ACTION_TITLE: 'Nova Ação',
        LEGEND_OP1:
          'É o desconto em que A representa as unidades a serem compradas pelo cliente e B representa as unidades a serem pagas pelo cliente. Exemplos: 2x1 (leve 2 e pague por 1) ou 3x2 (leve 3 e pague 2)',
        LEGEND_OP2:
          'É a porcentagem ou valor do desconto que será aplicado ao preço atual do produto. Exemplos: "15% de desconto sobre o preço atual" ou "R$ 10 de desconto sobre o preço atual"',
        LEGEND_OP3:
          'É a porcentagem de desconto que será aplicada ao preço atual do produto quando mais de uma unidade for comprada. Exemplo: Compre a segunda unidade com 80% de desconto.',
        CANCEL_BTN: 'Cancelar',
        CREATE_BTN: 'Criar',
        OVERLAP_TITLE: 'Há uma sobreposição',
        OVERLAP_SUBTITLE: 'Os produtos estão sendo divulgados em diferentes ações promocionais.',
        DATAIL_BTN: 'Mostre-me as sobreposições',
        ACCEPT_BTN: 'Aceitar',
        ROUTE2: 'Promoções / Campanha',
        ROUTE2_PROMOTIONAL_PERIOD: 'Promociones / Períodos Promocionais',
        NEW_ACTION_BTN: 'Nova Ação',
        ACTIONS_TITLE: 'Ações',
        VIEW_TTIP: 'Visualizar',
        VIEW_TABLE: 'Apenas Tabela',
        VIEW_CALENDAR: 'Apenas Calendário',
        TITLE_FILTERS: 'Filtros',
        STATE_FILTER: 'Estado',
        STATE_OP1_FILTER: 'Histórica',
        STATE_OP2_FILTER: 'Vigente',
        STATE_OP3_FILTER: 'Futura',
        CAMPAINGS_FILTER: 'Campanha',
        CLEAN_FILTER_BTN: 'Limpar',
        APPLY_FILTER_BTN: 'Aplicar',
        STORES_TTIP: 'Número de Pontos de Venda',
        LAST_MOD_TTIP: 'Última modificação',
        STP1_SUB: 'Nesta etapa você pode definir os principais componentes do tipo de ação selecionada.',
        STP2_SUB: 'Nesta etapa você pode definir as condições de sortimento e as restrições mínimas e máximas para a ação.',
        STP3_SUB: 'Nesta etapa, você pode selecionar os produtos a serem promovidos.',
        STP4_SUB: 'Nesta etapa você pode selecionar as lojas que realizarão esta promoção.',
        STP5_SUB: 'Nesta etapa você pode estabelecer condições que irão limitar a aplicação desta ação promocional.',
        STRATEGY: 'Em seguida, escolha a estratégia de seleção dos produtos filhos',
        STRATEGY_ATTR_TITLE: 'Seleção por atributo',
        STRATEGY_ATTR_MSG: 'Os atributos são selecionados para definir o escopo dos produtos',
        STRATEGY_STORE_ATTR_MSG: 'Os atributos são selecionados para definir o escopo dos Pontos de Venda',
        STRATEGY_PROD_TITLE: 'Seleção por produto',
        STRATEGY_STORE_TITLE: 'Seleção por Ponto de Venda',
        STRATEGY_PROD_MSG: 'Os produtos devem ser selecionados um por um',
        STRATEGY_STORE_MSG: 'Os pontos de venda devem ser selecionados um a um',
        GENERIC_MSG_ERRROR_EXECSUGGESTION: 'Não foi possível gerar sugestões.',
        GENERIC_MSG_NOSUGGESTIONS_EXECSUGGESTION: 'Não há novas sugestões.',
        GENERIC_ACTUAL_FILE: 'Arquivo Atual:',
      },
      HELP: {
        QUANTITY_BUY_INPUT: 'Indica as unidades (A) que o cliente levará. Exemplo: Se a ação for "3 x 2", você deve inserir "3".',
        QUANTITY_PAY_INPUT:
          'Indica as unidades (B) que o cliente pagará. Deve ser sempre menor que (A). Exemplo: Se a ação for "3 x 2" aqui, você deve inserir "2".',
        FRECUENCY_INPUT: 'Indica a frequência da ação.',
        DAYS_INPUT: 'Dias da semana em que a ação será efetiva.',
        TIME_FROM_INPUT: 'Intervalo de tempo em que a ação será efetiva.',
        TIME_TO_INPUT: 'Intervalo de tempo em que a ação será efetiva.',
        TICKET_MESSAGE_INPUT: 'Breve descrição da ação que será refletida na fatura ou ticket.',
        OBSERVATION_INPUT: 'Permite inserir algum tipo de informação ou detalhe da ação.',
        UNIT_DISCOUNT_INPUT: 'Indica o valor do desconto a ser aplicado a cada unidade vendida.',
        DISCOUNT_RATE_INPUT: 'Indica se o desconto será em percentual ou em valor fixo.',
        SUPPLIES_LAST_CHECK: 'Mensagem informativa para fins legais para o ponto de venda.',
        UNITS_AVAILABLE_INPUT:
          'Indica o total de unidades de produtos da empresa disponíveis para a ação. Mensagem informativa para fins legais para o ponto de venda.',
        DISCOUNT_VALUE_INPUT:
          'Valor de desconto. Exemplo: Se a ação for “2ª unidade com 30% de desconto”, aqui devemos inserir o número “30”.',
        UNIT_DISCOUNT_PER_INPUT:
          'Valor de desconto para cada unidade vendida. Exemplo: Se a ação for “2ª unidade com 30% de desconto”, aqui devemos inserir o número “15” que é o percentual que aplicará o desconto a cada unidade vendida.',
        QUANTITY_UNITS_INPUT:
          'Indica o número de unidades que o cliente deve comprar para que o desconto seja aplicado. Exemplo: Se a ação for “2ª unidade com 30% de desconto”, aqui devemos inserir o número “2”.',
        MINIMUM_AMOUNT_INPUT:
          'Indica o número mínimo de unidades que o cliente deve comprar para que o desconto seja aplicado. Exemplo: Se a ação for "desconto de 15% levando 3 unidades", aqui devemos inserir o número "3".',
        MAXIMUM_AMOUNT_INPUT:
          'Indica o número máximo de unidades que o cliente pode comprar com o desconto. Exemplo: Se a ação for “desconto de 15% até 6 unidades”, aqui devemos inserir o número “6”. Se o cliente comprar sete unidades, a 7ª unidade não terá desconto.',
        MINIMUM2_AMOUNT_INPUT:
          'Indica o valor monetário mínimo que o cliente deve gastar para que a promoção se aplique. Exemplo: Se a ação for "10% de desconto nas compras acima de R$ 1.000", aqui devemos inserir o número "1.000". Se esse valor não for atingido, o desconto não se aplica.',
        MAXIMUM2_AMOUNT_INPUT:
          'Indica o valor monetário máximo que o cliente deve gastar para que a promoção se aplique. Exemplo: Se a ação for “10% de desconto em compras até R$ 1.000”, aqui devemos inserir o número “1.000”. Se a compra for R$ 1.500, o desconto ainda será R$ 100 = 1000 x 10%.',
      },
    },
    PROMOV2: {
      CONFIGURATIONS: {
        LIST: {
          TITLE: 'Regras de Promoções',
          NEW_RULE: 'Nova regra',
          NAME: 'Nome',
          CODE: 'Código',
          RULE_TYPE: 'Tipo de Regra',
        },
        FORM: {
          NEW_ITEM_TITLE: 'Nova Regra de Promoção',
          NAME: 'Nome',
          CODE: 'Código',
          RULE_TYPE: 'Tipo de Regra',
          PROMOTIONAL_PROCESS_TYPE: 'Tipo de Processo Promocional',
          PROMOTION_TYPE: 'Mecânica',
          PROMOTION_RULE_TYPE: 'Tipo de Regra',
          LIMITS: 'Limites',
          PRICE_RULES_TITLE: 'O preço deve ser:',
          VALUE: 'Valor {{val}}',
          RULE_MESSAGES: {
            FIXPRICE_MINIMUM: 'Meu {{val}} preço promocional deve ser ${{val2}}.',
            FIXPRICE_MAXIMUM: 'Meu {{val}} preço promocional deve ser ${{val2}}.',
            REGULARPRICE_MINIMUM: 'Meu {{val}} preço promocional deve ser {{val3}}{{val2}} menor que o preço regular.',
            REGULARPRICE_MAXIMUM: 'Meu {{val}} preço promocional deve ser {{val3}}{{val2}} acima do preço regular.',
            TRUCKPRICE_MINIMUM: 'Meu preço de promoção {{val}} deve ser {{val3}}{{val2}} menor que o preço do caminhão.',
            TRUCKPRICE_MAXIMUM: 'Meu preço de promoção {{val}} deve ser {{val3}}{{val2}} porcento acima do preço da caminhonete.',
            SELECT_CONDITION: '(Escolha uma condição para a regra)',
            INSERT_VALUE: '(Insira um valor)',
            SELECT_DISCOUNT_TYPE: '(Escolha o tipo de desconto)',
          },
          REFERENCE_PRICE_TYPES: {
            PLACEHOLDER: 'Tipo de Preço de Referência',
            FIXPRICE: 'Preço Fixo',
            REGULARPRICE: 'Preço Regular',
            TRUCKPRICE: 'Preço do Caminhão',
          },
          RULE_LIMIT_TYPES: {
            PLACEHOLDER: 'Condição',
            MINIMUM: 'Mínimo',
            MAXIMUM: 'Máximo',
          },
          PROMOTION_REGULAR_PRICE_CONDITION: {
            CURRENCY: '$',
            PERCENTAGE: '%',
          },
        },
        RULE_TYPES: {
          PRICE: 'Preço',
        },
        PROMOTIONAL_PROCESS: {
          TABS: {
            MAINDATA: 'Dados principais',
            TASKSTAB: 'Tarefas',
            TAB_ERROR: 'A aba "{{val}}" contém erros ou campos incompletos.',
            TASKSTAB_ERRORS: {
              NO_TASK_WITH_BEFORE_POSITION: 'Deve haver pelo menos uma tarefa com "Antes" selecionado.',
              ACTIONABLE_EDITING_TASK_NOT_BEFORE: 'Não é possível editar uma tarefa com acionáveis se não tiver "Antes" selecionado.',
              ACTIONABLES_NOT_ALLOWED_FOR_NON_BEFORE_TASKS: 'Não é possível usar acionáveis em tarefas que não tenham "Antes" selecionado.',
            },
          },
          LIST_TITLE: 'Processos Promocionais',
          NAME: 'Nome',
          CODE: 'Código',
          MINIMUM_COVERAGE: 'Cobertura mínima %',
          TASK_QUANTITY: 'Quantidade de tarefas',
          EDIT: 'Editar',
          CANT_EDIT_TOOLTIP: 'O processo promocional não pode ser editado porque possui períodos promocionais atribuídos.',
          CANT_DELETE_TOOLTIP: 'Não é possível excluir o processo promocional, pois ele possui períodos promocionais atribuídos.',
          NEW: 'Novo processo promocional',
          WITHOUT_PERMISSION: 'O usuário não tem permissão para editar.',
          DELETE_ROW: 'Excluir processo promocional',
          DELETE_MODAL_TITLE: 'Deseja excluir o processo promocional{{val}}?',
          TASKS: {
            NAME: 'Nome',
            STARTING_DAY: 'Dia de início',
            BEFORE: 'Antes',
            AFTER: 'Depois',
            TASK_OWNER: 'Responsável',
            CONSULTANTS: 'Consultores',
            DURATION_IN_DAYS: 'Duração',
            REQUIRES_COMPLETION: 'Requer finalização',
            ACTIONABLE: 'Acionável',
            NO_ACTIONABLES: 'Não há acionáveis disponíveis',
            NEW: 'Adicionar tarefa',
            DELETE_MODAL_TITLE: 'Deseja excluir a tarefa {{val}}?',
            CLOSE_ALL: 'Fechar Tudo',
            EXPAND_ALL: 'Expandir Tudo',
            ORDER: 'Ordem',
            ORDER_TOOLTIP: 'Classificar as tarefas pela data de início',
            ACTIONABLES: {
              GeneratePOSAndPeriodReport: 'Publicação automática',
              GeneratePromotionReport: 'Envio automático de saída',
              GeneratePrintingAndLogisticsReport: 'Envio automático de relatório de promoções ',
              PublishAllApprovedNewActions: 'Envio automático de listas de produção',
              EnableActionEditingAndCreation: 'Habilitar carga e edição de ações promocionais',
            },
          },
          MAIN_DATA_TAB: 'Dados principais',
          TASKS_TAB: 'Tarefas',
        },
        MESSAGE_STRUCTURES: {
          TABS: {
            MAINDATA: 'Dados Principais',
            MESSAGESTRUCTURE: 'Estrutura de Mensagem',
            TAB_ERROR: 'A aba "{{val}}" contém erros ou campos incompletos.',
          },
          MESSAGE_STRUCTURE_WARNING: 'Já existe uma estrutura de mensagem padrão. Se desejar editá-la, os dados atuais serão sobrescritos.',
          MESSAGE_STRUCTURE_WARNING_TITLE: 'Estrutura de Mensagem Padrão',
          LIST: {
            NAME: 'Nome',
            CODE: 'Código',
            PROMOTION_PROCESS: 'Processo Promocional',
            PROMOTION_TYPE: 'Mecânica',
            COMMUNICATION_TYPE: 'Tipo de Comunicação',
            DEFAULT_STRUCTURE: 'Estrutura Padrão',
            NEW_STRUCTURE: 'Nova Estrutura',
            DELETE_STRUCTURE: 'Eliminar estrutura',
            VIEW_ONLY_INACTIVES: 'Apenas Inativos',
            DELETE_STRUCTURE_MESSAGE: 'Tem certeza que deseja eliminar a estrutura de mensagem{{val}}?',
            DELETE_STRUCTURE_IN_USE: 'A estrutura de mensagem está em uso e não pode ser eliminada.',
            DELETE_DEFAULT_STRUCTURE: 'A estrutura padrão não pode ser eliminada.',
            DELETE_DEFAULT_STRUCTURE_MESSAGE: 'A estrutura padrão não pode ser eliminada.',
            NO_MESSAGE_STRUCTURES: 'Não há nenhuma estrutura de mensagem disponível',
            CLONE_MESSAGE_STRUCTURE: 'Clonar Estrutura Promocional',
            CLONE_MESSAGE_STRUCTURE_REFERENCE: 'Você está prestes a clonar a estrutura de mensagem {{val}}?',
          },
          FORM: {
            NEW_STRUCTURE_TITLE: 'Nova estrutura de mensagem',
            NAME_INPUT: 'Nome',
            CODE_INPUT: 'Código',
            COMMUNICATION_TYPE_INPUT: 'Tipo de comunicação',
            NO_MECHANIC_TITLE: 'Selecione uma mecânica',
            NO_MECHANIC_MESSAGE:
              'Para visualizar e configurar os chips disponíveis, você deve primeiro selecionar uma mecânica promocional na aba "Dados Principais".',
            DEFAULT_MESSAGE_STRUCTURE_INPUT: 'Estrutura de mensagem padrão',
            MESSAGE_STRUCTURE_TAB: 'Estrutura de mensagem',
            MESSAGE_STRUCTURE_TAB_ERROR: 'A aba "{{val}}" contém erros ou campos incompletos.',
            EXAMPLE: 'Exemplo',
            DEFAULT_MESSAGE_STRUCTURE_INPUT_DISABLED:
              'É necessário um processo promocional e uma mecânica para selecionar uma estrutura padrão',
            CHIP_MENU_TYPES: {
              InitialSupportText: 'Ajuda Inicial',
              FinalSupportText: 'Texto de apoio final',
              Quantity: 'Quantidade',
              Items: 'Produtos',
              Connectors: 'Conexões',
              Price: 'Precificação',
              FreeText: 'Texto livre',
              VariableText: 'Texto variável',
              SupportText: 'Ajuda para selecionar',
              Tags: 'Etiquetas',
              Extra: 'Extra',
            },
            CHIP_PLACEHOLDER: {
              ITEMS: 'Selecione produtos',
              TAGS: 'Selecione o valor',
            },
          },
          ADD_CHIP_MODAL: {
            ADD_CHIP_TITLE: 'Adicionar Chip a {{val}}',
            ADD_CHIP: 'Adicionar Chip',
            CHIP_TEXT_INPUT: 'Texto do Chip',
            CHIP_TEXT_LABEL: 'Digite o texto do chip',
            CHIP_TEXT_REQUIRED: 'O texto do chip é obrigatório',
          },
          CHIP_MENU_TYPES: {
            InitialSupportText: 'Texto de apoio inicial',
            FinalSupportText: 'Texto de apoio final',
            Quantity: 'Quantidade',
            Items: 'Produtos',
            Connectors: 'Conectores',
            Price: 'Preço',
            FreeText: 'Texto livre',
            VariableText: 'Texto variável',
            SupportText: 'Texto de apoio a selecionar',
            Tags: 'Etiquetas',
          },
        },
      },
      CAMPAIGNS_LIST: {
        ROUTE: 'Promoções',
        TITLE: 'Campainhas',
        TITLE_PROMOTIONAL_PERIOD: 'Período promocional',
        NEW_CAMPAING_BTN: 'Nova campanha',
        NEW_PROMOTIONAL_PERIOD: 'Novo período promocional',
        NAME: 'Nome',
        CODE: 'Código',
        ACTIONS: '# Ações',
        FROM: 'A partir de',
        TO: 'Até',
        STATE: 'Status',
        USER: 'Usuário',
        ACTIONSCOUNT: '# Ações',
        LAST_MOD: 'Última Modificação.',
        FULLSCREEN_TTIP: 'Abrir',
        EXITFULLSCREEN_TTIP: 'Diminuir',
        EXPORT_TTIP: 'Exportar',
        IMPORT_TTIP: 'Importar',
        PRINT_TTIP: 'Imprimir',
        TITLE_FORM: 'Nova Campanha',
        SAVE_BTN: 'Salvar',
        BASIC_INFORMATION_TAB: 'Dados Principais',
        CODE_INPUT: 'Código',
        NAME_INPUT: 'Nome',
        FROM_TTIP: 'Data a partir de',
        TO_TTIP: 'Data até',
        DESCRIPTION_INPUT: 'Descrição',
        STATUS_STORES: 'Todas',
        STATUS_HISTORY: 'História',
        STATUS_VIGENT: 'Em vigor',
        STATUS_FUTURE: 'Futuro',
        STATUS_NOTVALID: 'Invalido',
        STATUS_EMPTY: 'Invalido',
        INVALID_TO_DATE: 'Deve ser maior que a data De e estar no intervalo de datas da campanha',
        INVALID_FROM_DATE: 'Deve ser menor que a data Até e estar no intervalo de datas da campanha',
        INVALID_TO_DATE_PROMOTIONAL_PERIOD: 'Deve ser maior que a data Desde e estar no intervalo de datas do período promocional',
        INVALID_FROM_DATE_PROMOTIONAL_PERIOD: 'Deve ser inferior à data Até e estar no intervalo de datas do período promocional',
        INVALID_TO_DATE_CAMPAING: 'Deve ser maior que a data de',
        INVALID_FROM_DATE_CAMPAING: 'Deve ser menor que a data Até',
        NAME_TTIP: 'Clique aqui para visualizar ações associadas',
        ACTIONS_TTIP: 'Quantidade de Ações',
        LAST_MOD_TTIP: 'Última modificação',
        SEE_ACTIONS: 'Ações',
      },
      CAMPAIGNS_EDIT: {
        SAVE_BTN: 'Salvar',
        BASIC_INFORMATION_TAB: 'Dados Principais',
        CODE_INPUT: 'Código',
        NAME_INPUT: 'Nome',
        FROM: 'A partir de',
        INVALID_TO_DATE_CAMPAING: 'Deve ser maior que a data de',
        INVALID_FROM_DATE_CAMPAING: 'Deve ser menor que a data Até',
        TO: 'Há até',
        DESCRIPTION_INPUT: 'Descrição',
        TITLE_FORM: 'Nova Campanha',
        TITLE_FORM_PROMOTIONAL_PERIOD: 'Novo Período de Promoção',
      },
      ACTIONS_LIST: {
        EXPORT_TTIP: 'Exportar',
        FILTER_TTIP: 'Filtro',
        DELETE_TTIP: 'excluir',
        DELETE: 'excluir',
        TITLE: 'Lista de ações promocionais',
        NEW_ACTION: 'Ação Promocional Nova',
        EDIT_ROW_DISABLED_TOOLTIP: 'Não é possível editar um registro em processo de publicação',
        EDIT_ROW: 'Editar',
        DELETE_ROW: 'Excluir',
        REVALIDATE_ROW: 'Revalidar',
        REVALIDATING_TOOLTIP: 'Revalidar',
        SEE_DELETED_FILTERS: 'Ver Excluídos',
        SEE_CANCELLED_FILTERS: 'Ver Apenas Cancelados',
        SEE_SUGGESTED_FILTERS: 'Ver Apenas Sugestões',
        SEE_WITHOUT_POP_MATERIAL: 'Visualizar Sem Fim de Estoque',
        SEE_SUGGESTED_FILTERS_TOOLTIP: 'Ação Sugerida',
        ACTION_STATUS: 'Estado da Ação:',
        STATUS_VAL: 'Estado e Validação',
        STATUS: 'Estado',
        ACTION_STATUS_VALIDATION: 'Estado de Validação:',
        TYPE_FILTERS: 'Filtrar por Tipo',
        CREATION_ON: 'Criatividade',
        STORES_FILTER: 'Pontos de Venda',
        ITEM_TAGS: 'Filtros de Produtos',
        STORE_TAGS: 'Etiqueta Pontos de Venda',
        ITEM_TYPE_INPUT: 'Ação do Tipo',
        ITEM_TYPE_INPUT_OXXO: 'Processo promocional',
        ITEM_TYPE_MEC_INPUT: 'Mecânica',
        NEW_ITEM_MODAL: 'Ação de Promoção Nova',
        CLONE_ROW: 'Clonar Registro',
        CANCEL_ROW: 'Cancelar registro',
        CREATE_BTN: 'Criar',
        COPY_ROW: 'Copiar Registro',
        DISABLED_CLONE_TOOLTIP: 'Sólo é possível clonar registros em estado publicado',
        REPORT_TOOLTIP: 'Baixar Relatório',
        REPORT_TOOLTIP_MORE_INFO:
          'Este relatório gera registros com base na configuração da promoção.\nPara gerar os registros, é necessário ter os seguintes campos preenchidos: período, espaços, alcance de lojas e produtos, e configuração do desconto e cobertura aprovada.',
        ACTIONS: {
          ROUTE: 'Ofertas',
          TITLE: 'Ações',
          FILTER_TTIP: 'Filtro',
          FULLSCREEN_TTIP: 'Abrir',
          EXITFULLSCREEN_TTIP: 'Diminuir',
          NAME: 'Nome',
          CODE: 'Código',
          TYPE: 'Mecânica',
          LIFT: 'Lift %',
          BRAND: 'Brand',
          NONE: 'Nenhum',
          TO: 'Há até',
          SUPPLIES_LAST: 'Hasta agotar stock',
          USER: 'Usuário',
          LAST_MOD: 'Última modif.',
          STATE: 'Status',
          PROMOTIONAL_SPACES: 'Espaços Promocionais',
          PROMOTIONAL_MATERIAL: 'Material Promocional',
          EDIT_PROMOTIONAL_SPACES: 'Editar Material Promocionais',
          EDIT_VALIDATIONS: 'Editar validações de negócios',
          LIST_PROMOTIONAL_SPACES: 'Espaços promocionais selecionados:',
          VALIDATION_STATE: 'Estado de Validação',
          VALIDATION_TYPES: 'Tipos de Validação',
          VALIDATION_TYPE_VALUES: {
            COVERAGE: 'Cobertura',
            MAX_SLOTS: 'Máximo de Espaços',
            FIX_AND_REGULAR_PRICE: 'Preço Fixo e Regular',
            STORES_AND_PROMOTIONAL_SPACE: 'Lojas e Espaços Promocionais',
            REFERENCE_PRICE: 'Preço de Referência',
            FIX_PRICE_EXCEPTIONS: 'Exceções de Preço Fixo',
            PROMOTIONAL_MESSAGE: 'Mensagem Promocional',
            GIFT_PRICE: 'Preço Regular do Presente vs Valor Extra',
          },
          VALID_TO_PUBLISH: 'Pronto para Publicação',
          TYPE_OP1: 'Lembre-se de pagar R$ {B}',
          TYPE_OP2: 'Desconto Direto',
          TYPE_OP3: 'Desconto por Quantidade',
          METHODTYPE: 'Método do tipo',
          DISCOUNTTYPE: 'Tipo de Desconto',
          STOREQUANTITY: '# Pontos de Venda',
          ESTIMATEDSALE: 'Venda estimada',
          FREQUENCYTYPE: 'Frequência do tipo',
          FROM: 'A partir de',
          FROM_TTIP: 'Data a partir de',
          TO_TTIP: 'Data até',
          PROMOTINOAL_PERIOD: 'Período Promocional',
          PROMOTIONAL_LOG: 'Registro de Promoções',
          PROMOTIONAL_PERIOD_CODE: 'Código do Período Promocional',
          EXTERNAL_CODE: 'Código Externo',
          ONLY_ACTIVE_PERIODS: 'Apenas períodos ativos',
          NO_ACTIVE_PERIODS: 'Não há períodos ativos.',
          NO_ACTIVE_PERIODS_IN_SELECTION: 'Atualmente não há períodos promocionais ativos para o ano e processo selecionados.',
          NO_ACTIVE_PERIODS_IN_SELECTION_MORE_INFO:
            'Se precisar fazer alterações, recomendamos:<br><ul> <li> Revisá o Calendário e verifique as datas da tarefa que inclua a opção "Habilitar envio e edição de ações promocionais" </li> <br> <li> Entre em contato com um <b>usuário administrador</b> ou com o <b>papel responsável</b> para ajustar as datas, se necessário.</li> </ul>',
          NAVIGATE_TO_CALENDAR: 'Ir para o Calendário',
          CANT_EDIT_VALIDATIONS:
            'As validações só podem ser modificadas quando o período estiver ativo. <br><br> Se precisar fazer alterações, recomendamos entrar em contato com um <b>usuário administrador</b> ou com o <b>papel responsável</b> para solicitar uma exceção, se necessário.',
          VALIDATION_TYPES_VALUES: {
            VALIDATION_TYPE: 'Tipo de Validação',
            VALIDATION_TYPE_VALUES: 'Valores de Validação',
            VALIDATION_TYPE_VALUES_VALUES: 'Valores de Validação',
            VALIDATION_TYPE_VALUES_VALUES_VALUES: 'Valores de Validação',
            VALIDATION_TYPE_VALUES_VALUES_VALUES_VALUES: 'Valores de Validação',
          },
          PROMOTIONAL_SPACE: 'Espaços promocionais',
        },
        TYPE: {
          DISCOUNT: 'Desconto',
          BUYAPAYB: 'Leve A Pague B',
          BUYAGETDISCOUNTINXUNIT: 'Obter Desconto por Unidade',
          SURCHARGE: 'Sobretaxa',
          FIXPRICE: 'Preço Fixo',
          GIFT: 'Presente',
          WHOLESALER: 'Atacadista',
          IMAGECOMMUNICATION: 'Comunicação de Imagem',
        },
        TYPE_DEC: {
          DISCOUNT: 'Permite definir um valor monetário ou percentual que será aplicado, reduzindo o preço final pago pelo cliente.',
          BUYAPAYB: 'Desconto onde A é a quantidade de unidades para compra pelo cliente e B as unidades a serem pagas.',
          BUYAGETDISCOUNTINXUNIT: 'Aplique desconto em um número de unidades dentro de uma quantidade mínima para compra do mesmo produto.',
          SURCHARGE: 'Permite definir um valor monetário ou percentual que será adicionado ao preço final pago pelo cliente.',
          FIXPRICE: 'Especifique o configure o preço para ser pago levantando uma quantidade específica.',
          GIFT: 'Permite definir um produto de presente ao comprar outros produtos, um mínimo de compra e/ou estabelecendo preço do produto presente.',
          WHOLESALER: 'Distribuidor',
          IMAGECOMMUNICATION: 'Destaque novos produtos ou o preço regular tão atraente',
        },
        METHODTYPE: {
          ACTIVATEONLYDURINGPROMOTION: 'Apenas disponível durante a promoção',
          ACTIVATEINDEFINITELY: 'Ativo Indefinidamente',
          DONOTACTIVATE: 'No Ativar Produtos',
        },
        DISCOUNTTYPE: {
          ABSOLUTEVALUE: 'R$',
          PERCENTAGE: '%',
        },
        FREQUENCYTYPE: {
          EVERYDAY: 'Dia a Dia',
          CERTAINDAYSOFTHEWEEK: 'Dias da Semana Especificados',
          CERTAINDAYSOFTHEMONTH: 'Dias específicos do mês',
        },
        CLONE: {
          MODAL_CONTENT:
            'Definir nome e código interno para a nova promoção. Serão copiados de {{val}} ({{val2}}) todos os pontos já existentes, tendo a possibilidade de edição.',
          CREATE_BTN: 'Clonar',
          CANCEL: 'Cancelar',
        },
        CANCEL: {
          MODAL_CONTENT:
            'A promoção {{val}} ({{val2}}) será cancelada. Todo seu conteúdo ficará desabilitado para modificações e a promoção não terá validade',
          CANCEL_REASON: 'Motivo do cancelamento',
          CANCEL_OBSERVATION: 'Observação',
          CREATE_BTN: 'Aceitar',
          CANCEL: 'Fecher',
        },
      },
      ACTIONS_TYPES: {
        Discount: 'Desconto Direto',
        BuyAPayB: 'Leve A Pague B',
        BuyAGetDiscountInXUnit: 'Obter Desconto por Unidade',
        Surcharge: 'Sobretaxa',
        FixPrice: 'Preço Fixo',
        Gift: 'Presente',
        Wholesaler: 'Atacadista',
        ImageCommunication: 'Comunicação de Imagem',
      },
      ACTIONS_EDIT: {
        TEST: 'TEST',
        SAVE: 'Salvar',
        PUBLISH: 'Publishar',
        CANCEL_ACTION: 'Cancelar',
        OK: 'Ok',
        WARNING_DOWNLOAD: 'É necessário ter apenas um período promocional selecionado nos filtros.',
        WARNING_SAVE: 'Precisa salvar as alterações atuais.',
        WARNING_PUBLISH: 'Precisa republicar para que as alterações salvas tenham efeito.',
        NOVALID_PUBLISH_ADVICE: 'O próximo painel não é válido:',
        PROMOTION_EDIT_DISABLED: 'A ação promocional só pode ser modificada quando o período estiver ativo.',
        BASIC_INFORMATION_TAB: 'Dados Principais',
        ACTIVATION_TAB: 'Ativação',
        LOADING: 'Cargando...',
        SCOPE_OF_ITEMS: 'Abrangência de Produtos',
        PAYMENTMETHODS: 'Pagamentos',
        CUSTOMFIELDS: 'Informação Adicional',
        SCOPE_OF_STORES: 'Ponto de Venda Reach',
        GIFT_ITEM: 'Produtos de Presente',
        GIFT_ITEM_TAB: 'Abrangência de Produtos de Presente',
        NEW_ITEM_BTN: 'Ação de Promoção Nova',
        PUBLISH_CONFIRM:
          'Há até o término do processo de validação para poder alterar a promoção novamente.<br><br><b>Você está certo ao querer Publicar?</b>',
        PUBLISH_CONFIRM_TITLE: 'Confirmação de Publicação',
        PUBLISHING_WARNING: 'Item em processo de publicação, tente novamente daqui a alguns minutos.',
        PUBLISH_LONG_TIME: 'A publicação deste Produto pode levar alguns minutos, ao término você será informado com uma notificação.',
        INVALID_TO_TIME: 'Deve ser maior que Hora de Início',
        INVALID_FROM_TIME: 'Deve ser menor que o horário Até',
        STRATEGY_ATTR_TITLE: 'Selecção por Atributo (Dinâmica)',
        STRATEGY_ATTR_MSG:
          'Os atributos são selecionados para definir o escopo dos produtos. Se houver alterações no escopo, o impacto dessa configuração é realizado automaticamente e não há necessidade de modificá-lo.',
        STRATEGY_PROD_TITLE: 'Selecção por produto',
        STRATEGY_PROD_MSG: 'Precisarão os produtos um por um explicitamente.',
        STRATEGY_ATTR_TITLE_STORE: 'Selecção por Atributo (Dinâmica)',
        STRATEGY_ATTR_MSG_STORE:
          'Os atributos são selecionados para definir o escopo dos pontos de venda. Se houver alterações no escopo, o impacto dessa configuração é realizado automaticamente e não há necessidade de modificá-lo.',
        STRATEGY_STORE_TITLE_STORE: 'Selecção por pontos de venda',
        STRATEGY_STORE_MSG_STORE: 'Pontos de Venda devem ser selecionados explicitamente um por um.',
        CLIPBOARD_STORE_TITLE: 'Pegar pontos de venda do clipboard',
        CODE_AND_DESCRIPTION_INPUT: 'Código / Descrição',
        CLIPBOARD_PRODUCT_TITLE: 'Pegar produtos do clipboard',
        DELETE_TIME_RANGE: 'Borrar Intervalo de Tempo',
        ADD_TIME_RANGE: 'Adicionar Intervalo de Tempo',
        OVERLAP_TIME_RANGE: 'Intervalo de Tempo Superposto',
        SAVE_LONG_TIME: 'Confirmar Salvamento',
        SAVE_OBSERVATION: 'Observações',
        SAVE_LONG_TIME_MSG_A:
          'Salvar esta promoção pode levar alguns minutos. Ela será validada e você será notificado quando o processo for concluído.',
        SAVE_LONG_TIME_MSG_B:
          'Até que o processo de validação seja concluído, a promoção não poderá ser modificada novamente.<br><br><b>Tem certeza de que deseja Salvar?</b>',
        SAVE_LONG_TIME_MSG_C: 'Até que o processo de validação seja concluído, a promoção não poderá ser modificada novamente.',
        SAVE_LONG_TIME_MSG_D: 'Tem certeza de que deseja salvar?',
        SAVE_PVD_MSG:
          'Eu concordo que minha ação promocional se aplique a todos os meus <br> produtos e pontos de venda. (Estou ciente de que isso pode resultar em um tempo de espera maior no processo de validação.)',
        SAVE_STORE_SCOPE_PVD_MSG:
          'Eu concordo que minha ação promocional se aplique a todos os meus <br> pontos de venda. (Estou ciente de que essa situação pode resultar em um tempo de espera maior no processo de validação.)',
        SAVE_ALL_ITEMS_SELECTED_WARNING:
          'O alcance do produto definido corresponde a 100% dos produtos, defina um escopo específico para salvar.',
        PROCESS_WARNING_TITLE: 'A ação requerida não pode ser completada',
        PROCESS_WARNING_MSGLONGTIME: 'A publicação e/ou salvamento não podem ser concluídos pelos seguintes motivos:',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_1:
          'A promoção está em Processo de Validação, portanto não é possível salvar ou publicar até que seja concluído.',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_2: 'A promoção está em estado de Validação Rejeitada, portanto não é possível publicar.',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_3: 'A promoção está em estado de Validação Cancelada, portanto não é possível publicar.',
        PROCESS_WARNING_MSGLONGTIME_EXTEND_4:
          'A promoção está pendente de Ação Requerida, portanto não é possível publicar até que a ação seja resolvida.',
        COVERAGE_TITLE: 'Cobertura',
        MAIN_DATA: {
          NAME: 'Nome',
          CODE: 'Código',
          EXTERNAL_CODE: 'Código Externo',
          MESSAGE: 'Mensagem do Bilhete',
          REGENERATE: 'Regenerar',
          REGENERATE_TOOLTIP: 'Uma mensagem é gerada com os primeiros {{val}} caracteres do nome da ação promocional, excluindo os preços.',
          INTERNAL_CODE: 'Código Interno',
          VALIDATION_CODE2: 'O código "{{val}}" já existe.',
          SINCE_INPUT: 'A partir de',
          TO_INPUT: 'Há até',
          OBSERVATION: 'Observação',
          TITLE_FRECUENCY: 'Frequência',
          TIME_FROM: 'Horário de Funcionamento',
          TIME_TO: 'Horário Até',
          CAMPAING: 'Campanha',
          PROMOTIONAL_PERIOD: 'Período Promocional',
          SET_PROMOTIONAL_PERIOD: 'Ao selecionar ou modificar, serão carregadas as datas do período de promoção escolhido',
          PROMOTIONAL_MATERIAL: 'Material Promocional',
          GIFT_ITEM: 'Produto de Presente',
          ACCUMULATE_ACTIONS: 'Pode ser acumulado com outras ações',
          GIFT_ITEM_POPOVER_MSG: 'Pode ser selecionado um produto de presente único, existente no módulo Item Master',
          GIFT_ITEM_NEW: 'Novo Produto de Presente',
          GIFT_ITEM_NEW_POPOVER_MSG:
            'Se o produto do presente não deve ser gerenciado pelo Módulo Item Master, pode-se informar seu nome neste campo.',
          SELECTTIMERANGE: 'Ação ativa em 24h do dia',
          SELECTTIMERANGE_TEXT:
            'Se a opção está ativada, a promoção terá vigência 24 horas por dia. Caso contrário, é necessário definir um intervalo horário diário para indicar o período em que a promoção estará disponível.',
          PLANOGRAMS_WARNING_PRODUCT_SCOPE: 'Selecione o Escopo do Produto para poder editar.',
          PLANOGRAMS_WARNING_STORE_SCOPE: 'Selecione o Escopo da Loja para poder editar.',
          PLANOGRAMS_WARNING_SAVE: 'Salve as alterações para poder editar.',
          PLANOGRAMS_WARNING_NO_PLANOGRAMS: 'Não há planogramas no escopo de lojas selecionado.',
          PLANOGRAMS_WARNING_ALL_ITEMS: 'Defina um escopo específico de produtos para obter o material promocional disponível.',
          PLANOGRAMS_WARNING_MAIN_DATA: 'Preencha os campos obrigatórios para poder salvar as alterações e editar.',
          PLANOGRAMS_WITHOUT_POP_MATERIAL: 'Sem material promocional',
          PLANOGRAMS_DELETED: '{{val}} materiais promocionais previamente selecionados não estão mais disponíveis.',
          PERIOD_WARNING_INVALID_FROM_TODAY:
            'O período promocional não está ativo no momento. Se precisar fazer alterações, recomendamos entrar em contato com um <b>usuário administrador</b> ou com o <b>papel responsável</b> para solicitar uma exceção, se necessário.',
          PERIOD_WARNING_INVALID_FROM_TASK: 'A primeira tarefa de planejamento para o período selecionado deveria ter começado em',
          PERIOD_WARNING_INVALID_FROM_TO: 'A data de início não pode ser posterior à data de término',
          ESTIMATEDSALE: 'Venda estimada',
          CHANGE_REASON: 'Motivo da mudança',
          TICKET_MESSAGE: {
            MODAL_TITLE: 'Deseja regenerar a mensagem do ticket?',
            PRICE: 'Preços não são permitidos na mensagem.',
            SPECIALCHARACTERS: 'Caracteres especiais não são permitidos na mensagem.',
            DOUBLESPACES: 'Espaços duplos não são permitidos na mensagem.',
            MAXCHARACTER: 'Você atingiu o número máximo de caracteres permitido para a mensagem.',
          },
        },
        VALIDATIONS: {
          VALIDATIONS_TITLE: 'Validações',
          ERROR_VALIDATION:
            'Ocorreu um erro ao executar a validação, tente REVALIDAR. Se o erro persistir, por favor, entre em contato com o suporte',
          COVERAGE_TOOLTIP:
            'Para aprimorar esta validação, sugerimos ajustar o escopo de lojas ou produtos, verificando a cobertura por meio de etiquetas antecipadamente e analisando o estado atual da cobertura por diferentes conjuntos de pontos de venda.',
          MAX_SLOTS_TOOLTIP:
            'Para aprimorar esta validação, sugerimos ajustar o escopo de lojas ou modificar os materiais promocionais utilizados.',
          FIX_AND_REGULAR_PRICE_TOOLTIP:
            'Para aprimorar os resultados desta validação, sugerimos ajustar o preço promocional a partir da guia de ativação.',
          STORE_AND_PROMOTIONAL_SPACE:
            'Para aprimorar esta validação, sugerimos ajustar o escopo de lojas ou modificar os materiais promocionais utilizados.',
          FIX_PRICE_EXCEPTIONS: 'Para melhorar esta validação, sugerimos ajustar as exceções de preços no importador de exceções.',
          REFERENCE_PRICE: 'Para melhorar esta validação, sugerimos ajustar o preço promocional na aba de ativação.',
          ACTION_BUTTON_DISABLED_TOOLTIP: 'As alterações só são permitidas quando a ação promocional está publicada.',
          PROMOTIONAL_MESSAGE_TOOLTIP: 'Para melhorar essa validação, sugerimos ajustar a mensagem promocional na aba escopo do produto.',
          TAB_TITLE: 'Validações de Negócio',
          TAB_DESCRIPTION:
            'As validações de negócio são usadas para garantir que a ação promocional atenda aos critérios necessários para execução. No caso de uma validação encontrar erros, ela pode ser aprovada ou rejeitada ao publicar ou modificar preventivamente os dados envolvidos para obter novos resultados. Através de relatórios, podemos obter informações detalhadas sobre as falhas, e se todos os dados necessários não estiverem disponíveis para realizar a validação, ela será relatada como incompleta. É necessário ter todas as validações aprovadas e validadas para obter relatórios produtivos.',
          storesAndPromotionalSpace: {
            VALIDATION_NAME: 'Escopo da Loja vs Material Promocional',
            VALIDATION_DESCRIPTION:
              'Valida se alguma loja configurada para esta promoção não possui os material promocionais selecionados.',
            VALIDATION_ERROR: '{{val}} lojas configuradas para esta promoção não possuem alguns dos material promocionais selecionados.',
            VALIDATION_SUCCESS: 'Todos os material promocionais selecionados estão disponíveis nas lojas da promoção.',
            VALIDATION_INCOMPLETE:
              'Não é possível determinar o impacto nas lojas porque os material promocionais ou o escopo das lojas para esta promoção não foram selecionados.',
          },
          MaxSlots: {
            VALIDATION_NAME: 'Quantidade Máxima de Promoções por Material Promocional',
            VALIDATION_DESCRIPTION:
              'Valida se o limite máximo de promoções suportadas em algum dos materiais promocionais selecionados foi excedido.',
            VALIDATION_ERROR: 'Esta promoção excede a capacidade máxima suportada por {{val}} espaço-lojas.',
            VALIDATION_SUCCESS: 'A promoção foi atribuída com sucesso aos materiais promocionais selecionados.',
            VALIDATION_INCOMPLETE:
              'A quantidade máxima de promoções não foi calculada porque os materiais promocionais não foram selecionados.',
          },
          FixAndRegularPrice: {
            VALIDATION_NAME: 'Preço Promocional vs Preço Regular',
            VALIDATION_DESCRIPTION:
              'Valida que o preço promocional fixado seja menor que o preço regular naquela loja, garantindo que seja verdade para todas as lojas onde esta promoção se aplica.',
            VALIDATION_ERROR: 'O preço promocional foi encontrado maior ou igual ao preço regular em {{val}} produto-lojas.',
            VALIDATION_SUCCESS: 'O preço promocional é menor que o preço regular em todos os produto-lojas desta promoção.',
            VALIDATION_INCOMPLETE:
              'Não é possível determinar se o preço promocional está correto porque produtos ou lojas em seus respectivos escopos não foram selecionados.',
          },
          FixPriceExceptions: {
            VALIDATION_NAME: 'Exceção de preço vs preço regular',
            VALIDATION_DESCRIPTION:
              'Valida que o preço promocional definido no importador de exceções de preço seja menor que o preço regular para cada loja do escopo de lojas definido no importador.',
            VALIDATION_ERROR:
              'O preço promocional é maior ou igual ao preço regular em {{val}} produtos-lojas nas exceções desta promoção.',
            VALIDATION_SUCCESS: 'O preço promocional é menor que o preço regular em todos os produtos-lojas desta promoção.',
            VALIDATION_INCOMPLETE:
              'Para validar esta ação promocional é necessário definir escopo de produtos, escopo de lojas e importar pelo menos 1 exceção de preço corretamente.',
          },
          Coverage: {
            VALIDATION_NAME: 'Cobertura Mínima',
            VALIDATION_DESCRIPTION: 'Valida se a cobertura mínima é alcançada.',
            VALIDATION_ERROR: 'A cobertura mínima definida de {{val}}% não é atingida.',
            VALIDATION_SUCCESS: 'A cobertura mínima definida de {{val}}% é atingida.',
            VALIDATION_INCOMPLETE:
              'A cobertura não foi calculada porque produtos ou lojas em seus respectivos escopos não foram selecionados.',
          },
          ReferencePrice: {
            VALIDATION_NAME: 'Preço promocional vs Preço de caminhão',
            VALIDATION_DESCRIPTION:
              'Valida que o preço promocional cumpre com a regra de preços definida, garantindo que se aplique a todas as lojas onde esta promoção é válida.',
            VALIDATION_ERROR:
              'O preço promocional não cumpre com a regra de preço de caminhão para todos os produtos-lojas desta promoção.',
            VALIDATION_SUCCESS: 'O preço promocional cumpre com a regra de preço de caminhão para todos os produtos-lojas desta promoção.',
            VALIDATION_INCOMPLETE:
              'Não é possível determinar se o preço promocional está correto porque precisa ser carregado na aba de ativação.',
          },
          PromotionalMessage: {
            VALIDATION_NAME: 'Mensagem Promocional',
            VALIDATION_DESCRIPTION: 'Valida se a mensagem promocional está correta.',
          },
          ADDITIONAL_GIFT_PRICE_TOOLTIP: 'Valida que o preço regular do produto presente seja maior que o valor extra.',
          AdditionalGiftPrice: {
            VALIDATION_NAME: 'Preço Regular do Presente vs Valor Extra',
            VALIDATION_DESCRIPTION:
              'Valida que, em todas as lojas do alcance, o preço regular do produto presente multiplicado pela sua quantidade seja maior que o Valor Extra.',
            VALIDATION_ERROR:
              'Em pelo menos uma loja do alcance, o preço regular do produto presente multiplicado pela sua quantidade é menor ou igual ao Valor Extra.',
            VALIDATION_SUCCESS:
              'Em todas as lojas do alcance, o preço regular do produto presente multiplicado pela sua quantidade é maior que o Valor Extra.',
          },
        },
        DOWNLOAD_VALIDATION_REPORT: 'Baixar Relatório de Validações',
        VALIDATION_NO_DATA: 'Não há dados suficientes para validar',
        ACTIVATION: {
          ASSORTMENTMETHOD: 'Comportamento de sortimento',
          CHANNELCODES: 'Canais de Vendas',
          LOYALTYPROGRAMCODES: 'Loyalty Programs',
          LOYALTYPROGRAMCODES_GLOBAL: 'Restrição para Programas de Fidelidade',
          LOYALTYPROGRAMCODE: 'Programa de Fidelidade',
          LOYALTY_PROGRAM_CODE_EXC: 'Programa de Fidelidade Excepcional',
          LOYALTY_PROGRAM_MODAL_ADVICE_TITLE: 'Deseja excluir as exceções de preço carregadas?',
          LOYALTY_PROGRAM_MODAL_ADVICE_SUBTITLE:
            'A ação promocional possui exceções de preço que serão excluídas caso sejam aplicadas restrições para o programa de fidelidade.',
          BUY_A_QUANT: 'Lembre-se',
          BUY_B_QUANT: 'Pegue',
          BUY_B_QUANT_DESC: 'Quantidade para desconto',
          MIN_QUANT: 'Quantidade',
          MIN_QUANT_DISCOUNT: 'Unidades a comprar',
          BUY_B_QUANT_DESC_DISCOUNT: 'Aplicar desconto a',
          SAMEITEM: 'Mesmo Produto',
          UNTILSTOCKLAST: 'Enquanto durarem os estoques',
          MIN_VALUE: 'Peso Mínimo $',
          MIN_VALUE_TICKET: 'Valor Mínimo do Ticket Total $',
          DISCOUNT: 'Desconto',
          LOYALTY_DISCOUNT: 'Desconto Excepcional por Fidelidade',
          LOYALTY_FIXED_PRICE: 'Preço Fixo Excepcional por Fidelidade',
          SURCHARGE: 'Acréscimo',
          DISCOUNTTYPE: 'Tipo de Desconto',
          SURCHARGETYPE: 'Tipo de Taxa Adicional',
          FIXPRICE: 'Preço Fixo $',
          FIXPRICE_TOOLTIP:
            "Indica o preço promocional para a quantidade total de produtos carregados. Exemplo: Se a ação é '3 x R$40', a Quantidade Mínima de produtos é 3 e o preço fixo a ser aplicado é o final, neste caso, R$40.",
          SHIPPINGDISCOUNT: 'Desconto no Frete %',
          MAXIMUMDISCOUNTVALUE: 'Limite de Desconto $',
          COMMUNICATIONTYPE: 'Tipo de Comunicação',
          COMMUNICATIONDISPLAY: 'Ordem de Comunicação',
          COMMUNICATIONDISPLAY_TOOLTIP: 'Ordem de Comunicação: Permite definir a ordem em que o texto é gerado para a lista de produção.',
          EXCEPTIONAL_FIXED_PRICE_TITLE: 'Carga de Preço Fixo Excepcional',
          EXCEPTIONAL_DISCOUNT_TITLE: 'Carga de Desconto Excepcional',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE: 'Você pode carregar exceções de preços através do importador',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_NO_ID:
            'Você pode carregar exceções de preços através do importador. É necessário salvar as alterações atuais.',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_NO_ID_ALT:
            'Você pode carregar exceções de preços através do importador. Permite carregar exceções a nível de loja ou etiqueta (somente um dos dois níveis pode ser utilizado para todo o importador). Cada importação substitui a importação anterior. É necessário salvar as alterações atuais.',
          EXCEPTIONAL_DISCOUNT_SBUTITLE: 'Você pode carregar exceções de descontos através do importador',
          EXCEPTIONAL_DISCOUNT_SBUTITLE_ALT:
            'Você pode carregar exceções de descontos através do importador. Permite carregar exceções a nível de loja ou etiqueta (somente um dos dois níveis pode ser utilizado para todo o importador). Cada importação substitui a importação anterior.',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_ALT:
            'Você pode carregar exceções de preços através do importador. Permite carregar exceções a nível de loja ou etiqueta (somente um dos dois níveis pode ser utilizado para todo o importador). Cada importação substitui a importação anterior.',
          EXCEPTIONAL_DISCOUNT_SBUTITLE_NO_ID:
            'Você pode carregar exceções de descontos através do importador. É necessário salvar as alterações atuais.',
          LOYALTYPROGRAMCODES_GLOBAL_TOOLTIP:
            'Restringir opcionalmente a execução da ativação para o(s) programa(s) de fidelidade selecionado(s).',
          COMMUNICATIONTYPE_TOOLTIP:
            'Em caso de selecionar <b>"Comunicar Desconto"</b> será indicado o percentual de desconto que será aplicado ao produto pela compra.<br>Se você seleciona <b>"Comunicar Preço"</b>, obterá o preço final da promoção nos relatórios de promoções e impressão.<br><br><b>Ejemplo de relatório:</b><br><b>Promoção 1</b> Coca Cola 600ml com um desconto de 10% cada uma.<br><b>Promoção 2</b> Coca Cola 600ml a apenas R$ 10 cada uma na loja A e Coca Cola 600ml a apenas R$ 9 cada uma na loja B, considerando que os preços regulares podem ser diferentes em cada loja.',
          LOYALTY_DISCOUNT_TOOLTIP:
            'Permite opcionalmente conceder um valor de desconto diferente e exclusivo para o programa de fidelidade selecionado.',
          LOYALTY_FIXED_PRICE_TOOLTIP:
            'Permite opcionalmente conceder um valor de preço fixo diferente e exclusivo para o programa de fidelidade selecionado.',
          LOYALTY_FIXED_PRICE_TOOLTIP_ALT:
            'Indica o preço promocional para o programa de fidelidade selecionado, respeitando a quantidade total de produtos carregados. Exemplo: Se a ação é "3 x R$30 para o programa de fidelidade", a Quantidade Mínima de produtos é 3 e o preço fixo excepcional por fidelidade a ser carregado é o final, neste caso, R$30. Esse preço se aplica a todas as lojas sem exceção.',
          ActionsV2_communicationType: {
            CommunicateDiscount: 'COMUNICAR DESCONTO',
            CommunicatePrice: 'Precificar Comunicação',
          },
          ActionsV2_communicationDisplay: {
            CommunicateFirstValue: 'Valor Promocional + Nome do Produto',
            CommunicateFirstName: 'Nome do Produto + Valor Promocional',
          },
          COMMUNICATION: {
            PROMOTIONAL_MESSAGE: 'Mensagem promocional',
            PROMOTIONAL_MESSAGE_TOOLTIP:
              'Este campo permite visualizar rapidamente um exemplo da mensagem promocional obtida em relatórios produtivos',
            PROMOTIONAL_MESSAGE_WARNING:
              'A ação promocional não apresenta dados suficientes para gerar a mensagem promocional, complete todos os dados necessários',
            SUPPORT_TEXT: 'Texto de apoio',
            SUPPORT_TEXT_TOOLTIP: ' ',
            COMMUNICATION_COMBO_MODAL_TITLE: 'Selecione informações para cada bloco',
          },
          IMPORT_LIST: {
            valuePrice: 'Preço Fixo $',
            valueDiscount: 'Desconto',
            tagValueId: 'Etiqueta {{val}}',
            storeId: 'Loja',
            storeName: 'Loja',
            storeScope: 'Alcance de pontos de venda',
            regularPrice: 'Preço Regular $',
            discount: 'Desconto Estimado %',
            comboId: 'Combo ID',
          },
          COMBOS: {
            DELETE_BLOCK: 'Excluir bloco',
            EDIT_ITEMS: 'Editar produtos',
            EDIT_NAME_STAGGERED: 'Ao editar o nome deste combo, a alteração será aplicada a todos os combos.',
            EDIT_NAME_MIXED: 'Editar nome',
            EDIT_QUANTITY: 'Editar quantidade',
            ADD_COMBO: 'Adicionar combo',
            ADD_STAGGERED_COMBO: 'Adicionar combo escalonado',
            COMBO_ITEMS: 'Produtos{{val}}',
            COMBO_ITEMS_EDIT: 'Editar produtos',
            ADD_BLOCK: 'Adicionar bloco',
            COPY_IDS: 'Copiar IDS',
            COPY_ID: 'Copiar ID',
            EDIT_STAGGERED_COMBO: 'Editar Combo Escalonado',
            EDIT_COMBO: 'Editar Combo',
            DELETE_COMBO: 'Deseja excluir o combo?',
            CREATE_COMBO: 'Criar Combo',
            CREATE_STAGGERED_COMBO: 'Criar Combo Escalonado',
            CLONE_COMBO: 'Clone Combo',
            DELETE_BLOCK_TITLE: 'Você deseja excluir o bloco {{val}}?',
            NAME_INPUT_VALIDATION_MESSAGES: {
              DUPLICATE_NAMES: 'Os blocos não podem ter o mesmo nome.',
              PRICE: 'Preços não são permitidos no nome.',
              SPECIALCHARACTERS: 'Caracteres especiais não são permitidos no nome.',
              DOUBLESPACES: 'Espaços duplos não são permitidos no nome.',
              MAXCHARACTER: 'O máximo de caracteres permitidos para o nome foi atingido.',
              DUPLICATE_ITEMS: 'Itens duplicados não são permitidos entre blocos.',
            },
          },
          DISCOUNT_AND_REGULAR_PRICE: 'Preço regular ${{val}}. Desconto estimado {{val2}}%.',
          DISCOUNT_TOOLTIP_TITLE: 'Desconto estimado sobre preço fixo',
          DISCOUNT_TOOLTIP_DESCRIPTION:
            'Um desconto estimado é definido ao comparar o preço regular e o preço fixo. O preço regular é definido como a moda, o preço mais frequente, existente no alcance de lojas para esta promoção.<br><br> Caso a promoção inclua mais de um produto ou um combo tenha mais de um produto em cada bloco, é utilizado o menor preço moda entre os produtos participantes da ação promocional ou bloco.',
          STORES_WITHOUT_REGULAR_PRICE: 'Não há preço regular nas lojas selecionadas para calcular o desconto.',
          DISCOUNT_WARNING_MESSAGE: 'Para ver o novo desconto aplicado, é necessário salvar.',
          WITHOUT_POP_MATERIAL_TOOLTIP_TITLE: 'Sem material promocional',
          WITHOUT_POP_MATERIAL_TOOLTIP_DESCRIPTION:
            'Ativo: Não é necessário selecionar um material promocional para publicar a ação promocional, e as validações que dependem dessa informação serão automaticamente validadas. O relatório de promoções não incluirá espaço publicitário, e esta ação promocional não fará parte dos resultados dos relatórios relacionados ao material promocional.<br><br> Não ativo: É necessário selecionar pelo menos um material promocional. A ação promocional fará parte dos relatórios relacionados ao material promocional, e as validações que dependem dessa informação deverão ser verificadas.',
        },
        SCOPE_ITEM: {
          IMPORT: 'Importar',
          RADIO_SIMPLE_PRODUCT: 'Produto simples ou múltiplos',
          RADIO_MULTIPLE_PRODUCT: 'Combos',
          RADIO_STAGGERED_PRODUCT: 'Promoções Escalonadas',
          DESCRIPTION_SIMPLE_PRODUCT:
            'Selecione os produtos que participam da promoção. Escolha um único tipo ou combine como desejar. Todos os produtos terão o mesmo preço promocional.',
          DESCRIPTION_MULTIPLE_PRODUCT:
            'Crie um ou mais conjuntos de produtos que participam da promoção. Defina a quantidade e os produtos que fazem parte de cada componente.',
          DESCRIPTION_STAGGERED_PRODUCT:
            'Crie um conjunto de produtos para definir a promoção base e variantes, diferenciando apenas na quantidade de seus componentes. Cada conjunto terá um preço promocional diferente.',
          WARNING_MESSAGE:
            'Ao modificar o escopo dos produtos, o Material Promocional atribuído a esta ação promocional será removido. Você precisará reatribuí-los após salvar as alterações.',
          WARNING_IMPORTANT_MESSAGE: 'Aviso Importante:',
        },
        SCOPE_STORE: {
          IMPORT: 'Importar',
          WARNING_MESSAGE:
            'Ao modificar o escopo das lojas, os espaços promocionais atribuídos a esta ação promocional serão excluídos. Você precisará reatribuí-los após salvar as alterações.',
          WARNING_IMPORTANT_MESSAGE: 'Aviso Importante:',
        },
        ActionsV2_FrequencyType: {
          EveryDay: 'Dia a Dia',
          CertainDaysOfTheWeek: 'Dias da Semana Especificados',
          CertainDaysOfTheMonth: 'Dias específicos do mês',
        },
        ActionsV2_AssortmentType: {
          ActivateOnlyDuringPromotion: 'Apenas disponível durante a promoção',
          ActivateIndefinitely: 'Ativo Indefinidamente',
          DoNotActivate: 'No Ativar Produtos',
        },
        ActionsV2_DiscountType: {
          AbsoluteValue: 'R$',
          Percentage: '%',
        },
        PAYMENTS: {
          ADD_BLOCK: 'Agregar Método de Pagamento',
          PAYMENT_BLOCK: 'Pagamento',
          FINANCIAL_INSTITUTION: 'Instituição Financeira',
          CARD_TYPE: 'Tipo de Cartão',
          PAYMENT_BLOCK_OPT: 'Pagamento específico (opcional)',
          BANK: 'Banco',
          INSTALLMENTS: 'Taxas',
          LOYALTYPROGRAMPOINTS: 'Pontos de Fidelidade',
          LOYALTYPROGRAMPOINTSEQUIVALENCEINCASH: 'Pontuação de Fidelidade',
          SPONSORSHIP: 'Sponsorização (%)',
          PAYMENT_BLOCK_COMBO: 'Combinação de Meios de Pagamento',
          VALUE: 'Valor',
          ADDSUBCOMBINATION: 'Agregar Tipo de Pagamento',
          REMOVECOMBINATION: 'Excluir Combinação',
          REMOVESUBCOMBINATION: 'Excluir Tipo de Pagamento',
          TYPE: 'Tipo de Meio de Pagamento',
          ALL: 'Todos',
          DEBIT: 'Débito',
          CREDIT: 'Crédito',
          NONE: 'Nenhum',
          ADD_COMBINATION_BLOCK: 'Adicionar Combinação',
          HELP_PAYMENT1:
            'Se aplicará a todos os métodos de pagamento se nenhou escolhido algum método de pagamento. Se métodos de pagamento forem selecionados, eles serão necessários para ativar a promoção.',
          DUPLICATE_WARNING: 'Duplo Pagamento',
          DUPLICATE_COMB_WARNING: 'Duplicidade do Meio de Pagamento',
          PAYMENT_ALL: 'Todos os meios de pagamento',
          PAYMENT_NO_COMB: 'Painel de Pagamentos',
          PAYMENT_COMB: 'Preço do Produto Presente',
          PAYMENT_ALL_DESC: 'Ação promocional estará ativa para qualquer meio de pagamento.',
          PAYMENT_NO_COMB_DESC: 'Caso os meios de pagamento sejam selecionados, eles serão necessários para ativar a promoção',
          PAYMENT_COMB_DESC:
            "Apenas se aplica se o produto é um presente com preço adicional (por exemplo, 'leve um brownie por R$ 50 adicionais ao seu café'). Aceita uma ou várias combinações de um ou mais meios de pagamento.",
          NO_ITEMS: 'Pelo menos uma opção deve ser selecionada como meio de pagamento.',
          NO_ITEMS_COMB: 'Pelo menos uma combinação de métodos de pagamento deve ser selecionada.',
        },
        GIFT_ITEMS: {
          SIZE: 'Quantidade de Produtos',
          SIZE_HELP: 'Quantidade de produtos que serão concedidas caso a promoção seja atendida.',
          GIF_SELECTION_NO_MANUAL_ITEMS_SELECTED: 'Nenhum item selecionado',
        },
        PUBLISH_CONTENT: 'Deseja publicar os seguintes {{val}} registros selecionados?',
      },
      ACTIONS_STATUS: {
        NEW: 'Novo',
        ENDORSED: 'Aprovação',
        INFORMED: 'Informado',
        DELETED: 'Excluído',
        MODIFIED: 'Módificado',
        CURRENT: 'Publicado',
        CANCELLED: 'Cancelado',
      },
      ACTIONS_VALIDATION_STATUS: {
        APPROVED: 'Aprovado',
        VALIDATING: 'Validando',
        ACTIONREQUIRED: 'Ação Requerida',
        REJECTED: 'Rejeitado',
        PENDING: 'Pendente',
      },
      HELP: {
        QUANTITY_BUY_INPUT: "Indique as unidades (A) que o cliente irá levar. Exemplo: Se a ação for '3 x 2', aqui deve ser informado '3'.",
        QUANTITY_PAY_INPUT:
          "Indique as unidades (B) que o cliente irá pagar. É um valor menor à 'Quantidade para Comprar'. Exemplo: Se a ação for '3 x 2', aqui devem ser informadas '2'.",
        FRECUENCY_INPUT: 'Indique a que intervalo o período se repete essa ação ao longo do tempo.',
        DAYS_INPUT: 'Dias da semana em que a ação estará válida.',
        DATE_FROM_INPUT: 'Data de início da ação.',
        DATE_TO_INPUT: 'Data de término da ação.',
        TIME_FROM_INPUT: 'Daily validity time range start.',
        TIME_TO_INPUT: 'Conclusão do período diário de validade da ação.',
        TICKET_MESSAGE_INPUT: 'Descrição curta da ação que será refletida no cupom fiscal.',
        OBSERVATION_INPUT: 'Permite a entrada algum tipo de informação ou detalhe da ação.',
        UNIT_DISCOUNT_INPUT:
          'Indique o valor do desconto a ser aplicado sobre o preço regular total da promoção. Exemplo: $5 de desconto ao comprar 2 produtos A, se cada produto tem um preço regular de $10. (2x$10) -$5 de desconto. Preço promocional final $15.',
        DISCOUNT_RATE_INPUT: 'Indique se o desconto será em percentual ou em reais.',
        SURCHARGE_RATE_INPUT: 'Escolha se o acréscimo aplica como porcentagem (%) do preço ou como valor fixo ($).',
        UNIT_SURCHARGE_INPUT: 'Valor do acréscimo aplicado a cada unidade vendida.',
        MAXIMUM_DISCOUNT_INPUT:
          'Valor máximo do desconto por ação. Se o desconto calculado (% × preço) superar este teto, é recortado. Exemplo: 20% off em item de R$ 500 = R$ 100, mas com teto R$ 60 o desconto efetivo é R$ 60.',
        SHIPPING_DISCOUNT_INPUT: 'Porcentagem de desconto sobre o frete. Exemplo: 100% → frete grátis. 50% → metade do frete.',
        UNTIL_STOCK_LAST_INPUT: 'Se ativo, a ação é encerrada automaticamente quando o estoque do item na loja chegar a 0.',
        BUY_B_QUANT_DESC_INPUT_BUYAGETDISCOUNTINXUNIT:
          'Quantidade de unidades dentro do mínimo comprado que recebem o desconto. Exemplo: "Compre 3, desconto 30% em 1" → inserir 1.',
        BUY_B_QUANT_DESC_INPUT_DISCOUNT:
          'Opcional. Vazio = desconto aplica a TODAS as unidades compradas. Com um número M = desconto aplica APENAS a essas M unidades dentro da quantidade de compra.',
        DISCOUNT_UNITS_HELPER_ALL: 'Comprando {{val}} unidades, o desconto aplica a todas.',
        DISCOUNT_UNITS_HELPER_PARTIAL: 'Comprando {{val}} unidades, o desconto aplica apenas a {{val2}}.',
        SUMMARY_TITLE: 'Resumo da ação',
        SUMMARY_EMPTY: 'Preencha os campos acima para ver o resumo.',
        SUMMARY_DISCOUNT_BASE: 'Comprando <b>{{val}} unidades</b>',
        SUMMARY_FIXPRICE_BASE: 'Levando <b>{{val}} unidades</b> por <b>R$ {{val2}} total</b> (não por unidade)',
        SUMMARY_GIFT_BASE:
          'Comprando <b>{{val}} unidades</b>, o cliente acessa os produtos configurados na aba <b>Abrangência de Produtos de Presente</b>',
        SUMMARY_BUYAPAYB_BASE: 'Levando <b>{{val}} unidades</b>, paga <b>{{val2}}</b> (<b>{{val3}}</b> grátis)',
        SUMMARY_SURCHARGE_PCT: 'Aplica um acréscimo de <b>{{val}}%</b> sobre o preço',
        SUMMARY_SURCHARGE_ABS: 'Aplica um acréscimo de <b>R$ {{val}}</b> sobre o preço',
        SUMMARY_SURCHARGE_PAYMENT: 'O acréscimo aplica aos meios de pagamento indicados na aba <b>Meios de Pagamento</b>',
        SUMMARY_SAME_ITEM: 'do mesmo item',
        SUMMARY_SCOPE_MIX: 'combinando produtos do escopo',
        SUMMARY_DISCOUNT_APPLIES_PCT: 'aplica <b>{{val}}% off</b>',
        SUMMARY_DISCOUNT_APPLIES_ABS: 'aplica <b>R$ {{val}} off</b>',
        SUMMARY_DISCOUNT_TO_ALL: 'a todas as unidades',
        SUMMARY_DISCOUNT_TO_N: 'a <b>{{val}}</b> unidade(s)',
        SUMMARY_MIN_VALUE_SCOPE: 'somente se gastar <b>R$ {{val}}</b> em produtos do escopo',
        SUMMARY_MIN_VALUE_TICKET: 'somente se o ticket ultrapassar <b>R$ {{val}}</b>',
        SUMMARY_MAX_DISCOUNT: 'com teto de desconto <b>R$ {{val}}</b>',
        SUMMARY_SHIPPING: '<b>{{val}}% off</b> no frete',
        SUMMARY_UNTIL_STOCK: 'até acabar o estoque',
        SUPPLIES_LAST_CHECK: 'Mensagem informativa legal para o ponto de venda.',
        UNITS_AVAILABLE_INPUT:
          'Indique as unidades do produto da empresa disponíveis no estoque para essa ação. Mensagem informativa para fins legais para o ponto de venda.',
        DISCOUNT_VALUE_INPUT:
          'Valor total do desconto correspondente à promoção. Exemplo: Se a ação for "segunda unidade com 30% de desconto", aqui devemos inserir o número "30".',
        UNIT_DISCOUNT_PER_INPUT:
          "Indique o valor do desconto a ser aplicado em cada unidade vendida. Exemplo: Se a ação for '2ª unidade com 30% de desconto', aqui deve ser informado o número '15' que é o percentual que será aplicado de desconto sobre cada unidade vendida.",
        QUANTITY_UNITS_INPUT:
          "Indique as unidades obrigatórias que o cliente deve comprar para aplicar o desconto. Exemplo: Se a ação for '2ª unidade com 30% de desconto', aqui devemos informar o número '2' que são as unidades necessárias para que se aplique o desconto.",
        QUANTITY_UNITS_INPUT_DISCOUNT:
          'Unidades obrigatórias que o cliente deve comprar para aplicar o desconto. Exemplo: "2ª unidade com 30% de desconto" → inserir 2.',
        QUANTITY_UNITS_INPUT_FIXPRICE:
          'Quantidade de unidades incluídas no preço fixo. Exemplo: "2 unidades por R$ 100" → inserir 2. O total é R$ 100 (não R$ 100 por unidade).',
        QUANTITY_UNITS_INPUT_GIFT:
          'Unidades que o cliente deve comprar para acessar o presente. A quantidade e os produtos de presente são configurados na aba "Abrangência de Produtos de Presente".',
        QUANTITY_UNITS_INPUT_BUYAGETDISCOUNTINXUNIT:
          'Quantidade mínima de unidades do mesmo produto a comprar para que o desconto aplique sobre parte dessas unidades.',
        QUANTITY_UNITS_INPUT_IMAGECOMMUNICATION:
          'Quantidade de referência a comunicar no destaque de preço (ex. mostrar "preço por 6 unidades").',
        MINIMUM_AMOUNT_INPUT:
          "Indique a quantas unidades o unidades mínimas deve comprar o cliente para aplicar o desconto. Exemplo: Se a promoção for '15% de desconto com compra de 3 unidades', aqui devem ser informadas as unidades '3'.",
        MAXIMUM_AMOUNT_INPUT:
          'Indique as unidades máximas que o cliente pode comprar com desconto. A partir deste valor, as unidades não contarão com a promoção. Exemplo: Se a ação for “15% de desconto até 6 unidades”, aqui devemos informar o número “6”, nas unidades “7” ou subsequentes não se aplica o 15%.',
        MINIMUM2_AMOUNT_INPUT:
          'Indique o valor monetário mínimo que deve ser comprado pelo cliente (sobre o total do ticket) para que seja aplicada a promoção. Exemplo: Se a ação for “10% de desconto em compras superiores a R$ 1.000”, aqui devemos inserir o número “1.000”. Se esse valor não for alcançado, não é aplicado o desconto.',
        MAXIMUM2_AMOUNT_INPUT:
          'Indique o valor monetário máximo que pode comprar o cliente para aplicar a promoção. A partir desse montante, o excesso da compra não terá desconto. Exemplo: Se a ação é “10% de desconto em compras até R$ 1.000”, aqui devemos informar o número “1.000”. Se a compra for de R$ 1.500, os R$ 500 não têm o 10% de desconto.',
        ASSORTMENTMETHOD: 'Indique o comportamento do Estoque',
        MINIMUM_AMOUNT_INPUT_GROUP:
          'Indique o valor monetário mínimo que deve comprar o cliente (sobre os produtos atingidos) para que seja aplicada a promoção. Exemplo: Se a ação for “10% de desconto em refrigerantes a partir de R$ 1.000”, aqui devemos informar o número “1.000”. Se não for alcançado esse valor, não é aplicado o desconto.',
        SAME_ITEM: 'Ocupação de Desconto será calculada em produtos iguais.',
        COMPLETE_COVERAGE:
          'Ativar a cobertura completa gera mudanças no cálculo, indicando que a loja atende à cobertura somente se todos os produtos no escopo desta promoção estiverem ativos no sortimento da loja. Se estiver desativado, mas pelo menos um produto estiver ativo na loja, a cobertura será atendida. <br><br> Se o produto for do tipo combo, esteja ativo ou não, é necessário ter pelo menos 1 variante de cada componente do combo ativa para que a loja atenda à cobertura.',
        COVERAGE_BASED_COMMUNICATION:
          'Ativo: Os mensagens promocionais variam com cada mudança na cobertura da ação promocional nas lojas do escopo. <br><br> Inativo: Independentemente da cobertura, todas as lojas dentro do escopo recebem o mesmo mensagem promocional.',
        COMMUNICATE_REGULAR_PRICE:
          'Se ativado, os relatórios calcularão o preço regular do produto para cada loja dentro do escopo definido.<br> Se desativado, a mensagem a ser comunicada não incluirá um preço.',
      },
      PAY_METHODS: {
        PAY_METHOD_Money: 'Dinheiro',
        PAY_METHOD_LoyaltyPoints: 'Fidelidade Programa',
      },
      PRODUCT_LIST: {
        TITLE: 'Relatório de imprensa',
        DOWNLOAD: 'Baixar Relatório',
        GENERATE: 'Gerar Relatório',
        LAST: 'Último Relatório Gerado',
        PERIODS: 'Períodos',
        VENDORS: 'Impressoras',
        ERROR_REPORT: 'O relatório não pôde ser gerado corretamente',
      },
      PROMOTION_OUTPUT: {
        TITLE: 'Dados para PDV',
        DOWNLOAD: 'Baixar dados',
        GENERATE: 'Gerar dados',
        LAST: 'Último relatório gerado',
        PERIODS: 'Períodos',
        ERROR_REPORT: 'O relatório não pôde ser gerado corretamente',
      },
      LOGISTIC_REPORT: {
        TITLE: 'Relatório de Logística',
        DOWNLOAD: 'Baixar Relatório',
        GENERATE: 'Gerar Relatório',
        LAST: 'Último Relatório Gerado',
        PERIODS: 'Períodos',
        VENDORS: 'Fornecedores',
        ERROR_REPORT: 'O relatório não pôde ser gerado corretamente',
      },
      PROMOTION_REPORT: {
        TITLE: 'Relatório de Promoções',
        DOWNLOAD: 'Gerar Relatório',
        LAST: 'Último Relatório Gerado',
        PERIODS: 'Períodos',
        VENDORS: 'Fornecedores',
        ERROR_REPORT: 'O relatório não pôde ser gerado corretamente',
      },
      PROMOTION_PRODUCTION_LISTS: {
        TITLE: 'Relatório de Promoções',
        DOWNLOAD: 'Gerar Relatório',
        LAST: 'Último Relatório Gerado',
        PERIODS: 'Períodos',
        VENDORS: 'Fornecedores',
        ERROR_REPORT: 'O relatório não pôde ser gerado corretamente',
      },
      PROMOTION_LOG: {
        TITLE: 'Registro de Promoções',
        DOWNLOAD: 'Gerar relatório',
        LAST: 'Último relatório gerado',
        ERROR_REPORT: 'O relatório não pôde ser gerado corretamente',
      },
      MARKETPLACE_LIST: {
        EXPORT_TTIP: 'exportar',
        FILTER_TTIP: 'Filtrar',
        DELETE_TTIP: 'eliminar',
        DELETE: 'eliminar',
        DELETE_ROW: 'Eliminar',
        EDIT_ROW: 'Editar',
        TITLE: 'Marketplace',
        PROMOTION_TYPE: 'Tipo de Promoção',
        YEAR: 'Ano',
        CLONE_ALL_PERIODS: 'Clonar períodos',
        CLONE_CONTENT: 'Clonar todos os períodos do primeiro campo Tipo de Promoção para o segundo para o ano indicado',
        CLONE_TITLE: 'Clonar períodos por tipo de promoção',
        PROMOTION_TYPE_FROM: 'Clonar períodos do processo promocional de',
        PROMOTION_TYPE_TO: 'Clonar períodos do processo promocional para',
        NEW_PERIOD: 'Novo',
        EDIT_ROW_DISABLED_TOOLTIP: 'Não é possível editar um registro em processo de publicação',
        SEE_DELETED_FILTERS: 'Ver eliminados',
        CREATION_ON: 'Data de criação',
        CLONE: 'Clonar Períodos',
        COPY: 'Copiar Períodos',
        NAME: 'Nome',
        ROUTE: 'Marketplace',
        FULLSCREEN_TTIP: 'Expandir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        STORENAME: 'Nome da Loja',
        CODE: 'Código',
        STATUS: 'Status',
        VIEW_MATERIAL_POP: 'Ver material promocional',
        DISABLE_STATUS: 'Filtro desativado por utilizar filtro `Contratos prestes a expirar`',
        STATUS_AVAILABLE: 'Disponível',
        STATUS_RESERVED: 'Reservado',
        STATUS_RENTED: 'Alugado',
        RESERV: 'Reservar',
        RENT: 'Alugar',
        POPMATERIAL: 'Material Promocional',
        CADUCATE: 'Contratos prestes a expirar',
        CADUCATE_1MONTH: 'Dentro de 1 Mês',
        CADUCATE_2MONTH: 'Dentro de 2 Meses',
        CADUCATE_3MONTH: 'Dentro de 3 Meses',
        ADVANCED_SEARCH: 'Filtros Avançados',
        INTERNAL_USE: 'Uso interno',
        CONTRACT: 'Gerenciar Contrato',
        CONTRACT_CONTENT: 'Reservar ou alugar {{val}}. Atribuindo datas e preço para o fornecedor selecionado',
        VENDOR: 'Fornecedor',
        PRICE: 'Preço',
        STORECOUNT: '# Lojas',
        OCUPATION: 'Ocupação',
        SPACE: 'Espaço',
        VALIDFROM: 'Data de início',
        VALIDTO: 'Data de término',
      },
      PERIODS_LIST: {
        EXPORT_TTIP: 'exportar',
        FILTER_TTIP: 'Filtrar',
        DELETE_TTIP: 'eliminar',
        CANT_DELETE_TTIP: 'O período promocional não pode ser excluído porque existem ações promocionais que o utilizam.',
        DELETE_MODAL_TITLE: 'Deseja excluir o período promocional{{val}}?',
        DELETE: 'eliminar',
        DELETE_ROW: 'Eliminar',
        IS_CANCELING: 'excluindo',
        EDIT_ROW: 'Editar',
        TITLE: 'Períodos Promocionais',
        PROMOTION_TYPE: 'Tipo de Promoção',
        PROMOTION_TYPE_PROCESS: 'Promotional process',
        FOLIO: 'Folha de Promoção',
        YEAR: 'Ano',
        YEAR_FROM: 'Ano De',
        YEAR_TO: 'Ano Para',
        CLONE_ALL_PERIODS: 'Clonar períodos',
        CLONE_CONTENT: 'Clonar todos os períodos do primeiro campo Tipo de Promoção para o segundo para o ano indicado',
        CLONE_TITLE: 'Clonar períodos por tipo de promoção',
        PROMOTION_TYPE_FROM: 'Clonar períodos de tipo de promoção de',
        PROMOTION_TYPE_TO: 'Clonar períodos de tipo de promoção para',
        NEW_PERIOD: 'Novo período promocional',
        EDIT_ROW_DISABLED_TOOLTIP: 'Não é possível editar um registro em processo de publicação',
        SEE_DELETED_FILTERS: 'Ver eliminados',
        CREATION_ON: 'Data de criação',
        CLONE: 'Clonar Períodos',
        COPY: 'Copiar Períodos',
        ROUTE: 'Períodos Promocionais',
        FULLSCREEN_TTIP: 'Expandir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        NAME: 'Nome',
        CODE: 'Código',
        RESPONSIBLEROLEID: 'Responsável',
        OBSERVATIONS: 'Observações',
        CONSULTEDROLEID: 'Consultor',
        STARTINGDAYOFWEEK: 'Dias de início',
        DURATIONINDAYS: 'Duração em dias',
        ORDER: 'Ordem',
        VALIDFROM: 'Data de início',
        VALIDTO: 'Data de término',
        EXTRAPLANNINGDAYS: 'Dias extras de planejamento',
        ISSPECIALEVENT: 'Evento especial',
        VALIDATION_CODE: 'O código {{val}} já existe',
        EDIT_ERROR: 'Erro ao editar: {{val}}',
      },
      CALENDAR_LIST: {
        EXPORT_TTIP: 'exportar',
        FILTER_TTIP: 'Filtrar',
        DELETE_TTIP: 'eliminar',
        DELETE: 'eliminar',
        TITLE: 'Calendário',
        MODIFY: 'Modificar',
        CHANGE_DATE_TITLE: 'Modificar Data',
        CHANGE_DATE_CONTENT: 'Modificar a data desta atividade',
        EDIT_ROW_DISABLED_TOOLTIP: 'Não é possível editar um registro em processo de publicação',
        ONLY_CURRENT_PERIODS: 'Apenas períodos ativos.',
        ACTIONS: {
          NAME: 'Descrição',
          RESPONSIBLEROLEID: 'Responsável',
          CONSULTEDROLEID: 'Consultor',
          OBSERVATIONS: 'Observações',
          STARTTASKXDAYSBEFORE: 'Dia de início',
          DURATIONINDAYS: 'Duração em dias',
        },
      },
      PERIODS_EDIT: {
        SAVE: 'Salvar',
        PUBLISH: 'Publicar',
        WARNING_SAVE: 'As alterações atuais precisam ser salvas.',
        WARNING_PUBLISH: 'Republicar é necessário para que as alterações salvas tenham efeito.',
        NOVALID_PUBLISH_ADVICE: 'A guia a seguir não é válida:',
        BASIC_INFORMATION_TAB: 'Informações Básicas',
        ACTIVATION_TAB: 'Ativação',
        LOADING: 'Carregando...',
        NEW_ITEM_BTN: 'Nova Ação Promocional',
        PUBLISH_CONFIRM:
          'O processo de publicação inclui a criação de Sortimento, Preços, Custos e outros registros relacionados a esta ação.<br><br><b>Você tem certeza de que deseja Publicar?</b>',
        PUBLISH_CONFIRM_TITLE: 'Confirmação de Publicação',
        PUBLISHING_WARNING: 'Item em processo de publicação, por favor, tente novamente em alguns minutos.',
        PUBLISH_LONG_TIME:
          'A publicação deste Produto pode levar alguns minutos, quando terminar você será notificado com uma notificação.',
        MAIN_DATA: {
          VALID_DATE: 'Data de validade',
          ORDER_WARNING:
            'Escolher uma ordem menor que o máximo recalculará as datas dos períodos subsequentes, excluindo eventos especiais',
          VALIDFROMEXCEEED: 'A data de início excede o ano atual',
          PERIOD_IN_USE: 'O período não pode ser editado porque está em uso.',
        },
      },
      COVERAGE: {
        WARNING_IS_NEW: 'Você precisa salvar as alterações para verificar a cobertura.',
        WARNING_STORE_AND_ITEM_SCOPE:
          'Ao modificar os escopos de item e loja, é necessário salvar as alterações para verificar a cobertura.',
        COVERAGE_BASED_COMMUNICATION_TITLE: 'Comunicação Baseada em Cobertura',
        COMPLETE_COVERAGE_TITLE: 'Cobertura Completa',
        COMMUNICATION_REGULAR_PRICE_TITLE: 'Comunicar preço regular',
      },
      REPORTS: {
        AVAILABLE_SPACES: {
          REGION: 'Região',
          AVAILABLE_SLOTS_PERCENTAGE: '% Total disponível',
          AVAILABLE_SLOTS: 'Quantidade total disponível',
          SLOTS: 'Slots',
          STORES: '# Lojas',
          SLOTS_TOTAL: 'Número total de slots',
          SLOTS_TOTAL_IN_USE: 'Número total em uso',
          SLOTS_PERCENTAGE_IN_USE: '% Total em uso',
          SLOTS_EXCEEDED: 'Quantidade de slots excedidos',
        },
        TAG_VALUES: 'Baixar relatório de etiquetas',
      },
    },
    M_SHOPPER: {
      MISSIONS: {
        CHECK_RULE: {
          MODAL_TITLE: 'Você quer mudar a seleção?',
          MODAL_CONTENT_FIRST_STEP: 'Se você confirmar, as etapas a seguir copiarão as configurações das regras de concorrência',
          MODAL_CONTENT:
            'Se confirmadas, as missões afetadas serão substituídas pelas modificações feitas com base na regra de concorrência da primeira etapa.',
          MODAL_BTN_CLOSE: 'Cancelar',
          MODAL_BTN_ACCEPT: 'Confirmar',
          CHECK: 'Não perguntar de novo.',
        },
        TYPE_OPTION: {
          PriceSurvey: 'Pesquisa de Preços',
          ExhibitionSurvey: 'Pesquisa de Exibição',
        },
        FRECUENCY_OPTION: {
          OneTime: 'Uma vez',
          Daily: 'Diariamente',
          Weekly: 'Semanal',
          Biweekly: 'Quincenal',
          Monthly: 'Mensal',
          Biannual: 'Semestral',
          Annual: 'Anual',
        },
        AUDYT_OPTION: {
          Internal: 'Interna',
          External: 'Externa',
        },
        METHODS_OPTION: {
          Strip: 'Strip',
          Ticket: 'Ticket',
          Catalog: 'Catálogo',
          Totem: 'Totem',
        },
        ACTION_OPTION: {
          PriceLabelScan: 'Escaneio de Etiqueta de Preço',
          VoiceCommand: 'Comando de voz',
          ManualEntry: 'Entrada manual',
          Indistinct: 'Indistinto',
        },
        CADUCATE: 'Expirado',
        TODAY: 'Hoje',
        DAYTOEXPIRE: 'Dias para Vencer',
        ROUTE: 'Comprador Misterioso',
        TITLE: 'Missões',
        SUBTITLE:
          'Nesta tela você verá todas as missões criadas, com sua porcentagem de progresso, sua frequência e se elas têm ou não regras de concorrência associadas a elas. Estas missões serão executadas pelo shopper através do aplicativo Prisma Mystery Shopper, caso existam relações entre lojas próprias ou da concorrência com o shopper, a missão será disponibilizada a esse utilizador a fim de verificar os seus próprios preços ou os da concorrência.',
        NEW_MISSION_BTN: 'Nova Missão',
        DAILYREPORT: 'Relatório Diário',
        FILTER_TTIP: 'Filtrar',
        FULLSCREEN_TTIP: 'Expandir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        EXPORT_TTIP: 'Exportar',
        IMPORT_TTIP: 'Importar',
        PRINT_TTIP: 'Imprimir',
        DELETE_TTIP: 'Apagar missões selecionadas',
        DELETE: 'Apagar',
        EDIT: 'Editar',
        NAME: 'Nome',
        TYPE: 'Tipo',
        AUDIT_METHOD: 'Método de Auditoria',
        AUDIT_METHOD_TTIP: 'Método de Auditoria',
        START_DATE: 'Date de Inicio',
        START_DATE_TTIP: 'Data de Início da Missão',
        FINISH_DATE: 'Data Final',
        FINISH_DATE_TTIP: 'Data de Fim da Missão',
        FRECUENCY: 'Frequência',
        ADVANCED: 'Progresso %',
        SURVEYED_STATUS: 'Status da pesquisa',
        SURVEYED_STATUS_NOTAVAIBLE_TOOLTIP:
          'A missão não está disponível para os usuários porque eles não estão atribuídos ou não têm concorrentes',
        SURVEYED_STATUS_AVAIBLE_TOOLTIP: 'A missão está disponível para os usuários',
        SURVEYED_STATUS_TAKENBYME_TOOLTIP: 'Um usuário aceitou a missão e ficará encarregado de assumi-la',
        SURVEYED_STATUS_COMPLETED_TOOLTIP: 'A missão já foi concluída, baixe o relatório diário para obter os resultados',
        SURVEYED_STATUS_NOTSURVEY_TOOLTIP: 'A missão não foi pesquisada e a data efetiva terminou',
        SURVEYED_STATUS_NOTAVAIBLE: 'Não disponível',
        SURVEYED_STATUS_AVAIBLE: 'Disponível',
        SURVEYED_TAKENBYME: 'Em andamento',
        SURVEYED_STATUS_COMPLETED: 'Concluído',
        SURVEYED_STATUS_NOTSURVEY: 'Não pesquisado',
        DAYS_TO_EXPIRE: 'Dias para expirar',
        SKUS: '# Produtos',
        SKUS_TTIP: 'Quantidade de produtos',
        MATCHINGS: '# Equivalências',
        MATCHINGS_TTIP: 'Cantidad de equivalências',
        SITES: '# Pontos de Venda',
        SITES_TTIP: 'Quantidade de pontos de venda',
        USERS_TTIP: 'Quantidade de usuários',
        USERS: '# Usuários',
        RULE: 'Regra',
        RULE_TTIP: 'Missão associada a uma regra de concorrência',
        YES: 'Sim',
        NO: 'No',
        STATUS: 'Status',
        DATE: 'Data',
        STATUS_ACTIVE: 'Missão atual',
        STATUS_OVERDUE: 'Misão Concluída',
        STORES_FILTER: 'Pontos de Venda',
        DEFINE_MISSION_STP1: 'Definir Missão',
        COMPETITORS_SCOPE_STP2: 'Escopo dos Concorrentes',
        PRODUCT_SCOPE_STP3: 'Escopo Produtos',
        STORE_SCOPE_STP4: 'Escopo Pontos de Venda',
        RESPONSIBLE_STP5: 'Responsável',
        NEW_TITLE_FORM: 'Nova Missão',
        EDIT_TITLE_FORM: 'Editar Missão',
        STP1: 'Etapa 1 - Definir Missão',
        STP1_SUBTITLE: 'Nesta etapa, você será capaz de definir os principais componentes de uma missão',
        NAME_INPUT: 'Nome',
        TYPE_INPUT: 'Tipo',
        AUDIT_METHOD_INPUT: 'Método de Auditoria',
        FRECUENCY_INPUT: 'Frequência',
        ACTION_TYPE_INPUT: 'Tipo de Açāo',
        AUDIT_TYPE_INPUT: 'Tipo de Auditoria',
        VALIDATE_LOCATION_TOOLTIP: 'A missão deve estar dentro do intervalo permitido de distância',
        REQUEST_EVIDENCE_TOOLTIP: 'Será obrigatório carregar imagem de comprovação do produto pesquisado',
        REQUEST_EVIDENCE: 'exige evidência fotográfica',
        VALIDATE_LOCATION: 'Validar Localização',
        SHOW_LAST_PRICE: 'mostrar último preço capturado ao agente',
        SHOW_LAST_PRICE_TOOLTIP:
          'Se ativado, o agente vê o último preço capturado do concorrente para cada item. Desative para uma captura sem viés de ancoragem.',
        SURVEYSAMOUNT: '#Concorrentes',
        SURVEYSAMOUNT_TTIP: 'Quantidade de concorrentes',
        STARTS_INPUT: 'Começa em',
        FINISHED_INPUT: 'Termina em',
        VALIDATE_PROMOTION_CHECK: 'Validar Promoção',
        VALIDATE_DATE_START: 'A data de início deve ser menor ou igual à data de término',
        VALIDATE_DATE_END: 'A data de término deve ser maior ou igual à data de início',
        VALIDATE_RANGE_TOO_SHORT_FOR_FREQUENCY: 'O intervalo de datas não cobre um ciclo completo da frequência selecionada',
        AUTOBUMP: {
          TOAST_TITLE: 'Data de término ajustada',
          TOAST_BODY: 'A data "Termina em" foi ajustada para incluir um ciclo completo da frequência selecionada.',
        },
        ERROR: {
          MISSION_SCOPE_ITEMS_EMPTY: 'Não foi possível salvar: adicione pelo menos um item ao escopo.',
          MISSION_SCOPE_COMPETITORS_EMPTY: 'Não foi possível salvar: configure pelo menos um concorrente no escopo.',
          MISSION_FREQUENCY_INVALID: 'Frequência inválida.',
          MISSION_RANGE_TOO_SHORT_FOR_FREQUENCY:
            'O intervalo de datas não cobre um ciclo completo. Estenda "Termina em" até a data indicada.',
        },
        EDIT_WARNING: {
          MODAL_TITLE: 'As mudanças não afetam as auditorias em curso',
          MAIN_MESSAGE: 'As auditorias em curso (programadas para hoje ou anteriores) não serão modificadas.',
          NEXT_AFFECTED_WITH_DATE: 'As mudanças se aplicarão a partir da auditoria de {{date}}.',
          NEXT_AFFECTED_OVERDUE:
            'Não há auditorias futuras programadas. As mudanças se aplicarão quando forem geradas novas auditorias (estendendo o intervalo de datas).',
          BTN_ACCEPT: 'Aceitar',
          BTN_CANCEL: 'Cancelar',
        },
        PREVIEW: {
          STEP_TITLE: 'Resumo',
          NO_COMPETITORS: 'Não foram encontrados concorrentes para esta seleção. Verifique a configuração.',
          BACK_TO_COMPETITORS: 'Voltar à etapa de Concorrentes',
          COMPETITORS_COUNT: 'concorrentes no escopo',
          COMPETITOR_COUNT_ONE: 'concorrente no escopo',
          ITEMS_COUNT: 'itens no escopo',
          ITEM_COUNT_ONE: 'item no escopo',
          SUMMARY_INTERNAL: 'Missão interna — auditoria em lojas próprias',
          ESTIMATE_PREFIX: 'Serão gerados',
          ESTIMATE_SUFFIX: 'relevamentos ao longo da missão.',
          ESTIMATE_TOOLTIP:
            'Um relevamento é uma visita a um concorrente (ou loja própria) em uma data programada e inclui todos os itens dessa visita. Total = concorrentes × ciclos do período.',
          LOADING_ERROR: 'Não foi possível carregar os concorrentes',
          RETRY: 'Tentar novamente',
          SEARCH_PLACEHOLDER: 'Buscar por nome',
        },
        VALIDATE_STOCK_CHECK: 'Validar Estoque',
        COMPETITIVE_RULE_INPUT: 'Regra',
        COMPETITIVE_RULE_INPUT_IN_USE: 'Esta regra está aplicada em uma missão',
        NEXT_BTN: 'Próximo',
        STP2: 'Etapa 2 - Escopo dos Concorrentes',
        LEGEND_SKIP_STEP: 'Esta etapa não é necessária se o tipo de auditoria for interna',
        SKIP_BTN: 'Pular',
        PREVIUS_BTN: 'Anterior',
        STP3: 'Etapa 3 - Escopo dos Produtos',
        STP3_SUBTITLE:
          'Nesta etapa você poderá definir quais produtos alcançará ou não esta missão. Você pode escolhê-los por seleção por atributo ou seleção individual.',
        STP3_TOGGLE: 'Permitir capturar preços de produtos fora da missão',
        STP3_TOGGLE_TOOLTIP:
          'Um lote de produtos genéricos estará disponível para identificar produtos encontrados que não estejam configurados na missão.',
        VIEW_PRODUCTS_BTN: 'Visualizar Produtos',
        REFRESH_PRODUCTS_BTN: 'Atualizar Produtos',
        STP4: 'Etapa 4 - Escopo dos Pontos de Venda',
        STP4_SUBTITLE:
          'Nesta etapa você poderá definir quais pontos de venda alcançará ou não esta missão. Você pode escolhê-los por seleção por atributo ou seleção individual.',
        AUTOMATIC_ASIGNATION_CHECK: 'Alocação automática',
        ADD_RESPONSIBLE_BTN: 'Adicionar Responsável',
        SAVE_BTN: 'Salvar',
        ADD_RESPONSIBLE_TITLE: 'Adicionar Responsável',
        COMPETITOR_INPUT: 'Concorrente',
        SHOPPER_INPUT: 'Shopper',
        ACCEPT_BTN: 'Aceitar',
        CANCEL_BTN: 'Cancelar',
        ADD_BTN: 'Adicionar',
        STRATEGY_ATTR_TITLE: 'Seleção por atributo',
        STRATEGY_ATTR_MSG: 'Os atributos são selecionados para definir o escopo dos produtos',
        STRATEGY_PROD_TITLE: 'Seleção por produto',
        STRATEGY_PROD_MSG: 'Os produtos devem ser selecionados um por um',
        STRATEGY_ATTR_TITLE_STORE: 'Seleção por atributo',
        STRATEGY_ATTR_MSG_STORE: 'Os atributos são selecionados para definir o escopo dos Pontos de Venda',
        STRATEGY_STORE_TITLE_STORE: 'Seleção por pontos de venda',
        STRATEGY_STORE_MSG_STORE: 'Os pontos de venda devem ser selecionados um a um',
        VIEW_STORES_BTN: 'Visualizar Pontos de Venda',
        REFRESH_STORES_BTN: 'Atualizar Pontos de Venda',
        STP5: 'Etapa 5 - Responsável pela Missão',
        LEGEND_RESPONSIBLE_STEP:
          'A atribuição de usuários à missão será feita automaticamente com base nos relacionamentos carregados na tela Atribuição de Usuários. A missão estará disponível no MS App, para todos os usuários relacionados aos pontos de venda e/ou concorrentes atingidos, e o primeiro usuário a cumprir a missão será aquele que lhe for atribuído',
        PASTE: 'Colar',
        PASTE_TTIP: 'Adicione pontos de venda de uma lista copiada para a sua área de transferência.',
        SEARCH: 'Procurar',
        CODE_AND_DESCRIPTION_INPUT: 'Código / Descrição',
        CLIPBOARD_TITLE: 'Colar lojas desde a área de transferência',
        CLIPBOARD_STEP1: '1) Defina que tipo de código você está usando',
        TYPE_CODE: 'Tipo de Código',
        INTERNAL_CODE_INPUT: 'Código Interno',
        EXTERNAL_CODE_INPUT: 'Código Externo',
        NOT_FOUND_CODE_ITEM: 'Este código de produto não foi encontrado no Catálogo de Ítens',
        NOT_FOUND_CODE_STORE: 'Este código de ponto de venda não foi encontrado no Catálogo de Pontos de Venda',
        CLIPBOARD_STEP2:
          '2) Selecione e copie os códigos de uma planilha ou texto. (Ctrl + C) conforme mostrado na imagem abaixo. Eles também podem ser carregados delimitando cada código com os seguintes caracteres "," ";" "|" "/" "\\\\" (tab) (enter) (espaço) ',
        CLIPBOARD_STEP3: '3) Pressione aqui e cole os códigos (Ctrl + V)',
        CLIPBOARD_MAX: 'A seleção individual suporta até {{val}} produtos.',
        CLIPBOARD_COUNT: 'Códigos foram carregados',
        CLIPBOARD_TITLE_DEFUALT: 'Pressione aqui e cole os códigos (Ctrl + V)',
        CLIPBOARD_NONE: 'Nenhum código foi carregado',
        CLIPBOARD_ACTION: 'Colar',
        PASTE_PRODUCT_TTIP: 'Adicione produtos de uma lista copiada para sua área de transferência.',
        CLIPBOARD_PRODUCT_TITLE: 'Colar produtos desde a área de transferência',
        CLIPBOARD_STORE_TITLE: 'Pegar pontos de venda do clipboard',
        FILTER_PROD: 'Produtos Filtrados',
        SELECT_PROD: 'Produtos Selecionados',
        ADD_PROD: 'Adicionar Produtos a uma lista',
        FILTER_STORE: 'Pontos de Venda Filtrados',
        SELECT_STORE: 'Pontos de Vendas Selecionados',
        ADD_STORE: 'Adicionar Pontos de Venda a uma lista',
        PROVINCE_CHIP: 'Província:',
        COUNTRY_CHIP: 'País:',
        PRICE_CHIP: 'Preço:',
        COST_CHIP: 'Custo:',
        LEGEND_SKIP_STEP4:
          'Esta etapa não é necessária uma vez que a opção Seleção de Concorrentes foi escolhida no Escopo de Concorrentes',
        STP2_COMP_BUTTON_TITLE: 'Escolha como você deseja se comparar com seus concorrentes.',
        MAINMARKET_TITLE: 'Marcador',
        ONLY_MARKERS_TITLE: 'Selecione apenas marcadores',
        MAINMARKET_MSG: 'Irá pesquisar o preço dos Marcadores de cada Ponto de Venda.',
        USE_TRADE_AREA_TITLE: 'Área Comercial',
        USE_TRADE_AREA_MSG: 'Irá pesquisar o preço dos Concorrentes associados à Área Comerciala de cada Ponto de Venda.',
        SELECT_COMPETITORS_TITLE: 'Seleção de Concorrentes',
        SELECT_COMPETITORS_MSG: 'Ele irá procurar por concorrentes que atendam aos critérios a serem definidos abaixo',
        HELP: {
          TYPE_INPUT:
            'Pesquisa de Preços: Você vai enviar o shopper para auditar os preços da concorrência e dentro de seus pontos de venda, para informá-lo ou garantir que suas políticas sejam atendidas.',
          TYPE_INPUT2:
            'Pesquisa de exibição: você enviará o comprador para auditar como os produtos são exibidos em seus pontos de venda ou em pontos de venda dos concorrentes.',
          AUDIT_METHOD_INPUT: 'Adhesivo: O preço que aparece na gôndola onde o produto está localizado devem ser auditadas. ',
          AUDIT_METHOD_INPUT2: 'Ticket: O preço que consta no ticket ou na nota fiscal será auditado após a compra dos produtos.',
          AUDIT_METHOD_INPUT3:
            'Catálogo: Os preços que aparecem em um catálogo, revista, folheto ou qualquer publicação de produto impresso serão auditados.',
          AUDIT_METHOD_INPUT4: 'Totem: Preços em totem e / ou painel de produtos devem ser auditados.',
          STARTS_INPUT: 'A partir desta data a missão começa.',
          FINISHED_INPUT: 'A partir desta data, o APP Mystery Shopper não pedirá aos compradores que assumam a missão. Ele será pausado.',
          VALIDATE_PROMOTION_CHECK: 'Os produtos selecionados também devem ser auditados, estejam eles em promoção ou não.',
          VALIDATE_STOCK_CHECK: 'Deve-se confirmar se havia ou não estoque do produto disponível no momento da auditoria.',
          FRECUENCY_INPUT: 'Determine com que freqüência a auditoria será repetida até a data de conclusão.',
          ACTION_TYPE_INPUT:
            'Determine se você precisa auditar de alguma forma específica, o Prisma Mystery Shopper APP permitirá que o comprador faça auditoria apenas usando a metodologia selecionada.',
          AUDIT_TYPE_INPUT: 'Interno: Será auditado em seus estabelecimentos.',
          AUDIT_TYPE_INPUT2: 'Externo: O estabelecimento do concorrente será auditado.',
          COMPETITIVE_RULE_INPUT:
            'Ao escolher uma regra de competição, os seguintes passos serão cumpridos pelo que já foi definido anteriormente na criação da regra.',
        },
        CHANGES_REFLECTED_NEXT_SURVEY: 'As alterações efetuadas serão refletidas no próximo inquérito.',
      },
      USER_ASSIGNMENT: {
        TITLE: 'Atribuição de Usuários',
        STATUS: {
          ASSIGNED: 'Atribuído',
          NOTASSIGNED: 'Não Atribuído',
        },
        CLONATION: {
          TITLE: 'Clonar Configurações do Usuário',
          CONTENT: 'Atribuirá a configuração de {{val}} aos usuários selecionados',
          CLIPBOARD: 'Importar Usuários',
          USER_SELECTED: 'Usuários Selecionados',
          USER_FOUND: 'Usuários Filtros',
          ADD_USERS: 'Adicionar Usuários',
          PASTE_USERS: 'Copiar Usuários para o clipboard',
          USER_NOTFOUND: 'Usuário não encontrado',
          HAS_ASSIGNED:
            'Encontramos usuários atualmente atribuídos, caso deseje continuar, eles serão substituídos pelas atribuições do usuário a partir de onde se deseja clonar. Caso contrário, cancelar e remover os usuários atribuídos que não desejar substituir.',
          CLIPBOARD_SELECT_STEP:
            'Selecione e copie os códigos de uma planilha ou texto. (Ctrl + C), como mostrado na imagem abaixo. Também podem ser carregados delimitando cada código com os seguintes caracteres: "," ";" "|" "/" "\\" (tab) (enter) (espaço) ',
          CLIPBOARD_PASTE_STEP: 'Clique aqui e cole os códigos (Ctrl + V)',
          SUCCESSFULL: 'A cópia foi concluída com sucesso',
          FAILED: 'Houve um erro e a clonagem falhou',
        },
        UNASSIGNED: {
          TITLE_ONE: 'Deseja desassociar de {{val}}?',
          CONTENT:
            'Ação irá desassociar as configurações dos pontos de venda próprios para os quais ela pertence e os concorrentes que ela tem atribuídos',
          TITLE_MULTIPLE: 'Deseja desassociar os usuários selecionados ({{val}})?',
        },
        LIST: {
          NAME: 'Nome',
          EMAIL: 'E-mail',
          CODE: 'Código',
          STORES_COUNT: '# Pontos de Venda Próprios',
          STORES: 'Pontos de Venda Próprios',
          COMPETITORS_COUNT: '# Concorrentes',
          STATUS: 'Status',
          UNASSIGNED_ROW: 'Deseassociar',
          FILTER: 'Filtro',
        },
        EDIT: {
          SAVE_WITH_CURRENT_COMPETITORS: 'Salvar com o Escopo dos Concorrentes atualizado',
          WARNING_SAVE:
            'Devido às alterações realizadas nos Escopos de Pontos de Venda há novos Concorrentes por Área de Comércio disponíveis, caso deseje utilizá-los, dirija-se ao Escopo dos Concorrentes antes de salvar. Caso contrário, os concorrentes atualmente selecionados serão mantidos',
          WARNING_COMPETITORS: 'Novos Concorrentes por Área de Negócios',
          STRATEGY_ATTR_TITLE_STORE: 'Selecção por Atributo (Estatístico)',
          STRATEGY_ATTR_MSG_STORE:
            'Selecionam-se atributos para definir o escopo dos pontos de venda. Se o escopo sofrer alterações, não afetará essa configuração. Caso deseje que isso tenha impacto, modifique esse escopo e salve novamente.',
          STRATEGY_STORE_TITLE_STORE: 'Selecção por pontos de venda',
          STRATEGY_STORE_MSG_STORE: 'Pontos de Venda devem ser selecionados explicitamente um por um',
          CLIPBOARD_COMPETITORS_TITLE: 'Pegar Competidores do Porta-Papeis',
          STORESCOPE: 'Abrangência de Pontos de Venda',
          COMPETITORSSCOPE: 'Competitor Reach',
          CHANGE_STORE_SCOPE_TITLE: 'Deseja alterar o escopo dos pontos de venda?',
          CHANGE_STORE_SCOPE_DESCRIPTION:
            'Se você cancelar, ele voltará para a configuração anterior. Se confirmar, alterará o escopo dos pontos de venda, apenas os concorrentes selecionados marcados como área de negócios serão substituídos.',
          STORE_SCOPE: {
            SUBTITLE:
              'Neste passo você poderá definir quais pontos de venda próprios pertencem a esse usuário. Você pode escolhê-los através da seleção por atributo ou seleção manual e também os importar',
            VIEW_STORES_BTN: 'Pontos de Venda',
            CODE_AND_DESCRIPTION_INPUT: 'Búsqueda por nome ou código',
            PASTE: 'Importar Lojas',
          },
          COMPETITORS_SCOPE: {
            SUBTITLE:
              'Neste passo você poderá definir a que concorrentes o usuário terá acesso (terá acesso às missões disponíveis que lhe corresponderão conforme concorrente). Inicialmente, serão atribuídos os concorrentes dentro da área de trade dos pontos de venda próprios, com a possibilidade de remover ou adicionar novos concorrentes',
            SEARCH_COMPETITORS: 'Pesquisar pelo nome ou código',
            PASTE: 'Importar Concorrentes',
            NOTFOUND: 'Not Found',
            SAVE_FIRST: 'Precisa salvar as alterações para poder configurar o Escopo dos Concorrentes',
          },
        },
      },
    },
    COMP: {
      GENERIC_TABLE: {
        COMPETITORS: {
          COMPETITORS_FOUND: 'Filtros de Competidores',
          COMPETITORS_SELECTED: 'Concorrentes Selecionados',
          ADD_COMPETITORS: 'Adicionar Concorrentes',
        },
      },
      PRISMA_TABLE: {
        CONFIG_COLUMNS: 'Configurar colunas',
        DELETE_ACTION: {
          DELETE: 'Desativar',
          DELETE_TTIP: 'Desativar registro',
          UNDELETE: 'Ativar',
          UNDELETE_TTIP: 'Ativar registro',
          DELETE_ROW: 'Desativar registro',
          DELETE_ROWS: 'Desativar, registros',
          DELETE_ROW_CONTENT: 'Seguro que desea Desativar {{val}}?',
          DELETE_ROWS_CONTENT: 'Seguro que desea Desativar {{val}}',
          UNDELETE_ROW: 'Ativar Registro',
          UNDELETE_ROWS: 'Ativar Registros',
          UNDELETE_ROW_CONTENT: 'Tem certeza de desejar ativar {{val}}? ao ser ativado, ele será iniciado com o novo status',
          UNDELETE_ROWS_CONTENT: 'Tem certeza de desejar ativar {{val}} registros? ao ser ativados, os mesmos iniciam com o novo status',
          ACTION_ROW_CONTENT_SUCCESS: 'Ação concluída com sucesso',
          ACTION_ROW_CONTENT_FAILED: 'Ação não pode ser realizada corretamente',
        },
        ENTITIES: {
          REPORT: 'Relatório Completo Aqui',
          APPLY: 'Devido à encontrar-se em uso nas seguintes entidades:',
          ITEM_NOT_FOUND: 'Produtos não encontrados',
          USEDINCOMBOS: 'CÓMBOS: {{val}}',
          USEDINMISSIONS: 'Missoes: {{val}}',
          USEDINPARENTRULES: 'Regras de Preços: {{val}}',
          USEDINPLANOGRAMS: 'Plano de Comércio: {{val}}',
          USEDINPROMOTIONS: 'Ofertas: {{val}}',
          USEDINRECIPES: 'Receitas: {{val}}',
        },
        ACTION_FAIL: {
          DESCRIPTION_ERROR: 'O problema foi causado por ',
          TYPE: 'Tipo: {{val}}',
          KEYWORD: 'Palavra-chave: {{val}}',
          VALUES: 'VALORES: {{val}}',
          WARNING: 'Alerta',
          ERROR: 'Erro',
          ENTITYNOTFOUND: 'No Entidade Encontrada',
        },
      },
      INSIGHT: {
        CONTEXT_MENU: {
          SUBSCRIBED: 'Subscrito',
          UNSUBSCRIBED: 'Cancelar subscrição',
          SUBSCRIBE: 'Assinar para receber todos os insights',
          UNSUBSCRIBE: 'Assinar para receber todos os insights',
          TYPE: 'de {{val}}',
          CATEGORY: 'da categoria {{val}}',
          STORE: 'da Loja {{val}}',
          STORETAG: 'da etiqueta {{val}}',
          CONCATENATE_MESSAGE: '{{val}} {{val2}}',
        },
      },
      MODAL: {
        IMPORT_VENDORS: {
          TITLE: 'Resolver conflitos de fornecedores',
          CLOSE: 'Fechar',
        },
        ADD_MODAL_VERIFY: {
          SELECT_ALL: 'Selecionar Todos',
          SELECT_OPTIONS_MSG: 'Selecionar as opções',
          CURRENT_SELECTION: 'Seleção Atual',
          VALIDATE_BTN: 'Validar',
          VALIDATION_TITLE: 'Validação',
          PLACEHOLDER: 'Procurar {{val}}',
          TITLE_EMPTY: 'Não há {{val}} para validar',
          VALIDATION_MESSAGE_OK: 'Todos os fornecedores foram configurados corretamente para o ponto de venda.',
          VALIDATION_MESSAGE_WARNING:
            'O {{val}} selecionado não cobre 100% do sortimento ativo. Nenhum fornecedor foi encontrado para os seguintes produtos',
          VALIDATION_MESSAGE_WARNING_FOOTER: 'Selecione {{val}} até que todo o sortimento seja coberto.',
          VALIDATION_TITLE_WARNING: 'Advertência',
          CLOSE: 'Fechar',
          VALIDATION_MESSAGE_ERROR: 'Mais de um fornecedor tem o mesmo produto',
          VALIDATION_TITLE_ERROR: 'Conflitos ',
          SOLVE: 'Resolver',
          DOWNLOAD_XLSX: 'Baixar Excel',
          XLSX: 'Fornecedor.xlsx',
          BTN_TOOLTIP_ERROR: 'Baixe o excel e preencha a coluna IsPrimary com o provedor principal com um X',
          INIT_VENDORS: 'Inicializar fornecedores',
          SURE_TO_SAVE:
            'Este processo é único e não pode ser modificado nesta tela, certifique-se de que os provedores selecionados são os corretos',
          CANCEL: 'Cancelar',
          SAVE: 'Salvar',
        },
        COPY_VENDORS_BY_STORE: {
          INTRO: 'Os fornecedores serão clonados de acordo com o ponto de venda selecionado.',
          PLACEHOLDER: 'Ponto de Venda',
          SAVE: 'Salvar',
          CLOSE: 'Fechar',
        },
      },
      PICK_COLOR: {
        SELECTION: 'Selecionar',
        CANCEL: 'Cancelar',
        CLEAR: 'Limpar',
        SELECTION_TITLE: 'Selecionar uma cor',
      },
      KPIS: {
        DOUBLE_KPI_SUGGESTION: 'SUGESTÕES ACEITAS',
      },
      MULTIPLE_GREEN_BUTTON: {
        MODAL_TITLE: 'Você quer mudar a seleção?',
        MODAL_CONTENT: 'Se você confirmar, os dados relacionados à seleção podem ser removidos da carga atual',
        MODAL_BTN_CLOSE: 'Cancelar',
        MODAL_BTN_ACCEPT: 'Confirmar',
        CHECK: 'Não perguntar de novo.',
      },
      ALERT_AND_CAP: {
        ALERTACOMPETENCIA:
          'O preço sugerido de R$ {{val}} é R$ {{val2}} do que o limite definido para o concorrente {{val3}}. Seu preço deve estar entre R$ {{val4}} e R$ {{val5}}',
        ALERTACOMPETENCIA_NO_MIN:
          'O preço sugerido para ${{val}} é {{val2}} no limite do Concorrente de {{val3}}. Seu preço deve ser de pelo menos ${{val5}}',
        ALERTACOMPETENCIA_NO_MAX:
          'O preço sugerido para ${{val}} é {{val2}} no limite do Concorrente de {{val3}}. Seu preço deve ser, no máximo, ${{val4}}.',
        ALERTACOMPETENCIA_NO_RANGE:
          'O preço sugerido é US$ {{val}} no limite para o competidor {{val3}}, com um valor máximo de R${{val2}}.',
        ALERTACOMPETENCIAMISSING:
          'O limite do concorrente não pôde ser verificado porque não encontramos preços de mercado válidos {{val}}',
        ALERTAMARGEN: 'O preço sugerido de R$ {{val}} é {{val2}} do que {{val3}} de acordo com o limite da margem.',
        ALERTAMARGENMISSING:
          'Não foi possível verificar o limite de margem porque não encontramos custos para este produto neste ponto de venda.',
        ALERTAVARIACION: 'O preço sugerido de R$ {{val}} é {{val2}} do que {{val3}} de acordo com o limite de variação.',
        CAPCOMPETENCIA:
          'O preço sugerido de {{val}} foi alterado para {{val2}} porque era {{val3}} do que o preço de {{val4}} R$ {{val7}}. Seu preço deve estar entre R$ {{val5}} e R$ {{val6}}',
        CAPCOMPETENCIAMISSING:
          'O limite do concorrente não pôde ser verificado porque não encontramos preços de mercado válidos para {{val}}.',
        CAPMARGE:
          'O preço sugerido de R$ {{val}} foi alterado para R$ {{val2}} porque era {{val3}} do que a margem de {{val4}}. Seu preço deve estar entre R$ {{val5}} e R$ {{val6}}',
        CAPMARGEMISSING:
          'Não foi possível verificar o limite de margem porque não encontramos custos para este produto neste ponto de venda.',
        CAPVARIACION:
          'O preço sugerido de R$ {{val}} foi alterado para R$ {{val2}} porque era {{val3}} do que a variação de {{val4}}. Seu preço deve estar entre R$ {{val5}} e R$ {{val6}}',
        MINIMOMAXIMO: '{{val}} de R${{val2}}',
        MINIMUM: 'mínimo',
        MAXIMUM: 'máximo',
        GREATER: 'Maior',
        ABOVE: 'acima',
        BELOW: 'abaixo',
        ALERT_MARGEN_LIMIT: 'O preço sugerido está dentro de {{val}} de {{val2}} do limite de margem exigido.',
        ALERT_VARIATION_LIMIT: 'O preço sugerido está dentro de {{val}} de {{val2}} do limite de variação exigido.',
        OF: 'de',
        LOWER: 'lower',
        FOR: 'para {{val}}',
      },
      DEFAULT_TBAR: {
        SEARCH: 'Procurar…',
        SEARCH_ITEM: 'Buscar Item...',
        SEARCH_STORE: 'Search Store...',
      },
      ACTION_TBAR: {
        ACTIONS: 'Ações',
        SELECTED_SINGULAR: 'Selecionado',
        SELECTED_PLURAL: 'Selecionados',
      },
      ITEMS_NO_FOUND: {
        NO_RESULTS_FILTERS: 'Nenhum resultado encontrado.',
        NO_RESULTS_FILTERS_MANDATORY:
          'Não foram encontrados resultados com os filtros selecionados. Por favor, preencha os filtros obrigatórios.',
        NO_RESULTS: 'Nenhum resultado encontrado',
        NO_RESULTS_REPORTS: 'Nenhum relatório foi encontrado.',
      },
      ERROR_MESSAGE: {
        TITLE: 'An error has occurred',
        SUBTITLE: 'Entre em contato com a equipe de suporte.',
        ACCEPT_BTN: 'Aceitar',
        DOWNLOAD_LOG: 'Baixar log de erro',
      },
      DINAMIC_TAGS: {
        ADD_ATTRIBUTE_BTN: '+',
        WITHOUT_SELECTION: 'Sem Seleção ...',
        SEARCH: 'Procurar ',
        ELEMENTS_NOTFOUND: 'Nenhuma etiqueta encontrada',
        NO_ELEMENTS_SELECTED: 'Nenhuma etiqueta foi selecionada',
        SELECTION_ALL: 'Selecionar Todos',
      },
      FILTER_CHARGE_COMBO: {
        OTHERS: ', Others',
        OTHER: ', Other',
        SELECTED: 'Selecionados',
        RESULT: 'Resultados encontrados',
        TOOLTIP: 'Opções Selecionadas: ',
      },
      ADD_ATTRIBUTE: {
        TITLE_MODAL: 'Novo Atributo',
        SELECT_ATTRIBUTE: 'Selecionar Atributo',
        SEARCH_ATTRIBUTE: 'Procurar Atributo',
        SELECT_ALL: 'Selecionar Todos',
        CANCEL_BTN: 'Cancelar',
        ADD_BTN: 'Adicionar',
        EXCLUDED: 'Excluído',
      },
      ERASURE_CONFIRMATION: {
        TITLE: 'Apagar',
        SUBTITLE: 'Quer continuar com a remoção?',
        CANCEL_BTN: 'Cancelar',
        DELETE_BTN: 'Apagar',
      },
      DRAG_DROP: {
        TITLE: 'Arraste e solte a imagem aqui ou clique para pesquisar em seu PC',
        SUBTITLE: 'Extensão não permitida: ',
        SUBTITLE_TTIP: 'Extensões permitidas: "jpeg", "jpg", "png", "ico"',
        SUBTITLE_TTIP_EXCEL: 'Extensões permitidas: "xls", "xlsx"',
        SUBTITLE_TTIP_ONLY: 'Extensões Permitidas:',
      },
      OPERATION_SUCCESS: {
        TITLE: 'Operação bem sucedida',
        SUBTITLE: 'A operação foi completada com sucesso',
        ACCEPT_BTN: 'Aceitar',
        TITLE_EMPTY: 'Operação sem modificações',
        SUBTITLE_EMPTY: 'A operação foi concluída com sucesso, nenhuma alteração foi encontrada pendente de relatório',
        SUBTITLE_WITHOUT_RESULT: 'Sem resultados',
      },
      IAN_IMPORTER: {
        BTN_IMPORT_SWITCH: 'Terminar',
        CLOSE: 'Fechar',
        UPLOAD_FILES_STP1: 'Carregar arquivos',
        VERIFY_FORMAT_STP2: 'Verificar Formato',
        VALIDATE_INFORMATION_STP3: 'Validar Informação',
        UPDATE_TABLES_STP4: 'Atualizar tabelas',
        UPDATE_TABLES_STP_END: 'Finalizar',
        RESTART_TTIP: 'Reinicie o importador para fazer carregamento de novos arquivos',
        STP1: 'Etapa 1 - Carregar Arquivo',
        DRAG_FILE: 'Arraste e solte o arquivo aqui ou clique para procurar em seu PC',
        STP2: 'Etapa 2 - Verifique o formato',
        CHECKING_FORMAT: 'Verificar o formato e a extensão do arquivo para fazer a carga para o servidor',
        STP3: 'Etapa 3 - Validar informação',
        VALIDATING_DATA: 'Validando dados do arquivo para detectar inconsistências',
        STP4: 'Etapa 4 - Atualizar tabelas',
        STP_END: 'Etapa 2 - Finalizar',
        INCORPORATING_INFORMATION: 'As informações processadas estão sendo adicionadas ao Prisma',
        CORRECT_FILE: 'O formato e a extensão do arquivo estão corretos',
        WITHOUT_ERRORS: 'A informação foi adicionada ao Prisma com sucesso, mas com',
        WARNINGS: 'alertas',
        ERRORS: 'A informação não foi adicionada ao Prisma. Os seguintes erros e alertas foram encontrados',
        WITHOUT_ERRORS_WARNINGS: 'A informação foi adicionada ao Prism com sucesso, sem erros ou alertas',
        DOWNLOAD_TEMPLATE: 'Baixar Template',
        TOTAL_ROWS_REGISTRED: 'Total de registros carregados',
        TOTAL_ROWS_REGISTRED_WITH_WARNINGS: 'Total de registros com alertas não carregados',
      },
      GEN_CATEGORYS: {
        CATEGORIES_INPUT: 'Categorias',
        CATEGORIES_INPUT_EXC: 'Categorias Excluídas',
        CATEGORIES_TTIP: 'Você deve selecionar pelo menos uma categoria, para selecionar as subcategorias',
        SEARCH_CATEGORIES: 'Procurar Categorias',
        SUBCATEGORIES_INPUT: 'Subcategorias',
        SUBCATEGORIES_INPUT_EXC: 'Subcategorias Excluídas',
        DEPT_INPUT: 'Departamento',
        DEPT_INPUT_EXC: 'Departamento Excluído',
        SUBCATEGORIES_TTIP: 'Você deve selecionar pelo menos uma subcategoria por categoria selecionada',
        SEARCH_SUBCATEGORIES: 'Procurar Subcategorias',
        SELECT_ALL: 'Selecionar Todos',
        SELECT_ALL_SUBCATEGORY: 'Selecionar todas as Subcateogiarias',
        SEARCH_SUBCATEGORIES_FILTER: 'Procurar Subcategorias',
        SELECT_ALL_CATEGORY: 'Selecionar todas as Categorias',
      },
      GEN_ITEM_LIST: {
        NAME: 'Nome',
        CODE: 'Código',
        BRAND: 'Marca',
        MANUFACTURER: 'Fabricante',
        PRICE: 'Preço R$',
        COST: 'Custo R$',
      },
      GEN_ITEM_STORE: {
        NAME: 'Nome',
        CODE: 'Código',
        BRAND: 'Marca',
      },
      GEN_TAGS: {
        FILTER_TAG_VALUES: 'Opções de filtro que estão relacionadas com os resultados da lista',
        ADD_ATRIBUTE_BTN: 'Adicionar Atributos',
        NO_TAGS: 'Sem Atributos para adicionar',
        NONE: 'Nenhum',
        ALL: 'Todos',
        EXCLUDED: 'excluído',
        SEARCH: 'Procurar',
        AUTO_VISIBLE_FALLBACK_HINT: 'Sem etiquetas por padrão: mostrando algumas. Use "+" para ver o resto.',
      },
    },
    MAT_PAGINATOR: {
      QUANTITY: 'Número de produtos por página',
      NEXT: 'Próxima página',
      PREVIUS: 'Página anterior',
      FIRST: 'Primeira página',
      LAST: 'Última página',
    },
    SERVICES: {
      CAN_DEACTIVATE: {
        TITLE_MODAL: 'Alterações sem salvar',
        SUBTITLE_MODAL: 'Você quer sair mesmo assim?',
        GO_OUT_BTN: 'Sair',
        FOLLOW_BTN: 'Continue no formulário',
      },
    },
    SPACES: {
      COMMON: {
        SEE_MORE: 'Ver mais',
        STORES_LIST_TITLE: 'Pontos de venda',
        STORES_TABLE_NAME: 'Nome',
        STORES_TABLE_ACTION: 'Ações',
      },
      ITEM_FINANCIALS: {
        TITLE: 'Dados financeiros (âmbito Range)',
        SUBTITLE: 'Por item, loja e estrutura. Mesmo período e consolidação que o detalhe de sortimento do Range.',
        COL_ITEM: 'Item',
        COL_STORE: 'Loja',
        COL_STRUCTURE: 'Estrutura',
        COL_STORES: 'N° lojas',
        COL_SALES: 'Vendas $',
        COL_UNITS: 'Unidades',
        COL_MARGIN: 'Margem',
        COL_MARGIN_VENDOR: 'Margem c/ acordos',
        COL_STOCK: 'Stock $',
        COL_STOCK_UN: 'Un. stock',
        COL_AVAIL: 'Disponibilidade',
        COL_DAYS_STOCK: 'Dias stock',
        COL_LINEAR: 'Espaço linear',
        COL_FACINGS: 'Frentes',
        COL_MKT_SALES: 'Vendas mercado $',
        COL_MKT_UN: 'Un. mercado',
        COL_PRICE: 'Preço',
        COL_GMROI: 'GMROI',
        PREV: 'Anterior',
        NEXT: 'Seguinte',
        EMPTY: 'Não há linhas financeiras para este modelo no âmbito atual (item–loja–estrutura).',
      },
      REPLACE: {
        LIST_TITLE: 'Últimas substituições realizadas',
        NEW_BTN: 'Substituir',
        LIST: {
          DATE_INPUT: 'Data',
          HOUR_INPUT: 'Hora',
          USER_INPUT: 'Usuário',
          FILE_INPUT: 'Ficheiro',
        },
        EDIT: {
          TITLE: 'Nova Substituição',
          TITLE_FORM_EDIT: 'Editar Reemplazo',
          STP1: 'Substituições',
          STP1_SUBTITLE: 'Selecione os produtos e suas substituições correspondentes',
          STP2: 'Planogramas',
          STP2_SUBTITLE: 'Selecione os planogramas em que deseja fazer o reembolso',
          STP3: 'Confirmar',
          STP3_SUBTITLE:
            'Os produtos selecionados serão substituídos para todos os planogramas seguintes. Verifique a lista antes de continuar.',
          NEXT_BTN: 'Próximo',
          PREVIOUS_BTN: 'Anterior',
          REPLACE_BTN: 'Substituir',
          NAME_INPUT: 'Nome',
          SAVE_BTN: 'Salvar',
          CANCEL_BTN: 'Cancelar',
          PRODUCT_INPUT: 'Produto',
          PRODUCT_REQUIRED: 'O produto é obrigatório',
          ACTION_INPUT: 'Ação',
          ACTION_REPLACE_OPTION: 'Substituir',
          ACTION_DELETE_OPTION: 'Excluir',
          REPLACEMENT_INPUT: 'Substituto',
          REPLACEMENT_REQUIRED: 'O substituto é obrigatório',
          SEARCH_PLACEHOLDER: 'Procurar por código ou nome',
          SEARCH_CLEAR: 'Limpar pesquisa',
          SEARCH_RESULTS: '{{val}} de {{val2}} planogramas',
          SELECTED_COUNT: '{{val}} selecionados',
          SEARCH_NO_RESULTS: 'Não há planogramas que correspondam à pesquisa',
        },
      },
      LIST: {
        ENTITIES: {
          REPORT: 'Relatório Completo Aqui',
          APPLY: 'Devido à encontrar-se em uso nas seguintes entidades:',
          CONTENT_DELETE_LAYOUT:
            'Ação não pôde ser concluída com sucesso, o plano de exposição está associado a pelo menos um arranjo. Pressione Continuar para eliminá-lo e removê-lo dos arranjos correspondentes',
          ITEM_NOT_FOUND: 'Sem permissões suficientes em todos os pontos de venda associados aos planogramas solicitados',
          USEDINLAYAOUTS: 'LAYOUTS EM USO: {{val}}',
          IMPEDIMENT: {
            USEDINLAYAOUTS: 'LAYOUTS EM USO: {{val}}',
          },
        },
        STATUS: {
          New: 'Novo',
          PendingEndorsement: 'Pendente da aprovação',
          Current: 'Publicado',
          Endorsed: 'Aprovado',
          Deleting: 'Removendo',
          Draft: 'Prévia',
          Implanted: 'Implantado',
        },
        TITLE_STRUCTURE: 'Estruturas',
        BTN_STRUCTURE: 'Nova Estrutura',
        TITLE_GENERIC_SPACE: 'Espaços Genéricos',
        BTN_GENERIC_SPACE: 'Novo Espaço Genérico',
        TITLE: 'Planogramas',
        POPOVER_TEXT:
          'Somente são exibidos os planogramas cujos Pontos de Venda estão disponíveis para o usuário. Se um ou mais planogramas não forem exibidos, por favor entre em contato com o administrador do sistema, informando os planogramas ausentes e solicitando a verificação dos PDVs associados ao usuário.',
        ROUTE: 'Planejamento de Espaços',
        BTN: 'Novo Planograma',
        ADMIN: 'Administração de planogramas',
        EXPORT_TTIP: 'Exportar',
        FILTER_TTIP: 'Filtrar',
        FULLSCREEN_TTIP: 'Expadir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        PRINT_TTIP: 'Imprimir',
        DELETE: 'Apagar',
        DELETE_TTIP: 'Apagar planogramas selecionados',
        RECOVER: 'Recuperar',
        RECOVER_TTIP: 'Recuperar',
        CLONE_STRUCTURE: 'Clonar únicamente a estrutura',
        CLONE_STRUCTURE_AND_PRODUCTS: 'Clonar estrutura e produtos',
        SURE_CLONE:
          'Tem certeza de que deseja clonar este item? apenas a estrutura do planograma será clonada e não a configuração com todos os seus produtos aplicados',
        SURE_CLONE_COMPLETE:
          'Tem certeza de que deseja clonar este item? A estrutura do planograma e a configuração com todos os seus produtos aplicados serão clonados',
        EDIT: 'Editar',
        STATUS_NEW: 'Novo',
        STATUS_EDITED: 'Editado',
        STATUS_ACTUAL: 'Atual',
        STATUS_APPROVED: 'Aprovado',
        STATUS_PENDING_APPROVAL: 'Aprovação pendente',
        STATUS_PEVIEW: 'Preview',
        STATUS_INFORMED: 'Informado',
        STATUS_INFORM: 'Informar',
        STATUS_IMPLANTED: 'Implantado',
        STATUS_INFORM_EXECUTED_SHORT: 'Inf. Executado',
        REQUEST_APPROVAL: 'Solicitar Aprovação',
        REQUEST_APPROVAL_SMALL: 'Solicitar Aprovação',
        APPROVE: 'Aprovado',
        COLUMN: {
          NAME: 'Nome',
          CODE: 'Código',
          TYPE: 'Tipo',
          LAST_MODIF: 'Última Modif.',
          STATUS: 'Status',
          CAT: '# Categorias',
          SUBCAT: '# Subcategorias',
          GENERATE: 'Geração',
          CHARGE: 'Capacidade (UN)',
          FRONT: 'Comprimento',
          LINEAL_SIZE: 'Espaço linear',
          LAYOUT: '# Layouts',
          STORES: '# Pontos de Venda',
          SKU: '# Produtos',
          SALES: 'Vendas Mês/ Espaço Linear',
          VAR: 'Var. Mês Passado',
          SCORE: 'Score',
          SCORE_MIN: 'Score Mín.',
          SCORE_MAX: 'Score Máx.',
          SCORE_MIN_ERROR: 'O score deve estar entre 0 e 100',
          SCORE_MAX_ERROR: 'O score deve estar entre 0 e 100',
          SCORE_RANGE_ERROR: 'O score mínimo não pode ser maior que o score máximo',
          PLANOGRAMTYPE: 'Tipo',
          STRUCTUREONLY: 'Estrutura',
          STRUCTUREONLY_Structure: 'Estrutura',
          STRUCTUREONLY_Planogram: 'Plano de Exposição',
          STRUCTUREONLY_Generic: 'Geral Space',
          FILTER_PREVIEW: 'Visualizar Prévia',
          EXCLUDED_FROM_ANALYSIS: 'Excluído da análise',
          EXCLUDED_YES: 'Excluído',
          EXCLUDED_NO: 'Não',
          EXCLUDED_FILTER_ALL: 'Todos',
          EXCLUDED_FILTER_ONLY: 'Somente excluídos',
          EXCLUDED_FILTER_NONE: 'Somente não excluídos',
          FILTER_TEMPLATE_GENERATE: 'Gerado por:',
          FILTER_TEMPLATE_GENERATE_FOR: 'Geração:',
          MASIVE_ACTIONS: 'Ações em Massa:',
          request_approval_msg: 'Você tem certeza de que deseja solicitar a aprovação de {{val}} registros?',
          approve_msg: 'Você tem certeza de que deseja aprovar {{val}} registros?',
          inform_msg: 'Você tem certeza de que deseja informar {{val}} registros?',
          APPROVE_ALERT: 'Aprovação enviada. Você receberá uma notificação quando o processo for concluído.',
          REQUEST_APPROVAL_ALERT: 'Solicitação de aprovação enviada. Você receberá uma notificação quando o processo for concluído.',
          INFORM_ALERT: 'Informando planogramas. Você receberá uma notificação quando o processo for concluído.',
          INACTIVATE_ALERT: 'Excluindo planogramas. Você receberá uma notificação quando o processo for concluído.',
          request_approval: 'Solicitar Aprovação',
          approve: 'Aprovar',
          inform: 'Informar',
          delete: 'Desativar',
          exclude_from_analysis: 'Excluir da análise',
          include_from_analysis: 'Incluir na análise',
          exclude_from_analysis_msg: 'Tem certeza de que deseja excluir {{val}} planogramas selecionados da análise?',
          include_from_analysis_msg: 'Tem certeza de que deseja incluir {{val}} planogramas selecionados na análise?',
          EXCLUDE_FROM_ANALYSIS_ALERT: 'Exclusão da análise enviada. Você receberá uma notificação quando o processo for concluído.',
          INCLUDE_FROM_ANALYSIS_ALERT: 'Inclusão na análise enviada. Você receberá uma notificação quando o processo for concluído.',
          VISITED: 'Visitado',
          NO_PERMISSIONS: 'You do not have permissions.',
          AUTOMATIC: 'Automática',
          MANUAL: 'Manual',
        },
        SNACKBAR_REPORT: 'O relatório está sendo gerado',
        MULTIPLE_REPORT_BTN: 'Relatório múltiplo',
        MULTIPLE_REPORT_BTN_FLAT_OPTION: 'Planogramas por aba',
        MULTIPLE_REPORT_BTN_MULTISHEET_OPTION: 'Planogramas por abas',
        SNACKBAR_CLOSE: 'Fechar',
        PLANOGRAM_TYPES: {
          All: 'Todos',
          Structure: 'Estruturas',
          Planogram: 'Planograms',
          GenericSpace: 'Geral Space',
          isGenericSpace: 'Geral Space',
        },
        PLANOGRAM_TYPE: {
          Structure: 'Estrutura',
          Planogram: 'Plano de Exposição',
          GenericSpace: 'Geral Space',
          isGenericSpace: 'Geral Space',
        },
      },
      TABS: {
        TAB1_ICON: 'configurações',
        TAB1: 'Geral',
      },
      GENERAL: {
        TITLE_NEW: 'Novo Planograma',
        TITLE_NEW_TEMPLATE: 'Nova Estrutura',
        TITLE_NEW_GENERICSPACE: 'Novo Espaço Geral',
        TITLE_EDIT: 'Editar Planograma',
        TITLE_EDIT_TEMPLATE: 'Editar Estrutura',
        TITLE_EDIT_GENERICSPACE: 'Editar Espaço Geral',
        SUBTITLE: 'Você está criando um novo planograma, digite um Nome e selecione os Pontos de Venda e categorias relacionadas',
        SAVE_BTN: 'Salvar',
        NAME_INPUT: 'Nome',
        OBSERVATIONS_INPUT: 'Observações',
        EXCLUDED_FROM_ANALYSIS: 'Excluir da análise de espaços',
        EXCLUDED_FROM_ANALYSIS_TOOLTIP:
          'Indica que este plano de exposição deve ser excluído da análise de espaços. É uma marca informativa e não altera seu status.',
        ADVANCED_SEARCH: 'Pesquisa Avançada',
        UPDATE: 'Atualizar',
        UPDATE_STRUCTURES: 'Você deve atualizar a lista de estruturas para ver as alterações realizadas.',
        CODE_SEARCH: 'Procurar por códigos',
        VALIDATION_CODE: 'O código {{val}} já existe e está em um planograma funcional ou inativo',
        STORES: 'Pontos de Venda',
        CATEGORIES: 'Categorias',
        DELETE_ALL: 'Excluir tudo',
        CONFIRM_DELETE: 'Tem certeza de que deseja excluir o ponto de venda?',
        CONFIRM_DELETE_ALL: 'Tem certeza de que deseja excluir todos?',
      },
      STRUCTURE: {
        HIDE_PANEL: 'Ocultar Painel',
        OPEN_L_PANEL: 'Abrir o painel esquerdo',
        OPEN_R_PANEL: 'Abrir o painel direito',
      },
      PRODUCTS: {
        TURN_OFF_INDICATOR: 'Desligue o indicador',
        FILTER_TITLE: 'Filtros',
      },
      CONFIRMATION: {
        TITLE: 'Atenção!',
        SUBTITLE: 'Deseja adicionar ao existente ou substituir completamente?',
        REPLACE_BTN: 'Substituir',
        ADD_BTN: 'Adicionar',
      },
      EXTRAS: {
        CATEGORY_TITLE: 'Subcategorias',
        CATEGORY_DESC: 'Selecione as subcategorias relacionadas a este planograma. Você pode modificá-los mais tarde.',
        STORE_TITLE: 'Pontos de Venda',
        STORE_DESC:
          'Atribua os Pontos de Venda individualmente ou em massa aos quais pertencerá. Você poderá modificá-los depois. Use (Ctrl + P) para colar a partir do Excel.',
      },
      MATERIAL_POP: {
        TITLE: 'Material POP',
        ROUTE: 'Planejamento de Espaços',
        NEW_BTN: 'Novo Material POP',
        FULLSCREEN_TTIP: 'Expandir',
        EXITFULLSCREEN_TTIP: 'Reduzir',
        NAME: 'Nome',
        CODE: 'Código',
        TYPE: 'Tipo',
        LAST_MODIF: 'Última Modif.',
        OBSERVATION: 'Observação',
        CHARGE_UNITS: 'Capacidade (UN)',
        LAYOUTS: '# Layouts',
        STP1_INITIAL_DATA: 'Dados Iniciais',
        STP2_ASSEMBLY: 'Armado',
        STP1: 'Etapa 1 - Dados Iniciais',
        BTN_NEXT: 'Próximo',
        STP2: 'Etapa 2 - Montagem',
        DISTANCE: 'Distancia entre Produtos (cm.)',
        PREVIOUS_BTN: 'Anterior',
        SAVE_BTN: 'Salvar',
        MOVE_UP: 'Mover o produto para cima',
        MOVE_DOWN: 'Mover o produto para baixo',
        DELETE: 'Remover o produto',
        SEARCH_PRODUCT: 'Procurar por produto ou código',
        TITLE_FORM: 'Novo Material POP',
        POP_MATERIAL: 'Material POP / ',
        EMTY_MSG: 'Arraste os produtos aqui',
        VALIDATION_CODE: 'O código {{val}} já existe e está em um Materiais POP em uso ou inativo',
        PARENT_MATERIAL: 'Material POP Pai',
        LIST: {
          DELETE_ROW: 'Desativar registro',
          DELETE_ROWS: 'Desativar registros',
          DELETE_ROW_IN_PROCESS: 'Solicitação de inativação em andamento. Notificaremos você assim que concluída.',
          CONTENT_DELETE_PLANOGRAM:
            'Ação não pôde ser concluída com sucesso, o Materiais POP estão associados a pelo menos um plano de exibição.',
        },
      },
      PLANOGRAMS_EDITOR: {
        VARIANT_GROUP: {
          PRINCIPAL_LABEL: '(Variante principal)',
          COLLISION_TOAST: 'Este grupo de variantes já está colocado no planograma. Não pode ser adicionado mais de uma vez.',
          PRINCIPAL_DATA_TOAST: 'Não foi possível carregar os dados do produto principal do grupo de variantes.',
          GROUP_TERM: 'Grupo de equivalência',
        },
      },
      EDITOR: {
        IS_PREVIEW: 'É um Preview',
        PREVIEW: 'Pré-visualizar',
        SAVE_FOR_PREVIEW: 'As alterações devem ser salvas para gerar uma pré-visualização.',
        DELETE: 'Remover pré-visualização',
        OPACITY: 'Opacidade',
        NEW_STRUCTURE: 'Nova estrutura',
        NEW_GENERIC_SPACE: 'Novo espaço genérico',
        DOWNLOAD_EXCEL: 'Baixar reporte',
        LOADING_POG: 'Carregando planograma ...',
        NEW_POG: 'Novo Planograma',
        SAVE: 'Salvar',
        AUTOSAVE_STATUS_SYNCING: 'Sincronizando…',
        AUTOSAVE_STATUS_SAVED: 'Salvo',
        AUTOSAVE_STATUS_ERROR: 'Não foi possível salvar automaticamente',
        AUTOSAVE_STATUS_OFFLINE: 'Sem conexão: tenta novamente sozinho',
        AUTOSAVE_STATUS_PREPARE_ERROR: 'Não foi possível preparar o salvamento automático',
        AUTOSAVE_ERROR_MODAL_MSG:
          'Não foi possível salvar o planograma automaticamente: o servidor respondeu com um erro ({{val}}). Tente novamente em alguns minutos; suas alterações continuam na tela e o salvamento automático é retomado quando um salvamento manual funcionar.',
        STALE_VERSION_MODAL_MSG:
          'Este planograma foi salvo em outra aba ou por outro usuário depois que você o abriu (último salvamento: {{val}}). As alterações desta tela não foram salvas e o salvamento automático ficou em pausa. Recarregue a página para trabalhar na versão mais recente.',
        SAVING: 'Salvando…',
        SAVING_IN_PROGRESS: 'O planograma está sendo salvo…',
        VISUALIZATION: 'Visualização',
        NULL_SPACES: 'Vazio bloqueado',
        NULL_SPACES_LEGEND: ' ',
        SEARCH_STRUCTURE: 'Buscar estrutura',
        STRUCTURE_SELECTED: 'Estrutura selecionada {{val}}',
        STRUCTURES_SELECTED: '{{val}} Estruturas selecionadas',
        STRUCTURE_WITHOUT_MEASUREMENTS: 'Esta estrutura não possui medidas válidas para seus móveis.',
        STRUCTURE_WITHOUT_MODULES: 'Esta estrutura não possui módulos disponíveis.',
        STRUCTURE_INVALID: 'Não foi possível validar a estrutura selecionada.',
        STRUCTURE_LOAD_ERROR: 'Não foi possível carregar a estrutura selecionada. Tente novamente.',
        STRUCTURE_NOT_FOUND: 'A estrutura selecionada não está mais disponível.',
        STRUCTURES_SELECTION_REFRESHED: 'Atualizamos a seleção porque algumas estruturas foram modificadas ou removidas.',
        ORDER: 'Ordenar',
        ORDER_STRUCTURES: 'Ordenar estruturas',
        ORDER_ITEMS: 'Ordenar no planograma',
        ORDER_ITEMS_HINT:
          'Arraste os itens para definir a ordem da esquerda para a direita. As estruturas movem todos os seus módulos como um bloco.',
        ORDER_MANUAL_MODULE: 'Móvel manual',
        BACK_TO_LIST: 'Voltar à lista',
        CLEAN_NI: 'Limpar Vazios bloqueados',
        CLEAN_POG: 'Limpar Planograma',
        NEW_BLOCK_SPACES: 'Adicionar Área',
        EDIT_BLOCK_SPACES: 'Editar Área',
        DELETE_ALL_BLOCK_SPACES: 'Limpar Áreas',
        DELETE_ALL_WARNING: 'Excluir todas as Áreas',
        DELETE_ALL_MSG: 'Esta ação não pode ser desfeita. Deseja continuar?',
        MIRROR_POG: 'Planograma espelhado',
        JUSTIFY_FACINGS: 'Dispersar',
        CLEAN_MOD: 'Limpar Módulo',
        MIRROR_MOD: 'Módulo espelho',
        CLEAN_SHELF: 'Limpar Prateleira',
        MIRROR_SHELF: 'Prateleira espelhada',
        AUTOCOMPLETE_SHELF: 'Auto-completa Estoque',
        SHELF_AVOID_CHECK_SPACE: 'No Validar Tamanhos',
        AUTOCOMPLETE_MODULE: 'Módulo de autocomplete',
        TITLE_POG: 'Planograma',
        TITLE_LAYERS: 'Camadas',
        TITLE_HEATMAP: 'Mapa de Calor',
        TITLE_HEATMAP_SING: 'Mapa de Calor',
        TITLE_VARIABLE: 'Variável',
        TITLE_TIMELINE: 'Linha do tempo',
        TITLE_VARIATIONS: 'Variações',
        TITLE_VIS_ATTRS: 'Visualizar Atributos',
        TITLE_VIS_ATTRS_SING: 'Visualizar Atributo',
        TITLE_VIS_ATTRS_CAT: 'Classificação por categoria',
        TITLE_VIS_ATTRS_DEP: 'anking por departamento',
        TITLE_STORES: 'Pontos de Venda',
        TITLE_FILTERS: 'Filtros',
        TITLE_SEARCH_BTN: 'Adicione produtos à um Strip de Impulso',
        TITLE_TYPE: 'Tipo',
        TITLE_SHELF: 'Estante',
        TITLE_BLOCK_SPACE: 'Área Bloqueada',
        NAME_BLOCK_SPACE: 'Nome',
        COUNT_SHELFS: 'Prateleiras selecionadas:',
        WIDTH_BLOCK_SPACE: 'Largura (cm):',
        DST_X_BLOCK_SPACE: 'Dist. inicial do móvel (cm):',
        TITLE_OWN: 'Própria',
        TITLE_CAPACITY: 'Capacidade',
        TITLE_CAPACITY_LIN: 'Capacidade linear',
        TITLE_CAPACITY_LIN_FREE: 'Cap. Lin. Livre',
        TITLE_ASSIGNED_TO: 'Designado a',
        TITLE_PRODS: 'Produtos',
        TITLE_FACINGS: 'Frentes',
        TITLE_LEVELS: 'Níveis',
        TITLE_LOAD: 'Capacidade',
        TITLE_STOCK_VALUE: 'Estoque R$',
        TITLE_PERFORMANCE: 'Desempenho',
        TITLE_ACTIVES: 'Ativos',
        TITLE_NO_ACTIVES: 'Não ativo',
        TITLE_ACTIVE: 'Ativo',
        TITLE_NO_ACTIVE: 'Inativo em alguns pontos de venda',
        TITLE_NO_ACTIVE_ALL_STORES: 'Inativo em todos os pontos de venda',
        TITLE_IS_BLOCKED: 'Disponível para vendas em algumas lojas',
        TITLE_NO_BLOCKED: 'Disponível para vendas',
        TITLE_BLOCKED_ALL_STORES: 'Bloqueado para vendas',
        TITLE_SEARCH: 'Procurar',
        TITLE_EXHIBITED: 'Exibidos',
        TITLE_EXHIBITED_SING: 'Exibido',
        TITLE_NO_EXHIBITED: 'Não exibido',
        TITLE_NEW_ONLY: 'Apenas novo',
        TITLE_BLOCKEDFORSALES: 'Bloqueado para vendas',
        TITLE_BLOCKEDFORSALES_NO: 'Disponível para vendas',
        TITLE_ADVANCED_FILTERS: 'Filtros Avançados',
        TITLE_CLEAN_FILTERS: 'Limpar Filtros',
        TITLE_SMALL_COD: 'Código',
        TITLE_SMALL_UNIT_MED: 'Unidade de Medida',
        TITLE_EAN: 'EAN',
        TITLE_BRAND: 'Marca',
        TITLE_SUPLIER: 'Fornecedor',
        TITLE_CAN_STACK: 'Pode Empilhar',
        TITLE_CAN_LAYDOWN: 'Pode Deitar',
        TITLE_CAN_ROTATE: 'Pode Rotar',
        TITLE_SALES_PART_PER: 'Part. % Vendas',
        TITLE_SALES_PART_LIN_ESP: 'Part. % Espaço (m/lin)',
        TITLE_EXH_DAYS: 'Dias em Exhibição',
        TITLE_EXH_STOCK: 'Dias em Estoque',
        TITLE_STOCK: 'Estoque R$',
        TITLE_STOCK_UN: 'Estoque UN',
        TITLE_DATE: 'Data',
        TITLE_USER: 'Usuário',
        TITLE_ANALISYS_TYPE: 'Tipo de Análise',
        TITLE_LOAD_LIMIT: 'Limite de carga',
        TITLE_STACK_LIMIT: 'Limíte de Empilhado',
        TITLE_LIMIT_PLACEHOLDER: 'lim.',
        TITLE_IS_PALLET: 'É um pallet',
        TITLE_IS_PALLET_PLACEHOLDER: 'É um pallet',
        FILTER_POPMATERIALESPECIAL: 'Material POP Especial',
        FREE_AREA: 'Área Livre',
        TOTAL_AREA: 'Área total',
        TOTAL_PLANOGRAMS: 'Planogramas',
        YES: 'Sim',
        NO: 'Não',
        TTIP_UNDO: 'Desfazer última alteração [ctrl + z]',
        TTIP_REDO: 'Refazer a última alteração [ctrl + y]',
        TTIP_DRAG: 'Arrastar [barra de espaço + mouse]',
        TTIP_FIT: 'Ajustar conteúdo [ctrl+0]',
        TTIP_ZOOM_IN: 'Zoom [+]',
        TTIP_ZOOM_OUT: 'Zoom [-]',
        TTIP_FULL_SCREEN: 'Maximizar a tela',
        TTIP_FULL_PRINT: 'Imprimir [ctrl + p]',
        TTIP_OPTIONS: 'Opções',
        TTIP_DEL: 'Apagar [del]',
        TTIP_CLONE: 'Clonar Módulo',
        TTIP_CLONE_ALT: 'Clonar',
        TTIP_COMMENTS: 'Comentários',
        TTIP_STACK_WARING: 'Este produto não é empilhável',
        PRINT_NAME: 'Nome',
        PRINT_POSITION: 'Posição',
        PRINT_NAME_CAT: 'Nome da Categoria',
        PRINT_NAME_SUBCAT: 'Nome da Subcategoria',
        PRINT_UNIT_MESURE: 'Unidade de Medida',
        PRINT_BRAND: 'Marca',
        PRINT_MANUFACTURE: 'Fabricante',
        PRINT_WIDTH: 'Largura',
        PRINT_HEIGHT: 'Altura',
        PRINT_DEPTH: 'Profundidade',
        PRINT_FACES: 'Faces',
        PRINT_LOAD: 'Carga Máxima.',
        PRINT_LINEAL_SPACE: 'Espaço Linear',
        PRINT_ROTATION: 'Rotação',
        PRINT_STACK: 'Pilhas',
        PRINT_VARIANT: 'Variante',
        PRINT_CONSOLIDATED_EQUIVALENTS: 'Equivalentes Consolidados',
        PRINT_MEMBER_CUFS: 'CUFs Membros',
        PRINT_TOTAL_FACINGS: 'Total Frentes',
        PRINT_TOTAL_LOAD: 'Carga Total',
        PRINT_SALES: 'Vendas',
        PRINT_UNITS: 'Unidades',
        PRINT_MARGIN: 'Margem',
        PRINT_VARIANT_LISTING: 'Lista de Variantes',
        PRINT_PRINCIPAL_PRODUCT_CODE: 'Código Produto Principal',
        PRINT_PRINCIPAL_PRODUCT_NAME: 'Nome Produto Principal',
        PRINT_VARIANT_PRODUCT_CODE: 'Código Produto Variante',
        PRINT_VARIANT_PRODUCT_NAME: 'Nome Produto Variante',
        MSG_SHELF_SHOULD_EMPTY: 'A prateleira deve estar vazia.',
        MSG_CONFIRM_SAVE: 'Tem certeza de que deseja salvar o planograma?',
        MSG_CONFIRM_SAVE_TEMPLATE: 'Confirme se deseja salvar a estrutura?',
        MSG_CONFIRM_SAVE_SPACE: 'Tem certeza de que deseja salvar o espaço genérico?',
        MSG_WIDTH_NI: 'Deve-se atribuir a largura do espaço vazio.',
        MSG_CONFIRM_DEL_PRODS: 'Deseja prosseguir com a remoção de todos os produtos do planograma?',
        MSG_CONFIRM_DEL_NI_PRODS: 'Deseja prosseguir com a remoção de todos os espaços vazios do planograma?',
        MSG_CONFIRM_MIRROR_PRODS: 'Você quer continuar com o planograma de espelhamento?',
        MSG_CONFIRM_DEL_SHELF_PRODS: 'Quer continuar retirando todos os produtos da prateleira?',
        MSG_CONFIRM_MIRROR_SHELF_PRODS: 'Você quer continuar com o espelhamento de todos os produtos na prateleira?',
        MSG_CONFIRM_DEL_PRODS_MOD: 'Quer continuar removendo todos os produtos do módulo?',
        MSG_CONFIRM_MIRROR_PRODS_MOD: 'Você quer continuar com o espelhamento de todos os produtos do módulo?',
        MSG_CONFIRM_DEL_PRODS_MOD_PRD: 'Quer continuar com a remoção do módulo? <br> <b> Todos os produtos serão removidos. </b>',
        MSG_CONFIRM_DEL_PRODS_SHELF_PRD: 'Quer continuar removendo a prateleira? <br> <b> Todos os produtos serão removidos. </b>',
        MSG_CONFIRM_DEL: 'Confirmação de exclusão.',
        MSG_CONFIRM_MIRROR: 'Confirmação de espelhamento.',
        MSG_MODULE_WIDTH_ALERT: 'Existem produtos na prateleira que não cabem na nova largura.',
        MSG_MODULE_DEPTH_ALERT: 'Existem produtos na prateleira que não se encaixam na nova profundidade.',
        MSG_PRD_NO_ENOUGH_SPACE: 'Espaço insuficiente.',
        MSG_PRD_NO_ENOUGH_SPACE_LIMIT: 'Carregamento máximo.',
        MSG_COMPRESSION_APPLIED: 'Compressão aplicada: {{val}}%',
        MSG_COMPRESSION_BLOCKED: 'Não foi possível adicionar frentes: {{val}} excede a compressão máxima ou não é comprimível.',
        MSG_COMPRESSION_ADD_FACING_REJECTED: 'Espaço insuficiente para adicionar um frente, mesmo comprimindo os produtos da prateleira.',
        MSG_COMPRESSION_ADD_PRODUCT_REJECTED: 'Espaço insuficiente para adicionar o produto, mesmo comprimindo os produtos da prateleira.',
        MSG_COMPRESSION_ORIENTATION_REJECTED: 'Espaço insuficiente para esta orientação, mesmo comprimindo os produtos da prateleira.',
        MSG_PRD_CATN_ROTATE: 'O produto selecionado não pode ser girado.',
        MSG_PRD_CATN_LAYDOWN: 'O produto selecionado não pode ser tombado.',
        MSG_PRD_CATN_ROTATE_LAYDOWN: 'Produtos caídos não podem ser girados.',
        MSG_PRD_CATN_ROTATE_ROTATEY: 'Produtos caídos não podem ser girados.',
        MSG_PRD_CATN_PALLET: 'O produto escolhido não pode ser colocado em modo de prateleira por falta de espaço.',
        MSG_SHELF_SHOULD_EMPTY_TYPE: 'Esvazie a prateleira antes de mudar seu tipo.',
        MSG_SHELF_PRD_HEIGTH_WARNING: 'Existem produtos com altura superior à da prateleira',
        MSG_SHELF_PRD_DEPTH_WARNING: 'Existem produtos com uma profundidade maior que a prateleira.',
        BTN_CANCEL: 'Cancelar',
        BTN_DEL: 'Remover',
        BTN_ACEPT: 'Aceitar',
        BTN_PRINT: 'Imprimir',
        BTN_CLEAN: 'Limpar',
        BTN_APPLY: 'Aplicar',
        BTN_SAVE: 'Salvar',
        BTN_CLOSE: 'Fechar',
        ACTION_REORDER_LEFT: 'Reordenar à Esquerda',
        ACTION_REORDER_RIGHT: 'Reordenar à Direita',
        ACTION_ADD_SHELF: 'Adicionar Prateleira',
        ACTION_DEL_PRODS: 'Apagar Produtos',
        ACTION_PRD_ADD_FACING: 'Adicionar uma frente [ctrl+right]',
        ACTION_PRD_REMOVE_FACING: 'Remover Frentes [ctrl + esquerda]',
        ACTION_PRD_STACKSLYINGDOWN: 'Nao tombar frentes',
        ACTION_PRD_NO_STACKSLYINGDOWN: 'Tombar frentes',
        ACTION_PRD_ROTATE_CW_NORMAL: 'Girar para a direita [r]',
        ACTION_PRD_ROTATE_NOCW: 'Girar para a esquerda',
        ACTION_PRD_ROTATE_CW: 'Deitar a direita [d]',
        ACTION_PRD_ROTATE_UP_CW: 'Parar o produto [r]',
        ACTION_PRD_ROTATE_REV: 'Deitar a esquerda',
        ACTION_PRD_ROTATE_REV_Y: 'Vista de Lateral',
        ACTION_PRD_ROTATE_REV_Y2: 'Ver de frente',
        MASS_SELECTION_ACTIONS_TITLE: 'Ações em massa',
        MASS_SELECTION_PRODUCTS_SELECTED: 'Produtos selecionados ({{val}})',
        MASS_SELECTION_SHELFS_SELECTED: 'Prateleiras selecionadas ({{val}})',
        MASS_SELECTION_COPY_PRODUCTS: 'Copiar produtos [Ctrl + C]',
        MASS_SELECTION_COPY_SUCCESS: '{{val}} produtos copiados.',
        MASS_SELECTION_ADD_FACING: 'Adicionar uma frente',
        MASS_SELECTION_REMOVE_FACING: 'Remover uma frente',
        MASS_SELECTION_ROTATE_RIGHT: 'Girar para a direita',
        MASS_SELECTION_VIEW_FRONT: 'Vista frontal',
        MASS_SELECTION_VIEW_SIDE: 'Vista lateral',
        MASS_SELECTION_VIEW_TOP: 'Vista superior',
        MASS_SELECTION_LOAD_LIMIT: 'Limite de carga',
        MASS_SELECTION_STACK_LIMIT: 'Limite de empilhado',
        MASS_SELECTION_DISABLE_LIMIT: 'Desativar limite',
        MASS_SELECTION_LIMIT_INVALID: 'Informe um limite válido maior que 0.',
        MASS_SELECTION_DEPTH_INVALID: 'Informe uma profundidade válida entre 6 e 1000.',
        MASS_SELECTION_DEPTH_UPDATED: 'A profundidade foi atualizada para {{val}} prateleiras.',
        MASS_SELECTION_NOT_APPLIED_TITLE: 'Ação em massa parcial',
        MASS_SELECTION_NOT_APPLIED_MESSAGE: '"{{val}}" não foi aplicada aos seguintes produtos porque essa opção não está habilitada:',
        MASS_SELECTION_NOT_APPLIED_MESSAGE_ADD_FACING:
          '"{{val}}" não pôde ser aplicada aos seguintes produtos por falta de espaço disponível:',
        MASS_SELECTION_NOT_APPLIED_MESSAGE_REMOVE_FACING:
          '"{{val}}" não pôde ser aplicada aos seguintes produtos porque já possuem apenas uma frente:',
        ACTION_SHELF_MOVEUP: 'Subir',
        ACTION_SHELF_MOVEDOWN: 'Mover para baixo',
        ACTION_SHELF_ADD_UP: 'Adicionar Prateleira Acima',
        ACTION_SHELF_ADD_DOWN: 'Adicionar Prateleira Embaixo',
        ACTION_SHELF_DEL_PRODS: 'Apagar Produtos',
        SHELF_PASTE_PRODUCTS: 'Colar produtos [Ctrl + V]',
        SHELF_PASTE_SUCCESS: '{{val}} produtos colados.',
        SHELF_PASTE_PARTIAL: '{{added}} de {{total}} produtos foram colados. Não há espaço suficiente na prateleira.',
        SHELF_PASTE_NO_SPACE: 'Não há espaço suficiente na prateleira para colar os produtos copiados.',
        MASS_MOVE_SUCCESS: '{{val}} produtos foram movidos.',
        MASS_MOVE_PARTIAL: '{{added}} produtos foram movidos. {{failed}} não couberam.',
        MASS_MOVE_NO_SPACE: 'Não há espaço suficiente na prateleira para mover os produtos selecionados.',
        ACTION_LAYER_TOGGLE_MODS: 'Ocultar / Ativar Módulos',
        ACTION_LAYER_HIDE_MODS: 'Ocultar Módulos',
        ACTION_LAYER_SHOW_MODS: 'Mostrar Módulos',
        ACTION_LAYER_HIDE_PRODS: 'Ocultar Produtos',
        ACTION_LAYER_HIDE_IMG: 'Ocultar imagens',
        ACTION_LAYER_SHOW_IMG: 'Mostrar imagens',
        ACTION_LAYER_HIDE_TEXT_ANNOTATIONS: 'Ocultar textos livres',
        ACTION_LAYER_SHOW_TEXT_ANNOTATIONS: 'Mostrar textos livres',
        ACTION_LAYER_SHOW_PRODS: 'Mostrar Produtos',
        ACTION_LAYER_HIDE_POP: 'Ocultar Material POP',
        ACTION_LAYER_SHOW_POP: 'Mostrar Material POP',
        ACTION_LAYER_HIDE_PITSHELF: 'Mostrar Freezer de frente',
        ACTION_LAYER_SHOW_PITSHELF: 'Mostrar Freezer 3D',
        ACTION_ADD_CONSTRAINTS: 'Adicionar Restrições',
        SHELF: 'Estante',
        SHELF_FRONT_VIEW: 'Vista frontal da caixa',
        SHELF_NORMAL_TYPE_SHELF: 'Estanterias',
        SHELF_NORMAL_TYPE_REFRIGERATOR: 'Geladeiras',
        SHELF_NORMAL_TYPE_SIMPLEPEG: 'Gancheira',
        SHELF_NORMAL_TYPE_PITSHELF: 'Box / Geladeira',
        SHELF_NORMAL_TYPE_PALLET: 'Palete',
        SHELF_NORMAL_TYPE_SLATWALL: 'Gancheiras SlatWall',
        NEW_SLATWALL: 'Novo SlatWall',
        MAG_SLAT_SPACING: 'Espacamento entre ripas',
        MAG_HOOK_DISTANCE: 'Distancia entre ganchos',
        MAG_HOOK_HEIGHT: 'Altura do gancho',
        MAG_HOOK_LENGTH: 'Comprimento do gancho',
        MAG_VERTICAL_MARGIN: 'Margem vertical',
        MAG_PRICE_TAG_HEIGHT: 'Altura da etiqueta de preco',
        MAG_PRICE_TAG_WIDTH: 'Largura da etiqueta de preco',
        SHOW_PRICE_TAG: 'Mostrar etiqueta de preco',
        PEGBOARD_LAYOUT: 'Layout do pegboard',
        PEGBOARD_LAYOUT_MASONRY: 'Masonry',
        PEGBOARD_LAYOUT_ROWBASED: 'Por linhas',
        SHELF_CANT_LEVELS: '# de Níveis',
        MOD_TITLE: 'Módulo',
        BARTAB_GENERAL: 'Geral',
        BARTAB_MODULES: 'Estrutura',
        BARTAB_BLOCK_SPACES: 'Áreas Bloqueáveis',
        BARTAB_PROMOTION_MATERIAL: 'Materiais de Promoção',
        BARTAB_SCOPES: 'Escopo Produtos',
        BARTAB_MODULES_PL: 'Estruturas',
        BARTAB_PRODS: 'Produtos',
        BARTAB_MULTI_PLANOGRAMS: 'Multi-Planogramas',
        BARTAB_OTHERS: 'Outros',
        BARTAB_POPMAT: 'Material POP',
        BARTAB_ACCESSORIES: 'Acessórios',
        FREE_TEXT: 'Texto Livre',
        FREE_TEXT_PLACEHOLDER: 'Adicionar texto livre aqui...',
        FREE_TEXT_ANNOTATION_PLACEHOLDER: 'Escreva uma anotação...',
        DELETE_TEXT_ANNOTATION: 'Excluir texto livre',
        TEXT_ANNOTATION_UNKNOWN_AUTHOR: 'Usuário',
        TEXT_ANNOTATION_FORMAT: 'Formato do texto',
        TEXT_ANNOTATION_MOVE: 'Mover',
        TEXT_ANNOTATION_RESIZE_WIDTH: 'Alterar largura',
        TEXT_ANNOTATION_RESIZE_HEIGHT: 'Alterar altura',
        TEXT_ANNOTATION_RESIZE_CORNER: 'Alterar largura e altura',
        TEXT_ANNOTATION_FONT_SIZE: 'Tamanho da fonte',
        TEXT_ANNOTATION_TEXT_COLOR: 'Cor',
        TEXT_ANNOTATION_BACKGROUND_COLOR: 'Fundo',
        TEXT_ANNOTATION_NO_BACKGROUND: 'Sem fundo',
        BARTAB_ANALISYS: 'Análise',
        BARTAB_CONSTRAINTS: 'Restrições',
        BARTAB_AUDIT: 'Auditoria',
        BADGE_GENERIC_SPACE: 'Genérico',
        BADGE_SPECIFIC_SPACE_PREFIX: 'Específico —',
        BADGE_SPECIFIC_SPACE_SUFFIX: 'PDV',
        TRANSITION_TO_SPECIFIC: 'PDV atribuído. Sortimento, indicadores e performance foram habilitados.',
        TRANSITION_TO_GENERIC: 'PDV removido. O planograma volta ao modo genérico. Os produtos posicionados são preservados.',
        PLANOGRAM_WITHOUT_STORES: 'Planograma sem Lojas associadas',
        BARTAB_MAX_QUANT: 'Quantidade Máxima de Promoções',
        IND_SALES: 'Vendas',
        IND_SALES_MAG: 'Vendas R$',
        IND_SALES_UINIT: 'Vendas UN.',
        IND_SALES_UINIT_PER: 'Vendas UN. %',
        IND_SALES_PER: '% Vendas R$',
        IND_MARGIN: 'Margem',
        IND_MARGIN_UNIT: 'Margem UN.',
        IND_MARGIN_MAG: 'Margem R$',
        IND_MARGIN_PER: 'Mergem %',
        IND_MARGIN_TOT: 'Margem Tot.',
        IND_ESP_MT_LIN: 'Esp. (m/lin) %',
        IND_ESP_MT2_LIN: 'Esp. m2',
        IND_SPACE_SUB: 'Sobespaçado',
        IND_SPACE_OK: 'Equilibrado',
        IND_SPACE_HI: 'Espaço Superestimado',
        SPACE_WARNING: 'Espaço Alerta',
        IND_SPACE_SUB_SMALL: 'Sob',
        IND_SPACE_OK_SMALL: 'Bal.',
        IND_SPACE_HI_SMALL: 'Sobre',
        IND_SPACE_GMROI: 'GMROI',
        IND_SPACE_GMROS: 'GMROS',
        IND_SPACE_PRICE: 'Preço',
        IND_SPACE_NONE: 'Nenhum',
        IND_SPACE_DAYS_EXH: 'Dias em Exhibição',
        IND_SPACE_DAYS_EXH_FULL: 'Dias em Exhibição',
        IND_SALES_PER_PROD: 'Vendas R$ por produto',
        IND_SALES_PER_FACING: 'Vendas por frente',
        IND_SALES_MTS_LIN_RATIO: 'Vendas R$ / Espaço',
        IND_SALES_MTS_LIN_RATIO_USED: 'VendasR$ / Espaço Usado',
        IND_SALES_PRICE_PROM: 'Preço Médio R$',
        IND_SALES_MARGIN_PROM: 'Margem Média R$',
        IND_SALES_MARGIN_PROM_PER: 'Margem Média %',
        IND_SALES_MONTH_UNITS: 'Vendas Mes UN',
        OPEN_IN_ITEM_MASTER: 'Aberto no Item Master',
        IND_SALES_MONTH: 'Vendas Mes R$',
        IND_SALES_UNITS_FACINGS: 'Venda UN / Frentes',
        IND_MARGIN_MONTH: 'Margem Mes',
        IND_SPACE_ASSIGN: 'Alocação de espaço',
        IND_SPACE_ASSIGN_FULL: 'Alocação de espaço',
        IND_LOAD: 'Capacidade',
        IND_STOCK_DAYS: 'Dias em Estoque',
        IND_STOCK_DAYS_FULL: 'Dias em Estoque',
        IND_ATTRS: 'Atributos',
        IND_NONE: 'Nenhum',
        IND_DAYS: 'Días',
        IND_MIN_SMALL: 'Mín.',
        IND_MAX_SMALL: 'Máx.',
        IND_NORMAL: 'Normal',
        IND_BIGGER_THAN_DAYS: 'Maior do que {{val}} dias',
        IND_SMALER_THAN_DAYS: 'Menos de {{val}} dias',
        MAG_DEFAULT: 'cm.',
        MAG_VOL_DEFAULT: 'm³',
        MAG_HEIGHT_WITH_MAG: 'Altura (cm.)',
        MAG_HEIGHT_WITH_MAG_ALLMOD: 'Altura (cm.)',
        MAG_WIDTH_WITH_MAG: 'Largura (cm)',
        MAG_DEPTH_WITH_MAG: 'Profundidade (cm.)',
        MARGIN_LEFT: 'Margem Esquerda (cm.)',
        MARGIN_RIGHT: 'Margem Direita (cm.)',
        MAG_GUIDES: 'Distância das guias (cm)',
        MAG_HEIGHT: 'Alto',
        MAG_WIDTH: 'Largura',
        MAG_DEPTH: 'Profundidade',
        MAG_VOL: 'Vol.',
        PRINT_TITLE_DIALOG: 'Imprimir Planograma',
        PRINT_MODS_SELECTION:
          'Escolha o módulo a ser impresso, se deixar a faixa vazia, todos os módulos serão impressos. (É possível usar intervalos, ex: 2-4)',
        PRINT_MODS_TO_PRINT: 'Módulos para imprimir',
        PRINT_PRINT_TYPES: 'Tipos de impressão',
        PRINT_COMMENTS: 'Comentários',
        PRINT_REVERSE_VIEW: 'Imprimir reverso',
        PRINT_BODIES_PER_PAGE: 'Corpos por página',
        PRINT_BODY_LABEL: 'Corpo {{val}}',
        PRINT_PRINT_TYPE_IMAGES: 'Imagens',
        PRINT_PRINT_TYPE_GROUP: 'Código de Grupos',
        PRINT_PRINT_TYPE_INDIV: 'Códigos Individuais',
        PRINT_PRINT_TYPE_ALL_PLANOGRAM_IMAGE: 'Planograma Completo',
        PRINT_PRINT_TYPE_POP: 'Material POP',
        PRINT_REPORT: 'Relatório Listagem',
        PRINT_WARN_NO_RANGE: 'Não há módulos para imprimir dentro do intervalo selecionado.',
        AUDIT_STATUS: 'Status',
        AUDIT_LAST_PUBLISH: 'Últ. Pub.',
        AUDIT_NO_IMAGE: 'Sem Imagem',
        AUDIT_IMG_UPLOAD: 'Carregar Imagem',
        AUDIT_IMG_VIEW: 'Visualizar Imagem',
        OPEN_PRISMA_VISION: 'Conformidade',
        AUDIT_TITLE: 'Auditoria',
        AUDIT_WARNING_NO_SAVED: 'Para alterar o status do planograma, não deve haver alterações não salvas.',
        AUDIT_AUDIT_IMG: 'Imagem de auditoria',
        AUDIT_NEW_AUDIT_IMG: 'Nova imagem de auditoria',
        AUDIT_NEW_AUDIT_IMG_OK: 'Imagem salva com sucesso',
        CONSTRAINTS_TITLE: 'Restrições',
        TLINE_TITLE: 'Linha do tempo',
        TLINE_ACTUAL_TIME: 'Atual (Hoje)',
        TLINE_TOTAL_MARG: 'Margem Total',
        TLINE_SALES_UNITS: 'Vendas UN',
        TLINE_LAST_PUB: 'Anterior [ctrl + esquerda]',
        TLINE_NEXT_PUB: 'Próxima [ctrl + direita]',
        TLINE_CLOSE_TL: 'Fechar Linha do Tempo',
        TLINE_OPEN_TL: 'Abris linha do tempo',
        TYPES: {
          'normalShelf-module': 'Estante',
          'simplePeg-module': 'Gancheira',
          'slatWall-module': 'Gancheiras SlatWall',
          'pitShelf-module': 'Freezer Horizontal',
          'refrigerator-module': 'Geladeiras',
          'normalShelf-level': 'Estante',
          'simplePeg-level': 'Gancheira',
          'slatWall-level': 'Gancheiras SlatWall',
          'pitShelf-level': 'Freezer Horizontal',
          'float-pop-impulse-strip-simple': 'Tira de Impulso',
        },
        COMM_TITLE: 'Comentários',
        COMM_DATE: 'Data',
        COMM_COMMENT: 'Comentários',
        COMM_NEW_COMMENT: 'Novo comentário',
        COMM_READ_MORE: '[Ler mais]',
        MENTION_NO_RESULTS: 'Sem resultados',
        NEW_NORMALSHELF: 'Nova Prateleira',
        NEW_REFRIGERATOR: 'Nova Geladeira',
        NEW_SIMPLEPEG: 'Nova Gancheira',
        NEW_PITSHELF: 'Nova Caixa / Geladeira',
        CONSTRAINS_TYPES: {
          MIN_FACINGS: 'Frentes mínimas por produto',
          MAX_FACINGS: 'Frentes máximas por produto',
          MIN_LINE_SPACE: 'Espaço linear mínimo',
          MAX_LINE_SPACE: 'Espaço linear máximo',
          MIN_SHARE_SPACE: 'Participação mínima de espaço',
          MAX_SHARE_SPACE: 'Participação máxima de espaço',
        },
        CONSTRAINS_NAME_TITLE: 'Nome',
        CONSTRAINS_APPLY_TO: 'Aplicar a:',
        CONSTRAINS_ALL_THE_PLANOGRAM: 'Todo o Planograma',
        CONSTRAINS_ALL_THE_PLANOGRAM_TTIP: 'Esta regra se aplica a todo o planograma',
        CONSTRAINS_ALL_SHELF_TTIP: 'Esta regra se aplica a toda a prateleira',
        CONSTRAINS_ALL_SHELF_MODULE_TTIP: 'Esta regra se aplicará a todo o módulo',
        CONSTRAINS_SHELF_SELECTED: 'Estante',
        CONSTRAINS_SHELF_MODULE: 'Módulo',
        CONSTRAINS_CONDITION: 'Condição',
        CONSTRAINS_FRONTS_VALUE: 'Frentes',
        CONSTRAINS_LINE_SPACE_VALUE: 'espaço linear (cm.)',
        CONSTRAINS_SHARE_SPACE_VALUE: '% Espaço',
        CONSTRAINS_GROUP_EAN: 'Agrupado por EAN',
        CONSTRAINS_ALL_ITEMS: 'Todos os ítens',
        CONSTRAINS_WARNINGS: 'Alertas',
        CONSTRAINS_ONLY_THIS: 'Visualizar alertas',
        CONSTRAINS_WARNINGS_SIZE: 'Quantidade de Alertas',
        DELETE_DELETE_ITEM: 'Remover iten',
        DELETE_DELETE_ALL_EANS: 'Remover todos os itens agrupados por EAN',
        CLONE_STRUCTURE: 'Clonar únicamente a estrutura',
      },
      SPACES_TEMPLATES: {
        GENERATION_PLANOGRAMS: 'Planogramas de geração ...',
        GENERATION_PLANOGRAMS_ALT:
          'O pedido para geração de Plano de Exposição foi salvo e está sendo processado. Você receberá uma notificação quando estiver concluído.',
        TITLE: 'Modelos',
        TITLE_NEW: 'Novo Modelo',
        TAB_GENERAL: 'em geral',
        TAB_BLOCKS: 'Configuração de Blocos',
        TAB_BLOCKS_TT: 'Define as regras de ordenação e condições comerciais para a geração de planogramas.',
        TAB_PLANOGRAMS: 'Planogramas',
        TAB_STRUCTURES: 'Estruturas',
        TAB_GENERATE: 'Geração',
        DEMO_TITLE_EDIT: 'Template para YOGHURT',
        DEMO_TITLE_CODE_EDIT: 'YOG1',
        PREVIEW: 'Visualização',
        CLOSE_PREVIEW: 'Fechar visualização',
        NEW_DIVISION: 'Nova Divisão',
        DIVISION: 'Divisão',
        LEVELS: 'Níveis',
        LEVEL_BLOCK: 'Nível de Bloco',
        TABLE: {
          NAME: 'Nome',
          FRONT: 'Largura',
          HEIGHT: 'Alto',
          SHELVES: 'Prateleiras',
          STORES: 'Pontos de Venda',
          BLOCK_AREAS: 'Atribuir Espaços Bloqueados',
          STORES_VIEW: 'Ver Pontos de Venda',
          STRUCTURE_VIEW: 'Ver Estrutura',
          DELETE: 'Apagar',
          SAVED_AREAS: 'Espaços Bloqueados',
        },
        LIST: {
          TITLE: 'Lista de modelos',
          PLANOGRAMS: 'Planogramas',
          STRUCTURES: 'Estruturas',
          GenericSpace: 'Espaço Genérico',
          DIVISIONS: 'Divisões',
          NO_DIVISIONS: 'Adicione divisões para começar a definir seus blocos.',
          NO_BLOCKS: 'Atualmente não há produtos disponíveis para a configuração selecionada.',
          TAG_SCOPE: 'Hit Tags',
          CATEGORY_SCOPE: 'Categorias alcançadas',
          EXCEED_TOLERANCE: 'Excesso tolerado',
          MIN_LINEAR_SPACE: 'Espaço linear mínimo',
          MAX_LINEAR_SPACE: 'Espaço linear máximo',
          LINEAR_SPACE_CALC_TYPE: 'Tipo de Cálculo Linear',
          LEVELS: 'Níveis',
          CODE: 'Código',
          NAME: 'inhame',
          EDIT_ROW: 'Editar',
          COPY_ROW: 'Clone',
          DELETE_ROW: 'Excluir',
          ITEM_TAGS: 'Tags de produto',
          NEW_ITEM: 'Novo modelo',
          DELETE: 'Excluir',
          DELETE_TTIP: 'Excluir um modelo',
          FILTER: 'Filtro avançado',
          FILTER_TTIP: 'Habilite ou desabilite o Filtro Avançado',
          EXPORT: 'Exportar',
          EXPORT_TTIP: 'Exportar um modelo',
          DELETE_ROW_IN_PROCESS: 'Solicitação de inativação em andamento. Notificaremos você assim que concluída.',
          DELETE_ROWS: 'Desativar registros',
        },
        PLANOGRAMS: {
          TITLE: 'Planogramas Associados',
          INTRO: 'Atribua as estruturas para vinculá-las ao modelo',
          PLANOGRAMS: 'Planogramas',
          STRUCTURES: 'Estruturas',
        },
        LINEAR_SPACES: {
          SALES: 'Vendas $',
          UNITS: 'Unidades de Vendas',
          MARGIN: 'Margem $',
          PROJECTEDSALES: 'Venda Projetada',
          STOCK: 'Estoque',
          PRICE: 'Preço',
          RANKING: 'Ranking',
        },
        MAIN_TAB: {
          TITLE: 'Dados gerais',
          CODE: 'Código',
          CODE_EXIST: 'Código já existe',
          NAME: 'inhame',
          LEVELS: 'Níveis',
          LINEAR_SPACE_CALC: 'Cálculo de frentes baseado em',
          MIN_LINEAR_SPACE: 'Mínimo de espaço linear',
          MAX_LINEAR_SPACE: 'Espaço linear máximo',
          LEVELS_PER_PRODUCT: 'Níveis por produto',
          ORDER_TYPE: 'Tipo de ordenamento',
          FILL_SPACES: 'Otimizar espaço',
          FACINGS_LIMIT: 'Usar limites por item',
          FILL_SPACES_MSG:
            'Ao habilitar esta opção, os espaços vazios nos planogramas serão automaticamente preenchidos, maximizando o uso do espaço disponível e evitando a perda de oportunidades de negócios',
          FACINGS_LIMIT_MSG:
            'Ao habilitar esta opção, os limites mínimos e máximos configurados para cada SKU serão aplicados, garantindo visibilidade e evitando excesso de estoque',
          EXCEED_BLOCK_TOLERANCE: 'Tolerância para exceder a largura do bloco',
          SCOPE_ITEMS: 'Escopo do Produto',
          SCOPE_ITEMS_COUNT: 'Produtos selecionados',
        },
        GENERATE: {
          TITLE: 'Geração de Planograma',
          INTRO:
            'Selecione o critério para gerar seus planogramas de maneira eficiente. Otimize a apresentação dos seus produtos nos pontos de venda de acordo com suas necessidades específicas.',
          BTN1_TITLE: 'Geração por Estrutura',
          BTN1_MSG: 'Desenvolva um planograma para cada estrutura, usando a média dos dados de todas as lojas com essa estrutura.',
          VERIFY_CONFIG: 'Verificar Configuração',
          VERIFY_CONFIG_DESC: 'Verifique a configuração do template para garantir que está completa e correta.',
          HAS_ALERTS: 'Tem alertas',
          NO_ALERTS: 'Não tem alertas',
          BTN2_TITLE: 'Geração por Ponto de Venda',
          BTN2_MSG: 'Crie um planograma específico para cada loja, usando dados detalhados de cada ponto de venda.',
          BTN3_TITLE: 'Geração por Cluster',
          BTN3_MSG:
            'Gera planogramas para clusters de lojas que compartilham comportamentos semelhantes, usando a média dos dados de cada grupo.',
          TEXT1:
            'Um planograma será gerado para cada estrutura associada ao Template; o desempenho de cada produto será a média dos pontos de venda associados à estrutura.',
          TEXT2:
            'Um planograma será gerado para cada Ponto de Venda associado às Estruturas do Template; o desempenho de cada produto será correspondente a cada Ponto de Venda. Importante: Se um ou mais Pontos de Venda estiver presente em mais de uma estrutura, então será gerado um planograma para cada dupla Estrutura-Ponto de Venda.',
          TEXT3:
            'Um planograma será gerado para cada Cluster selecionado; o desempenho de cada produto será a média em cada Cluster. Importante: Se houver múltiplas estruturas, e estas estiverem associadas a Pontos de Venda de um mesmo Cluster, então serão gerados planogramas para cada dupla Cluster-Estrutura.',
          INTRO2: 'Este processo pode demorar vários minutos',
          PLANOGRAM: 'Gerar Planograma',
          PREVIEW: 'Gerar visualização',
          MODAL_TITLE_PREVIEW: 'Gerar visualização',
          MODAL_INTRO_PREVIEW: 'Selecione o ponto de venda para gerar a visualização',
          MODAL_TITLE_GENERATE: 'Gerar planogramas',
          MODAL_INTRO_GENERATE: 'Selecione as saídas associadas para gerar os planogramas relacionados',
          SELECT_PLANOGRAM: 'Planogramas',
          SELECT_STORE: 'Lojas',
          SELECT_AREA: 'Espaços Bloqueados',
          SELECT_STRUCTURE: 'Estruturas',
          SELECT_CLUSTER: 'Cluster',
          ACCEPT: 'Aceitar',
          CANCEL: 'Cancelar',
          ALERT: 'Salvar alterações para gerar planogramas',
          WARNING: 'Precisa salvar as alterações para gerar planograms com as novas modificações das estruturas de aba',
          WARNING_ALT: 'Detectaram-se alterações não salvas. As alterações não salvas serão salvas automaticamente ao gerar planogramas.',
          WARNING_ALT_PDV: 'Você deve salvar as alterações para ver os pontos de venda.',
          CREATEVERSIONFOR: 'Geração de Plano de Exposição para:',
          PREVIEW_MODE: 'Geração de planogramas como Rascunho',
          ALERTS: {
            NO_EXHIBIT: 'Há produtos não exibíveis, a configuração da Unidade de Medida no Item Master deve ser verificada',
            STORE_NOT_AVAILABLE: 'Há {{quantity}} produtos indisponíveis para venda na loja: {{storeCode}}',
            STRUCTURE_OVERSPACE:
              'Há móveis com baixo índice de exposição (suas dimensões não atendem aos frentes mínimos configurados), as dimensões das estruturas devem ser verificadas',
            EXHIBIT: 'Todos os produtos são exibíveis conforme sua Unidade de Medida no Item Master',
            STORE_AVAILABLE: 'Todos os produtos estão disponíveis para venda em todas as lojas',
            STRUCTURE_AVAILABLE:
              'Todos os móveis possuem alto índice de exposição (suas dimensões atendem aos frentes mínimos configurados)',
            BLOCKED_FOR_SALES: 'Há produtos bloqueados para venda, a configuração da Unidade de Medida no Item Master deve ser verificada',
            NOT_BLOCKED_FOR_SALES: 'Não há produtos bloqueados para venda a partir de sua Unidade de Medida no Item Master',
            NO_ALERTS: 'Não foram encontrados alertas',
            ERROR: 'Erro ao verificar a configuração',
            DISCARDED_COMBINATIONS:
              '{{count}} combinações de valores de etiquetas de loja não gerarão planograma: nenhuma loja do template possui essa combinação de valores atribuída.',
          },
          SELECT_TAGS: 'Etiquetas de loja',
          TAG_REQUIRED: 'Deve selecionar ao menos uma etiqueta de loja para gerar neste modo.',
          TAG_MIN_ONE_VALUE: 'Selecione ao menos um valor para esta etiqueta',
          CREATEVERSIONFOR_OPTIONS: {
            PerStructure: 'Estruturas associadas ao Modelo',
            PerStore: 'Selecção Manual de Pontos de Venda',
            PerClusterStructure: 'Selecção Manual por Clusters',
            PerStoreTag: 'Geração por Etiqueta de Loja',
          },
          NAME_COLUMN: 'Nome',
          PLANOGRAM_EXIST_TITLE: 'Planogramas Existentes',
          PLANOGRAM_EXIST_SUBTITLE:
            'Tem certeza de que deseja continuar com a geração dos planogramas? Este processo sobrescreverá os elementos da seguinte lista:',
          AI: {
            GENERATE_DIVISIONS: 'Gerar Divisões com IA',
            GENERATE_DIVISIONS_TTIP: 'Gerar Divisões com IA',
            GENERATOR_TITLE: 'Gerador de Divisões IA',
            MINIMIZE: 'Minimizar',
            MINIMIZE_TTIP: 'Minimizar',
            WRITE_PROMPT: 'Escreva seu prompt...',
            GENERATE_DIVISIONS_BTN: 'Gerar Divisões',
            PROCESSING: 'Processando...',
            AI_RESPONSE: 'Resposta da IA:',
            COPY: 'Copiar',
            CLEAR: 'Limpar',
            RESPONSE_COPIED: 'Resposta copiada para a área de transferência',
            COPY_ERROR: 'Erro ao copiar para a área de transferência',
            IA_SERVICE_ERROR: 'O serviço de IA só está disponível no ambiente de desenvolvimento (porta 4200)',
            AI_PROCESSING_ERROR: 'Erro ao processar a resposta da IA. Verifique se o formato está correto.',
            AI_COMMUNICATION_ERROR: 'Erro ao comunicar com a IA',
          },
        },
        CUSTOM_PARAMETERS: 'Parâmetros Personalizados',
        CUSTOM_PARAMETERS_CONFIG: 'Configuração de Parâmetros Personalizados',
        CUSTOM_PARAMETERS_INFO: 'Este é um parâmetro personalizado que permite configurações específicas',
        CUSTOM_PARAMETERS_ADVANCED: 'Configuração Avançada',
        BLOCKS: {
          SELECT_PARENT: 'Selecione Bloco Pai',
          CREATE_CUSTOM_PARAMETER: 'Criar Parâmetro Custom',
          SELECT_VARIABLE: 'Selecione a Variável',
          STOP_DIVISION_AT_BLOCK: 'Detener división',
          STOP_DIVISION_DESCRIPTION:
            'Si se habilita, la división se detendrá en este bloque y no se continuará con la división en los bloques hijos',
          STOP_DIVISION_TITLE: 'Configuración de División',
          CREATE_MASS_CUSTOM_PARAMETER: 'Criar Parâmetro Custom Masivo',
          UNION: {
            ENTER_MODE: 'Unir blocos',
            EXIT_MODE: 'Sair do modo união',
            MODE_ACTIVE: 'Modo união ativo',
            MODE_HINT: 'Selecione 2 ou mais blocos irmãos usando as caixas de seleção laranjas no canvas.',
            ADD_TO_SELECTION: 'Adicionar à seleção para união',
            REMOVE_FROM_SELECTION: 'Remover da seleção para união',
            SELECTED_LABEL: 'blocos selecionados',
            DEFAULT_NAME: 'Nome padrão',
            MERGE_BUTTON: 'Unir blocos',
            UNDO_BUTTON: 'Desfazer união',
            UNDO_CONFIRM_TITLE: 'Desfazer união de blocos',
            UNDO_CONFIRM_MESSAGE: 'Os blocos voltarão a ser exibidos separadamente e o nome do composto será perdido. Continuar?',
            CHANGE_DIVISION_VARIABLE_TITLE: 'Alterar critério de divisão',
            CHANGE_DIVISION_VARIABLE_MESSAGE:
              'Este nível tem uniões de blocos ativas. Se você alterar o critério de divisão, essas uniões serão perdidas. Continuar?',
            PREVIEW_BEFORE: 'Antes',
            PREVIEW_AFTER: 'Depois',
            CONFIRM_TITLE: 'Confirmar união de blocos',
            NAME_LABEL: 'Nome do composto',
            NAME_HINT: 'Se não informar um nome, será usada a concatenação dos blocos.',
            COMPOSITE_LABEL: 'Composto',
            OTHER_LABEL: 'Outros',
            VALIDATION: {
              MIN_BLOCKS: 'Para unir blocos, selecione pelo menos 2 blocos.',
              DIFFERENT_LEVEL: 'Para unir blocos, todos devem estar no mesmo nível de divisão.',
              DIFFERENT_PARENT: 'Para unir blocos, devem pertencer ao mesmo bloco pai.',
              BLOCK_ALREADY_UNITED: 'Um ou mais blocos selecionados já pertencem a outra união.',
              UNDO_BLOCKED_BY_CHILDREN: 'Não é possível desfazer: o composto tem subdivisões criadas após a união.',
            },
            ERRORS: {
              GENERIC: 'Não foi possível salvar a união. Tente novamente.',
              UNION_MIN_TWO_BLOCKS: 'A união requer pelo menos 2 blocos.',
              UNION_BLOCK_ALREADY_UNITED: 'Um ou mais blocos já pertencem a outra união neste nível.',
              UNION_DIFFERENT_PARENT: 'Os blocos devem pertencer ao mesmo bloco pai.',
              UNION_UNDO_BLOCKED_BY_CHILDREN: 'Não é possível desfazer: o composto tem subdivisões criadas após a união.',
            },
          },
          SELECT_VARIABLE_OPTS: {
            Department: 'Pelos Departamentos',
            Category: 'Categoria',
            SubCategory: 'Subcategoria',
            Tag: 'Rótulo',
            Price: 'Preço',
            Size: 'Tamanho',
            category: 'Categoria',
            subcategory: 'Categoria Subordinada',
            tag: 'Label',
            price: 'Precio',
            size: 'Tamanho',
          },
          SELECT_ORIENTATION_OPTS_NEW: {
            Vertical: 'Vertical',
            Horizontal: 'Horizontal',
          },
          SELECT_CALCULATIONTYPE: {
            Sales: 'Vendas',
            Units: 'Unidades',
            Margin: 'Margem',
            Price: 'Precço',
            Size: 'Tamanho',
            ProjectedSales: 'Venda Projetada',
            Stock: 'Estoque',
            Ranking: 'Ranking',
            Custom: 'Custo',
          },
          SELECT_ORDERTYPE: {
            Descending: 'Decrescente',
            Ascending: 'Aumentante',
            Custom: 'Custo',
          },
          COLOR: 'Cor',
          SELECT_DIVISIONTYPE_ROOT: 'Tipo de Divisão',
          SELECT_DIVISIONTYPE: 'Cálculo de Blocos de Divisão',
          SELECT_DIVISIONTYPE_ITEM: 'Cálculo de Itens por Divisão',
          SELECT_ORDER_TYPE: 'Pedido de Itens',
          SELECT_ORDER_TYPE_ITEMS: 'Ordem de Itens',
          SELECT_ORDER_TYPE_BLOCKS: 'Bloque Order',
          SELECT_DIVISIONTYPE_OPTS: {
            Horizontal: 'Horizontal',
            Vertical: 'Vertical',
          },
          MAX_DIVISIONS: 'Divisões máximas',
          MAX_DIVISIONS_ALT: 'Máximo',
          MIN_DIVISIONS_ALT: 'Mínimo',
          DIVISION_INDEX: 'Seção Nº',
          DIVISION_WIDTH_ALT: 'Largura (%)',
          ALLOCATION_CRITERIA: 'Critérios para Alocação de Espaço',
          ALLOCATION_CRITERIA_OPTS: {
            '0': 'Prop. Para vendas $',
            '1': 'Sai A.',
            '2': 'Margem $',
          },
          ORDER: 'Pedido',
          ORDER_OPTS: {
            '0': 'Ascendente',
            '1': 'descendente',
            '2': 'Custom',
          },
          ADD_DIVITION: 'Adicionar Divisão',
          PRODUCTS: 'Produtos',
          UNITS: 'Unidades',
          MARGIN: 'Margem',
          SALES: 'Vendas',
          ADD_DIVITION_EXCEPTION: 'Ordem Personalizada',
          ADD_DIVITION_EXCEPTION_SIZE: 'Tamanho Personalizado',
          DIVISION_WIDTH: 'Tamanho (%)',
          DIVISION: 'Divisão',
          DIVISIONS: 'Divisões',
          DEMO_BRAND: 'Marca',
          DEMO_FLAVOR: 'Sabor',
          DEMO_SIZE: 'Tamanho',
          DEMO_PRESENTATION: 'Apresentação',
          SELECT_ORIENTATION: 'Orientação',
          SELECT_ORIENTATION_OPTS: {
            horizontal: 'Horizontal',
            vertical: 'Vertical',
          },
          SELECT_VARIABLE_CUSTOM: 'Selecionar Variável (Parâmetro Personalizado)',
          SELECT_DIVISIONTYPE_CUSTOM: 'Tipo de divisão (Parâmetro Personalizado)',
          MAX_DIVISIONS_CUSTOM: 'Máximo de divisões (Custom)',
          MAX_DIVISIONS_CUSTOM_HINT: 'Número máximo de divisões para este parâmetro personalizado',
          BLOCK_CUSTOM_ORDER_CUSTOM: 'Ordem personalizada de blocos (Custom)',
          BLOCK_CUSTOM_SIZE_CUSTOM: 'Tamanho personalizado de blocos (Custom)',
          ADD_DIVISION_EXCEPTION_CUSTOM: 'Adicionar Exceção de Ordem (Custom)',
          ADD_DIVISION_EXCEPTION_SIZE_CUSTOM: 'Adicionar Exceção de Tamanho (Custom)',
          VALIDATIONS: {
            blockCustomSize_invalidWidth: 'Tamanho do bloco inválido',
            blockCustomSize_invalidWidth_max: 'Tamanho do bloco inválido',
            blockCustomSize_invalidtagValueOrCategoryId: 'Falha de categoria ou label',
            blockCustomOrder_invalidtagValueOrCategoryId: 'Falha de categoria ou label',
            blockCustomOrder_invalidOrder: 'Pedido Inválido',
            blockCustomSize_invalidtagValueOrCategoryId_dup: 'Categoria ou rótulo duplicado',
            blockCustomOrder_invalidtagValueOrCategoryId_dup: 'Categoria ou rótulo duplicado',
            blockCustomDivisionType_invalidHorizontal: 'Tipo de divisão inválido no nível superior',
            divisionVariable_duplicate: 'Variável duplicada',
            tagId_duplicate: 'Tag duplicada',
          },
        },
      },
      FLOOR_PLANS: {
        LIST: {
          NEW_ITEM: 'Criação do layout',
          TITLE: 'Lista de layouts',
          NAME: 'Nome',
          CODE: 'Código',
          SIZE_PLANOGRAMS: 'Nro Planogramas',
          SIZE_LEVELS: 'Níveis',
          EDIT_ROW: 'Editar',
          COPY_ROW: 'Clonar',
          DELETE_ROW: 'Excluir',
          ITEM_TAGS: 'Etiquetas de produtos',
          DELETE: 'Excluir',
          DELETE_TTIP: 'Excluir um modelo',
          FILTER: 'Filtro avançado',
          FILTER_TTIP: 'Ativar ou desativar o filtro avançado',
          EXPORT: 'Exportar',
          EXPORT_TTIP: 'Exportando um modelo',
          DELETE_CONFIRM: 'Você quer continuar com a remoção do Layout? ',
        },
        EDITOR: {
          TAB_GENERAL: 'Geral',
          TAB_LAYOUTS: 'Layouts',
          TAB_ANALISYS: 'Análise',
          TITLE_EDIT: 'Layouts',
          TAB_LEVELS: 'Níveis',
          LEVEL: 'Nível',
          LEVEL_LABEL_NAME: 'Nível',
          TITLE_NEW: 'Novo Layout',
          SUBTITLE: 'Você está criando um novo Layout, selecione o Nome, os pontos de venda ou a categoria.',
          BACK_OPACITY: 'Opacidade do Fundo',
          ROTATION: 'Ângulo de Rotação',
          BACK_BW: 'Imagem monocromática',
          DELETE_ALL_MODULES: 'Módulos limpos',
          OPEN_PLANOGRAM: 'Planograma aberto',
          OPEN_STRUCTURE: 'Abrir Estrutura',
          OPEN_STRUCTURE_UNAVAILABLE: 'Nenhuma estrutura associada a este planograma.',
          MSG_CONFIRM_DEL_MODULES: 'Você quer continuar com a remoção de todos os planogramas do layout?',
          ADD_LEVEL: 'Adicionar nível',
          EDIT_LEVEL: 'Nível de edição',
          NEW_LEVEL: 'Novo nível',
          WIDTH: 'Largura',
          DEPTH: 'Profundidade (m.)',
          TOTALSPACE: 'Área total (m².)',
          SELLINGAREASPACE: 'Área de vendas (m².)',
          BLUEPRINT_PHOTO: 'Imagem de referência do Plano',
          DELETE_LEVEL: 'Remover nível',
          MOVELEVELTOP: 'Mover para cima (reordenar)',
          MOVELEVELBOTTOM: 'Descer (reordenar)',
          MSG_CONFIRM_DEL_LEVEL: 'Você deseja continuar com a remoção do nível {{val}}?',
          NAME: 'Nome',
          CODE: 'Código',
          CATEGORY: 'Categoria',
          NO_LEVELS: 'Sem níveis',
          PLANOGRAMS: 'Planogramas',
        },
        VERSIONS: {
          DROPDOWN: {
            LABEL: 'Versão',
            LOADING: 'Carregando versões…',
            ERROR_TOOLTIP: 'Falha ao carregar versões — reabra o editor para tentar novamente',
            NO_PREVIOUS_TOOLTIP: 'Sem versões anteriores',
            CURRENT_TAG: 'Atual',
            SYSTEM_USER: 'Sistema',
          },
          TRIGGER: {
            CREATE: 'Criação',
            STORES_CHANGE: 'Lojas',
            LEVELS_CHANGE: 'Níveis',
            PLANOGRAM_ASSIGNMENT: 'Plan. atribuído',
            PLANOGRAM_MOVEMENT: 'Plan. movido',
            PLANOGRAM_PUBLICATION: 'Publicação',
            BACKFILL: 'Migrada',
          },
          MODAL: {
            HEADER: 'Versão V{{val}} · {{val2}} · {{val3}} · por {{val4}}',
            SECTION_WHAT_CHANGED: 'O que mudou',
            SECTION_SNAPSHOT: 'Snapshot do layout',
            SECTION_METRICS: 'Performance dos planogramas publicados',
            INHERITED_DISCLAIMER: 'Performance herdada de V{{val}} ({{val2}}). Esta versão não modificou os planogramas publicados.',
            METRIC_UNAVAILABLE: 'Métrica indisponível',
            NO_PUBLISHED_PLANOGRAMS: 'Sem planogramas publicados nesta versão',
            CLOSE: 'Fechar',
            TABLE: {
              PLANOGRAM: 'Planograma',
              SALES: 'Vendas',
              MARGIN: 'Margem',
              UNITS: 'Unidades',
              PERIOD: 'Período',
            },
          },
          ERRORS: {
            LIST_LOAD_FAILED: 'Não foi possível carregar as versões do layout',
            DETAIL_LOAD_FAILED: 'Não foi possível carregar a versão selecionada',
          },
        },
      },
      SUPER_PLANOGRAMAS: {
        LIST: {
          DELETE_CONFIRM: 'Você deseja continuar com a remoção do Multi-Planogramas',
          TITLE: 'Multi-Planogramas',
          NAME: 'Nome',
          CODE: 'Código',
          PLANOGRAMS: 'Planogramas',
          NEW_SUPER_PLANOGRAMA_BTN: 'Novo Multi-Planograma',
          DELETE_ROW: 'Excluir',
          DELETE: 'Excluir',
        },
        EDIT: {
          TITLE: 'Novo Multi-Planogramas',
          TAB1: 'Dados Principais',
          NAME: 'Nome',
          CODE: 'Código',
          PLANOGRAMS: 'Planogramas',
          NEW_PLANOGRAM_BTN: 'Novo Planograma',
          VALIDATION_CODE: 'O código já existe',
          LOADING: 'Carregando...',
          PLANOGRAMAS_TAB: 'Planogramas',
          PLANOGRAMAS_TAB_TITLE: 'Planogramas',
          PLANOGRAMAS_TAB_ADD_PLANOGRAM: 'Adicionar Planograma',
          PLANOGRAMAS_TAB_DELETE_PLANOGRAM: 'Excluir Planograma',
          PLANOGRAMAS_TAB_DELETE_PLANOGRAM_CONFIRM: 'Você deseja continuar com a remoção do Planograma',
          PLANOGRAMAS_TAB_NAME: 'Nome',
          PLANOGRAMAS_TAB_CODE: 'Código',
          PLANOGRAM_ADDED_SUCCESSFULLY: 'Planograma adicionado com sucesso',
          PLANOGRAM_REMOVED_FROM_SELECTION: 'Planograma removido da seleção',
          PLANOGRAMS_ADDED_SUCCESSFULLY: 'Planogramas adicionados com sucesso',
          PLANOGRAMAS_TAB_VIEW_PLANOGRAM: 'Visualizar Planograma',
        },
      },
    },
    TAGS_MODAL: {
      TITLE: 'Seleçāo avançada',
      DESC: 'Aplique filtros à sua pesquisa para obter o resultado desejado. Esta opção será desmarcada por filtros.',
      FIRST_TABLE_BTN: 'Aplicar',
      FIRST_TABLE_HEADER: 'Filtros',
      SECOND_TABLE_BTN: 'Selecionar',
      THIRD_TABLE_HEADER: 'Seleção Atual',
      THIRD_TABLE_EMPTY: 'Selecione Opções',
      CANCEL: 'Cancelar',
      APPLY: 'Aplicar',
    },
    AI_CHAT: {
      PAGE_TITLE: 'Ask Prisma',
      CHAT_TYPES: {
        DATABRICKS: 'Converse com seus Dados',
        STREAMING: 'Agente de Insights',
        DATABRICKS_DESC: 'Converse diretamente com seus dados usando linguagem natural',
        STREAMING_DESC: 'Chat com agente de insights com capacidades avançadas de análise em tempo real',
      },
      HEADERS: {
        DATABRICKS_TITLE: 'Converse com seus dados',
        STREAMING_TITLE: 'Chat com Agente de insight',
        DEFAULT_TITLE: 'Ask Prisma',
      },
      MESSAGES: {
        USER_DEFAULT: 'Usuário',
        AI_NAME: 'Ask Prisma',
        AI_NAME_AGENT: 'Agente Prisma',
        INITIAL_MESSAGE: 'Como posso ajudá-lo hoje?',
        DATABRICKS_WELCOME:
          'Olá! Sou seu assistente de dados. Posso ajudá-lo a analisar informações, gerar consultas e responder perguntas sobre seus dados usando linguagem natural. Como posso ajudá-lo hoje?',
        STREAMING_WELCOME:
          'Olá, sou seu **Insight Agent** especializado em análise de vendas. Estou aqui para ajudá-lo a extrair insights acionáveis dos dados de negócio.\n\nIndique-me que tipo de análise você precisa ou selecione uma das sugestões para começar.',
        LOADING: 'Pensando...',
        PROCESSING: 'Processando consulta...',
        HEALTH_CHECK: 'Verificando API...',
        COPY_TOOLTIP: 'Copiar conteúdo para a área de transferência',
        COPY_SUCCESS: 'Conteúdo copiado para a área de transferência',
        COPY_SUCCESS_CONVERSATION: 'Conversa copiada para a área de transferência',
        COPY_ERROR: 'Erro ao copiar o conteúdo',
        COPY_THIS_MESSAGE: 'Copiar esta resposta',
        COPY_CONVERSATION: 'Copiar conversa completa',
        PDF_TOOLTIP: 'Baixar como PDF',
        PDF_THIS_MESSAGE: 'Baixar esta resposta',
        PDF_CONVERSATION: 'Baixar conversa completa',
        PDF_CONVERSATION_TITLE: 'Prisma Agent – Conversa completa',
      },
      INPUT: {
        PLACEHOLDER: 'Escreva uma mensagem para o assistente...',
        PLACEHOLDER_SIMPLE: 'Escreva uma mensagem...',
        RESET_TOOLTIP: 'Reiniciar conversação',
      },
      ERRORS: {
        SERVICE_UNAVAILABLE: 'Serviço indisponível',
        SERVICE_UNAVAILABLE_DESC:
          'Não foi possível conectar com o serviço de IA. Por favor, verifique se o backend está funcionando corretamente.',
        PROCESSING_ERROR: 'Ocorreu um erro ao processar sua mensagem',
        API_HEALTH_CHECK_FAILED: 'Erro inesperado ao verificar a API',
        CONNECTION_ERROR_TITLE: 'Erro de Conexão',
        CONNECTION_ERROR_MESSAGE:
          'Não foi possível verificar o status da API do Data Agent. Verifique sua conexão com a internet e tente novamente mais tarde.',
        NETWORK_ERROR_TITLE: 'Erro de Conexão',
        TIMEOUT_ERROR_TITLE: 'Tempo de Espera Esgotado',
        AUTH_ERROR_TITLE: 'Erro de Autenticação',
        RATE_LIMIT_ERROR_TITLE: 'Limite de Consultas Atingido',
        UNKNOWN_ERROR_TITLE: 'Erro ao Processar a Consulta',
        NETWORK_ERROR_MESSAGE:
          'Não foi possível conectar com o servidor. Verifique sua conexão com a internet ou se o servidor está disponível.',
        TIMEOUT_ERROR_MESSAGE: 'A consulta demorou muito tempo',
        AUTH_ERROR_MESSAGE: 'Erro de autenticação',
        RATE_LIMIT_ERROR_MESSAGE: 'Limite de consultas atingido',
        UNKNOWN_ERROR_MESSAGE: 'Ocorreu um erro ao processar sua mensagem.',
        STREAM_ERROR_MESSAGE: 'Ocorreu um erro na comunicação com o agente.',
        NETWORK_ERROR_SUGGESTION: 'Se o problema persistir, entre em contato com o suporte técnico.',
        TIMEOUT_ERROR_SUGGESTION: 'Tente uma pergunta mais simples ou tente novamente mais tarde.',
        AUTH_ERROR_SUGGESTION: 'Recarregue a página ou entre em contato com o suporte técnico.',
        RATE_LIMIT_ERROR_SUGGESTION: 'Aguarde alguns minutos antes de fazer outra consulta.',
        UNKNOWN_ERROR_SUGGESTION: 'Se o problema persistir, entre em contato com o suporte técnico.',
        AUTH_EXPIRED_SUGGESTION: 'Sua sessão pode ter expirado. Tente recarregar a página.',
        INTERNAL_SERVER_SUGGESTION: 'Estamos trabalhando para resolvê-lo. Tente novamente mais tarde.',
        CONTACT_SUPPORT: 'Se o problema persistir, entre em contato com o suporte técnico.',
        DATABRICKS_RESOURCE_NOT_FOUND: 'O espaço do Lakehouse configurado não existe ou não está disponível.',
        DATABRICKS_RESOURCE_GENERIC: 'O recurso solicitado não existe no Lakehouse.',
        DATABRICKS_PERMISSION_DENIED: 'Você não tem permissão para acessar este recurso no Lakehouse.',
        DATABRICKS_INVALID_PARAMS: 'Os parâmetros enviados ao Lakehouse são inválidos.',
        DATABRICKS_COMM_ERROR: 'Erro de comunicação com o Lakehouse',
        SERVICE_DISABLED: 'O serviço de chat com IA está desabilitado',
        AUTH_FAILED_GENERIC: 'Falha na autenticação',
        RATE_LIMIT_EXCEEDED: 'Limite de consultas excedido',
        INTERNAL_SERVER_ERROR: 'Erro interno do servidor',
        BAD_GATEWAY: 'Erro de comunicação com Proxy',
        SERVICE_UNAVAILABLE_TEMP: 'O serviço está temporariamente indisponível',
        WAREHOUSE_WARMING_UP: 'O motor de consultas está iniciando. Tente novamente em alguns segundos.',
        GATEWAY_TIMEOUT: 'O servidor demorou muito para responder',
        AGENT_NETWORK_ERROR: 'Não foi possível conectar com o servidor',
        AGENT_NETWORK_SUGGESTION: 'Verifique sua conexão com a internet e se o servidor está disponível.',
      },
      QUERY_RESULTS: {
        HEADER: 'Resultado da consulta',
        NO_DATA: 'Não há dados disponíveis.',
        VIEW_QUERY: 'Ver Query',
        COPY_QUERY: 'Copiar Query para a Área de Transferência',
      },
      REASONING: {
        VIEW_HISTORY: 'Ver histórico de raciocínio',
        VIEW_HISTORY_TOOLTIP: 'Ver o processo de raciocínio passo a passo',
        PROCESSING_HISTORY: 'Histórico de processamento',
        CYCLE: 'Ciclo',
        WORDS: 'palavras',
        STEP: 'Passo',
        STEPS: 'passos',
        OF: 'de',
        NO_HISTORY: 'Não há histórico de raciocínio',
        NO_HISTORY_DESC: 'Esta consulta não gerou um histórico de ciclos detalhado.',
        CYCLE_PROCESSING: 'ciclo de processamento',
        CYCLES_PROCESSING: 'ciclos de processamento',
      },
      CYCLES: {
        PROCESSING_STEP: 'Processando passo',
        EXECUTING: 'Executando...',
        SUCCESS: 'Sucesso',
        RUNNING: 'Em execução',
        UNKNOWN_TOOL: 'Ferramenta desconhecida',
      },
      NOTIFICATIONS: {
        NEW_SUGGESTIONS_ONE: '{{count}} nova sugestão foi gerada.',
        NEW_SUGGESTIONS_MANY: '{{count}} novas sugestões foram geradas.',
        VIEW_ACTION: 'Ver',
      },
      ACTIONS: {
        RESET_CONVERSATION: 'Reiniciar conversação',
        CLOSE_PANEL: 'Fechar painel',
        RETRY: 'Verificar novamente',
        EXPORT: 'Exportar',
      },
      INSIGHTS: {
        CONTAINER_TITLE: 'Sugestões de Ações',
        TITLE: 'Agente de Insights',
        CONTAINER_DESC: 'Com base na análise anterior, estas são as ações recomendadas:',
        LOADING: 'Carregando sugestões...',
        ERROR: 'Erro ao carregar as sugestões',
        RETRY: 'Tentar novamente',
        NO_SUGGESTIONS: 'Não há sugestões pendentes no momento',
        SUGGESTIONS_AVAILABLE: 'sugestão',
        SUGGESTIONS_AVAILABLE_PLURAL: 'sugestões',
        AVAILABLE: 'disponível',
        AVAILABLE_PLURAL: 'disponíveis',
        NO_PENDING: 'Não há sugestões pendentes',
        EXPAND_ARIA: 'Expandir sugestões',
        COLLAPSE_ARIA: 'Recolher sugestões',
        PROCESSING: 'Processando...',
        APPROVE: 'Aprovar',
        REJECT: 'Rejeitar',
        PROPOSED_CHANGES: 'Mudanças propostas:',
        ITEM_STORE: 'Item',
        STORE: 'Loja',
        TYPES: {
          PRICE_CHANGE: 'Mudança de Preço',
          INVENTORY_ADJUSTMENT: 'Ajuste de Inventário',
          PROMOTION_RECOMMENDATION: 'Recomendação de Promoção',
          OTHER: 'Outra Sugestão',
          DEFAULT: 'Sugestão',
        },
        STATUS: {
          PENDING: 'Pendente',
          APPROVED: 'Aprovada',
          REJECTED: 'Rejeitada',
          IMPLEMENTED: 'Implementada',
          UNKNOWN: 'Desconhecido',
        },
      },
      HISTORY: {
        TITLE: 'Histórico de Sessões',
        TOOLTIP: 'Ver histórico de sessões',
        REFRESH: 'Atualizar histórico',
        LOADING: 'Carregando histórico...',
        EMPTY: 'Não há sessões salvas',
        NEW_SESSION: 'Nova sessão',
        VIEW_SUGGESTION: 'Ver Sugestão',
      },
      CHAT_INPUT: {
        SELECT_TYPE: 'Selecionar tipo de chat',
        TYPE_PREFIX: 'Tipo:',
        SEND_TOOLTIP: 'Enviar mensagem',
        STOP_TOOLTIP: 'Parar processamento',
      },
      PROMPT_EXAMPLES: {
        TITLE: 'Exemplos de consultas',
        RECENT_QUERIES: 'Consultas recentes',
        TOP_PRODUCTS: 'Quais são os 10 produtos com mais vendas este mês?',
        SALES_COMPARISON: 'Compare as vendas deste mês com o mês anterior',
        INVENTORY_ALERT: 'Mostre as vendas por categoria do último mês',
        MONTHLY_TREND: 'Dê-me uma análise de tendência de vendas mensais dos últimos 6 meses',
        INSIGHT_PRICE_OPTIMIZATION: 'Quais produtos deveriam ajustar seu preço para maximizar a rentabilidade?',
        INSIGHT_PERFORMANCE_ANOMALIES: 'Detecte anomalias no desempenho de vendas das últimas semanas',
        INSIGHT_STOCK_RECOMMENDATIONS: 'Quais itens têm baixo estoque e alta demanda que requerem reabastecimento urgente?',
        INSIGHT_STRATEGIC_OPPORTUNITIES: 'Identifique oportunidades estratégicas baseadas em tendências do mercado',
      },
    },
    INSIGHTS_SUGGESTIONS_PANEL: {
      TITLE: 'Sugestões de Insights',
      PENDING_BADGE: 'pendente',
      PENDING_BADGE_PLURAL: 'pendentes',
      ACCEPT_BUTTON: 'Aceitar',
      REJECT_BUTTON: 'Rejeitar',
      STATUS_ACCEPTED: 'Aceita',
      STATUS_REJECTED: 'Rejeitada',
      EMPTY_MESSAGE: 'Não há sugestões disponíveis',
      VIEW_DETAILS: 'Ver detalhes',
      DETAILED_REPORT_TITLE: 'Análise Detalhada',
      VIEW_CONVERSATION: 'Ver conversa',
      VIEW_CONVERSATION_TOOLTIP: 'Ver conversa original',
      CLOSE_BUTTON: 'Fechar',
      PRICE_RECOMMENDATIONS_TABLE: 'Recomendações de Preços',
      ESTIMATED_IMPACT: 'Impacto estimado:',
      DEFAULT_TITLE_SUGGESTION: 'Sugestão sem título',
      SORT_BY: 'Ordenar por',
      SORT_IMPACT: 'Impacto estimado',
      SORT_DATE: 'Data',
      SCHEMA: {
        ITEM: 'Item',
        STORE: 'Loja',
        CURRENT_PRICE: 'Preço Atual',
        NEW_PRICE: 'Novo Preço',
      },
      TYPE: {
        PRECIOS: 'Preços',
        SURTIDO: 'Sortimento',
        PROMOS: 'Promos',
      },
      PRIORITY: {
        ALTA: 'Alta',
        MEDIA: 'Média',
        BAJA: 'Baixa',
      },
      TIME_AGO: {
        MINUTES: 'Há {{count}} minuto',
        MINUTES_PLURAL: 'Há {{count}} minutos',
        HOURS: 'Há {{count}} hora',
        HOURS_PLURAL: 'Há {{count}} horas',
        DAYS: 'Há {{count}} dia',
        DAYS_PLURAL: 'Há {{count}} dias',
      },
    },
    DATA_AGENT: {
      ERRORS: {
        API_UNAVAILABLE: 'API do Data Agent não está disponível',
        API_TIMEOUT: 'Timeout ao verificar a API (mais de 15 segundos sem resposta)',
        API_CONNECTION_ERROR: 'Não foi possível conectar com a API do Data Agent',
        API_ERROR_PREFIX: 'Erro ao verificar a API:',
        NETWORK_ERROR: 'Não foi possível conectar com o servidor. Verifique sua conexão com a internet ou se o servidor está disponível.',
        API_STATUS_ERROR: 'API respondeu com status {{status}}: {{statusText}}',
        API_HEALTHY: 'API do Data Agent está disponível e funcionando corretamente',
        BAD_GATEWAY: 'Bad Gateway - Erro de comunicação com o Proxy do Data Agent',
        SERVICE_UNAVAILABLE: 'Service Unavailable - O serviço está temporariamente indisponível',
        GATEWAY_TIMEOUT: 'Gateway Timeout - O servidor demorou muito para responder',
      },
    },
    DATA_VISUALIZATION: {
      TABLE: {
        TITLE: 'Tabela de Resultados',
        SEARCH_PLACEHOLDER: 'Buscar...',
        NO_DATA: 'Não há dados disponíveis.',
        RECORDS: 'registros',
        PIN_TOOLTIP: 'Fixar no Dashboard',
        VIEW_QUERY_TOOLTIP: 'Ver Query',
        EXPORT_CSV_TOOLTIP: 'Exportar para CSV',
        DOWNLOAD_FULL_CSV_TOOLTIP: 'Baixar CSV completo',
        EXPAND_TABLE_TOOLTIP: 'Ampliar tabela',
        COPY_QUERY_TOOLTIP: 'Copiar Query para a Área de Transferência',
        PREPARING_DOWNLOAD: 'Preparando download...',
        DOWNLOAD_READY: 'Download concluído',
        DOWNLOAD_ERROR: 'Erro ao baixar CSV completo',
        RESULTS_LIMIT_WARNING: 'A visualização da tabela é limitada. Para obter a totalidade dos dados,',
        CLICK_HERE: 'você pode baixar o CSV completo aqui.',
        PIN_LIMIT_TOOLTIP: 'Não é possível fixar: a listagem excede o limite de {limit} registros.',
      },
      CHART: {
        NO_VISUALIZATION: 'Com os dados disponíveis atualmente, não é possível gerar o gráfico',
        SELECT_COLUMNS: 'Ver Gráfico, selecionar colunas para visualizar',
        VIEW_CHART: 'Ver gráfico',
        PIE_CHART: 'de pizza',
        TIME_LINE_CHART: 'de série temporal',
        BAR_CHART: 'de barras',
        SHOW_GROUPED_VALUES: 'Mostrar valores agrupados',
        SHOW_GROUPED_VALUES_OTHERS: 'Mostrar valores agrupados (Outros)',
        TYPE: 'Tipo',
        TYPE_BAR: 'Barras',
        TYPE_HORIZONTALBAR: 'Barras horizontais',
        TYPE_TIME_LINE: 'Linhas',
        TYPE_PIE: 'Pizza',
        LABEL_COLUMN: 'Rótulo',
        SERIES: 'Séries',
        AXIS_MODE: 'Eixos',
        AXIS_AUTO: 'Auto',
        AXIS_SHARED: 'Eixo único',
        AXIS_DUAL: 'Eixo duplo',
      },
      COLUMN_SELECTOR: {
        TITLE: 'Selecionar colunas para o gráfico',
        LABEL_COLUMN: 'Coluna de rótulos',
        NUMERIC_COLUMN: 'Coluna de valores (numérica)',
        MULTI_SERIES_HINT: 'Você pode selecionar várias colunas para comparar séries',
        CANCEL: 'Cancelar',
        VISUALIZE: 'Visualizar',
      },
      PIN_DIALOG: {
        DESCRIPTION:
          'Esta consulta será convertida em um cartão interativo que exibirá os resultados em formato de tabela e gráfico, atualizando periodicamente.',
        USER_QUERY: 'O que você deseja consultar?',
        SQL_QUERY: 'Query SQL:',
        CANCEL: 'Cancelar',
        CONFIRM: 'Confirmar',
      },
      PIN: {
        SUCCESS: 'Cartão "{title}" adicionado ao dashboard com sucesso',
        ACTION_VIEW: 'Ver Dashboard',
      },
    },
    AI_DASHBOARD: {
      PAGE_TITLE: 'Smart Dashboard',
      ACTIONS: {
        ADD_CARD: 'Adicionar Card',
        ADD_CARD_TOOLTIP: 'Adicionar novo card',
        REMOVE_CARD: 'Remover card',
        VIEW_JSON: 'Ver JSON',
        HIDE_JSON: 'Ocultar',
        VIEW_CONFIG_JSON: 'Ver configuração JSON',
        CLEAR_ALL: 'Limpar Tudo',
        CLEAR_ALL_TOOLTIP: 'Remover todos os cards',
        LAYOUT_JSON: 'Layout JSON',
        NEW_COMPONENT: 'Novo Componente',
        EDIT_TITLE: 'Editar título',
        VIEW_QUERY: 'Ver Query SQL',
        VIEW_PROMPT: 'Ver Prompt IA',
        REFRESH_DATA: 'Atualizar dados',
        REMOVE_CARD_SHORT: 'Remover cartão',
        COPY: 'Copiar',
        SAVE: 'Salvar',
        CANCEL: 'Cancelar',
        CONFIRM: 'CONFIRMAR',
        VIEW_TABLE: 'Ver como Tabela',
        VIEW_CHART: 'Ver Gráfico',
        CHANGE_VISUALIZATION: 'Alterar Visualização',
        CHANGE: 'Alterar',
        MORE_OPTIONS: 'Mais opções',
        CONFIRM_DELETE_CARD_TITLE: 'Confirmar exclusão',
        CONFIRM_DELETE_CARD_MESSAGE: 'Tem certeza de que deseja remover este cartão do dashboard?',
        DELETE: 'Excluir',
        DELETE_GALLERY: 'Excluir Dashboard',
        EDIT_GALLERY: 'Editar Dashboard',
        CREATE_GALLERY: 'Criar Dashboard',
        CREATE: 'Criar',
        CREATE_GALLERY_TITLE: 'Nova Dashboard',
        CREATE_GALLERY_MESSAGE: 'Digite o nome da nova Dashboard',
        EDIT_GALLERY_TITLE: 'Editar Dashboard',
        EDIT_GALLERY_MESSAGE: 'Modifique o nome da Dashboard',
        CONFIRM_DELETE_GALLERY_TITLE: 'Confirmar exclusão de Dashboard',
        CONFIRM_DELETE_GALLERY_MESSAGE: 'Tem certeza de que deseja excluir a Dashboard "{{galleryName}}"?',
        CONFIRM_DELETE_GALLERY_WITH_CARDS_MESSAGE:
          'Tem certeza de que deseja excluir a Dashboard "{{galleryName}}"? {{cardCount}} cartões associados serão removidos.',
        CHANGE_GALLERY: 'Mudar Dashboard',
        CHANGE_GALLERY_TITLE: 'Mudar Dashboard do cartão',
        CHANGE_GALLERY_MESSAGE: 'Selecione a nova Dashboard para este cartão',
        REORDER_GALLERIES: 'Reordenar Dashboards',
        REORDER_GALLERIES_TITLE: 'Reordenar Dashboards',
        REORDER_GALLERIES_MESSAGE: 'Arraste os Dashboards para alterar sua ordem',
        REORDER_GALLERIES_HINT: 'O primeiro Dashboard (com ⭐) será o Dashboard padrão',
        MANAGE_GALLERIES_TITLE: 'Gerenciar Dashboards',
        MANAGE_GALLERIES_MESSAGE: 'Arraste para reordenar, edite nomes ou exclua dashboards',
        EDIT_NAME: 'Editar nome',
        DELETE_GALLERY_TITLE: 'Excluir Dashboard?',
        DELETE_GALLERY_MESSAGE:
          'Tem certeza de que deseja excluir o dashboard "{{val}}"? Todos os cartões associados também serão excluídos.',
        DELETE_GALLERY_ERROR_TITLE: 'Não é possível excluir',
        DELETE_GALLERY_ERROR_MESSAGE: 'Você deve manter pelo menos um Dashboard ativo.',
        CANNOT_DELETE_LAST: 'Não é possível excluir o último Dashboard',
        OK: 'OK',
        ADD_FIRST_COMPONENT: 'Adicionar Componente',
      },
      LABELS: {
        POSITION: 'Posição',
        SIZE: 'Tamanho',
        TYPE: 'Tipo',
        QUERY_SQL: 'Query SQL',
        AI_PROMPT: 'Prompt de IA',
        CARD_TITLE: 'Título do Card',
        USER_QUERY: 'Consulta do Usuário:',
        GALLERY_NAME: 'Nome da Dashboard',
        GALLERY_NAME_PLACEHOLDER: 'Ex: Vendas, Marketing, etc.',
        SELECT_GALLERY: 'Selecionar Dashboard',
        DEFAULT_GALLERY: 'Dashboard padrão',
      },
      CARD_TYPES: {
        CHART: 'Gráfico',
        KPI: 'KPI',
        LIST: 'Lista',
        STATUS: 'Status',
        TABLE: 'Tabela',
        DEFAULT: 'Cartão',
      },
      CHART_TYPES: {
        BAR: 'Barras',
        LINE: 'Linhas',
        PIE: 'Pizza',
        HORIZONTAL: 'Barras Horizontais',
      },
      MESSAGES: {
        NO_DATA: 'Não há dados para exibir',
        ERROR_LOADING: 'Erro ao carregar dados',
        CURRENT_TYPE: 'Tipo atual',
        CURRENT_CHART_TYPE: 'Tipo de gráfico atual',
        SELECT_CARD_TYPE: 'Selecionar tipo de cartão',
        SELECT_CHART_TYPE: 'Selecionar tipo de gráfico',
        COLUMN_MAPPING: 'Colunas do gráfico',
        LABEL_COLUMN: 'Rótulo (eixo X)',
        SERIES_COLUMNS: 'Séries (valores)',
        SERIES_MULTI_HINT: 'Você pode selecionar várias colunas para comparar séries',
        BOTH_FIELDS_REQUIRED: 'Ambos os campos são obrigatórios',
        GENERATING_COMPONENT: 'Gerando componente...',
        NEW_COMPONENT: 'Novo Componente',
        REGENERATING_QUERY: 'Regenerando query',
        QUERY_REGENERATED: 'Query regenerada com sucesso',
        NO_QUERY_GENERATED:
          'Não foi possível gerar a consulta. Tente descrever que informação você quer ver em uma tabela com números ou valores, por exemplo: "Mostrar as vendas por mês" ou "Top 10 produtos mais vendidos".',
        NO_QUERY_AVAILABLE: 'Não há query disponível',
        ERROR_REGENERATING_QUERY: 'Erro ao regenerar query',
        MAX_CARDS_REACHED: 'Limite máximo de {{maxCards}} cards por Dashboard atingido',
        GALLERY_FULL: 'Cheia',
        EMPTY_DASHBOARD_HINT: 'Comece adicionando componentes com dados do seu negócio',
        LOADING_CARDS: 'Carregando componentes...',
        LOADING_GALLERIES: 'Carregando galerias...',
        CARD_MOVED_TO: 'Cartão movido para {{val}}',
        CONFIRM_MOVE_TITLE: 'Mover Cartão',
        CONFIRM_MOVE_MESSAGE: 'Tem certeza de que deseja mover o cartão "{{val}}" para o dashboard "{{val2}}"?',
      },
      PLACEHOLDERS: {
        CARD_TITLE: 'Total de vendas acumuladas dos últimos 5 meses',
        AI_PROMPT: 'Total de vendas acumuladas dos últimos 5 meses',
      },
      CONFIRMATION: {
        CLEAR_ALL_CARDS: 'Tem certeza de que deseja remover todos os cards?',
      },
      TROUBLESHOOTING: {
        REQUEST_SPECIFIC_DATA: 'Certifique-se de pedir dados específicos (números, vendas, quantidades, etc.)',
        MENTION_TABLE_INFO: 'Mencione que informação você quer ver na tabela',
        INCLUDE_TIME_PERIOD: 'Inclua o período de tempo se for relevante (último mês, ano atual, etc.)',
        BE_MORE_SPECIFIC: 'Seja mais específico sobre as métricas que você precisa',
      },
      NEW_CARD: {
        TITLE: 'Novo Cartão',
        DATA_LABEL_A: 'Dado A',
        DATA_LABEL_B: 'Dado B',
        DATA_LABEL_C: 'Dado C',
      },
      ERRORS: {
        EXECUTING_QUERY: 'Erro ao executar query',
        GENERATING_QUERY: 'Erro ao gerar query a partir do prompt',
        UNKNOWN_ERROR: 'Erro desconhecido',
        UNKNOWN_DATABRICKS_ERROR: 'Erro desconhecido ao comunicar com Databricks.',
        UNEXPECTED_STATEMENT_STATE: 'Statement em estado inesperado',
        QUERY_GENERATION_FAILED:
          'Não foi possível gerar uma consulta válida a partir do prompt. Tente reformular a pergunta ou forneça mais contexto sobre os dados que você procura.',
        QUERY_GENERATION_FAILED_SHORT: 'Erro: Não foi possível gerar a consulta',
        LOAD_CARDS_FAILED: 'Erro ao carregar componentes. Por favor, tente novamente.',
        LOAD_GALLERIES_FAILED: 'Erro ao carregar galerias. Por favor, tente novamente.',
        SAVE_FAILED: 'Erro ao salvar alterações. Por favor, tente novamente.',
      },
      BUTTON_LABELS: {
        DETAILS: 'Detalhes',
        EDIT_PROMPT: 'Editar Consulta',
        RETRY: 'Tentar Novamente',
      },
    },
    REPORTS: {
      MAX_SELECTED_WARNING: 'Não é possível selecionar mais de {{val}} {{val2}} por relatório. Remova alguns para continuar.',
      GENERAL_TITLE: 'Hub de Relatórios',
      PREFIX_TITLE: 'Relatórios: ',
      TYPE_FILTERS: 'Tipo de Relatório',
      DOWNLOAD: 'Gerar e baixar Relatório',
      GENERATE: 'Geração de Relatório',
      FORMAT: 'Formato',
      GENERATE_FORMAT: 'Formatação',
      GO_TO_REPORT_LIST: 'Acessar Relatórios',
      OPEN_REPORT_LIST: 'Abrir Relatórios',
      ASYNC_START_MSG: 'A solicitação para gerar o relatório foi encaminhada. Você receberá uma notificação quando estiver concluído.',
      FILTERS_TITLE: 'Filtro Seleção',
      TABLE: {
        filename: 'Nome do Arquivo',
        lastModified: 'Ultima Alteração',
        reportType: 'Tipo de Relatório',
        username: 'Nome do Usuário',
        status: 'Estado',
      },
      REPORT_TYPE_KEYS: {
        COMMENTARIO_DOCU: 'São utilizados/Utilizar: GENERIC_COMP.IMPORTERV2.TYPES',
      },
      LABEL_KEYS: {
        INCLUDEISDELETED: 'Incluir Excluídos',
        SEARCH: 'Búsqueda',
        PRICE: 'Precço',
        PERCENT: 'Percentagem',
        DATE: 'Data',
        DATEFROM: 'Data a partir de',
        DATETO: 'Data Até',
        FROMTODATES: 'Fechas (De/Até)',
        ITEMTAGVALUES: 'Atributos do Item',
        STORETAGVALUES: "Atributos de PDV's",
        CATEGORYVALUES: 'Categorias',
        PLANOGRAMAS: 'Planogramas',
      },
      STATUS: {
        LABEL: 'Estado',
        PENDING: 'Pendente',
        SUCCESS: 'Completado',
        FAILED: 'Falhado',
        REPORTNOTGENERATED: 'Relatório não gerado',
        NODATA: 'Sem dados no intervalo',
      },
      TOOLTIP: {
        REPORTNOTGENERATED: 'Não foram obtidos resultados com os filtros utilizados',
        NODATA: 'A consulta foi executada corretamente, mas nao ha dados para os filtros selecionados. Verifique o intervalo de datas e gere novamente.',
        FAILED: 'Ocorreu um erro ao gerar o relatório. Tente novamente e, se persistir, entre em contato com o suporte.',
        DOWNLOAD: 'Download {{val}}',
        PENDING: 'O relatório está em processo de geração',
      },
      CANNOT_GENERATE_MANUALLY: 'Este relatório não se permite executar manualmente',
    },
    SELLING: {
      PRICING: {
        TITLE: 'Preços',
        SUBTITLE: 'Obtenha o preço certo com IA.',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Atingir o seu posicionamento competitivo desejado',
        FEATURE1_SUBTITLE:
          'Os algoritmos de localização identificam seus concorrentes em cada zona de preço e o ajudam a ajustar seus preços para alcançar seu posicionamento.',
        FEATURE2_TITLE: 'Analise o impacto de suas decisões',
        FEATURE2_SUBTITLE: 'Prisma estima um impacto na margem e na imagem do preço que ajudará no seu processo de tomada de decisão.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
      CTA_MODAL: {
        TITLE: 'Contacte-nos para mais informações',
        NAME_INPUT: 'Nome',
        COMPANY_INPUT: 'Companhia',
        PHONE_INPUT: 'Telefone',
        SEND_BTN: 'Enviar',
      },
      ASSORTMENT: {
        TITLE: 'Sortimentos',
        SUBTITLE: 'Otimize seu mix de produtos e maximize seus resultados.',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Catalogação',
        FEATURE1_SUBTITLE:
          'Atribua produtos à seus pontos de venda: * Segmente seus produtos. * Agrupe seus pontos de venda em clusters e relacione a segmentação de seus produtos em cada cluster. ',
        FEATURE2_TITLE: 'Optimização de Sortimento',
        FEATURE2_SUBTITLE:
          'Regras de Pareto com IA: Suas regras de negócios podem funcionar em conjunto com a IA para exibir em suas lojas os produtos que seus clientes desejam. Adicione produtos com melhor desempenho no mercado ou em outras lojas. Remova facilmente os produtos que não estão funcionando conforme o esperado.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
      PROMOTIONS: {
        TITLE: 'Promoções',
        SUBTITLE: 'Aumente sua inteligência promocional.',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Crie promoções incríveis',
        FEATURE1_SUBTITLE: 'Encante seus clientes implementando diferentes mecânicas promocionais.',
        FEATURE2_TITLE: 'Mede os resultados em detalhes',
        FEATURE2_SUBTITLE:
          'Leva em consideração o efeito de canibalização, as vendas pré e pós-promocionais e o investimento em marketing para calcular a lucratividade incremental de cada promoção.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
      ITEM_MASTER: {
        TITLE: 'Catálogo de Produtos.',
        SUBTITLE: 'Simplifique seu processo de gerenciamento de produtos com Inteligência Artificial.',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Combinação de produtos com IA',
        FEATURE1_SUBTITLE: 'Encontre produtos correspondentes para comparar preços e sortimento e detectar tendências de mercado.',
        FEATURE2_TITLE: 'Melhoria contínua da árvore de categorias',
        FEATURE2_SUBTITLE: 'Aumente a precisão e rapidez no processo de classificação de produtos.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
      SPACES: {
        TITLE: 'Planejamento de Espaços',
        SUBTITLE: 'Coloque seus produtos de forma eficiente, otimizada e visualmente atraente para os clientes.',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Preenchimento Automático Inteligente',
        FEATURE1_SUBTITLE:
          'Use o recurso de preenchimento automático definindo a meta de dias de exibição e o Prisma irá sugerir frentes para minimizar a falta de estoques.',
        FEATURE2_TITLE: 'Use elementos móveis e diferentes tipos de prateleiras',
        FEATURE2_SUBTITLE:
          'Adicione produtos como ganchos, gavetas ou cabides nas prateleiras dos planogramas. Congeladores para congelados ou lácteos, cestas e mesas gratuitas, para poder localizar as suas promoções.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
      SUPPLY: {
        TITLE: 'Abastecimento Inteligente',
        SUBTITLE: 'INTEGRAR SEUS DADOS NA CADEIA DE ABASTECIMENTO',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Reduzir falta de estoque e dias de estoque',
        FEATURE1_SUBTITLE:
          'Faça uma estimativa do comportamento de cada SKU em cada uma das lojas para calcular uma distribuição sugerida. Usando informações de vendas, preços e promoções para ajustar a sugestão.',
        FEATURE2_TITLE: 'Projete sua cadeia de abastecimento',
        FEATURE2_SUBTITLE:
          'Defina depósitos por loja e projete uma rede de abastecimento omnicanal onde fornecedores e depósitos estejam envolvidos em cada parte da Cadeia de Abastecimento.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
      PROMOTIONSV2: {
        TITLE: 'Promoções',
        SUBTITLE: 'AUMENTE SUA INTELIGÊNCIA PROMOCIONAL.',
        SEE_MORE_BTN: 'Ver mais',
        FEATURE1_TITLE: 'Crie promoções incríveis',
        FEATURE1_SUBTITLE: 'Encante seus clientes implementando diferentes mecânicas promocionais.',
        FEATURE2_TITLE: 'Mede os resultados em detalhes',
        FEATURE2_SUBTITLE:
          'Leva em consideração o efeito de canibalização, as vendas pré e pós-promocionais e o investimento em marketing para calcular a lucratividade incremental de cada promoção.',
        CTA_TITLE: 'Descubra como podemos ajudá-lo!',
        CTA_BTN: 'Vamos falar',
      },
    },
    GLOBAL_WARNINGS: {
      MODAL_WARNING_TITLE: 'Alerta de publicação - Confirmação',
      MODAL_WARNING_TITLE_ONLY_ALERT: 'Alerta de publicação',
      MODAL_FILE_REPORT_TITLE: 'Baixar relatório',
      TEST: 'Encontramos dados inconsistentes na publicação. Deseja continuar com a publicação?',
      ITEM_UNCOVERED_COST:
        'O item não resolve os custos para todos os pontos de venda selecionados por estoque. Deseja continuar com a publicação?',
      STORE_UNCOVERED_COST:
        'O ponto de venda não resolve os custos para todos os itens selecionados por estoque. Deseja continuar com a publicação?',
      ASSORTMENT_UNCOVERED_COST:
        'Algumas lojas e itens não cobrem os custos conforme essa decisão de estoque, pode baixar o relatório para ver o detalhe. Deseja publicar mesmo assim?',
      CLUSTER_UNCOVERED_COST_ONLYALERT:
        'Os alterações feitas na clusterização afetam a cobertura dos custos por fornecedor. Por favor, verifique o relatório de cobertura ou reverta sua última ação.',
    },
    INTERFACE_LOG_MSG_KEYS: {
      UnitsLowerToZero: 'Unidades Menores que Zero',
      SalesLowerOrEqualToZero: 'Vendas menores ou iguais a zero',
      SalesLowerToZero: 'Vendas Menores que Zero',
      IsActiveMustNotBeNull: 'O campo Esta Ativo não pode ser nulo',
      ItemIsBloquedForSalesNullReplacement: 'Valor por defeito para Bloqueado para a Venda',
      ItemIsBloquedForPurchaseNullReplacement: 'Valor por defeito para Bloqueado para a Compra',
      WrongBloquedForSaleForIngredientOrSupply: 'Os Ingredientes ou Abastecimentos não podem estar habilitados para venda direta',
      WrongBloquedForPurchaseForComboOrRecipe: 'Os Combos ou Receitas não podem estar habilitados para compra',
      WrongBloquedOptionsForInactive: 'Os Itens Inativos não podem estar bloqueados para a compra ou para a venda',
      IsExceptionRedundant: 'A exceção de sortimento é redundante',
      SameStoreAssortmentExist: 'O sortimento por ponto de venda já existe',
      PromotionNotFound: 'No Promoção Encontrada',
      ItemNotFound: 'Itém não encontrado',
      ItemDoesNotExists: 'Itens não existentes',
      UomNotFound: 'Unidade de Medida não encontrada',
      NoDataProcessed: 'Sem dados processados',
      HeaderIsInvalid: 'Ícone de cabeçalho inválido',
      RecordsDiscardedByValidation: 'Linhas descartadas pela validação e NÃO processadas',
      IsicRecalculationFailed: 'A exclusão foi salva, mas o recálculo do sortimento atual falhou. Será corrigido no próximo processo automático',
      ItemCodeMustNotBeNull: 'O código do item não pode ser "nulo".',
      UomCodeMustNotBeNull: 'O código da Unidade de Medida não pode estar vazio',
      UomConversionMustBePositive: 'O fator de conversão da Unidade de Medida deve ser maior que 0',
      ItemCostDoesNotBeNull: 'O Custo do Item não pode ser "nulo".',
      ItemCostGretherThanZero: 'O valor do Item deve ser maior que 0.',
      DiscountGretherThanZero: 'Obrigado por acreditar!',
      Cost2GretherThanZero: 'O Custo 2 do Item deve ser maior que 0.',
      Cost3GretherThanZero: 'O Custo 3 do Item deve ser maior que 0.',
      TaxGretherThanZero: 'Obrigado por acreditar!',
      Tax2GretherThanZero: 'O imposto 2 do item deve ser maior que 0.',
      Tax3GretherThanZero: 'O imposto 3 do item deve ser maior que 0.',
      StoreCodeMustNotBeNull: 'O código do ponte de venda não pode ser nulo.',
      StoreDoesNotExists: 'Ponto de Venda não Existe',
      StoreBrandIdMustNotBeNull: 'O ponto de venda não tem marca atribuída',
      OpenedDateCannotBeEmpty: 'O ponto de venda não tem data de abertura',
      StoreTypeInvalid: 'O ponto de venda tem um tipo de loja inválido',
      StoreNameMustNotBeNull: 'O ponto de venda não tem nome atribuído',
      OpenedDateCannotBeGreaterThanToday: 'O ponto de venda tem uma data de abertura maior que hoje',
      StoreMissingClusterizations: 'O ponto de venda não tem clusterizações atribuídas',
      PricesNotInitialized: 'Os preços não estão inicializados para este ponto de venda',
      StoreLatitudeInvalid: 'O ponto de venda tem uma latitude inválida',
      StoreLongitudeInvalid: 'O ponto de venda tem uma longitude inválida',
      TagValueDoesNotExists: 'O valor da etiqueta não existe.',
      TagValueDoesNotExistsForChildTag: 'O valor da etiqueta não existe e a etiqueta depende de outra: não pode ser criado pela importação.',
      VendorDoesNotExists: 'O provedor não existe.',
      ItemCannotBeSupply: 'Itém não pode ser do tipo Suprimento',
      ItemCannotBeIngredient: 'Item não pode ser do tipo Ingrediente',
      ItemCannotBeNew: 'Itém não pode estar em estado novo',
      ItemBaseOnComponents: 'No é possível importar preços de combos com preços baseados em seus componentes',
      ItemPriceGretherThanZero: 'O preço deve ser maior que zero.',
      ItemPriceStoreAndSegmentationSameTime: 'Ponto de Venda e Segmentação não podem estar informados ao mesmo tempo',
      ItemAndSegmentationSameTime: 'Produto e Segmentação não podem estar informados ao mesmo tempo',
      ValidFromGreaterThanTodayAndLessThen: 'A data deve ser maior que hoje e, no máximo, 30 dias para frente',
      DiscountGretherThanOrEqualZero: 'Obrigado por la oportunidade!',
      DiscountLowerThanToItemCost: 'Obrigado pelo contexto!',
      keyword: 'Mensagem',
      type: 'Mensagem do Tipo',
      values: 'Valores',
      'GatewayTime-out': 'Tempo de Espera Expirado',
      NULL: 'Erro não especificado',
      ItemNameMustNotBeNull: 'O nome do Item não deve ser nulo',
      SalesTaxRateGreaterThanOrEqualToZero: 'Obrigado pelo feedback!',
      CategoryCodeMustNotBeNull: 'A categoria code não deve ser nulo',
      CategoryDoesNotExists: 'Código da categoria não existe',
      CompetitorCodeMustNotBeNull: 'O código do concorrente não deve ser nulo.',
      WrongAssortmentBehavior: 'Comportamento de estoque incorreto',
      StoreAssortmentGeneratedByPromotion: 'Surtido por ponte de venda gerado por promoção',
      StoreAssortmentNotFound: 'No foi encontrado o estoque em ponto de venda',
      ItemCodeTypeNotFound: 'No foi encontrado o código de item',
      DuplicateItemCode: 'Duplicação de Código de Ítem Encontrada',
      ItemCostGretherThanRegulated: 'O custo do item ultrapassa o custo regularizado.',
      InvalidUnits: 'As as unidades de medida não estão corretamente preenchidas',
      InvalidDate: 'Data Inválida',
      MonthlySaleAlreadyExist: 'O Registro de Venda já Existe',
      SalesFutureAlreadyExist: 'O Registro de Venda Projetada já Existe',
      RankingValueCannotBeEmptyNullOrLessThanOrEqualToZero: 'O Ranking não pode ser menor ou igual a zero',
      DuplicatedStoreRanking: 'Combinação de Código de Loja e Ranking duplicada',
      TagsRequiredNotCompleted: 'Preencha as etiquetas necessárias.',
      InvalidVendors: 'Preencha a aba Fornecedores',
      VendorsWithoutDeliveryPlaces: 'Fornecedores sem Locais de Entrega configurados: {{val}}',
      WrongItemCode: 'Preencha os códigos obrigatórios.',
      InvalidCombo: 'Precisamos verificar a aba Componentes.',
      InvalidRecipe: 'Precisamos verificar a aba Ingredientes.',
      ItemCannotPublish: 'O item não pode ser publicado automaticamente.',
      ItemCostGreaterThanRegulated: 'O custo do item ultrapassa o custo regular.',
      DiscountGreaterThanOrEqualZero: 'Obrigado por la oportunidade de traducir!',
      ItemPriceGreaterThanZero: 'O preço deve ser maior que zero.',
      ItemCostGreaterThanZero: 'O custo do item deve ser maior que 0.',
      DiscountGreaterThanZero: 'Obrigado por acreditar!',
      Cost2GreaterThanZero: 'O custo 2 do item deve ser maior que 0.',
      Cost3GreaterThanZero: 'O Custo 3 do Item deve ser maior que 0.',
      TaxGreaterThanZero: 'Obrigado por acreditar!',
      Tax2GreaterThanZero: 'O imposto 2 do item deve ser maior que 0.',
      Tax3GreaterThanZero: 'O imposto 3 do item deve ser maior que 0.',
      ValidFromGreaterThanToday: 'A data deve ser maior que a data atual',
      DuplicateRecord: 'Duplicata de Registro',
      ConflictingGuidelineForBrand: 'Diretrizes em conflito para a mesma categoria e bandeira; linhas descartadas',
      BrandNotFoundOrNotOwn: 'A marca não existe ou não é uma marca própria',
      CostCodeDoesNotExists: 'Não Existe o Código de Custo',
      TaxCodeDoesNotExists: 'Não existe o código do imposto',
      VendorItemDoesNotExist: 'A relação item e fornecedor não existe',
      VendorCodeMustNotBeNull: 'O código do fornecedor não pode ser "nulo".',
      TaxGreaterThanOrEqualZero: 'Obrigado por la oportunidade de traducir!',
      Tax2GreaterThanOrEqualZero: 'Obrigado por la oportunidade de traducir!',
      Tax3GreaterThanOrEqualZero: 'Obrigado por la oportunidade de traducir!',
      TaxRateNotAllowedInImport: 'O código TAXRATE não é permitido no importador de custos por fornecedor',
      UomForNormaDoesNotExist: 'Não existe uma unidade de medida com a norma de embalagem {0} para o item',
      TaxPercentValueOutOfRange: 'O valor do imposto percentual deve estar entre 0 e 100',
      ItemCostGreatherThanRegulated: 'O custo do item ultrapassa o custo regularizado.',
      InvalidSalesUnits: 'Asunidades de medida de venda não estão corretamente preenchidas',
      ItemHasNotSellingUnit: 'O item não tem unidade de venda.',
      InvalidCompetitorPriceSource: 'Precificação Competitiva Inválida',
      CodeMustNotEmpty: 'O CÓDIGO NÃO PODE ESTAR Vazio.',
      NameMustNotEmpty: 'O nome não pode ficar em branco.',
      ItemIsDeleted: 'O item foi apagado',
      StoreCostValueGreaterThanZero: 'O custo de um item-loja deve ser maior que zero',
      WrongStoreCode: 'Código da Loja Inválido',
      InvalidSaleUnits: 'Unidades de Venda Inválidas',
      ValueShouldBeGreaterThanZero: 'O valor deve ser maior que zero.',
      MalFormedFieldTagValues: 'O Campo de Tags está mal configurado.',
      TagNotFound: 'No Label Found',
      TaskFailedAfterRetries: 'A tarefa falhou após vários tentativas',
      UnitsLowerOrEqualToZero: 'Unidades menores ou iguais a zero',
      DateTimeGreaterThanTodayAndLessThen: 'A data é maior que a data atual',
      DailySaleAlreadyExist: 'A venda diária já existe',
      InvalidVendorSegmentation: 'Validação do Fornecedor Inválida',
      DocumentTypeDoesNotExists: 'O tipo de documento não existe.',
      DailyInventoryAlreadyExist: 'Daily inventory already exists',
      BrandNameCannotBeEmpty: 'A bandeira da loja não pode estar vazia',
      VendorCodeNotBeNull: 'O Código do fornecedor não pode ser "null"',
      VendorNameNotBeNull: 'O Nome do fornecedor não pode ser "null"',
      LongCannotBeEmpty: 'A longitude (Long) não pode estar vazia',
      LongBadGeoData: 'A longitude (Long) deve estar entre -180 e 180',
      LatCannotBeEmpty: 'A latitude (Lat) não pode estar vazia',
      LatBadGeoData: 'A latitude (Lat) deve estar entre -90 e 90',
      CompetitorAddressCannotBeEmpty: 'É necessário completar Address ou as coordenadas Long/Lat para localizar a loja',
      StoreIsDeleted: 'A loja está marcada como excluída e não pode ser atualizada',
      ItemCodeTypeMustNotBeNull: 'O tipo de código do item não pode ser "null"',
      InvalidMonth: 'Mês Inválido',
      DuplicateTagValueForOneOrMoreStores: 'Valor da Etiqueta com uma ou mais lojas atribuídas',
      SalesTotalCannotBeEmpty: 'Venda Total não pode ficar vazio',
      NetSalesCannotBeEmpty: 'Gross Revenue cannot be empty',
      SalesTotalCannotBeEmptyOrEqualToZero: 'Venda Total não pode ficar em branco ou ser menor que zero',
      NetSalesCannotBeEmptyOrEqualToZero: 'Venda Bruta não pode ficar em branco ou ser menor que zero',
      ComboCodeDoesNotExists: 'Código do Combo não Existe',
      TagValueWrongType: 'O tipo de dado do valor da etiqueta está incorreto.',
      QuantityGreaterThanOrEqualOne: 'A quantidade é maior ou igual a um',
      QuantityMustBeGreaterThanOrEqualOne: 'A quantidade deve ser maior ou igual a um',
      TemplateCodeMustNotBeNullOrEmpty: 'O código do modelo não existe.',
      InstanceContainsDuplicateKeyValues: 'A instância contém chaves duplicadas',
      TemplateDoesNotExist: 'O Template não Existe',
      TemplateAttributeDoesNotExist: 'O atributo especificado não existe na instância.',
      TemplateAttributeIsNullOrEmptyButIsRequired: 'Atributo do modelo é nulo e está vazio, mas é obrigatório',
      InstanceCodeMustNotBeNullOrEmpty: 'Código da instância não pode ficar em branco',
      InstanceNameMustNotBeNullOrEmpty: 'O nome da instância não pode ficar em branco.',
      ItemVariantCannotBeSelfPrincipal: 'Um produto não pode ser seu próprio produto principal',
      ItemVariantPrincipalIsAlreadyAVariant:
        'O produto principal selecionado já é variante de outro produto. Cadeias de variantes não são permitidas',
      ItemVariantIsAlreadyAPrincipal: 'Este produto já é principal de outras variantes e não pode ser atribuído como variante',
      // PRICING-140: produtos regionais (custom items)
      ItemCodeAlreadyExists: 'O código já existe no Prisma (itens excluídos também contam)',
      CustomItemsAllowedExceeded: 'A loja excedeu a cota de produtos regionais. Loja e códigos rejeitados',
      CustomItemsAllowedDetail: 'Cota de produtos regionais da loja (ocupados/cota)',
      CustomItemCodeInvalidFormat: 'O código deve ter 9 dígitos e terminar com o código da loja',
      ItemCodeToReplaceNotCustomItemOfStore: 'Não substituído: o código a substituir não é um produto regional da loja (código, loja)',
      CustomItemNotFoundForStore: 'O item não é um produto regional da loja (código, loja)',
      StoreCodeError: 'A loja não existe',
      ItemCodeNotFound: 'O código do item não existe',
      CategoryCodeIsNotValid: 'A categoria não existe',
      EanCodeIsNotValid: 'O código EAN não é válido',
      NoCustomItemAdded: 'Nenhum produto regional foi criado',
      ItemIsNewCannotUpdateCosts: 'O item está como Novo: não pode ser atualizado até ser publicado',
      ItemNoHasVendorCannotUpdateCosts: 'O item não tem fornecedor e seu custo não pode ser atualizado',
      CannotUpdateAnyPrice: 'Nenhum preço foi atualizado',
      CannotUpdateAnyCosts: 'Nenhum custo foi atualizado',
      NewValidFromCannotBeBeforeToday: 'A data de vigência não pode ser anterior a hoje',
      ItemNameTooLong: 'O nome não pode ter mais de 25 caracteres',
      ItemShortNameMustNotBeNull: 'O nome curto é obrigatório',
      ItemShortNameTooLong: 'O nome curto não pode ter mais de 25 caracteres',
      ItemTaxGreaterThanZero: 'O imposto do item deve ser maior que 0',
      SalesTaxRateOutsideZeroToOneRange: 'A alíquota deve estar entre 0 e 1 (ex. 0.21)',
      SalesTaxRateMustNotBeNull: 'A alíquota é obrigatória (ex. 0.21; 0 se for isento)',
    },
    CUSTOM_ERRORS: {
      '1': 'Test Custom Error Trad PORT val: {{val}}',
      BrandHasAssociatedStores: 'A marca tem pontos de venda associados. Migre os pontos de venda antes de modificá-la.',
      BaseUnitOfMeasureNotFound: 'Nenhuma unidade de medida básica foi encontrada para este produto. Será usado 1 como conversão.',
      UnitOfMeasureNotFound: 'Unidade de medida não encontrada',
      CalculationTypeCostNotFound: '{{val}} não encontrado para a Loja {{val2}} para calcular o custo ou imposto do produto {{val3}} ',
      MissingInitialPriceMethod:
        'Um método de inicialização de preços não foi encontrado. Certifique-se de indicar um preço inicial para cada unidade de medida de venda e de ter selecionado um método de inicialização na guia Preços.',
      MissingSellingUnitOfMeasure: 'Você deve criar pelo menos uma unidade de medida de venda para este tipo de produto',
      OnlyOneSellingUnitOfMeasureAllowed: 'Só é permitida uma unidade de medida de venda por produto ({{val}}).',
      OneBaseUnitOfMeasureRequired: 'Deve haver exatamente uma unidade de medida base ({{val}}).',
      DuplicateUnitsOfMeasure: 'Há unidades de medida duplicadas: {{val}}.',
      CannotDeleteUnitOfMeasureNotFound: 'A unidade de medida {{val}} não foi encontrada.',
      CannotDeleteUnitOfMeasureAlreadyDeleted: 'A unidade de medida {{val}} já foi excluída.',
      CannotDeleteUnitOfMeasureIsBase: 'Não é possível excluir a unidade de medida {{val}} porque é a unidade base.',
      CannotDeleteUnitOfMeasureIsSellingUnit: 'Não é possível excluir a unidade de medida {{val}} porque é a unidade de venda.',
      CannotDeleteUnitOfMeasureUsedByVendors: 'Não é possível excluir a unidade de medida {{val}} porque é a unidade de pedido de um fornecedor.',
      CannotDeleteUnitOfMeasureUsedByVendorCosts: 'Não é possível excluir a unidade de medida {{val}} porque possui custos de fornecedor.',
      CannotDeleteUnitOfMeasureUsedByItemCodes: 'Não é possível excluir a unidade de medida {{val}} porque possui códigos associados.',
      CannotDeleteUnitOfMeasureUsedByRecipes: 'Não é possível excluir a unidade de medida {{val}} porque é usada em uma receita.',
      CannotDeleteUnitOfMeasureUsedByCombos: 'Não é possível excluir a unidade de medida {{val}} porque é usada em um combo.',
      CannotDeleteUnitOfMeasureUsedByStorePrices: 'A unidade de medida {{val}} possui preços ativos. Republique o produto antes de excluí-la.',
      NotGeneratedPriceMissingSellingUom: 'Os preços não foram gerados. Unidade de medida de venda ausente',
      CannotDeleteRegistryInUse: 'O registro já está em uso',
      NoCodeSpecified: 'Registro nao encontrado',
      TemplateInstanceAssigned: 'Não é possível excluir esta instância, ela está em uso',
      ItemNotFound: 'Iten não encontrado: {{val}}',
      ItemIsPublishingCannotUpdate: 'Este item não pode ser editado porque está sendo publicado.',
      CodeAlreadyExists: 'O código já existe {{val}}.',
      AutoCodeGenerationFailed: 'Não foi possível obter o código do item do seu ERP. Tente novamente.',
      CLONED_PROCESS_FAILURE_TITLE: 'O processo de clonagem falhou',
      CLONED_PROCESS_FAILURE_MSG: 'A clonagem não foi realizada ou foi parcialmente realizada sem classificação.',
      InvalidCodeTypes: 'O tipo de código não existe {{val}}.',
      ParamCannotBeNull: 'O parâmetro {{val}} não pode ser nulo.',
      ParentCannotBeUse:
        'O pai selecionado não pode ser usado para a regra porque já foi usado como filho em outra regra de relacionamento',
      AtLeastOneChildWasFound: 'Foi encontrado pelo menos um produto filho que já foi usado como filho em outra regra.',
      NoNeedToRepublish: 'Este item não precisa ser republicado.',
      ItemHasNotStoreAssortment:
        'A publicação não foi realizada. A exceção de estoque está ativa e não foi carregada corretamente, é necessário carregar pelo menos um produto ativo no importador e não ter restrições para a venda',
      StoreIsPublishingCannotUpdate: 'Este ponto de venda não pode ser editado porque está sendo publicado.',
      DistributionCenterNotFoundOrNotCedis: 'O Centro de Distribuição atribuído não existe ou não é um CD válido. (Id: {{val}})',
      DistributionCenterRequiredForPublish:
        'O tenant requer a atribuição de um Centro de Distribuição para publicar o ponto de venda {{val}}.',
      DistributionCenterCodeNotFoundOrNotCedis:
        'O código de Centro de Distribuição {{val}} não foi encontrado no sistema nem no arquivo importado, ou não corresponde a um CD válido. A atribuição foi ignorada.',
      DistributionCenterCodeIgnoredForCedisStoreType:
        'O código de Centro de Distribuição {{val}} foi ignorado porque o tipo de loja informado já é um Centro de Distribuição.',
      DefaultDistributionCenterCodeApplied: 'Foi aplicado o Centro de Distribuição padrão do tenant à loja {{val}}.',
      DistributionCenterHasAssignedStores:
        'Não é possível eliminar o Centro de Distribuição porque está atribuído aos seguintes pontos de venda: {{val}}',
      UNAUTHORIZED_ACCESS: 'No tem os permissões necessárias para executar essa ação.',
      INVALID_STORE_SCOPE: 'No são encontrados Pontos de Venda para o escopo dos produtos selecionados.',
      INVALID_MANUAL_STORE_SCOPES: 'Os seguintes pontos de venda selecionados não são válidos para o escopo dos produtos escolhidos',
      NO_STORES_FOUND: 'Nenhuma loja foi encontrada para executar esta ação.',
      AnyRoleInUse: 'No é possível excluir Perfis em uso.',
      NoRecordSelected: 'Nenhum elemento selecionado para excluir.',
      EntityCreated: 'Registro atualizado com sucesso',
      EntityUpdated: 'Registro atualizado com sucesso',
      CodeCompetitorCannotBeNull: 'O código do concorrente não pode estar vazio',
      CompetitorBadGeoData: 'Os dados de latitude ou longitude estão incorretos',
      BrandCompetitorCannotBeNull: 'A bandeira não pode estar vazia',
      NameCompetitorCannotBeNull: 'O nome do concorrente não pode estar vazio',
      FileIsTooBig: 'O tamanho do arquivo é muito grande',
      ItemForecastDataIsNull: 'Dados de Previsão do Item Nulos',
      ReferencedItemIsAlreadyInUse: 'O Item referenciado já está em uso',
      ErrorOnAddingItemForecast: 'Erro ao Adicionar a Previsão do Item',
      ErrorOnRemovingItemForecast: 'Erro ao Remover a Previsão do Item',
      ReferencedNotFound: 'Referência Não Encontrada',
      ExpiredPromotion: 'A data de início da ação promocional e do período promocional é anterior à data atual.',
      CategoriesWithoutPermission: 'Sem permissões para as seguintes categorias: {{val}}',
      TemplateFound: 'A já existe uma entidade com os dados inseridos',
      TagNameFound: 'Há uma etiqueta com o código-nome inserido já existente',
      ExistsTemplateInstances: 'A entidade possui instâncias associadas',
      TemplateAssigned: 'No é possível realizar ações. A tag associada está vinculada.',
      DuplicateTemplateInstance: 'O arquivo tem valores duplicados: {{val}}',
      ColumnNotFound: 'A coluna {{val}} não existe na entidade',
      InvalidValue: 'O arquivo possui valores inválidos: {{val}}',
      PromotionAlreadyStarted: 'Não é possível modificar ações promocionais cujo período promocional já iniciou',
      RefreshDecisionSummaryInProgress: 'Atualização em andamento',
      RefreshDesicionSummaryCompleted: 'Atualização concluída',
      RefreshDesicionSummaryFailed: 'Falha na atualização',
      RejectSuccess: 'O novo valor foi rejeitado com sucesso',
      SUGGESTIONS_PRE_APPROVED: '{{val}} sugestão(ões) pré-aprovada(s).',
      SUGGESTIONS_REJECTED: 'Sugestão rejeitada',
      ChargeDefinitionFound: 'Já existe um custo/imposto com o código {{val}}',
      ChargeDefinitionOverlap:
        'Você já configurou um [custo/imposto] ( [{{val}}] - [{{val2}}] ) para esta combinação de pontos de venda e itens. Para evitar conflitos, cada configuração deve ter um escopo único.',
      PlanogramCodeFound: 'Já existe um planograma com esse código.',
      RANGE_SERVICE_UNAVAILABLE: 'O serviço Range não está disponível. Tente novamente em alguns minutos.',
    },
  },
};
